(function () {
  'use strict';

  angular
    .module('minotaur', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      // 'ngResource',
      'ui.router',
      'ui.bootstrap',
      // 'toastr',
      // 'pascalprecht.translate',
      'cfp.loadingBar',
      // 'ngAlertify',
      // 'FBAngular',
      // 'daterangepicker',
      // 'ui.sortable',
      // 'slick',
      // 'textAngular',
      // 'ngTagsInput',
      // 'angularBootstrapNavTree',
      // 'ui.tree',
      // 'ipsum',
      // 'wu.masonry',
      // 'dragularModule',
      // 'chart.js',
      // 'angular.morris',
      // 'easypiechart',
      // 'angular-svg-round-progressbar',
      // 'angular-rickshaw',
      // 'rzModule',
      // 'colorpicker.module',
      // 'nk.touchspin',
      // 'localytics.directives',
      // 'ui.select',
      // 'validation.match',
      // 'angularFileUpload',
      // 'ngImgCrop',
      // 'ngTable',
      // 'smart-table', 
      // 'angular-intro',
      // 'ngMap',
      // 'leaflet-directive',
      // 'ui.calendar', 
      // 'angular-flot',
      'ui-notification',
      'angular-jwt',
      // 'angucomplete-alt', 
      // 'checklist-model', 
      // 'counter', 
      // 'ngecharts',   
      // 'treeControl',   
      'LocalStorageModule',
      // 'ngFileSaver',
      // 'ckeditor',
      'ngclipboard'
    ]);

})();

(function () {
    'use strict';
    angular
        .module('minotaur')
        .directive('minotaurHeader', minotaurHeader)
        .controller('modalPaswordController', modalPaswordController);        

    /** @ngInject */
    function minotaurHeader($window) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/partials/header/header.html',
            controller: HeaderController,
            controllerAs: 'header',
            bindToController: true,
            link: function (scope, element) {
                var app = angular.element('.appWrap'),
                    $el = angular.element(element),
                    w = angular.element($window);

                function setViewport() {
                    if ($window.innerWidth < 768) {
                        $el.addClass('viewport-sm');
                        app.addClass('viewport-sm');
                    } else {
                        $el.removeClass('viewport-sm');
                        app.removeClass('viewport-sm');
                    }
                }

                setViewport();

                w.bind('resize', setViewport);
            }
        };

        return directive;

        /** @ngInject */
        function HeaderController($http, $scope, $uibModal, entidadService, AuthenticationService, $location, $log, $state, $rootScope, $cookies, jwtHelper, Notification, settings) {
            var vm = this;


            vm.searchAPI = function (inputString) {
                return entidadService.GetSearchPaginate({ likeentidad: inputString });
            };

            vm.selectedObject = function (selected) {
                if (selected) {
                    $state.go("dashboard", { 'perfilId': selected.originalObject.identidad });
                }
            };

            vm.openModalNuevaVenta = function () {
                $scope.$emit('handleBroadcastVenta');
            };

            vm.logout = function () {
                AuthenticationService.Logout($rootScope.urlente, function (r) {
                    if (r.data.success) {
                        AuthenticationService.ClearCredentials();
                        //$location.path('/sign-in');    
                        //$state.go("signin"); 
                        window.location = settings.baseURL + '/#/login';
                    } else {
                        Notification.error({ message: r.message });
                    }
                });
            }

            vm.abrirModal = function (data) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'myModalPasswordContent.html',
                    controller: 'modalPaswordController',
                    windowClass: 'modal-primary',
                    size: 'sm',
                    resolve: {
                        modalParam: function () {
                            return {
                                data: data
                            };
                        }
                    }
                });

                modalInstance.result.then(function () { }, function () {
                    $log.info('Modal dismissed at: ' + new Date());
                });
            };

        }
    }

    modalPaswordController.$inject = ['$scope', '$uibModalInstance', 'modalParam', 'entidadService', 'Notification'];
    function modalPaswordController($scope, $uibModalInstance, modalParam, entidadService, Notification) {

        $scope.entidad = {};
        $scope.entidad.identidad = modalParam.data;
        $scope.entidad.contrasenanueva = '';
        $scope.entidad.contrasenaconfirm = '';
        $scope.confirm = false;

        $scope.save = function () {
            if ($scope.entidad.contrasenanueva !== $scope.entidad.contrasenaconfirm) {
                Notification.warning({ message: 'Contraseña no coincide con la confirmación de contraseña.' });
                $scope.miForm.$submitted = false;
                $scope.confirm = true;
                return false;
            }

            entidadService.UpdatePassword($scope.entidad).then(function (entidad) {
                if (entidad.type === 'success') {
                    Notification.primary({ message: entidad.data });
                    $uibModalInstance.close();
                } else {
                    Notification.error({ message: entidad.data });
                    $scope.miForm.$submitted = false;
                }
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
    

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurNav', minotaurNav);

  /** @ngInject */
  function minotaurNav($timeout, $window ) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/partials/navigation/navigation.html',
      controller: NavigationController,
      controllerAs: 'navigation',
      bindToController: true,  
      link: function (scope, $el) { 
        $timeout(function(){

          var $dropdowns = $el.find('ul').parent('li'),
            $a = $dropdowns.children('a'),
            $notDropdowns = $el.find('.nav-sidebar').children('li').not($dropdowns),
            $notDropdownsLinks = $notDropdowns.children('a'),
            app = angular.element('.appWrap'),
            $navigation_toggle = app.find('#navigation-toggle'),
            w = angular.element($window);

          $el.on('mouseenter', function() {
            if (app.hasClass('hz-menu') && !app.hasClass('viewport-sm')) {
              $el.addClass('nav-expanded');
              app.addClass('nav-expanded');
            }
          });
          $el.on('mouseleave', function() {
            if (app.hasClass('hz-menu') && !app.hasClass('viewport-sm')) {
              $el.removeClass('nav-expanded');
              app.removeClass('nav-expanded');
            }
          });

          $dropdowns.addClass('dropdown');

          var $submenus = $dropdowns.find('ul >.dropdown');
          $submenus.addClass('submenu');

          $a.append('<span class="indicator"></span>');

          $a.on('click', function(event) {

            var $this = angular.element(this),
              $parent = $this.parent('li'),
              $openSubmenu = angular.element('.submenu.open');

            if (!$parent.hasClass('submenu')) {
              $dropdowns.not($parent).removeClass('open').find('ul').slideUp();
            }

            $openSubmenu.not($this.parents('.submenu')).removeClass('open').find('ul').slideUp();
            $parent.toggleClass('open').find('>ul').stop().slideToggle();
            event.preventDefault();
          });

          $notDropdownsLinks.on('click', function() {
            $dropdowns.removeClass('open').find('ul').slideUp();
          });

          var $activeDropdown = angular.element('.dropdown>ul>.active').parent();

          $activeDropdown.css('display', 'block');

          scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState){
            if ($el.find('ul').parent('li.open.active').length > 0 && toState.parent !== fromState.parent) {
              $dropdowns.find('ul').slideUp();
            }
            if (app.hasClass('viewport-sm')) {
              $el.addClass('navigation-hidden');
              app.addClass('navigation-hidden');
            }
          });

          $navigation_toggle.on('click', function(){
            if (app.hasClass('viewport-sm')) { 
              $el.toggleClass('navigation-hidden');
              app.toggleClass('navigation-hidden');
            } else { 
              $el.toggleClass('navigation-sm');
              app.toggleClass('navigation-sm');
            }
          });

          function setSmallNavigation(){
            if($window.innerWidth < 1200 && $window.innerWidth > 768){
              $el.addClass('navigation-sm');
              app.addClass('navigation-sm');
              $el.removeClass('navigation-hidden');
              app.removeClass('navigation-hidden');
            } else if ($window.innerWidth <= 768) {
              $el.removeClass('navigation-sm');
              app.removeClass('navigation-sm');
              $el.addClass('navigation-hidden');
              app.addClass('navigation-hidden');
            } else {
              $el.removeClass('navigation-sm');
              app.removeClass('navigation-sm');
              $el.removeClass('navigation-hidden');
              app.removeClass('navigation-hidden');
            }
          }

          setSmallNavigation();

          w.bind('resize', setSmallNavigation);

        }, 0);

      }
    };

    return directive;
    
    /** @ngInject */    
    function NavigationController($rootScope, localStorageService) {
      var navigation = this;    
      navigation.modules = localStorageService.get('modules'); 
 
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('minotaur')
    .run(['$anchorScroll', function ($anchorScroll) {
      $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
    }])
    .controller('terapiaencuestaController', terapiaencuestaController);

  terapiaencuestaController.$inject = ['$scope', '$filter', 'Notification', 'citaterapeuticaService', '$stateParams', '$location', '$anchorScroll'];
  function terapiaencuestaController($scope, $filter, Notification, citaterapeuticaService, $stateParams, $location, $anchorScroll) {

    debugger
    var vm = this;
    vm.p1_califica = null;
    vm.p2_califica = null;
    vm.p3_califica = null;
    vm.p4_califica = null;
    vm.p5_califica = null;
    vm.p6_califica = null;
    vm.p7_califica = null;
    vm.p8_califica = null;
    vm.p9_califica = null;
    vm.p10_califica = null;


    vm.spinerLoading = false;
    vm.others = null;
    vm.entidad = null;

    var param = $stateParams.param;
    var cadena = param.split(",");

    var param = {
      numerodoc: cadena[0],
      identidad: cadena[1],
      idterapia: cadena[2]
    };

    vm.ingresarDoc = false;
    vm.noExiste = false;
    vm.encuestacompleta = false;
    vm.pregunta;
    vm.checkencuesta = true;
 
    if (!param.identidad) {
      vm.noExiste = true;
      return false;
    }

    citaterapeuticaService.Terapiaentrevista(param).then(function (data) {

      if (data.type === 'success') {
        vm.entidad = data.data;
        var nombres = data.data.nombre.split(' ');
        vm.entidad.primernombre = nombres[0];
        vm.others = data.others; 
      } else {
        Notification.error({ message: data.data });
        vm.noExiste = true;
      }
    });

    function checkEncuesta() {
      if (!vm.p1_califica && vm.p1_califica != 0) {
        vm.checkencuesta = false;
        vm.pregunta = 1;
        $scope.gotoAnchor(vm.pregunta);
        return false;
      }
      if (!vm.p2_califica && vm.p2_califica != 0) {
        vm.checkencuesta = false;
        vm.pregunta = 2;
        $scope.gotoAnchor(vm.pregunta);
        return false;
      }
      if (!vm.p3_califica && vm.p3_califica != 0) {
        vm.checkencuesta = false;
        vm.pregunta = 3;
        $scope.gotoAnchor(vm.pregunta);
        return false;
      }
      if (!vm.p4_califica && vm.p4_califica != 0) {
        vm.checkencuesta = false;
        vm.pregunta = 4;
        $scope.gotoAnchor(vm.pregunta);
        return false;
      }
      if (!vm.p5_califica && vm.p5_califica != 0) {
        vm.checkencuesta = false;
        vm.pregunta = 5;
        $scope.gotoAnchor(vm.pregunta);
        return false;
      }
      if (!vm.p6_califica && vm.p6_califica != 0) {
        vm.checkencuesta = false;
        vm.pregunta = 6;
        $scope.gotoAnchor(vm.pregunta);
        return false;
      }
      return true;
    }

    $scope.gotoAnchor = function (x) {
      var newHash = 'anchor' + x;
      if ($location.hash() !== newHash) {
        $location.hash('anchor' + x);
      } else {
        $anchorScroll();
      }
    };

    vm.save = function () {
      if (!checkEncuesta()) {
        Notification.warning({ title: 'Oh..!', message: "Completa correctamente la pregunta número: " + vm.pregunta, templateUrl: 'angular-ui-notification-intranet-warning.html' });
        $scope.miForm.$submitted = false;
      }
      else {
        var OBJsurvey = {
          identidad: vm.entidad.identidad,
          idterapia: vm.others.idterapia,
          calificaciones: {
            p1_califica: vm.p1_califica,
            p2_califica: vm.p2_califica,
            p3_califica: vm.p3_califica,
            p4_califica: vm.p4_califica,
            p5_califica: vm.p5_califica,
            p6_califica: vm.p6_califica,
            p7_califica: vm.p7_califica
          }

        }

        vm.spinerLoading = true;
        console.log('OBJentidad', OBJsurvey);

        citaterapeuticaService.SaveEncuestaTerapia(OBJsurvey).then(function (data) {
          if (data.type === 'success') {
            Notification.primary({ message: '¡Su <strong>calificación</strong> ha sido <strong>registrada exitosamente</strong>!', templateUrl: 'angular-ui-notification-intranet-primary.html' });
            vm.spinerLoading = false;
            vm.encuestacompleta = true;
            $scope.miForm.$submitted = false;
          } else {
            vm.spinerLoading = false;
            $scope.miForm.$submitted = false;
            Notification.error({ title: 'Oh..!', message: data.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
          }
        });
      }

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('minotaur')
    .run(['$anchorScroll', function($anchorScroll) {
      $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
    }])
    .controller('SurveyController', SurveyController);

  SurveyController.$inject = ['$scope', '$filter', 'Notification', 'entidadService', '$stateParams', '$location','$anchorScroll'];
  function SurveyController($scope, $filter, Notification, entidadService, $stateParams, $location, $anchorScroll) {

    var vm = this;
    vm.p1_califica = null;
    vm.p2_califica = null;
    vm.p3_califica = null;
    vm.p4_califica = null;
    vm.p5_califica = null;
    vm.p6_califica = null;
    vm.p7_califica = null;
    vm.p8_califica = null;
    vm.p9_califica = null;
    vm.p10_califica = null;


    vm.spinerLoading = false;
    vm.others = null;
    vm.entidad = null;
 
    var param = $stateParams.param;
    var cadena = param.split(",");

    var param = {
      numerodoc: cadena[0],
      identidad: cadena[1],
      idcitamedica: cadena[2]
    };

    vm.ingresarDoc = false;
    vm.noExiste = false;
    vm.encuestacompleta = false;
    vm.pregunta ;
    vm.checkencuesta = true;
    console.log(param);

    if (!param.identidad) {
      vm.noExiste = true;
      return false;
    }

    entidadService.PacienteCitamedica(param).then(function (data) {

      if (data.type === 'success') {
        vm.entidad = data.data;
        var nombres = data.data.nombre.split(' ');
        vm.entidad.primernombre = nombres[0];
        vm.others = data.others;
        if(data.others.idencuesta){
          vm.encuestacompleta = true;
        }
       

      } else {
        Notification.error({ message: data.data });
        vm.noExiste = true;
      }
    });

    function checkEncuesta() {
      if(!vm.p1_califica && vm.p1_califica != 0)
      {
        vm.checkencuesta = false;
        vm.pregunta = 1;        
        $scope.gotoAnchor( vm.pregunta);
        return false;
      }
      if(!vm.p2_califica && vm.p2_califica != 0)
      {
        vm.checkencuesta = false;
        vm.pregunta = 2;
        $scope.gotoAnchor( vm.pregunta);
        return false;
      }
      if(!vm.p3_califica && vm.p3_califica != 0)
      {
        vm.checkencuesta = false;
        vm.pregunta = 3;
        $scope.gotoAnchor( vm.pregunta);
        return false;
      }
      if(!vm.p4_califica && vm.p4_califica != 0)
      {
        vm.checkencuesta = false;
        vm.pregunta = 4;
        $scope.gotoAnchor( vm.pregunta);
        return false;
      }
      if(!vm.p5_califica && vm.p5_califica != 0)
      {
        vm.checkencuesta = false;
        vm.pregunta = 5;
        $scope.gotoAnchor( vm.pregunta);
        return false;
      }
      if(!vm.p6_califica && vm.p6_califica != 0)
      {
        vm.checkencuesta = false;
        vm.pregunta = 6;
        $scope.gotoAnchor( vm.pregunta);
        return false;
      }
      if(!vm.p7_califica && vm.p7_califica != 0)
      {
        vm.checkencuesta = false;
        vm.pregunta = 7;
        $scope.gotoAnchor( vm.pregunta);
        return false;
      }
      if(!vm.p8_califica && vm.p8_califica != 0)
      {
        vm.checkencuesta = false;
        vm.pregunta = 8;
        $scope.gotoAnchor( vm.pregunta);
        return false;
      }
      if(!vm.p9_califica && vm.p9_califica != 0)
      {
        vm.checkencuesta = false;
        vm.pregunta = 9;
        $scope.gotoAnchor( vm.pregunta);
        return false;
      }
      return true;
    }

    $scope.gotoAnchor = function(x) {
      var newHash = 'anchor' + x;
      if ($location.hash() !== newHash) {
        $location.hash('anchor' + x);
      } else {
        $anchorScroll();
      }
    };

    vm.save = function () {
      if(!checkEncuesta())
      {
          Notification.warning({ title: 'Oh..!', message: "Completa correctamente la pregunta número: "+vm.pregunta, templateUrl: 'angular-ui-notification-intranet-warning.html' });
          $scope.miForm.$submitted = false;
      }
      else{
        var OBJsurvey = {
          identidad: vm.entidad.identidad,
          idcitamedica: vm.others.idcitamedica,
          calificaciones: {
            p1_califica: vm.p1_califica,
            p2_califica: vm.p2_califica,
            p3_califica: vm.p3_califica,
            p4_califica: vm.p4_califica,
            p5_califica: vm.p5_califica,
            p6_califica: vm.p6_califica,
            p7_califica: vm.p7_califica,
            p8_califica: vm.p8_califica,
            p9_califica: vm.p9_califica,
            p10_califica: vm.p10_califica,
          }
          
        }

        vm.spinerLoading = true;
        console.log('OBJentidad', OBJsurvey);

        entidadService.SaveSurvey(OBJsurvey).then(function (data) {
          if (data.type === 'success') {
            Notification.primary({ message: '¡Su <strong>calificación</strong> ha sido <strong>registrada exitosamente</strong>!', templateUrl: 'angular-ui-notification-intranet-primary.html' });
            vm.spinerLoading = false;
            vm.encuestacompleta = true;
            $scope.miForm.$submitted = false;
          } else {
            vm.spinerLoading = false;
            $scope.miForm.$submitted = false;
            Notification.error({ title: 'Oh..!', message: data.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
          }
        });
      }
      
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('minotaur')
    .controller('UpdateController', UpdateController);

  UpdateController.$inject = ['$scope', '$filter', 'Notification', 'entidadService', '$stateParams'];
  function UpdateController($scope, $filter, Notification, entidadService, $stateParams) {

    var vm = this;

    vm.spinerLoading = false;
    vm.others = null;
    vm.entidad = null;
    vm.documentos = [{ iddocumento: 1, abreviatura: 'DNI' }, { iddocumento: 3, abreviatura: 'CARNET EXT.' }, { iddocumento: 4, abreviatura: 'PASAPORTE Y OTROS' }];

    var param = $stateParams.param;
    var cadena = param.split(",");

    var param = {
      iddocumento: cadena[0],
      numerodoc: cadena[1],
      identidad: cadena[2]
    };

    vm.ingresarDoc = false;
    vm.noExiste = false;
    console.log(param);

    if (!param.identidad) {
      vm.noExiste = true;
      return false;
    }

    entidadService.PacienteNrodocumento(param).then(function (data) {

      if (data.type === 'success') {
        vm.entidad = data.data;
        vm.others = data.others;

        if (data.data.fechanacimiento) {
          vm.entidad.fechanacimiento = convertDate(data.data.fechanacimiento);
        }



      } else {
        Notification.error({ message: data.data });
        vm.noExiste = true;
      }
    });


    vm.save = function () {

      var fechanacimiento = null;

      if (vm.entidad.iddocumento === 1 && vm.entidad.numerodoc.length !== 8) {//DNI 
        // Notification.warning({ message: 'DNI debe ser 8 números' });
        Notification.error({ title: 'Oh..!', message: 'DNI debe ser 8 números', templateUrl: 'angular-ui-notification-intranet-error.html' });
        $scope.miForm.$submitted = false;
        return false;
      }

      if (vm.entidad.fechanacimiento) {
        fechanacimiento = $filter('date')(vm.entidad.fechanacimiento, "dd/MM/yyyy");
      }

      var OBJentidad = {
        identidad: vm.entidad.identidad,
        iddocumento: vm.entidad.iddocumento,
        numerodoc: vm.entidad.numerodoc,
        fechanacimiento: fechanacimiento,
        ocupacion: vm.entidad.ocupacion,
        estadocivil: vm.entidad.estadocivil,
        hijos: vm.entidad.hijos,
        idubigeo: vm.entidad.idubigeo,
        celular: vm.entidad.celular,
        sangre: vm.entidad.sangre,
        altura: vm.entidad.altura,
        peso: vm.entidad.peso,
        direccion: vm.entidad.direccion 
      }

      vm.spinerLoading = true;
      console.log('OBJentidad', OBJentidad);

      entidadService.UpdateDatosAtencion(OBJentidad).then(function (data) {
        if (data.type === 'success') {
          Notification.primary({ message: '¡Sus <strong>datos</strong> han sido <strong>actualizado exitosamente</strong>!', templateUrl: 'angular-ui-notification-intranet-primary.html' });
          vm.spinerLoading = false;
          $scope.miForm.$submitted = false;
        } else {
          vm.spinerLoading = false;
          $scope.miForm.$submitted = false;
          Notification.error({ title: 'Oh..!', message: data.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('minotaur')
    .controller('RegisterController', RegisterController);

  /** @ngInject */
  function RegisterController($scope, Notification, entidadService,ubigeoService) {

    var vm = this;
    vm.save = save;

    vm.documentos = [{ iddocumento: 1, abreviatura: 'DNI' }, { iddocumento: 3, abreviatura: 'CARNET EXT.' }, { iddocumento: 4, abreviatura: 'PASAPORTE y OTROS' }];
    vm.iddocumento = 1;
    vm.aceptado = '1';

    // vm.numerodoc = '44120020';
    // vm.nombre = 'Yolanda';
    // vm.apellidopat = 'Chauca';
    // vm.apellidomat = 'Chavez';
    // vm.celular = '900 000 000';
    // vm.sexo = 'F';
    // vm.correo = 'yolanda.cablemas@gmail.com';
    // vm.fechanacimiento = '08/07/1986';
    // vm.password = '1';
    // vm.passwordrepeat = '1';

    vm.registrado = false;
    vm.spinerLoading = false;

    vm.pass = 'password';
    vm.passrepeat = 'password';

    entidadService.InformacionFormularioQuejas().then(function (entidades) {
      vm.spinerLoading=false;
      vm.others = entidades.others; 
      vm.pais="PE";
    });

    vm.changeUbigeo = function (ubigeo, to) {
      if (ubigeo.pais === '' || ubigeo.dpto === '' || ubigeo.prov === '') {
          vm.others[to] = [];
          return false;
      }
      if (to === 'departamentos') {
          vm.dpto = ''; //Por default '- Provincia -'
          vm.others.provincias = []; //Limpiar distritos
      }
      if (to === 'provincias') {
          vm.prov = ''; //Por default '- Provincia -'
          vm.others.distritos = []; //Limpiar distritos
      }
      if (to === 'distritos') {
          vm.dist = ''; //Por default '- Distrito -' 
      }
      ubigeoService.GetIndex(ubigeo).then(function (result) {
          vm.others[to] = result.data;
      });
  };
    
    // vm._isNotMobile = (function () {
    //   var check = false;
    //   (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera);
    //   return !check;
    // })();

    function save() {

      if (typeof vm.numerodoc === 'undefined') {
        Notification.warning({ message: 'Ingrese N° documento' });
        $scope.miForm.$submitted = false;
        return false;
      }

      if (vm.iddocumento === 1 && vm.numerodoc.length !== 8) {//DNI 
        Notification.warning({ message: 'DNI debe ser 8 números' });
        $scope.miForm.$submitted = false;
        return false;
      }

      var emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;      
      if (emailRegex.test(vm.correo)) {
        
      } else {
        Notification.warning({ message: 'Formato correo incorrecto' });
        $scope.miForm.$submitted = false;
        return false;
      }

      if (vm.aceptado === '0') {
        Notification.warning({ message: 'Es requisito aceptar los términos y condiciones del servicio.' });
        $scope.miForm.$submitted = false;
        return false;
      }

      // if (vm.password !== vm.passwordrepeat) {
      //   Notification.warning({ message: 'Contraseñas no coinciden, ingrese correctamente.' });
      //   $scope.miForm.$submitted = false;
      //   return false;
      // }

      var OBJentidad = {
        entidad: {
          iddocumento: vm.iddocumento,
          numerodoc: vm.numerodoc,
          nombre: vm.nombre,
          apellidopat: vm.apellidopat,
          apellidomat: vm.apellidomat,
          celular: vm.celular,
          sexo: vm.sexo,
          email: vm.correo,
          fechanacimiento: vm.fechanacimiento,
          password: vm.password,
          dpto: vm.dpto,
          prov: vm.prov,
          dist: vm.dist,
          pais: vm.pais
        }
      }

      vm.spinerLoading = true;
      entidadService.CreatePaciente(OBJentidad).then(function (data) {
        if (data.type === 'success') {
          console.log('data', data.data);
          vm.data = data.data.correo;
          vm.registrado = true;
          vm.spinerLoading = false;
        } else {
          vm.spinerLoading = false;
          Notification.error({ message: data.data.message });
          $scope.miForm.$submitted = false;
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('minotaur')
    .controller('ConfirmController', ConfirmController);

  /** @ngInject */
  function ConfirmController($scope, $stateParams, entidadService, AuthenticationService, $state, $timeout) {

    var vm = this;
    vm.spinerLoading = true;
    vm.data = null;
    var paramtoken = $stateParams.paramtoken || 'vacio';
    console.log('paramtoken', paramtoken);
 
    var navegador = navigator.userAgent;

    var objeto = {
      navegador: navegador
    };

    entidadService.PacienteToken(paramtoken, objeto).then(function (data) {
      if (data.type === 'success') {
        console.log('data', data.data);
        vm.data = data.data;
        vm.spinerLoading = false;

        $timeout(function () {
          AuthenticationService.SetCredentials(data.data);
          $state.go("mireserva");
        }, 2000);
        
      } else {
        vm.data = data.data;
        console.log('data error', data.data);
        vm.spinerLoading = false;
      }
    }); 
  }
})();

(function () {
  'use strict';

  angular
    .module('minotaur')
    .controller('RecoveryController', RecoveryController);

  /** @ngInject */
  function RecoveryController($scope, entidadService, Notification) {
    var vm = this;
    vm.save = save;

    vm.documentos = [{ iddocumento: 1, abreviatura: 'DNI' }, { iddocumento: 3, abreviatura: 'CARNET EXT.' }, { iddocumento: 4, abreviatura: 'PASAPORTE Y OTROS' }];
    vm.iddocumento = 1;

    vm.enviado = false;
    vm.spinerLoading = false;

    vm.data = null;
    vm.error = null;

    function save() {

      var inValid = false;
      var mensaje;
      if (vm.iddocumento === 1 && vm.numerodoc.length !== 8) {//DNI
        mensaje = 'DNI debe ser 8 números';
        inValid = true;
      }

      if (inValid) {
        Notification.warning({ message: mensaje });
        $scope.miForm.$submitted = false;
        return false;
      }

      var numerodoc = vm.numerodoc;

      var objeto = {
        iddocumento: vm.iddocumento,
        numerodoc: numerodoc
      };
      
      vm.spinerLoading = true;
      entidadService.Recovery(objeto).then(function (array) {
        if (array.type === 'success') {
          vm.data = array.data;
          vm.enviado = true;
          vm.spinerLoading = false;
          console.log('vm.data', vm.data);
        } else {
          vm.error = array.data;
          vm.spinerLoading = false;
          $scope.miForm.$submitted = false;
          console.log('vm.error', vm.data);
          
        }
      });
    }
  }
})();

(function () {
    'use strict';
  
    angular
      .module('minotaur')
      .controller('LibroReclamacionesController', LibroReclamacionesController);
  
      LibroReclamacionesController.$inject = ['$scope', '$filter', 'Notification', 'entidadService', '$stateParams'];
    function LibroReclamacionesController($scope, $filter, Notification, entidadService, $stateParams) {
       var vm = this;
      vm.spinerLoading = true;

      vm.others = null;
      vm.entidad = {};
      vm.documentos = [{ iddocumento: 1, abreviatura: 'DNI' }, { iddocumento: 3, abreviatura: 'CARNET EXT.' }, { iddocumento: 4, abreviatura: 'PASAPORTE Y OTROS' }];
      vm.requiredNombre=true;
    //   var param = $stateParams.param;
    //   var cadena = param.split(",");

   
    var digitostd = [8,10, 12, 11]; //DNI, C.Extranj, Pasaporte, Ruc.

      vm.getDocumento = function() {
      vm.requiredNombre=true;

        if (digitostd.indexOf(vm.entidad.numerodoc.length) !== -1) {
          var param = {
            iddocumento: vm.entidad.iddocumento,
            numerodoc: vm.entidad.numerodoc
          };
          vm.spinerLoading=true;

          entidadService.PacienteNrodocumento(param).then(function (data) {            
            vm.spinerLoading=false;
            vm.requiredNombre = false;

            if (data.type === 'success') {
              vm.entidad = data.data;
              // vm.others = data.others;
      
              if (data.data.fechanacimiento) {
                vm.entidad.fechanacimiento = convertDate(data.data.fechanacimiento);
              }
              vm.entidad.idusuarioafectado = 0;
      
      
            } else {
              vm.entidad.apellidopat = null;
              vm.entidad.apellidomat = null;
              vm.entidad.nombre = null;
              vm.entidad.email = null;

              vm.requiredNombre=true;

            }
          });
        }
      }
      vm.saveLibroReclamo = function () {
   
        // var fechanacimiento = null;
  
        // if (vm.entidad.iddocumento === 1 && vm.entidad.numerodoc.length !== 8) {//DNI 
        //   // Notification.warning({ message: 'DNI debe ser 8 números' });
        //   Notification.error({ title: 'Oh..!', message: 'DNI debe ser 8 números', templateUrl: 'angular-ui-notification-intranet-error.html' });
        //   $scope.miForm.$submitted = false;
        //   return false;
        // }
  
        if (vm.entidad.fecha_reclamo) {
          vm.entidad.fechanacimiento = $filter('date')(vm.entidad.fechanacimiento, "dd/MM/yyyy");
          vm.entidad.fecha_reclamo = $filter('date')(vm.entidad.fecha_reclamo, "dd/MM/yyyy"); 
        }
        
        if(vm.entidad.idusuarioafectado != 1){
          vm.entidad.fechanacimiento_afect = $filter('date')(vm.entidad.fechanacimiento_afect, "dd/MM/yyyy"); 

        }

        if (!vm.entidad.autorizacion) {
          Notification.error({ title: 'Oh..!', message: 'MARCAR AUTORIZACIÓN LA NOTIFICACIÓN DE RESULTADO DE RECLAMO A E-MAIL', templateUrl: 'angular-ui-notification-intranet-error.html' });
          $scope.miForm.$submitted = false;
          return false;
        }

        var OBJentidad=[]
        OBJentidad=vm.entidad;
        
  
        vm.spinerLoading = true;
     
        entidadService.SaveLibroQuejas(OBJentidad).then(function (data) {
          if (data.type === 'success') {
            Notification.primary({ message: '¡Se ha <strong>registrados exitosamente</strong>!', templateUrl: 'angular-ui-notification-intranet-primary.html' });
            vm.spinerLoading = false;
            $scope.miForm.$submitted = false;
            setTimeout('window.location.reload();', 2000);
          } else {
            vm.spinerLoading = false;
            $scope.miForm.$submitted = false;
            Notification.error({ title: 'Oh..!', message: data.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
          }
        });
      }
  
      entidadService.InformacionFormularioQuejas().then(function (entidades) {
        vm.spinerLoading=false;

        vm.others = entidades.others; 
        vm.entidad.pais="PE";

        vm.entidad.iddocumento = 1;
        }); 

        vm.changeUbigeo = function (ubigeo, to,estado) {
 
         

          if(estado == "afectado"){

            if (ubigeo.pais === '' || ubigeo.dpto_afect === '' || ubigeo.prov_afect === '') {
              vm.others[to] = [];
              return false;
            }

            if (to === 'dpto_afect') {
              vm.entidad.dpto_afect = ''; //Por default '- Provincia -'
              vm.others.provincias = []; //Limpiar distritos
            }
            if (to === 'prov_afect') {
                vm.entidad.prov_afect = ''; //Por default '- Provincia -'
                vm.others.dist_afect = []; //Limpiar distritos
            }
            if (to === 'distritos') {
                vm.entidad.dist_afect = ''; //Por default '- Distrito -' 
            }
            vm.spinerLoading = true;

            entidadService.GetIndexUbigeo(ubigeo).then(function (result) {
                vm.others[to] = result.data;
                vm.spinerLoading=false;
            });

          }else{
            if (ubigeo.pais === '' || ubigeo.dpto === '' || ubigeo.prov === '') {
              vm.others[to] = [];
              return false;
            }

            if (to === 'departamentos') {
              vm.entidad.dpto = ''; //Por default '- Provincia -'
              vm.others.provincias = []; //Limpiar distritos
            }
            if (to === 'provincias') {
                vm.entidad.prov = ''; //Por default '- Provincia -'
                vm.others.distritos = []; //Limpiar distritos
            }
            if (to === 'distritos') {
                vm.entidad.dist = ''; //Por default '- Distrito -' 
            }
            vm.spinerLoading = true;

            entidadService.GetIndexUbigeo(ubigeo).then(function (result) {
                vm.others[to] = result.data;
                vm.spinerLoading=false;
            });
          } 
        };
  
       
    }
  
  })();
  
(function () {
    'use strict';

    angular
        .module('minotaur')
        .controller('SigninCtrl', SigninCtrl);

    /** @ngInject */
    function SigninCtrl($scope, $state, AuthenticationService, Notification) {

        var vm = this;
        vm.login = login;

        vm.submitlogin = 'Entrar';
        // vm.username = '1';
        // vm.password = '2';
        vm.documentos = [{ iddocumento: 1, abreviatura: 'DNI' }, { iddocumento: 3, abreviatura: 'CARNET EXT.' }, { iddocumento: 4, abreviatura: 'PASAPORTE Y OTROS' }];
        vm.iddocumento = 1;

        function login() {
 
            if (typeof vm.username === 'undefined') {
                Notification.warning({ message: 'Ingrese N° documento' });
                $scope.miForm.$submitted = false;
                return false;
            }

            if (vm.iddocumento === 1 && vm.username.length !== 8) {//DNI 
                Notification.warning({ message: 'DNI debe ser 8 números' });
                $scope.miForm.$submitted = false;
                return false;
            }

            var navegador = navigator.userAgent;
            vm.submitlogin = 'Ingresando...';

            var username = vm.username;
            var password = vm.password;

            var objeto = {
                iddocumento: vm.iddocumento,
                username: username,
                password: password,
                navegador: navegador
            };

            AuthenticationService.Login(objeto).then(function (array) {
                if (array.type === 'success') {
                    AuthenticationService.SetCredentials(array.data);
                    $state.go("mireserva");
                } else {
                    vm.error = array.data;
                    vm.submitlogin = 'Entrar';
                    $scope.miForm.$submitted = false;
                }
            });
        }

    }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('slimscroll', slimscroll);

  /** @ngInject */
  function slimscroll() {
    var directive = {
      restrict: 'A',
      link: function ($scope, $elem, $attr) {
        var off = [];
        var option = {};

        var refresh = function () {
          if ($attr.slimscroll) {
            option = $scope.$eval($attr.slimscroll);
          } else if ($attr.slimscrollOption) {
            option = $scope.$eval($attr.slimscrollOption);
          }

          angular.element($elem).slimScroll({ destroy: true });

          angular.element($elem).slimScroll(option);
        };

        var registerWatch = function () {
          if ($attr.slimscroll && !option.noWatch) {
            off.push($scope.$watchCollection($attr.slimscroll, refresh));
          }

          if ($attr.slimscrollWatch) {
            off.push($scope.$watchCollection($attr.slimscrollWatch, refresh));
          }

          if ($attr.slimscrolllistento) {
            off.push($scope.$on($attr.slimscrolllistento, refresh));
          }
        };

        var destructor = function () {
          angular.element($elem).slimScroll({ destroy: true });
          off.forEach(function (unbind) {
            unbind();
          });
          off = null;
        };

        off.push($scope.$on('$destroy', destructor));

        registerWatch();
      }
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('pdf', pdf);
  
  /** @ngInject */
  pdf.$inject = ['$http'];
  function pdf($http) {
    var directive = {
      restrict: 'E',
      link: function(scope, element, attrs) {
        var url = scope.$eval(attrs.src);
        element.replaceWith('<object type="application/pdf" data="' + url + '" width="100%" height="600"></object>');
    }
    };

    return directive; 
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('nativeTabs', nativeTabs);

  /** @ngInject */
  function nativeTabs() {
    var directive = {
      restrict: 'EA',
      link: function(scope, element){
        var $element = angular.element(element);
        $element.on('click', function(e) {
          e.preventDefault();
          $element.tab('show');
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('minotaurLoading', minotaurLoading);

  /** @ngInject */
  function minotaurLoading($window, $timeout, cfpLoadingBar) {
    var directive = {
      restrict: 'E',
      controller: MinotaurLoadingController,
      controllerAs: 'loading',
      bindToController: true,
      link: function (scope, element) {
        if (!element.hasClass('hide')){
          element.addClass('animate');
        }
        scope.$on('$stateChangeStart', function(event, toState) {
          if (element.hasClass('hide') && toState.specialClass === 'core'){
            element.removeClass('hide');
          }
          cfpLoadingBar.start();
        });
        scope.$on('$stateChangeSuccess', function (event) {
          event.targetScope.$watch('$viewContentLoaded', function () {
            $timeout(function () {
              cfpLoadingBar.complete();
              element.addClass('hide');
            }, 1000);
          });
        });
      }
    };

    return directive;

    /** @ngInject */
    function MinotaurLoadingController() {

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('keypressEscape', keypressEscape);

  /** @ngInject */
  function keypressEscape() {
    var ESCAPE_KEY = 27;

    var directive = {
      restrict: 'A',
      link: function postLink(scope, element, attrs) {
        element.bind('keydown', function (event) {
          if (event.keyCode === ESCAPE_KEY) {
            scope.$apply(attrs.keypressEscape);
          }
        });
      }
    };

    return directive;

  }

})();

(function () {
  'use strict';

  angular
    .module('minotaur')
    .directive('inputMask', inputMask)
    .directive('myCurrentTime', myCurrentTime);

  /** @ngInject */
  function inputMask() {
    var directive = {
      restrict: 'A',
      scope: true,
      link: function (scope, element, attrs) {
        var options;
        if (attrs.inputMask) {
          options = scope.$eval(attrs.inputMask);
        } else if (attrs.maskOptions) {
          options = scope.$eval(attrs.maskOptions);
        }
        angular.element(element).inputmask(options);
      }
    };
    console.log('llamada a directiva');
    return directive;
  }


  function myCurrentTime($interval, dateFilter) {
    // https://docs.angularjs.org/api/ng/service/$interval
    // return the directive link function. (compile function not needed)
    return function (scope, element, attrs) {
      var format,  // date format
        stopTime, // so that we can cancel the time updates
        init;
      // used to update the UI
      function updateTime() { 
        init += 1000;
        element.text(dateFilter(init, format));         
      }
 
      // watch the expression, and update the UI on change.
      scope.$watch(attrs.myCurrentTime, function (value) {  
        format = 'h:mm:ss';  
        init = value; 
        updateTime();
      });

      stopTime = $interval(updateTime, 1000);

      // listen on DOM destroy (removal) event, and cancel the next UI update
      // to prevent updating time after the DOM element was removed.
      element.on('$destroy', function () {
        $interval.cancel(stopTime);
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('ifLoading', ifLoading);
  
  /** @ngInject */
  ifLoading.$inject = ['$http'];
  function ifLoading($http) { 

    var directive = {
      restrict: 'A',
      link: function postLink(scope, elem) {
        scope.isLoading = isLoading; 
        scope.$watch(scope.isLoading, toggleElement); 
        function toggleElement(loading) {
          if (loading) {
            elem.show();
          } else {
            elem.hide();
          }
        }

        function isLoading() {
          return $http.pendingRequests.length > 0;
        }
      }
    };

    return directive; 
  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('fileReader', fileReader);

  /** @ngInject */
  function fileReader() {
    var directive = {
      scope: {
        fileReader:"="
      }, 
      link: function(scope, el) {
        el.on('change', function(changeEvent) {
          var files = changeEvent.target.files;
          if (files.length) {
            var r = new FileReader();  
            r.onload = function(e) {
                var contents = e.target.result;
                scope.$apply(function () { 
                  var matriz = []; 
                  var array = contents.split("\r\n");  
                  array.forEach(function(element, i) {
                    if (element.length > 0 && i > 0) {
                      var row = element.split(";"); 
                      matriz.push({
                        Fecha: row[0],
                        Grupo_Timbrado: row[3],
                        Anexo: row[5],
                        Origen: row[2],
                        Tipo: row[1],
                        Destino: row[4],
                        Desvio: row[6],
                        Estado: row[7],
                        Duraci_n: row[8],
                        Costo_Minuto: row[9],
                        Costo_Bolsa: row[10],
                        Costo_Total: row[11]
                      });
                    } 
                  });
                  scope.fileReader = matriz;
                });
            };
            
            r.readAsText(files[0]);
          }
        });
      }
    };

    return directive;

  }

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .directive('anchorScroll', anchorScroll);

  /** @ngInject */
  function anchorScroll($location, $anchorScroll) {
    var directive = {
      restrict: 'AC',
      link: function(scope, el, attr) {
        el.on('click', function() {
          $location.hash(attr.anchorScroll);
          $anchorScroll();
        });
      }
    };

    return directive;

  }

})();

(function () {
    'use strict';

    angular
        .module('minotaur')
        .factory('ventaService', ventaService);

    ventaService.$inject = ['$http', '$rootScope', '$cookies', 'settings', 'Notification'];
    function ventaService($http, $rootScope, $cookies, settings, Notification) {
        var service = {};

        service.GetIndex = GetIndex;       
        service.GetMisordenes = GetMisordenes;       
        return service;

        //Grid
        function GetIndex(request) {
            return $http.get($rootScope.servidor + '/venta', { params: request }).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());
        } 

        function GetMisordenes(request) {
            return $http.get($rootScope.servidor + '/venta/misordenescliente', { params: request }).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());
        } 

        // private functions
        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }

        function verificarToken() {
            return $http.get($rootScope.servidor + '/verify')
                        .then(function (result) {
                            if (result.data.code === 400) {
                                var mensaje = result.data.tokenstatus.mensaje;
                                if (mensaje === "Token invalid") {
                                    Notification.error({ message: 'Usted, accedió desde otro dispositivo' });
                                }
                                if (mensaje === "Token not found") {
                                    Notification.error({ message: 'Su sessión ha sido eliminado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token expired") {
                                    Notification.error({ message: 'Su sessión se ha expirado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token error") {
                                    Notification.error({ message: 'Hay un error con su sessión, por favor acceda nuevamente' });
                                }
                                $cookies.remove('token'); 
                                $cookies.remove('GLOBALidsede');
                                window.location = settings.baseURL + '/#/login/';
                            }
                        })
                        .catch(function(e) {
                            $cookies.remove('token'); 
                            $cookies.remove('GLOBALidsede');
                            Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                            window.location = settings.baseURL + '/#/login/';
                        });
        }
    }
})();

(function () {
    'use strict';
    
    angular
            .module('minotaur')
            .factory('ubigeoService', ubigeoService);

    ubigeoService.$inject = ['$http', '$rootScope', '$cookies', 'settings', 'Notification'];     
    function ubigeoService($http, $rootScope, $cookies, settings, Notification) {
        var service = {}; 
        
        service.GetIndex = GetIndex;  
        
        return service;  
        //Grid
        function GetIndex(request) {  
            return $http.get($rootScope.servidor + '/ubigeo', {params: request}).then(handleSuccess, handleError('Error al consultar entidad'));             
        }
        
        // private functions
        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return {success: false, message: error};
            };
        }

        function verificarToken() {
            return $http.get($rootScope.servidor + '/verify')
                        .then(function (result) {
                            if (result.data.code === 400) {
                                var mensaje = result.data.tokenstatus.mensaje;
                                if (mensaje === "Token invalid") {
                                    Notification.error({ message: 'Usted, accedió desde otro dispositivo' });
                                }
                                if (mensaje === "Token not found") {
                                    Notification.error({ message: 'Su sessión ha sido eliminado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token expired") {
                                    Notification.error({ message: 'Su sessión se ha expirado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token error") {
                                    Notification.error({ message: 'Hay un error con su sessión, por favor acceda nuevamente' });
                                }
                                $cookies.remove('token'); 
                                $cookies.remove('GLOBALidsede');
                                window.location = settings.baseURL + '/#/login/';
                            }
                        })
                        .catch(function(e) {
                            $cookies.remove('token'); 
                            $cookies.remove('GLOBALidsede');
                            Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                            window.location = settings.baseURL + '/#/login/';
                        });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('minotaur')
        .factory('sedeService', sedeService);

    sedeService.$inject = ['$http', '$rootScope', '$cookies', 'settings', 'Notification'];

    function sedeService($http, $rootScope, $cookies, settings, Notification) {
        var service = {};

        service.GetIndex = GetIndex;
        service.GetShow = GetShow;
        service.GetSedes = GetSedes;
        service.Create = Create;
        service.Update = Update;
        service.Delete = Delete;
        service.GetAfiliado = GetAfiliado;
        service.CreateCIP = CreateCIP;
        service.GetHorariosDisponibles = GetHorariosDisponibles;

        return service;

        // Grid
        function GetIndex(request) {
            return $http.get($rootScope.servidor + '/sede', { params: request }).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());
        }

        // Grid
        function GetSedes() {
            return $http.get($rootScope.servidor + '/sede/autorizadas').then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());
        }

        // Visualizar un registro
        function GetShow(id) {
            return $http.get($rootScope.servidor + '/sede/' + id).then(handleSuccess, handleError('Error getting all promocion'), verificarToken());
        }

        // Grabar
        function Create(sede) {
            return $http.post($rootScope.servidor + '/sede', sede).then(handleSuccess, handleError('Error creating entidad'), verificarToken());
        }

        // Actualizar
        function Update(Objeto) {
            return $http.post($rootScope.servidor + '/sede/' + Objeto.sede.idsede, Objeto).then(handleSuccess, handleError('Error updating entidad'), verificarToken());
        }

        function GetAfiliado(Objeto) {
            return $http.get($rootScope.servidor + '/sede/afiliado/' + Objeto.idsede, { params: Objeto }).then(handleSuccess, handleError('Error updating entidad'), verificarToken());
        }

        // Eliminar
        function Delete(id) {
            return $http.post($rootScope.servidor + '/sede/delete/' + id).then(handleSuccess, handleError('Error deleting user'), verificarToken());
        }

        function CreateCIP(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/ventacip', OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function GetHorariosDisponibles(request) {
            return $http.get($rootScope.servidor + '/sede/horarios/disponibilidadv2', { params: request }).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());
        }

        // private functions
        function handleSuccess(res) {
            return res.data;
        }

        // Error
        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }

        function verificarToken() {
            return $http.get($rootScope.servidor + '/verify')
                .then(function (result) {
                    if (result.data.code === 400) {
                        var mensaje = result.data.tokenstatus.mensaje;
                        if (mensaje === "Token invalid") {
                            Notification.error({ message: 'Usted, accedió desde otro dispositivo' });
                        }
                        if (mensaje === "Token not found") {
                            Notification.error({ message: 'Su sessión ha sido eliminado, por favor acceda nuevamente' });
                        }
                        if (mensaje === "Token expired") {
                            Notification.error({ message: 'Su sessión se ha expirado, por favor acceda nuevamente' });
                        }
                        if (mensaje === "Token error") {
                            Notification.error({ message: 'Hay un error con su sessión, por favor acceda nuevamente' });
                        }
                        $cookies.remove('token');
                        $cookies.remove('GLOBALidsede');
                        window.location = settings.baseURL + '/#/login/';
                    }
                })
                .catch(function (e) {
                    $cookies.remove('token');
                    $cookies.remove('GLOBALidsede');
                    Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                    window.location = settings.baseURL + '/#/login/';
                });
        }
    }
})();
(function () {
    'use strict';
    
    angular
            .module('minotaur')
            .factory('preguntasService', preguntasService);

    preguntasService.$inject = ['$http', '$rootScope', '$cookies', 'settings', 'Notification'];     
    function preguntasService($http, $rootScope, $cookies, settings, Notification) {
        var service = {}; 

        function handleSuccess(res) {
            return res.data;
        }
        
        service.GetConstruct = GetConstruct;
        service.GetIndex = GetIndex;  

        return service; 
        
        function GetConstruct(request) {  
            return $http.get($rootScope.servidor + '/preguntas/construct', {params: request}).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());             
        }
        
        //Grid
        function GetIndex() {  
            return $http.get($rootScope.servidor + '/preguntas').then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());             
        }
        
        function handleSuccess(res) {            
            return res.data;
        }

        function handleError(error) {
            return function () {
                return {success: false, message: error};
            };
        }

        function verificarToken() {
            return $http.get($rootScope.servidor + '/verify')
                        .then(function (result) {
                            if (result.data.code === 400) {
                                var mensaje = result.data.tokenstatus.mensaje;
                                if (mensaje === "Token invalid") {
                                    Notification.error({ message: 'Usted, accedió desde otro dispositivo' });
                                }
                                if (mensaje === "Token not found") {
                                    Notification.error({ message: 'Su sessión ha sido eliminado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token expired") {
                                    Notification.error({ message: 'Su sessión se ha expirado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token error") {
                                    Notification.error({ message: 'Hay un error con su sessión, por favor acceda nuevamente' });
                                }
                                $cookies.remove('token'); 
                                $cookies.remove('GLOBALidsede');
                                window.location = settings.baseURL + '/#/login/';
                            }
                        })
                        .catch(function(e) {
                            $cookies.remove('token'); 
                            $cookies.remove('GLOBALidsede');
                            Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                            window.location = settings.baseURL + '/#/login/';
                        });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('minotaur')
        .factory('ositedsService', ositedsService);

    ositedsService.$inject = ['$http', '$rootScope', '$cookies', 'settings', 'Notification'];
    function ositedsService($http, $rootScope, $cookies, settings, Notification) {
        var service = {}; 
        
        service.GetCodigoAfiliadoSiteds     = GetCodigoAfiliadoSiteds; 
        service.GetDetalleAseguradoSiteds   = GetDetalleAseguradoSiteds;
        service.GetAutorizacionConsulta     = GetAutorizacionConsulta; 
        service.GetRestricciones            = GetRestricciones;        
        service.GetDatosAdicionales         = GetDatosAdicionales;
        service.GetConsultarObservaciones   = GetConsultarObservaciones;
        service.GetCondicionesMedicas       = GetCondicionesMedicas;
        service.GetSedesDeIpress            = GetSedesDeIpress;
        service.GetIafasOsiteds             = GetIafasOsiteds;
        service.GetEntidadVinculada         = GetEntidadVinculada;
        service.GetConsultaCartaDeGarantia  = GetConsultaCartaDeGarantia;
        service.GetConsultaSCTR             = GetConsultaSCTR;
        service.GetConsultaAfiliadosAus     = GetConsultaAfiliadosAus;
        service.GetSincronizarCatalogos     = GetSincronizarCatalogos;
        service.GetProductosDeIafa          = GetProductosDeIafa;
        
        return service;
        
        function GetCodigoAfiliadoSiteds(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-getconsulta-asegnom', { params: request })
                .then(handleSuccess, handleError('Error al obtener SITEDS'), verificarToken());
        }

        function GetDetalleAseguradoSiteds(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-getconsulta-asegcod', { params: request })
                .then(handleSuccess, handleError('Error al obtener el detalle del asegurado'), verificarToken());
        }

        function GetAutorizacionConsulta(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-get-autorizacion-consulta', { params: request })
                .then(handleSuccess, handleError('Error al obtener la autorización de consulta'), verificarToken());
        }

        function GetRestricciones(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-get-restriccion', { params: request })
                .then(handleSuccess, handleError('Error al obtener la restricción del asegurado'), verificarToken());
        }

        function GetDatosAdicionales(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-obtener-datos-adicionales', { params: request })
                .then(handleSuccess, handleError('Error al obtener los datos adicionales del asegurado'), verificarToken());
        }

        function GetConsultarObservaciones(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-consultar-observaciones', {params: request})
                .then(handleSuccess, handleError('Error al obtener las observaciones del asegurado'), verificarToken()) ;
        }        

        function GetCondicionesMedicas(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-consultar-condiciones-medicas', {params: request})
                .then(handleSuccess, handleError('Error al obtener las condiciones médicas'), verificarToken()) ;
        }        
        
        function GetSedesDeIpress(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-obtener-sedes-ipress-osi', {params: request})
                .then(handleSuccess, handleError('Error al obtener las sedes de ipress'), verificarToken()) ;
        }

        function GetProductosDeIafa(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-obtener-productos', {params: request})
                .then(handleSuccess, handleError('Error al obtener productos de iafa'), verificarToken()) ;
        }

        function GetIafasOsiteds(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-obtener-iafas-asociadas-appsiteds', {params: request})
                .then(handleSuccess, handleError('Error al obtener las sedes de ipress'), verificarToken()) ;
        }        
        
        function GetEntidadVinculada(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-getconsulta-entvinculada', {params: request})
                .then(handleSuccess, handleError('Error al obtener entidad vinculada'), verificarToken()) ;
        }

        function GetConsultaCartaDeGarantia(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-consultar-carta-garantia', { params: request })
                .then(handleSuccess, handleError('Error al obtener SITEDS'), verificarToken());
        }

        function GetConsultaSCTR(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-consulta-declaracion-accidentes', { params: request })
                .then(handleSuccess, handleError('Error al obtener declaración de accidentes'), verificarToken());
        }

        function GetConsultaAfiliadosAus(request) {
            // $rootScope.servidorOsiteds 
            return $http.get($rootScope.servidorOsiteds + '/api/siteds-consulta-afiliados', { params: request })
                .then(handleSuccess, handleError('Error al obtener SITEDS'), verificarToken());
        }

        function GetSincronizarCatalogos(request) {
            return $http.get($rootScope.servidorOsiteds + '/api/mq-sincronizacioncatalogos')
                .then(handleSuccess, handleError('Error al obtener SITEDS'), verificarToken());
        }

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }

        function verificarToken() {
            return $http.get($rootScope.servidor + '/verify')
                        .then(function (result) {
                            if (result.data.code === 400) {
                                var mensaje = result.data.tokenstatus.mensaje;
                                if (mensaje === "Token invalid") {
                                    Notification.error({ message: 'Usted, accedió desde otro dispositivo' });
                                }
                                if (mensaje === "Token not found") {
                                    Notification.error({ message: 'Su sessión ha sido eliminado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token expired") {
                                    Notification.error({ message: 'Su sessión se ha expirado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token error") {
                                    Notification.error({ message: 'Hay un error con su sessión, por favor acceda nuevamente' });
                                }
                                $cookies.remove('token'); 
                                $cookies.remove('GLOBALidsede');
                                window.location = settings.baseURL + '/#/login/';
                            }
                        })
                        .catch(function(e) {
                            $cookies.remove('token'); 
                            $cookies.remove('GLOBALidsede');
                            Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                            window.location = settings.baseURL + '/#/login/';
                        });
        }
    }
})();

(function () {
    'use strict';
    
    angular
            .module('minotaur')
            .factory('entidadService', entidadService);

    entidadService.$inject = ['$http', '$rootScope', '$cookies', 'settings', 'Notification'];     
    function entidadService($http, $rootScope, $cookies, settings, Notification) {
        var service = {}; 
        
        service.GetConstruct = GetConstruct;
        service.GetIndex = GetIndex;  
        service.GetCumpleanos = GetCumpleanos; 
        service.GetModulos = GetModulos; 
        service.GetSearch = GetSearch;
        service.GetSearchPaginate = GetSearchPaginate;
        service.GetShow = GetShow; 
        service.GetNew = GetNew;
        service.Create = Create;
        service.CreatePaciente = CreatePaciente;
        service.Recovery = Recovery;        
        service.Update = Update;
        service.Delete = Delete;        
        service.GetNumero = GetNumero;
        service.GetNumeroHc = GetNumeroHc;
        service.UpdateEntidad = UpdateEntidad;
        service.UpdatePassword = UpdatePassword;
        service.UpdateDuplicado = UpdateDuplicado;
        service.UpdateDatosAtencion = UpdateDatosAtencion;
        service.GetProfile = GetProfile;
        service.GenerarHc = GenerarHc;
        service.PacienteToken = PacienteToken;
        service.PacienteNrodocumento = PacienteNrodocumento;
        service.PacienteCitamedica = PacienteCitamedica;
        service.SaveSurvey = SaveSurvey;
        service.SaveLibroQuejas = SaveLibroQuejas;
        service.GetIndexUbigeo = GetIndexUbigeo;
        service.InformacionFormularioQuejas = InformacionFormularioQuejas;

        return service; 
        
        function GetConstruct(request) {  
            return $http.get($rootScope.servidor + '/entidad/construct', {params: request}).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());             
        }
        
        //Grid
        function GetIndex(request) {  
            return $http.get($rootScope.servidor + '/entidad', {params: request}).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());             
        }
        
        //Cumpleaños del dia
        function GetCumpleanos(request) {  
            return $http.get($rootScope.servidor + '/entidad/cumpleanos', {params: request}).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());             
        }
        
        //Modulos del usuario
        function GetModulos(request) {
            return $http.get($rootScope.servidor + '/entidad/modulos', {params: request}).then(handleSuccess, handleError('Error al consultar modulos de entidad'), verificarToken());             
        }
        
        //Autocompletable
        function GetSearch(request) {  
            return $http.get($rootScope.servidor + '/entidad', {params: request});
        }

        function GetSearchPaginate(request) {  
            return $http.get($rootScope.servidor + '/entidad/search', {params: request});
        } 
        
        //Visualizar un registro
        function GetShow(id, request){ 
            return $http.get($rootScope.servidor + '/entidad/' + id, {params: request}).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }
        
        //Visualizar profile
        function GetProfile(id){ 
            return $http.get($rootScope.servidor + '/entidad/profile/' + id).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }
        
        //ConsultarSiExisteNroDocumento
        function GetNumero(request){
            return $http.get($rootScope.servidor + '/entidad/documento/nro', {params: request}).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }
        
        function GetNumeroHc(request){
            return $http.get($rootScope.servidor + '/entidad/documento/nrohc', {params: request}).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }
        
        //Actulizar Entidad Con una nueva entidad
        function UpdateEntidad(entidad){
            return $http.post($rootScope.servidor + '/entidad/subentidad/'+entidad.identidad, entidad).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }
        
        //Actulizar Contrasena Entidad 
        function UpdatePassword(entidad){
            return $http.post($rootScope.servidor + '/entidad/password/'+entidad.identidad, entidad).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }
        
        function GenerarHc(entidad){
            return $http.post($rootScope.servidor + '/entidad/generarhc', entidad).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }
        
        //Nuevo 
        function GetNew(request){
            return $http.get($rootScope.servidor + '/entidad/new', {params: request}).then(handleSuccess, handleError('Error getting all producto'));
        }
        
        //Grabar
        function Create(OBJentidad) {  
            return $http.post($rootScope.servidor + '/entidad', OBJentidad).then(handleSuccess, handleError('Error creating entidad'), verificarToken());
        }

        function CreatePaciente(OBJentidad) {  
            return $http.post($rootScope.servidor + '/entidad/paciente', OBJentidad).then(handleSuccess, handleError('Error creating entidad'));
        }

        function Recovery(OBJentidad) {  
            return $http.post($rootScope.servidor + '/entidad/recovery', OBJentidad).then(handleSuccess, handleError('Error creating entidad'), verificarToken());
        }

        function PacienteToken(tokenconfirm, request) {
            return $http.post($rootScope.servidor + '/entidad/confirm/'+ tokenconfirm, request).then(handleSuccess, handleError('Error creating entidad'), verificarToken());
        }

        function PacienteNrodocumento(request) {
            return $http.post($rootScope.servidor + '/entidad/nrodocumento/'+ request.identidad, request).then(handleSuccess, handleError('Error creating entidad'));
        }

        function PacienteCitamedica(request) {
            return $http.post($rootScope.servidor + '/entidad/survey/'+ request.identidad, request).then(handleSuccess, handleError('Error creating entidad'));
        }

         //Guardar encuesta
         function SaveSurvey(OBJsurvey) {    
            return $http.post($rootScope.servidor + '/entidad/datosencuesta/' + OBJsurvey.identidad, OBJsurvey).then(handleSuccess, handleError('Error updating citamedica'), verificarToken());
        }
        
        //Actualizar
        function Update(OBJentidad) {    
            return $http.post($rootScope.servidor + '/entidad/' + OBJentidad.entidad.identidad, OBJentidad).then(handleSuccess, handleError('Error updating entidad'), verificarToken());
        }


        //Actualizar 
        function UpdateDuplicado(entidad){
            return $http.post($rootScope.servidor + '/entidad/unirduplicados', entidad).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }

        //Actualizar
        function UpdateDatosAtencion(OBJentidad) {    
            return $http.post($rootScope.servidor + '/entidad/datosatencion/' + OBJentidad.identidad, OBJentidad).then(handleSuccess, handleError('Error updating entidad'), verificarToken());
        }
        
        //Eliminar
        function Delete(id, request) {
            return $http.post($rootScope.servidor + '/entidad/delete/' + id,  request).then(handleSuccess, handleError('Error deleting user'), verificarToken());
        }

        function GetIndexUbigeo(request) {  
            return $http.get($rootScope.servidor + '/ubigeoindexInformacion', {params: request}).then(handleSuccess, handleError('Error al consultar entidad'));             
        }
        
        function InformacionFormularioQuejas() {
            return $http.post($rootScope.servidor + '/entidad/InformacionFormularioQuejas').then(handleSuccess, handleError('Error deleting user'));
        }

        function SaveLibroQuejas(OBJentidad) {
            return $http.post($rootScope.servidor + '/entidad/SaveLibroQuejas',OBJentidad).then(handleSuccess, handleError('Error deleting user'));
        }
        
        // private functions
        function handleSuccess(res) {            
            return res.data;
        }

        function handleError(error) {
            return function () {
                return {success: false, message: error};
            };
        }

        function verificarToken() {
            return $http.get($rootScope.servidor + '/verify')
                        .then(function (result) {
                            if (result.data.code === 400) {
                                var mensaje = result.data.tokenstatus.mensaje;
                                if (mensaje === "Token invalid") {
                                    Notification.error({ message: 'Usted, accedió desde otro dispositivo' });
                                }
                                if (mensaje === "Token not found") {
                                    Notification.error({ message: 'Su sessión ha sido eliminado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token expired") {
                                    Notification.error({ message: 'Su sessión se ha expirado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token error") {
                                    Notification.error({ message: 'Hay un error con su sessión, por favor acceda nuevamente' });
                                }
                                $cookies.remove('token'); 
                                $cookies.remove('GLOBALidsede');
                                window.location = settings.baseURL + '/#/login/';
                            }
                        })
                        .catch(function(e) {
                            $cookies.remove('token'); 
                            $cookies.remove('GLOBALidsede');
                            Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                            window.location = settings.baseURL + '/#/login/';
                        });
        }
    }
})();

(function () {
    'use strict';
    
    angular
            .module('minotaur')
            .factory('enterpriseService', enterpriseService);

    enterpriseService.$inject = ['$http', '$rootScope', '$cookies', 'settings', 'Notification'];     
    function enterpriseService($http, $rootScope, $cookies, settings, Notification) { 
        var service = {}; 
           
        service.Uploadtmp = Uploadtmp;
        service.UploadtmpFile = UploadtmpFile;
        
        
        return service;  

        function Uploadtmp(file, directorio) { 
            
            var fd = new FormData();
            fd.append('file', file); //Agregamos data al "formulario" que vamos a enviar 
            
            if (directorio) {
                fd.append('directorio', directorio); //Directorio donse se guarda la imagen
            }

            return $http.post($rootScope.servidor + '/empresa/uploadtmp', fd, {
                    transformRequest: angular.identity, //Le decimos a angular que no serialize el envio
                    headers: {'Content-Type': undefined}
                })
                .then(uploadComplete)
                .catch(uploadFailed);

            function uploadComplete(response) {
                return response.data;
            }

            function uploadFailed(error) { 
            }
        }

        function UploadtmpFile(file, directorio) { 
            
            var fd = new FormData();
            fd.append('file', file); //Agregamos data al "formulario" que vamos a enviar 
            
            if (directorio) {
                fd.append('directorio', directorio); //Directorio donse se guarda la imagen
            }

            return $http.post($rootScope.servidor + '/empresa/uploadtmpfile', fd, {
                    transformRequest: angular.identity, //Le decimos a angular que no serialize el envio
                    headers: {'Content-Type': undefined}
                })
                .then(uploadComplete)
                .catch(uploadFailed);

            function uploadComplete(response) {
                return response.data;
            }

            function uploadFailed(error) { 
            }
        }
        
        // private functions
        function handleSuccess(res) { 
            return res.data;
        }

        function handleError(error) {             
            return error; 
        }

        function verificarToken() {
            return $http.get($rootScope.servidor + '/verify')
                        .then(function (result) {
                            if (result.data.code === 400) {
                                var mensaje = result.data.tokenstatus.mensaje;
                                if (mensaje === "Token invalid") {
                                    Notification.error({ message: 'Usted, accedió desde otro dispositivo' });
                                }
                                if (mensaje === "Token not found") {
                                    Notification.error({ message: 'Su sessión ha sido eliminado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token expired") {
                                    Notification.error({ message: 'Su sessión se ha expirado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token error") {
                                    Notification.error({ message: 'Hay un error con su sessión, por favor acceda nuevamente' });
                                }
                                $cookies.remove('token'); 
                                $cookies.remove('GLOBALidsede');
                                window.location = settings.baseURL + '/#/login/';
                            }
                        })
                        .catch(function(e) {
                            $cookies.remove('token'); 
                            $cookies.remove('GLOBALidsede');
                            Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                            window.location = settings.baseURL + '/#/login/';
                        });
        }
    }
})();

(function () {
    'use strict';
    
    angular
            .module('minotaur')
            .factory('citaterapeuticaService', citaterapeuticaService);

    citaterapeuticaService.$inject = ['$http', '$rootScope', 'Notification', '$cookies', 'settings'];
    function citaterapeuticaService($http, $rootScope, Notification, $cookies, settings) {
        var service = {};
        
        service.GetConstruct = GetConstruct;
        service.GetIndex = GetIndex;
        service.GetIndexReservas = GetIndexReservas;
        service.GetIndexTurnos = GetIndexTurnos;
        service.GetAgenda = GetAgenda;
        service.GetShow = GetShow;
        service.GetLog = GetLog;
        service.GetShowConsulta = GetShowConsulta;
        service.GethorasDisponibles = GethorasDisponibles;
        service.GetterapistasDisponibles = GetterapistasDisponibles;
        service.GetterapistasDisponiblesPostCovid = GetterapistasDisponiblesPostCovid;        
        service.GetAseguradorasPaciente = GetAseguradorasPaciente;
        service.GetNew = GetNew;
        service.Create = Create;
        service.CreateMasivo = CreateMasivo;
        service.CreateProgramacion = CreateProgramacion;
        service.ReasignarProgramacion = ReasignarProgramacion;
        service.DeleteProgramacion = DeleteProgramacion;
        service.DeleteReservacion = DeleteReservacion;
        service.ReprogramarReservacion = ReprogramarReservacion;
        service.CopiarProgramacion = CopiarProgramacion;
        service.Calificacion = Calificacion;
        service.Update = Update;
        service.Delete = Delete;
        service.Terapiaentrevista=Terapiaentrevista;
        service.SaveEncuestaTerapia=SaveEncuestaTerapia;
        return service;
        
        function GetConstruct(request) {  
            return $http.get($rootScope.servidor + '/citaterapeutica/construct', {params: request}).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());             
        } 
        
        //Grid
        function GetIndex(request) {  
            return $http.get($rootScope.servidor + '/citaterapeutica', {params: request}).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());             
        }

        function GetIndexReservas(request) {
            return $http.get($rootScope.servidor + '/citaterapeutica/reservas', {params: request}).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());             
        }
 
        function GetIndexTurnos(request) {
            return $http.get($rootScope.servidor + '/citaterapeutica/turnos', {params: request}).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }
        
        function GetAgenda(request) {  
            return $http.get($rootScope.servidor + '/citaterapeutica/agenda', {params: request}).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());             
        }

           //Guardar encuesta
        function SaveEncuestaTerapia(OBJsurvey) {    
            return $http.post($rootScope.servidor + '/citaterapeutica/datosencuesta/' + OBJsurvey.identidad, OBJsurvey).then(handleSuccess, handleError('Error updating citamedica'), verificarToken());
        }

        function GetAseguradorasPaciente(request) {  
            return $http.get($rootScope.servidor + '/citaterapeutica/aseguradoraspaciente', {params: request}).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());             
        }
         
        function Terapiaentrevista(request) {
            return $http.post($rootScope.servidor + '/citaterapeutica/terapiaentrevista/'+ request.identidad, request).then(handleSuccess, handleError('Error creating entidad'));
        }

        //Visualizar un registro
        function GetShow(id, request){ 
            return $http.get($rootScope.servidor + '/citaterapeutica/' + id, {params: request}).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }
        
        function GetShowConsulta(id){
            return $http.get($rootScope.servidor + '/citaterapeutica/consulta/' + id).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }
        
        function GethorasDisponibles(request) {
            return $http.get($rootScope.servidor + '/citaterapeutica/horario/disponibilidad', {params: request}).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());             
        }
        
        function GetterapistasDisponibles(request) {
            return $http.get($rootScope.servidor + '/citaterapeutica/terapista/disponibilidad', {params: request}).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());             
        }

        function GetterapistasDisponiblesPostCovid(request) {
            return $http.get($rootScope.servidor + '/citaterapeutica/terapista/disponibilidad/postcovid', {params: request}).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());             
        }
        
        function GetLog(id){ 
            return $http.get($rootScope.servidor + '/citaterapeutica/log/' + id).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }

        function CreateProgramacion(OBJprogramacion) { 
            return $http.post($rootScope.servidor + '/citaterapeutica/programacion', OBJprogramacion).then(handleSuccess, handleError('Error creating citamedica'), verificarToken());
        }

        function DeleteProgramacion(OBJprogramacion) { 
            return $http.post($rootScope.servidor + '/citaterapeutica/programacion/delete', OBJprogramacion).then(handleSuccess, handleError('Error creating citamedica'), verificarToken());
        }

        function ReasignarProgramacion(OBJprogramacion) {
            return $http.post($rootScope.servidor + '/citaterapeutica/programacion/reasignacion', OBJprogramacion).then(handleSuccess, handleError('Error creating citamedica'), verificarToken());
        }

        function CopiarProgramacion(OBJprogramacion) {
            return $http.post($rootScope.servidor + '/citaterapeutica/programacion/copiar', OBJprogramacion).then(handleSuccess, handleError('Error creating citamedica'), verificarToken());
        }

        function Calificacion(id, Objeto) {
            return $http.post($rootScope.servidor + '/citaterapeutica/calificacion/' + id, Objeto).then(handleSuccess, handleError('Error creating citamedica'), verificarToken());
        }

        //Nuevo 
        function GetNew(request){
            return $http.get($rootScope.servidor + '/citaterapeutica/new', {params: request}).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }
        
        //Grabar
        function Create(OBJcitaterapeutica) { 
            return $http.post($rootScope.servidor + '/citaterapeutica', OBJcitaterapeutica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }    
        
        function CreateMasivo(OBJcitaterapeutica) { 
            return $http.post($rootScope.servidor + '/citaterapeutica/masivo', OBJcitaterapeutica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        } 
        
        //Actualizar
        function Update(OBJcitaterapeutica) {   
            return $http.post($rootScope.servidor + '/citaterapeutica/' + OBJcitaterapeutica.citaterapeutica.idcitaterapeutica, OBJcitaterapeutica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }        
        
        //Eliminar
        function Delete(id) {
            return $http.post($rootScope.servidor + '/citaterapeutica/delete/' + id).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        //Eliminar reservacion
        function DeleteReservacion(id) {
            return $http.post($rootScope.servidor + '/citaterapeutica/deletereservacion/' + id).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        //Reprogramar reservacion
        function ReprogramarReservacion(OBJcitaterapeutica) {
            return $http.post($rootScope.servidor + '/citaterapeutica/reprogramacion', OBJcitaterapeutica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        } 
        
        // private functions
        function handleSuccess(res) { 
            return res.data;
        }

        function handleError(error) { 
            return function () {
                return {success: false, message: Notification.warning({message: error})};
            };
        }

        function verificarToken() {
            return $http.get($rootScope.servidor + '/verify')
                        .then(function (result) {
                            if (result.data.code === 400) {
                                var mensaje = result.data.tokenstatus.mensaje;
                                if (mensaje === "Token invalid") {
                                    Notification.error({ message: 'Usted, accedió desde otro dispositivo' });
                                }
                                if (mensaje === "Token not found") {
                                    Notification.error({ message: 'Su sessión ha sido eliminado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token expired") {
                                    Notification.error({ message: 'Su sessión se ha expirado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token error") {
                                    Notification.error({ message: 'Hay un error con su sessión, por favor acceda nuevamente' });
                                }
                                $cookies.remove('token'); 
                                $cookies.remove('GLOBALidsede');
                                window.location = settings.baseURL + '/#/login/';
                            }
                        })
                        .catch(function(e) {
                            $cookies.remove('token'); 
                            $cookies.remove('GLOBALidsede');
                            Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                            window.location = settings.baseURL + '/#/login/';
                        });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('minotaur')
        .factory('citamedicaarchivoService', citamedicaarchivoService);

    citamedicaarchivoService.$inject = ['$http', '$rootScope', '$cookies', 'settings', 'Notification'];
    function citamedicaarchivoService($http, $rootScope, $cookies, settings, Notification) {
        var service = {};

        service.GetIndex = GetIndex;
        service.Create = Create;
        service.Delete = Delete;
        return service;

        //Grid
        function GetIndex(request) {
            return $http.get($rootScope.servidor + '/citamedicaarchivo', { params: request }).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());
        }

        //Grabar
        function Create(OBJcitamedicaarchivo) {
            return $http.post($rootScope.servidor + '/citamedicaarchivo', OBJcitamedicaarchivo).then(handleSuccess, handleError('Error creating entidad'), verificarToken());
        }

        //Eliminar
        function Delete(id) {
            return $http.post($rootScope.servidor + '/citamedicaarchivo/delete/' + id).then(handleSuccess, handleError('Error deleting user'), verificarToken());
        }

        // private functions
        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }

        function verificarToken() {
            return $http.get($rootScope.servidor + '/verify')
                        .then(function (result) {
                            if (result.data.code === 400) {
                                var mensaje = result.data.tokenstatus.mensaje;
                                if (mensaje === "Token invalid") {
                                    Notification.error({ message: 'Usted, accedió desde otro dispositivo' });
                                }
                                if (mensaje === "Token not found") {
                                    Notification.error({ message: 'Su sessión ha sido eliminado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token expired") {
                                    Notification.error({ message: 'Su sessión se ha expirado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token error") {
                                    Notification.error({ message: 'Hay un error con su sessión, por favor acceda nuevamente' });
                                }
                                $cookies.remove('token'); 
                                $cookies.remove('GLOBALidsede');
                                window.location = settings.baseURL + '/#/login/';
                            }
                        })
                        .catch(function(e) {
                            $cookies.remove('token'); 
                            $cookies.remove('GLOBALidsede');
                            Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                            window.location = settings.baseURL + '/#/login/';
                        });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('minotaur')
        .factory('citamedicaService', citamedicaService);

    citamedicaService.$inject = ['$http', '$rootScope', 'Notification', '$cookies', 'settings'];
    function citamedicaService($http, $rootScope, Notification, $cookies, settings) {
        var service = {};

        service.GetConstruct = GetConstruct;
        service.GetIndex = GetIndex;
        service.Dashboard = Dashboard;
        service.DashboardDetail = DashboardDetail;
        service.DashboardMedicoDetail = DashboardMedicoDetail;
        service.TratamientosMedicos = TratamientosMedicos;
        service.ControlDiario = ControlDiario;
        service.GetShow = GetShow;
        service.IpreesSited = IpreesSited;
        service.GetReferencia = GetReferencia;
        service.GetLog = GetLog;
        service.GetShowConsulta = GetShowConsulta;
        service.GethorasDisponibles = GethorasDisponibles;
        service.GetmedicosDisponibles = GetmedicosDisponibles;
        service.GetNew = GetNew;
        service.Create = Create;
        service.CreateDiagnostico = CreateDiagnostico;
        service.Update = Update;
        service.UpdateTratamiento = UpdateTratamiento;
        service.UpdateDiagnostico = UpdateDiagnostico;
        service.UpdateReagendaMasivo = UpdateReagendaMasivo;
        service.Delete = Delete;
        service.SendSms = SendSms;
        service.GenerarInforme = GenerarInforme;
        service.CreatePagar = CreatePagar;
        service.CreatePagarIzipay = CreatePagarIzipay;
        service.CreatePagarTrat = CreatePagarTrat;
        service.CreatePagarTratIzipay = CreatePagarTratIzipay;
        service.CrearFormularioIziPay = CrearFormularioIziPay;
        service.CreateTempCitaMedica = CreateTempCitaMedica;
        service.CreateTempTratamiento = CreateTempTratamiento;
        service.CreatePagarPe = CreatePagarPe;
        service.GetValidarCitamedicaPortal = GetValidarCitamedicaPortal;

        return service;

        function GetConstruct(request) {
            return $http.get($rootScope.servidor + '/citamedica/construct', { params: request }).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());
        }

        //Grid
        function GetIndex(request) {
            return $http.get($rootScope.servidor + '/citamedica', { params: request }).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function GenerarInforme(id, request) {
            return $http.get($rootScope.servidor + '/pdf/informemedico/' + id, { params: request }).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function Dashboard(request) {
            return $http.get($rootScope.servidor + '/citamedica/dashboard', { params: request }).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function TratamientosMedicos(request) {
            return $http.get($rootScope.servidor + '/citamedica/tratamientosmedicos', { params: request }).then(handleSuccess, handleError('Recurso no encontrado', verificarToken()));
        }

        function DashboardDetail(request) {
            return $http.get($rootScope.servidor + '/citamedica/dashboard/detail', { params: request }).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function DashboardMedicoDetail(request) {
            return $http.get($rootScope.servidor + '/citamedica/dashboard/medico/detail', { params: request }).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function ControlDiario(request) {
            return $http.get($rootScope.servidor + '/citamedica/controldiario', { params: request }).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        //Visualizar un registro
        function GetShow(id, request) {
            return $http.get($rootScope.servidor + '/citamedica/' + id, { params: request }).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function IpreesSited() {
            return $http.get($rootScope.servidor + '/citamedica/IpreesSitedListar').then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function GetReferencia(id) {
            return $http.get($rootScope.servidor + '/citamedica/referencia/' + id).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function GetLog(id) {
            return $http.get($rootScope.servidor + '/citamedica/log/' + id).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }

        function GetValidarCitamedicaPortal(request) {
            return $http.post($rootScope.servidor + '/citamedica/ValidarCitamedicaPortal', request).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }


        function GetShowConsulta(id, request) {
            return $http.get($rootScope.servidor + '/citamedica/consulta/' + id, { params: request }).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function GethorasDisponibles(request) {
            return $http.get($rootScope.servidor + '/citamedica/horario/disponibilidad', { params: request }).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function GetmedicosDisponibles(request) {
            return $http.get($rootScope.servidor + '/citamedica/medico/disponibilidad', { params: request }).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        //Nuevo 
        function GetNew(request) {
            return $http.get($rootScope.servidor + '/citamedica/new', { params: request }).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        //Nuevo SMS
        function SendSms(Objeto) {
            $http.defaults.headers.common = [];
            $http.defaults.headers.common.Authorization = 'Basic TU9VVEVDOjEyMzQ1Njc4';
            return $http.post('https://api.infobip.com/sms/1/text/single', Objeto).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        //Grabar
        function Create(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/citamedica', OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function CreatePagar(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/citamedica/pagar', OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function CreatePagarIzipay(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/citamedica/pagarIzipay', OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function CreatePagarTrat(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/citamedica/pagartrat', OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function CreatePagarTratIzipay(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/citamedica/pagartratIzipay', OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function CreateTempCitaMedica(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/citamedica/tempCitamedica', OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function CreateTempTratamiento(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/citamedica/tempTratamientoPortal', OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function CreatePagarPe(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/citamedica/pagarPagoefectivo', OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function CrearFormularioIziPay(arrayToken) {
            return $http.post($rootScope.servidor + '/citamedica/CrearFormularioIziPay', arrayToken).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function CreateDiagnostico(Objeto) {
            return $http.post($rootScope.servidor + '/diagnostico', Objeto).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        //Actualizar
        function Update(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/citamedica/' + OBJcitamedica.citamedica.idcitamedica, OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function UpdateTratamiento(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/citamedica/tratamiento/' + OBJcitamedica.citamedica.idcitamedica, OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function UpdateDiagnostico(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/citamedica/diagnostico', OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function UpdateReagendaMasivo(OBJcitamedica) {
            return $http.post($rootScope.servidor + '/citamedica/reagenda/masivo', OBJcitamedica).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        //Eliminar
        function Delete(id) {
            return $http.post($rootScope.servidor + '/citamedica/delete/' + id).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        // private functions
        function handleSuccess(res) {
            return res.data;
        }

        function handleSuccess(res) {
            return res.data;
        }

        function handleSuccessHeaders(data) {
            return data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: Notification.warning({ message: error }) };
            };
        }

        function verificarToken() {
            return $http.get($rootScope.servidor + '/verify')
                .then(function (result) {
                    if (result.data.code === 400) {
                        var mensaje = result.data.tokenstatus.mensaje;
                        if (mensaje === "Token invalid") {
                            Notification.error({ message: 'Usted, accedió desde otro dispositivo' });
                        }
                        if (mensaje === "Token not found") {
                            Notification.error({ message: 'Su sessión ha sido eliminado, por favor acceda nuevamente' });
                        }
                        if (mensaje === "Token expired") {
                            Notification.error({ message: 'Su sessión se ha expirado, por favor acceda nuevamente' });
                        }
                        if (mensaje === "Token error") {
                            Notification.error({ message: 'Hay un error con su sessión, por favor acceda nuevamente' });
                        }
                        $cookies.remove('token');
                        $cookies.remove('GLOBALidsede');
                        window.location = settings.baseURL + '/#/login/';
                    }
                })
                .catch(function (e) {
                    $cookies.remove('token');
                    $cookies.remove('GLOBALidsede');
                    Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                    window.location = settings.baseURL + '/#/login/';
                });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('minotaur')
            .factory('cicloatencionService', cicloatencionService);

    cicloatencionService.$inject = ['$http', '$rootScope', '$cookies', 'settings', 'Notification'];
    function cicloatencionService($http, $rootScope, $cookies, settings, Notification) {
        var service = {};

        service.GetConstruct = GetConstruct;
        service.GetIndex = GetIndex;
        service.GetCobros = GetCobros;
        service.GetShow = GetShow;
        service.GetGenerarfactura = GetGenerarfactura;
        service.GetNew = GetNew;
        service.Create = Create;
        service.Anadir = Anadir;
        service.Update = Update;
        service.UpdateOpenClose = UpdateOpenClose;
        service.UpdateMovercm = UpdateMovercm;
        service.UpdateMoverciclo = UpdateMoverciclo;
        service.UpdateContabilidad = UpdateContabilidad;       
        service.RegenerarHAyAU = RegenerarHAyAU; 
        service.Delete = Delete;
        service.UpdateTratamiento = UpdateTratamiento;  
        service.DeleteTratamiento = DeleteTratamiento;  
        service.GetShowPrevioEnvio = GetShowPrevioEnvio;
        service.EnviarAContabilidad = EnviarAContabilidad;
        service.AnularEnvioAContabilidad = AnularEnvioAContabilidad;

        return service;

        function GetConstruct(request) {
            return $http.get($rootScope.servidor + '/cicloatencion/construct', {params: request}).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());
        }

        //Grid
        function GetIndex(request) {
            return $http.get($rootScope.servidor + '/cicloatencion', {params: request}).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());
        }

        //Grid
        function GetCobros(request) {
            return $http.get($rootScope.servidor + '/cicloatencion/cobrocitasmedicas', {params: request}).then(handleSuccess, handleError('Error al consultar entidad'), verificarToken());
        }

        //Visualizar un registro
        function GetShow(id, request){
            return $http.get($rootScope.servidor + '/cicloatencion/' + id, {params: request}).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }

        //Generar factura
        function GetGenerarfactura(id, request){
          return $http.get($rootScope.servidor + '/cicloatencion/' + id + '/generarfactura', {params: request}).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }

      //Nuevo
        function GetNew(request){
            return $http.get($rootScope.servidor + '/cicloatencion/new', {params: request}).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }

        //Grabar
        function Create(Objeto) {
            return $http.post($rootScope.servidor + '/cicloatencion', Objeto).then(handleSuccess, handleError('Error creating entidad'), verificarToken());
        }

        //Grabar
        function Anadir(Objeto) {
            return $http.post($rootScope.servidor + '/cicloatencion/anadir', Objeto).then(handleSuccess, handleError('Error creating entidad'), verificarToken());
        }

        //Actualizar
        function Update(Objeto) {
            return $http.post($rootScope.servidor + '/cicloatencion/' + Objeto.cicloatencion.idcicloatencion, Objeto).then(handleSuccess, handleError('Error updating entidad'), verificarToken());
        }

        function UpdateTratamiento(Objeto, id) {
            return $http.post($rootScope.servidor + '/cicloatencion/tratamiento/' + id, Objeto).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }
        
        function DeleteTratamiento(Objeto, id) {
            return $http.post($rootScope.servidor + '/cicloatencion/tratamiento/delete/' + id, Objeto).then(handleSuccess, handleError('Recurso no encontrado'), verificarToken());
        }

        function UpdateOpenClose(Objeto) {
            return $http.post($rootScope.servidor + '/cicloatencion/openclose/' + Objeto.cicloatencion.idcicloatencion, Objeto).then(handleSuccess, handleError('Error updating entidad'), verificarToken());
        }
        
        function UpdateContabilidad(Objeto) {
            return $http.post($rootScope.servidor + '/cicloatencion/estadocontabilidad', Objeto).then(handleSuccess, handleError('Error updating entidad'), verificarToken());
        }
        
        function RegenerarHAyAU(id) {
            return $http.post($rootScope.servidor + '/cicloatencion/regenerarhayau/' + id).then(handleSuccess, handleError('Error updating entidad'), verificarToken());
        }

        function UpdateMovercm(Objeto) {
            return $http.post($rootScope.servidor + '/cicloatencion/mover/cm/' + Objeto.cicloatencion.idcicloatencion, Objeto).then(handleSuccess, handleError('Error updating entidad'), verificarToken());
        }

        function UpdateMoverciclo(Objeto) {
            return $http.post($rootScope.servidor + '/cicloatencion/mover/ciclo/' + Objeto.cicloatencion.idcicloatencion, Objeto).then(handleSuccess, handleError('Error updating entidad'), verificarToken());
        }

        function GetShowPrevioEnvio(id, request){
            return $http.get($rootScope.servidor + '/cicloatencion/' + id + '/previoenvio', {params: request}).then(handleSuccess, handleError('Error getting all producto'), verificarToken());
        }
        
        function EnviarAContabilidad(id) {
            return $http.post($rootScope.servidor + '/cicloatencion/enviaracontabilidad/' + id).then(handleSuccess, handleError('Error updating entidad'), verificarToken());
        }

        function AnularEnvioAContabilidad(id) {
            return $http.post($rootScope.servidor + '/cicloatencion/anularenvioacontabilidad/' + id).then(handleSuccess, handleError('Error updating entidad'), verificarToken());
        }
        //Eliminar
        function Delete(id) {
            return $http.post($rootScope.servidor + '/cicloatencion/delete/' + id).then(handleSuccess, handleError('Error deleting user'), verificarToken());
        }

        // private functions
        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return {success: false, message: error};
            };
        }

        function verificarToken() {
            return $http.get($rootScope.servidor + '/verify')
                        .then(function (result) {
                            if (result.data.code === 400) {
                                var mensaje = result.data.tokenstatus.mensaje;
                                if (mensaje === "Token invalid") {
                                    Notification.error({ message: 'Usted, accedió desde otro dispositivo' });
                                }
                                if (mensaje === "Token not found") {
                                    Notification.error({ message: 'Su sessión ha sido eliminado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token expired") {
                                    Notification.error({ message: 'Su sessión se ha expirado, por favor acceda nuevamente' });
                                }
                                if (mensaje === "Token error") {
                                    Notification.error({ message: 'Hay un error con su sessión, por favor acceda nuevamente' });
                                }
                                $cookies.remove('token'); 
                                $cookies.remove('GLOBALidsede');
                                window.location = settings.baseURL + '/#/login/';
                            }
                        })
                        .catch(function(e) {
                            $cookies.remove('token'); 
                            $cookies.remove('GLOBALidsede');
                            Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                            window.location = settings.baseURL + '/#/login/';
                        });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('minotaur')
            .factory('AuthenticationService', AuthenticationService);

    AuthenticationService.$inject = ['$http', '$cookies', '$rootScope', '$timeout',  'Notification', 'jwtHelper', 'localStorageService','$window'];
    function AuthenticationService($http, $cookies,  $rootScope, $timeout,  Notification, jwtHelper, localStorageService,$window) {
        var service = {};

        service.Login = Login;
        service.Logout = Logout;
        service.SetCredentials = SetCredentials;
        service.ClearCredentials = ClearCredentials;
        service.authenticate = Authenticate;
        service.jsonIp = jsonIp;

        return service;

        function Login(Objeto) {
            return $http.post($rootScope.servidor + '/authenticate', Objeto).then(handleSuccess, handleError('Recurso no encontrado'));
        }

        function Logout(enterprise, callback) {
            $http.post($rootScope.api+'/logout', {enterprise: enterprise})
            .then(function (response) {
                callback(response);
            });
        }

        function SetCredentials(response) {
            //23.01.2015
            var modulos = response.userModules;
            $rootScope.entidad  = response.entidad//response.userProfiles[$rootScope.urlente];
            $rootScope.tokenPayload = jwtHelper.decodeToken(response.token);
            $rootScope.token = response.token;
            $window.sessionStorage.setItem('recargaForzada', 'false');
            $cookies.put('token', response.token);
            $cookies.putObject('entidad', response.entidad);
            $http.defaults.headers.common['Authorization'] = response.token; // 'Basic ' + authdata;
            $http.defaults.headers.common['AuthorizationToken'] = response.token;

            localStorageService.set('modules',(typeof modulos[$rootScope.urlente] === 'undefined')?[]: modulos[$rootScope.urlente].modules);
        }

        function ClearCredentials() {
            $cookies.remove('token');
            $cookies.remove('GLOBALidsede');

            $rootScope.entidad = {};

            localStorageService.remove('modules')

            $http.defaults.headers.common.Authorization = 'Basic ';
            $http.defaults.headers.common.AuthorizationToken = '';
        }

        function Authenticate() {
            return (typeof $cookies.get('token') === 'string' )? true : false;
        }

        function jsonIp() {
            $http.defaults.headers.common = [];
            // return $http.get('https://jsonip.com').then(handleSuccess, handleError('Recurso no encontrado'));
            return $http.get('https://api.ipify.org/?format=json').then(handleSuccess, handleError('Recurso no encontrado'));
        }

        // private functions
        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return {success: false, message: Notification.warning({message: error})};
            };
        }

    }
})();

"use strict";
(function () {
  angular.module('minotaur')
    .controller('misOrdenesCtrl', misOrdenesCtrl);




    misOrdenesCtrl.$inject = ['$rootScope', '$scope', '$state', '$uibModal', '$log', 'ventaService', 'settings'];
  function misOrdenesCtrl($rootScope, $scope, $state, $uibModal, $log, ventaService, settings) {

    var vm = this;
    vm.spinerLoading = true;

    vm.loadMisOrdenes = function () {
      vm.spinerLoading = true;

      try {
        // Verifica si $rootScope.tokenPayload está definido y tiene la propiedad 'my'
        if ($rootScope.tokenPayload && $rootScope.tokenPayload.my) {
            // Accede a la propiedad 'my' de tokenPayload
            console.log('Token payload:', $rootScope.tokenPayload.my);
            // Aquí puedes agregar más lógica si es necesario
        } else {
          window.location = settings.baseURL + '/#/login';
        }
    } catch (error) {
      window.location = settings.baseURL + '/#/login';
    }

      var param = { idcliente: $rootScope.tokenPayload.my};

      ventaService.GetMisordenes(param).then(function (array) {
        debugger;
        vm.misordenes = array.data;
        var count=1;
        vm.misordenes.forEach(function (row) {
          debugger;
          row.count= count++;
          row.total_pagado="S/"+row.total_pagado;

          row.urlPdf = null;
            var codTipoDocumento;
            if (row.iddocumentofiscal === 1) {
              codTipoDocumento = '01';
            }

            if (row.iddocumentofiscal === 2) {
              codTipoDocumento = '03';
            }

            if (row.iddocumentofiscal === 13) {
              codTipoDocumento = '07';
            }

            if (codTipoDocumento) {
              var nombre = row.numerodocafiliado + '-' + codTipoDocumento + '-' + row.serie + '-' + row.serienumero + '.pdf';
              row.urlPdf = $rootScope.servidorUrl + '/content/uploads?us=' + $rootScope.token + '&tipFolder=comprobantes&archivo=' + nombre;
            }
        });

        vm.spinerLoading = false;
      });
    }
    vm.loadMisOrdenes();


    // vm.loadCitamedicas = function () {

    //     citamedicaService.GetIndex(param).then(function (array) {
    //       vm.citas = array.data.citas;

    //       vm.citas.forEach(function (row) {
    //         row.inicioms = formatoMs(row.fecha, row.inicio);
    //         row.fechams = formatoMs(row.fecha, row.inicio);
    //         row.fechavencida = false;

    //         if (milisegundosactual > row.fechams) {
    //           row.fechavencida = true;
    //         }

    //         if (row.idestado === 4 || row.idestado === 5) {
    //           row.estadocita = milisegundosactual > row.fechams ? 'Faltó' : 'Reservado';
    //         }

    //         row.urlzoom = null;
    //         row.idzoom = null;
    //         row.clavezoom = null;
    //         if (row.telemedicina) {
    //           var porciones = row.telemedicina.split('|');
    //           row.urlzoom = porciones[0];
    //           row.idzoom = porciones[1];
    //           row.clavezoom = porciones[2];
    //         }
    //       });
    //       vm.spinerLoading = false;
    //     });
    //   }

    // vm.loadPagos();
  }


})();

"use strict";
(function () {
    angular.module('minotaur')
        .controller('misDatosCtrl', misDatosCtrl)
        .controller('faqCtrl', faqCtrl)
        .controller('modalChangePaswordCtrl', modalChangePaswordCtrl);

    misDatosCtrl.$inject = ['$rootScope', '$scope', '$state', '$uibModal', '$log', 'entidadService', 'ubigeoService', 'Notification', '$cookies', 'settings'];
    function misDatosCtrl($rootScope, $scope, $state, $uibModal, $log, entidadService, ubigeoService, Notification, $cookies, settings) {


        var vm = this;

        vm.entidad = {};
        vm.spinerLoading = true;

        vm.changeUbigeo = function (ubigeo, to) {
            if (ubigeo.pais === '' || ubigeo.dpto === '' || ubigeo.prov === '') {
                vm.others[to] = [];
                return false;
            }
            if (to === 'departamentos') {
                vm.entidad.dpto = ''; //Por default '- Provincia -'
                vm.others.provincias = []; //Limpiar distritos
            }
            if (to === 'provincias') {
                vm.entidad.prov = ''; //Por default '- Provincia -'
                vm.others.distritos = []; //Limpiar distritos
            }
            if (to === 'distritos') {
                vm.entidad.dist = ''; //Por default '- Distrito -'
            }
            ubigeoService.GetIndex(ubigeo).then(function (result) {
                vm.others[to] = result.data;
            });
        };

        try {
          // Verifica si $rootScope.tokenPayload está definido y tiene la propiedad 'my'
          if ($rootScope.tokenPayload && $rootScope.tokenPayload.my) {
              // Accede a la propiedad 'my' de tokenPayload
              console.log('Token payload:', $rootScope.tokenPayload.my);
              // Aquí puedes agregar más lógica si es necesario
          } else {
            window.location = settings.baseURL + '/#/login';
          }
      } catch (error) {
        window.location = settings.baseURL + '/#/login';
      }

        entidadService.GetShow($rootScope.tokenPayload.my, { tipoentidad: 'cliente' }).then(function (entidades) {

            vm.entidad = entidades.data;
            vm.entidad.peso = parseFloat(vm.entidad.peso);
            vm.entidad.altura = parseFloat(vm.entidad.altura);

            vm.others = entidades.others;

            //Inicializar con España
            if (typeof vm.entidad.pais === 'undefined') {
                vm.entidad.pais = 'PE';
                vm.changeUbigeo({ pais: vm.entidad.pais || '' }, 'departamentos');
            }

            vm.entidad.paisnombre = selectObject(vm.others.paises, vm.entidad.pais, 'pais').nombre;
            vm.spinerLoading = false;
        });

        vm.save = function () {

            console.log($scope);

            if (!vm.entidad.dist || vm.entidad.dist === '00') {
                Notification.warning({ message: 'Seleccione distrito' });
                $scope.miForm.$submitted = false;
                return false;
            }

            vm.OBJentidad = {
                entidad: vm.entidad,
                tipoentidad: 'cliente'// Tablas: cliente, proveedor, medico, personal
            };

            entidadService.Update(vm.OBJentidad).then(function (entidades) {
                if (entidades.type === 'success') {
                    Notification.primary({ message: '¡Sus <strong>Datos Personales</strong> ha sido actualizado exitosamente!', templateUrl: 'angular-ui-notification-intranet-primary.html' });

                    //Actualiza cookie y rootscope
                    var entidadcook = $cookies.getObject("entidad");
                    entidadcook.sexo = vm.entidad.sexo;
                    entidadcook.celular = vm.entidad.celular;
                    $cookies.putObject('entidad', entidadcook);
                    $rootScope.entidad = entidadcook;
                    $scope.miForm.$submitted = false;
                    // $scope.$$childTail.miForm.$submitted = false;
                } else {
                    Notification.error({ message: entidades.data });
                    $scope.miForm.$submitted = false;
                    // $scope.$$childTail.miForm.$submitted = false;
                }
            });
        };


        vm.openResetPasswordModal = function (data) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalChangePasswordContent.html',
                controller: 'modalChangePaswordCtrl as vm',
                windowClass: 'modal-primary',
                size: 'sm',
                resolve: {
                    modalParam: function () {
                        return {
                            data: data
                        };
                    }
                }
            });

            modalInstance.result.then(function () { }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };
    }

    modalChangePaswordCtrl.$inject = ['$scope', '$uibModalInstance', 'modalParam', 'entidadService', 'Notification'];
    function modalChangePaswordCtrl($scope, $uibModalInstance, modalParam, entidadService, Notification) {

        var vm = this;

        vm.entidad = {};
        vm.entidad.identidad = modalParam.data;
        vm.entidad.contrasenanueva = '';
        vm.entidad.contrasenaconfirm = '';
        vm.confirm = false;

        vm.save = function () {
            if (vm.entidad.contrasenanueva !== vm.entidad.contrasenaconfirm) {
                Notification.warning({ message: 'Contraseña no coincide con la confirmación de contraseña.' });
                $scope.miForm.$submitted = false;
                vm.confirm = true;
                return false;
            }

            entidadService.UpdatePassword(vm.entidad).then(function (entidad) {
                if (entidad.type === 'success') {
                    Notification.primary({ message: entidad.data, templateUrl: 'angular-ui-notification-intranet-primary.html' });
                    $uibModalInstance.close();
                } else {
                    Notification.error({ message: entidad.data });
                    $scope.miForm.$submitted = false;
                }
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    faqCtrl.$inject = ['$rootScope', '$scope', '$state', '$uibModal', '$log', 'preguntasService'];
    function faqCtrl($rootScope, $scope, $state, $uibModal, $log, preguntasService) {

        var vm = this;
        vm.spinerLoading = true;
        vm.preguntasfrec = {};

        preguntasService.GetIndex().then(function (array) {
            vm.preguntasfrec = array.data;

            vm.spinerLoading = false;
        });
    }

})();

"use strict";
(function () {
    angular.module('minotaur')
        .controller('miReservarCtrl', miReservarCtrl)
        .controller('misCitasMedicasCtrl', misCitasMedicasCtrl)
        .controller('misCitasMedicasShowCtrl', misCitasMedicasShowCtrl)
        .controller('misCitasTerapeutasCtrl', misCitasTerapeutasCtrl)
        .controller('modalAnularCitaMedicaCtrl', modalAnularCitaMedicaCtrl)
        .controller('modalAnularCitaTerapeutaCtrl', modalAnularCitaTerapeutaCtrl)
        .controller('modalMapaSedeCtrl', modalMapaSedeCtrl)
        .controller('modalReprogramarCitaCtrl', modalReprogramarCitaCtrl)
        .controller('modalReprogramarCitaTerapeutaCtrl', modalReprogramarCitaTerapeutaCtrl)
        .controller('miReservaMedicaCtrl', miReservaMedicaCtrl)
        .controller('miReservaTerapeutaCtrl', miReservaTerapeutaCtrl)
        .controller('misPagosCtrl', misPagosCtrl)
        .controller('misCiclosCtrl', misCiclosCtrl)
        .controller('misCiclosDetalleCtrl', misCiclosDetalleCtrl)
        .controller('modalCalificacionCtrl', modalCalificacionCtrl)
        .controller('modalSeleccionarPagoCtrl', modalSeleccionarPagoCtrl)
        .controller('modalPagadoCtrl', modalPagadoCtrl)
        .controller('modalReservaCtrl', modalReservaCtrl)
        .controller('modalTerapiaPECtrl', modalTerapiaPECtrl)
        .controller('modalArchivosAdjuntosInstanceCtrl', modalArchivosAdjuntosInstanceCtrl)
        .controller('modalIframeReservasPorAsistirInstanceCtrl', modalIframeReservasPorAsistirInstanceCtrl)
        .directive('fileModel', fileModel);

    misCitasMedicasCtrl.$inject = ['$rootScope', '$state', '$uibModal', '$log', 'citamedicaService', '$timeout', 'Notification', 'settings'];

    function misCitasMedicasCtrl($rootScope, $state, $uibModal, $log, citamedicaService, $timeout, Notification, settings) {

        try {
            // Verifica si $rootScope.tokenPayload está definido y tiene la propiedad 'my'
            if ($rootScope.tokenPayload && $rootScope.tokenPayload.my) {
                // Accede a la propiedad 'my' de tokenPayload
                console.log('Token payload:', $rootScope.tokenPayload.my);
                // Aquí puedes agregar más lógica si es necesario
            } else {
                console.error('$rootScope.tokenPayload no está definido o no tiene la propiedad "my".');
                // Limpiar cookies y refrescar la página
                window.location = settings.baseURL + '/#/login/';
            }
        } catch (error) {
            window.location = settings.baseURL + '/#/login/';

        }
        $('#krtoolbar').remove();
        var vm = this;
        var milisegundosactual = new Date().getTime();

        vm.stateparent = $state.$current.parent.self.name;
        vm.spinerLoading = true;
        vm.citas = [];
        vm.anos = [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017];
        vm.ano = new Date().getFullYear();

        vm.zoomhoy = hoy();
        vm.urlzoom = '';
        vm.idzoom = '';
        vm.clavezoom = '';

        vm.loadCitamedicas = function () {
            if ($rootScope.tokenPayload.my === undefined) {

            }
            vm.spinerLoading = true;
            var desde = '01/01/' + vm.ano;
            var hasta = '31/12/' + vm.ano;
            var param = { idpaciente: $rootScope.tokenPayload.my, desde: desde, hasta: hasta };
            citamedicaService.GetIndex(param).then(function (array) {
                vm.citas = array.data.citas;

                vm.citas.forEach(function (row) {
                    row.inicioms = formatoMs(row.fecha, row.inicio);
                    row.fechams = formatoMs(row.fecha, row.inicio);
                    row.fechavencida = false;

                    if (milisegundosactual > row.fechams) {
                        row.fechavencida = true;
                    }

                    if (row.idestado === 4 || row.idestado === 5) {
                        row.estadocita = milisegundosactual > row.fechams ? 'Faltó' : 'Reservado';
                    }

                    row.urlzoom = null;
                    row.idzoom = null;
                    row.clavezoom = null;
                    if (row.telemedicina) {
                        var porciones = row.telemedicina.split('|');
                        row.urlzoom = porciones[0];
                        row.idzoom = porciones[1];
                        row.clavezoom = porciones[2];
                    }
                });
                vm.spinerLoading = false;
            });
        }

        /** Tokbox **/

        vm.doctor = '';
        vm.abrirVideoLlamada = function (tokboxSession, tokboxToken, doctor) {

            navigator.getUserMedia = (navigator.getUserMedia ||
                navigator.webkitGetUserMedia ||
                navigator.mozGetUserMedia ||
                navigator.msGetUserMedia);

            navigator.getUserMedia(
                // constraints
                {
                    video: true,
                    audio: true
                },
                // successCallback
                function (localMediaStream) {
                    console.log('localMediaStream');
                    console.log(localMediaStream);
                    // var video = document.querySelector(video);
                    // video.src = window.URL.createObjectURL(localMediaStream);
                },
                // errorCallback
                function (err) {
                    console.log("Dispositivo FAIL");
                    console.log(err);
                }
            );

            // Iniciar
            vm.doctor = 'Dr. ' + doctor;
            $('#myModalTokBoxPopUp').modal({ backdrop: false, keyboard: false });
            initializeSession($rootScope.tokboxApiKey,
                tokboxSession,
                tokboxToken);
        }

        /*Modal Anular Cita*/
        vm.openAnularCitaModal = function (row) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalAnularCitaContent.html',
                controller: 'modalAnularCitaMedicaCtrl as vm',
                windowClass: 'modal-primary',
                size: 'sm',
                resolve: {
                    modalParam: function () {
                        return {
                            data: row
                        };
                    }
                }
            });
            modalInstance.result.then(function (reload) {
                if (reload) {
                    vm.loadCitamedicas();
                }
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        /* Modal subir imagen sited */
        vm.openArchivosAdjuntos = function (cita) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalArchivosAdjuntosContent.html',
                controller: 'modalArchivosAdjuntosInstanceCtrl as vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    modalParam: function () {
                        return {
                            data: cita
                        };
                    }
                }
            });

            modalInstance.result.then(function (reload) {
                if (reload) {
                    vm.loadCitamedicas();
                }
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        /*Modal Mapa Sede*/
        vm.openMapaSedeModal = function (id) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalMapaSedeContent.html',
                controller: 'modalMapaSedeCtrl as vm',
                windowClass: 'modal-primary',
                // size: 'lg',
                resolve: {
                    modalParam: function () {
                        return {
                            idsede: id
                        };
                    }
                }
            });
            modalInstance.result.then(function (reload) { }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        /*Modal Reprogramar Cita*/
        vm.openReprogramarCitaModal = function (row) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalReprogramarCitaContent.html',
                controller: 'modalReprogramarCitaCtrl as vm',
                windowClass: 'modal-primary',
                size: 'lg',
                resolve: {
                    modalParam: function () {
                        return {
                            data: row
                        };
                    }
                }
            });
            modalInstance.result.then(function (reload) {
                if (reload) {
                    vm.loadCitamedicas();
                }
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        vm.loadCitamedicas();
    }

    miReservarCtrl.$inject = ['$state', 'AuthenticationService', 'localStorageService', '$window'];
    function miReservarCtrl($state, AuthenticationService, localStorageService, $window) {

        var recargaForzada = JSON.parse($window.sessionStorage.getItem('recargaForzada') || 'false');
        if (!recargaForzada) {
            // Marcar que ya se recargó
            $window.sessionStorage.setItem('recargaForzada', 'true');

            // Forzar recarga desde el servidor
            $window.location.reload(true);
        }

        var isAuthenticated = AuthenticationService.authenticate();
        if (!isAuthenticated) {
            $state.go("pages.login");
        }
    }

    misCitasMedicasShowCtrl.$inject = ['$stateParams', 'citamedicaService'];
    function misCitasMedicasShowCtrl($stateParams, citamedicaService) {

        var vm = this;

        vm.citamedica = {};
        vm.others = [];
        vm.spinerLoading = true;
        vm.idcitamedica = parseInt($stateParams.paramId, 10);

        vm.show = function () {
            vm.spinerLoading = true;
            citamedicaService.GetShowConsulta($stateParams.paramId, { others: 'gruposdx' }).then(function (array) {
                vm.citamedica = array.data;
                vm.others = array.others;

                array.others.examenfisicocita.forEach(function (row) {
                    row.orden = parseInt(row.zona.substr(3), 10);
                });

                vm.gruposdx = array.others.gruposdx;

                vm.citamedica.urlPdf = null;

                vm.spinerLoading = false;
            });
        }

        vm.show();
    }

    misCitasTerapeutasCtrl.$inject = ['$rootScope', '$uibModal', '$log', 'citaterapeuticaService', 'settings'];

    function misCitasTerapeutasCtrl($rootScope, $uibModal, $log, citaterapeuticaService, settings) {

        try {
            // Verifica si $rootScope.tokenPayload está definido y tiene la propiedad 'my'
            if ($rootScope.tokenPayload && $rootScope.tokenPayload.my) {
                // Accede a la propiedad 'my' de tokenPayload
                console.log('Token payload:', $rootScope.tokenPayload.my);
                // Aquí puedes agregar más lógica si es necesario
            } else {
                window.location = settings.baseURL + '/#/login/';
            }
        } catch (error) {
            window.location = settings.baseURL + '/#/login/';
        }

        var vm = this;

        vm.citas = [];
        var milisegundosactual = new Date().getTime();
        vm.spinerLoading = true;
        vm.anos = [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017];
        vm.ano = new Date().getFullYear();

        vm.loadCitamedicas = function () {
            vm.spinerLoading = true;
            var desde = '01/01/' + vm.ano;
            var hasta = '31/12/' + vm.ano;
            var param = { idpaciente: $rootScope.tokenPayload.my, desde: desde, hasta: hasta };

            citaterapeuticaService.GetIndex(param).then(function (array) {
                vm.citas = array.data;

                vm.citas.forEach(function (row) {
                    row.inicioms = formatoMs(row.fecha, row.inicio);
                    row.fechams = formatoMs(row.fecha, row.inicio);
                    row.fechavencida = false;

                    if (milisegundosactual > row.fechams) {
                        row.fechavencida = true;
                    }

                    if (row.idestado === 32 || row.idestado === 33) {
                        row.estadocita = milisegundosactual > row.fechams ? 'Faltó' : 'Reservado';
                    }
                });

                vm.spinerLoading = false;
            });
        }

        /*Modal Anular Cita*/
        vm.openAnularCitaModal = function (row) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalAnularCitaContent.html',
                controller: 'modalAnularCitaTerapeutaCtrl as vm',
                windowClass: 'modal-primary',
                size: 'sm',
                resolve: {
                    modalParam: function () {
                        return {
                            data: row
                        };
                    }
                }
            });
            modalInstance.result.then(function (reload) {
                if (reload) {
                    vm.loadCitamedicas();
                }
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        /*Modal Mapa Sede*/
        vm.openMapaSedeModal = function (id) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalMapaSedeContent.html',
                controller: 'modalMapaSedeCtrl as vm',
                windowClass: 'modal-primary',
                // size: 'sm',
                resolve: {
                    modalParam: function () {
                        return {
                            idsede: id
                        };
                    }
                }
            });
            modalInstance.result.then(function (reload) { }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        /*Modal Calificacion*/
        vm.openCalificacionModal = function (idcitaterapeutica) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalCalificacionContent.html',
                controller: 'modalCalificacionCtrl as vm',
                windowClass: 'modal-primary',
                // size: 'sm',
                resolve: {
                    modalParam: function () {
                        return {
                            idcitaterapeutica: idcitaterapeutica
                        };
                    }
                }
            });
            modalInstance.result.then(function (reload) {
                if (reload) {
                    vm.loadCitamedicas();
                }
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        /*Modal Reprogramar Cita*/
        vm.openReprogramarCitaModal = function (row) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalReprogramarCitaTerapeutaContent.html',
                controller: 'modalReprogramarCitaTerapeutaCtrl as vm',
                windowClass: 'modal-primary',
                size: 'lg',
                resolve: {
                    modalParam: function () {
                        return {
                            data: row
                        };
                    }
                }
            });
            modalInstance.result.then(function (reload) {
                if (reload) {
                    vm.loadCitamedicas();
                }
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        vm.loadCitamedicas();

        vm.openModalIframeImprimir = function () {
            console.log(vm.citas);
            vm.citaterapeutica = vm.citas[0];
            console.log(vm.citaterapeutica);

            var modalInstance = $uibModal.open({
                templateUrl: 'myModalIframeReservacionesPorAsistirImprimirContent.html',
                controller: 'modalIframeReservasPorAsistirInstanceCtrl as vm',
                windowClass: 'modal-primary',
                size: 'lg',
                resolve: {
                    modalParam: function () {
                        return {
                            data: angular.copy(vm.citaterapeutica)
                        };
                    }
                }
            });

            modalInstance.result.then(function (reload) { }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };
    }

    misCiclosCtrl.$inject = ['$rootScope', 'cicloatencionService', 'settings'];

    function misCiclosCtrl($rootScope, cicloatencionService, settings) {
        var vm = this;

        vm.data = [];
        vm.ciclosabiertos = [];
        vm.cicloscerrados = [];
        vm.spinerLoading = true;

        try {
            // Verifica si $rootScope.tokenPayload está definido y tiene la propiedad 'my'
            if ($rootScope.tokenPayload && $rootScope.tokenPayload.my) {
                // Accede a la propiedad 'my' de tokenPayload
                console.log('Token payload:', $rootScope.tokenPayload.my);
                // Aquí puedes agregar más lógica si es necesario
            } else {
                window.location = settings.baseURL + '/#/login/';
            }
        } catch (error) {
            window.location = settings.baseURL + '/#/login/';
        }

        vm.loadCiclos = function () {
            vm.spinerLoading = true;
            var param = { idpaciente: $rootScope.tokenPayload.my };
            cicloatencionService.GetIndex(param).then(function (array) {
                vm.data = array.data;

                vm.ciclosabiertos = [];
                vm.cicloscerrados = [];

                vm.data.forEach(function (row, index) {
                    if (row.idestado === 20) {
                        vm.ciclosabiertos.push(row);
                    } else {
                        vm.cicloscerrados.push(row);
                    }
                });

                vm.spinerLoading = false;
            });
        }

        vm.loadCiclos();
    }

    modalAnularCitaMedicaCtrl.$inject = ['$scope', '$uibModalInstance', 'modalParam', 'citamedicaService', 'Notification'];

    function modalAnularCitaMedicaCtrl($scope, $uibModalInstance, modalParam, citamedicaService, Notification) {

        var vm = this;
        vm.citamedica = modalParam.data;

        vm.save = function () {
            citamedicaService.Delete(modalParam.data.idcitamedica).then(function (array) {
                if (array.type === 'success') {
                    Notification.primary({ message: '¡Su <strong>Cita Médica</strong> ha sido <strong>eliminada exitosamente</strong>!', templateUrl: 'angular-ui-notification-intranet-primary.html' });
                    $uibModalInstance.close(true);
                } else {
                    Notification.error({ title: 'Oh..!', message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                    $scope.miForm.$submitted = false;
                }
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    modalAnularCitaTerapeutaCtrl.$inject = ['$scope', '$uibModalInstance', 'modalParam', 'citaterapeuticaService', 'Notification'];

    function modalAnularCitaTerapeutaCtrl($scope, $uibModalInstance, modalParam, citaterapeuticaService, Notification) {

        var vm = this;
        vm.citaterapeutica = modalParam.data;

        vm.save = function () {

            citaterapeuticaService.Delete(modalParam.data.idcitaterapeutica).then(function (array) {

                if (array.type === 'success') {
                    Notification.primary({ message: '¡Su <strong>Cita de Terapia</strong> ha sido <strong>eliminada exitosamente</strong>!', templateUrl: 'angular-ui-notification-intranet-primary.html' });
                    $uibModalInstance.close(true);
                } else {
                    Notification.error({ title: 'Oh..!', message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                    $scope.miForm.$submitted = false;
                }
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    modalMapaSedeCtrl.$inject = ['$scope', '$uibModalInstance', 'modalParam', 'sedeService'];

    function modalMapaSedeCtrl($scope, $uibModalInstance, modalParam, sedeService) {

        var vm = this;
        vm.sede = {};

        sedeService.GetShow(modalParam.idsede).then(function (array) {
            vm.sede = array.data;
        });

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    modalPagadoCtrl.$inject = ['$scope', '$rootScope', '$uibModalInstance', 'modalParam', 'sedeService'];

    function modalPagadoCtrl($scope, $rootScope, $uibModalInstance, modalParam, sedeService) {

        var vm = this;

        vm.urlPdf = null;

        if (modalParam.filenamepdf) {
            row.urlPdf = $rootScope.servidorUrl + '/content/uploads?us=' + $rootScope.token + '&tipFolder=comprobantes&archivo=' + nombre;
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }


    modalReservaCtrl.$inject = ['$scope', '$rootScope', '$uibModalInstance', 'modalParam', 'sedeService', 'citamedicaService'];

    function modalReservaCtrl($scope, $rootScope, $uibModalInstance, modalParam, sedeService, citamedicaService) {

        var vm = this;
        console.log("PARAMETROS", modalParam)
        vm.precio = parseFloat(modalParam.precio).toFixed(2);
        vm.doctor = modalParam.namemedico;
        vm.fecha = modalParam.fecha;
        vm.hora = modalParam.inicio;
        vm.nombresede = modalParam.namesede
        vm.paciente = modalParam.apellidos + " " + modalParam.nombre;
        vm.codigocip = modalParam.codigocip;
        vm.urlIzipay = modalParam.urlIzipay;
        vm.orderId = modalParam.orderId;

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }


    modalTerapiaPECtrl.$inject = ['$scope', '$rootScope', '$uibModalInstance', 'modalParam', 'sedeService', 'citamedicaService'];

    function modalTerapiaPECtrl($scope, $rootScope, $uibModalInstance, modalParam, sedeService, citamedicaService) {

        var vm = this;
        console.log("PARAMETROS", modalParam)
        vm.precio = modalParam.precio;
        vm.codigocip = modalParam.codigocip;

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    modalCalificacionCtrl.$inject = ['$scope', '$uibModalInstance', 'modalParam', 'citaterapeuticaService', 'Notification'];

    function modalCalificacionCtrl($scope, $uibModalInstance, modalParam, citaterapeuticaService, Notification) {

        var vm = this;
        vm.p1_califica = null;
        vm.p2_antes = null;
        vm.p3_desp = null;
        vm.p4_comen = null;


        vm.save = function () {

            if (!vm.p1_califica) {
                Notification.warning({ message: 'Por favor responder pregunta 1.' });
                $scope.miForm.$submitted = false;
                return false;
            }

            if (!vm.p2_antes) {
                Notification.warning({ message: 'Por favor responder pregunta 2.' });
                $scope.miForm.$submitted = false;
                return false;
            }

            if (!vm.p3_desp) {
                Notification.warning({ message: 'Por favor responder pregunta 3.' });
                $scope.miForm.$submitted = false;
                return false;
            }
            debugger;
            if (!vm.p4_comen) {
                Notification.warning({ message: 'Por favor responder pregunta 3.' });
                $scope.miForm.$submitted = false;
                return false;
            }

            var param = {
                p1_califica: vm.p1_califica,
                p2_antes: vm.p2_antes,
                p3_desp: vm.p3_desp,
                p4_comen: vm.p4_comen

            };

            citaterapeuticaService.Calificacion(modalParam.idcitaterapeutica, param).then(function (array) {
                if (array.type === 'success') {
                    Notification.primary({ message: '¡Su <strong>calificación</strong> ha sido <strong>enviada exitosamente</strong>!', templateUrl: 'angular-ui-notification-intranet-primary.html' });
                    $uibModalInstance.close(param);
                } else {
                    Notification.error({ title: 'Oh..!', message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                    $scope.miForm.$submitted = false;
                }
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    modalSeleccionarPagoCtrl.$inject = ['$scope', '$uibModalInstance', 'modalParam', 'sedeService', 'Notification', 'ventaService', '$rootScope', 'settings'];

    function modalSeleccionarPagoCtrl($scope, $uibModalInstance, modalParam, sedeService, Notification, ventaService, $rootScope, settings) {

        var vm = this;
        vm.mediopago_status = false;
        vm.presupuesto = modalParam.presupuesto;
        vm.presupuestodet = [];
        vm.total = 0;
        vm.presupuestodetTemp = [];
        vm.totalTemp = [];
        vm.btnpagar = false;
        vm.spinerLoadingPagar = false;
        vm.generoCIP = false;
        /* Presupuesto */
        vm.presupuestoseleccionado = vm.presupuesto.tipotarifa === 1 ? vm.presupuesto.regular : (vm.presupuesto.tipotarifa === 2 ? vm.presupuesto.tarjeta : vm.presupuesto.efectivo);
        vm.porpagar = vm.presupuestoseleccionado - vm.presupuesto.montopago;
        vm.porpagar = vm.porpagar > 0 ? vm.porpagar : 0; // 10;

        try {
            // Verifica si $rootScope.tokenPayload está definido y tiene la propiedad 'my'
            if ($rootScope.tokenPayload && $rootScope.tokenPayload.my) {
                // Accede a la propiedad 'my' de tokenPayload
                console.log('Token payload:', $rootScope.tokenPayload.my);
                // Aquí puedes agregar más lógica si es necesario
            } else {
                window.location = settings.baseURL + '/#/login/';

            }
        } catch (error) {
            window.location = settings.baseURL + '/#/login/';
        }
        //validar pagos en espera
        ventaService.GetMisordenes({ idcliente: $rootScope.tokenPayload.my }).then(function (array) {
            if (array.data.length === 0) {
                vm.mediopago_status = true;
            } else {
                array.data.forEach(function (row) {
                    if (row.estado == "En Proceso") {
                        Notification.warning({ message: 'Ya Cuenta con un pago en espera esta por confirmar en unos minutos o contactarse con una admisionista' });
                        $uibModalInstance.close(false);
                        return false;
                    } else {
                        vm.mediopago_status = true;
                    }
                });
            }
        });


        /* Presupuesto detalle */
        modalParam.presupuestodet.forEach(function (row) {

            var cantidad = row.cantmedico - row.cantpagada;

            if (cantidad > 0) {
                var precio = 0;
                switch (vm.presupuesto.tipotarifa) {
                    case 1:
                        precio = row.preciounitregular
                        break;
                    case 2:
                        precio = row.preciounittarjeta
                        break;
                    case 3:
                        precio = row.preciounitefectivo
                        break;
                }

                var total = redondearValor(cantidad * precio, 2);
                var cantidadFinal = 0;
                if (precio !== "0.00") {
                    cantidadFinal = cantidad;
                }
                var item = {
                    idproducto: row.idproducto,
                    codigo: row.codigo,
                    cantidadmax: cantidadFinal,
                    cantidad: cantidadFinal,
                    valorunit: redondearValor(precio / 1.18, 3),
                    preciounit: precio,
                    nombreproducto: row.nombreproducto,
                    valorventa: redondearValor(total / 1.18, 2),
                    montototalimpuestos: redondearValor(total - redondearValor(total / 1.18, 2), 2),
                    total: total
                };
                vm.total += total;
                vm.presupuestodet.push(item);
            }
        });

        vm.mediopago_select = function (mediopago) {
            if (mediopago == 'izipay') {
                vm.mediopagoIzi = true;
                vm.mediopagoPE = false
            } else {
                vm.mediopagoIzi = false;
                vm.mediopagoPE = true
            }
        }

        vm.presupuestodetTemp = angular.copy(vm.presupuestodet);

        vm.actualizarCantidad = function (array, indice, idproducto) {

            var cantidad = array[indice]['cantidad'];

            if (cantidad > array[indice]['cantidadmax']) {
                cantidad = array[indice]['cantidadmax'];
                array[indice]['cantidad'] = cantidad;
            }

            if (cantidad < 0) {
                cantidad = 0;
                array[indice]['cantidad'] = cantidad;
            }

            cantidad = redondearValor(cantidad, 0);
            array[indice]['cantidad'] = cantidad;

            if (idproducto === 3) {
                array.forEach(function (row) {
                    if (row.idproducto === 23) {
                        if (cantidad > 0) {
                            var cantAguja = 6 * cantidad;
                            var total = redondearValor(cantAguja * row.preciounit, 2);
                            row.cantidad = cantAguja;
                            row.valorventa = redondearValor(total / 1.18, 2);
                            row.montototalimpuestos = redondearValor(total - redondearValor(total / 1.18, 2), 2);
                            row.total = total;
                        } else {
                            row.cantidad = null;
                            row.valorventa = null;
                            row.montototalimpuestos = null;
                            row.total = null;
                        }
                    }
                });
            }



            if (cantidad === 0) {
                array[indice]['cantidad'] = null;
                array[indice]['valorventa'] = null;
                array[indice]['montototalimpuestos'] = null;
                array[indice]['total'] = null;
            } else {
                var total = redondearValor(cantidad * array[indice]['preciounit'], 2);
                array[indice]['valorventa'] = redondearValor(total / 1.18, 2);
                array[indice]['montototalimpuestos'] = redondearValor(total - redondearValor(total / 1.18, 2), 2);
                array[indice]['total'] = total;
            }

            vm.calcularTotal();
        };

        vm.calcularTotal = function () {
            var total = 0;
            vm.presupuestodetTemp.forEach(function (row) {
                total += row.total;
            });
            vm.totalTemp = total;
        }

        vm.calcularTotal();

        vm.generarCIP = function () {
            $("#btnGenerarCIP").prop('disabled', true);
            var ventadet = [];
            console.log("vm.presupuestodet", vm.presupuestodet)

            var totalpago = 0;
            var totalimpuestos = 0;
            var valorventa = 0;
            var codigo = '';
            vm.presupuestodetTemp.forEach(function (row) {
                if (row.cantidad > 0) {
                    var item = {
                        idproducto: row.idproducto,
                        cantidad: row.cantidad,
                        preciounit: row.preciounit,
                        valorunit: row.valorunit,
                        valorventa: row.valorventa,
                        montototalimpuestos: row.montototalimpuestos,
                        total: row.total,
                        nombreproducto: row.nombreproducto
                    };
                    ventadet.push(item);
                    totalpago = totalpago + row.total;
                    totalimpuestos = totalimpuestos + row.montototalimpuestos;
                    valorventa = valorventa + row.valorventa;
                    codigo += (codigo ? ' + ' : '') + (row.cantidad + ' ' + row.codigo);
                }
            });

            if (ventadet.length === 0) {
                Notification.warning({ message: 'Ingrese cantidad a comprar' });
                return false;
            }
            var ventaCheck = {
                docfis: 0,
                idsede: modalParam.idsede,
                operation: 0,
                tipo: 'documentos',
                mediopago: 19
            }
            sedeService.GetAfiliado(ventaCheck).then(function (array) {
                var datosVenta = [];
                if (array.type === 'success') {

                    var venta = {
                        idmediopago: 19,
                        iddocumentoserie: array.data.iddocumentoserie,
                        idsede: modalParam.idsede,
                        idcicloatencion: modalParam.presupuesto.idcicloatencion,
                        idpaciente: modalParam.presupuesto.idcliente,
                        idcliente: modalParam.presupuesto.idcliente,
                        total: redondearValor(totalpago, 2),
                        subtotal: redondearValor(valorventa, 2),
                        valorimpuesto: redondearValor(totalimpuestos, 2),
                        igv: 18,
                        movecon: "1",
                        cpecorreopaciente: modalParam.email,
                        cpecorreo: modalParam.email,

                    }
                    var array = {
                        venta: venta,
                        ventadet: ventadet
                    }

                    datosVenta.push(ventadet);
                    console.log("venta", venta)
                    vm.spinerLoadingPagar = true;
                    sedeService.CreateCIP(array).then(function (array) {
                        if (array.type === 'success') {
                            vm.generoCIP = true
                            vm.precio = redondearValor(totalpago, 2);
                            vm.codigocip = array.others.codigo_cip;
                            vm.spinerLoadingPagar = false;
                        } else {
                            vm.spinerLoadingPagar = false;
                            vm.generoCIP = false;
                            $uibModalInstance.close();
                            Notification.error({ message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                        }
                    });



                    // $uibModalInstance.close({ codigocompra: codigo, ventadet: ventadet,data:modalParam,afiliado: array.data});
                } else {
                    Notification.error({ title: 'Oh..!', message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                }
            });

        }

        vm.save = function (param, codigo) {
            var totalpago = 0
            var ventadet = [];
            switch (param) {
                case 'carrito':
                    var codigo = '';
                    vm.presupuestodetTemp.forEach(function (row) {
                        if (row.cantidad > 0) {
                            var item = {
                                idproducto: row.idproducto,
                                cantidad: row.cantidad,
                                preciounit: row.preciounit,
                                valorunit: row.valorunit,
                                valorventa: row.valorventa,
                                montototalimpuestos: row.montototalimpuestos,
                                total: row.total,
                                nombreproducto: row.nombreproducto
                            };
                            ventadet.push(item);

                            codigo += (codigo ? ' + ' : '') + (row.cantidad + ' ' + row.codigo);
                            totalpago = totalpago + row.total;
                        }
                    });
                    break;

                case 'acuentatodo':
                    var item = {
                        idproducto: 22,
                        cantidad: 1,
                        preciounit: vm.porpagar,
                        valorunit: redondearValor(vm.porpagar / 1.18, 3),
                        valorventa: redondearValor(vm.porpagar / 1.18, 2),
                        montototalimpuestos: redondearValor(vm.porpagar - redondearValor(vm.porpagar / 1.18, 2), 2),
                        total: vm.porpagar,
                        nombreproducto: '**Acuenta**'
                    };
                    ventadet.push(item);
                    break;

            }

            if (ventadet.length === 0) {
                Notification.warning({ message: 'Ingrese cantidad a comprar' });
                return false;
            }
            vm.btnpagar = true;
            var ventaCheck = {
                docfis: 0,
                idsede: modalParam.idsede,
                operation: 0,
                tipo: 'documentos',
                mediopago: 18
            }
            sedeService.GetAfiliado(ventaCheck).then(function (array) {
                vm.btnpagar = false;
                if (array.type === 'success') {
                    vm.spinerLoadingPagar = true;
                    $uibModalInstance.close({ codigocompra: codigo, ventadet: ventadet, data: modalParam, afiliado: array.data });
                } else {
                    Notification.error({ title: 'Oh..!', message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                }
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    modalReprogramarCitaCtrl.$inject = ['$scope', '$uibModalInstance', '$filter', 'modalParam', 'citamedicaService', 'Notification', 'sedeService'];

    function modalReprogramarCitaCtrl($scope, $uibModalInstance, $filter, modalParam, citamedicaService, Notification, sedeService) {

        var vm = this;
        vm.checkpaso2 = false;
        vm.spinerLoadingHoras = true;
        vm.spinerLoadingv2 = true;

        vm.checkpaso2 = false;
        vm.medicos = [];
        vm.radioModel = {};

        vm.dt = null; // new Date();


        $scope.IsDateAvailable = function (date) {
            for (var i = 0; i < $scope.availableDates.length; i++) {
                if (date.getDate() === $scope.availableDates[i].getDate() && date.getMonth() === $scope.availableDates[i].getMonth() && date.getFullYear() === $scope.availableDates[i].getFullYear())
                    return true;
            }

            return false;
        }

        sedeService.GetHorariosDisponibles({ sedeid: modalParam.data.idsede }).then(function (horarios) {
            vm.spinerLoadingfecha = false;
            vm.checkpaso2 = true;
            var fechasdisponibles = horarios.data;
            vm.availableDates = [];

            var arrayDate = []
            angular.forEach(fechasdisponibles, function (row) {
                arrayDate.push(new Date(row));
            })
            vm.spinerLoadingHoras = true;
            vm.spinerLoadingv2 = false;

            $scope.availableDates = arrayDate;
            vm.checkpaso2 = true;
            vm.dateOptions = {
                minDate: new Date(),
                showWeeks: false,
                dateDisabled: function (data) {
                    var date = data.date,
                        mode = data.mode;
                    return mode === 'day' && !$scope.IsDateAvailable(date);
                }
            };
        });


        var milisegundosactual = new Date().getTime();

        citamedicaService.GetShow(modalParam.data.idcitamedica).then(function (array) {
            vm.citamedica = array.data;
            vm.citamedica.inicioms = formatoMs(vm.citamedica.fecha, vm.citamedica.inicio);
            vm.citamedica.finms = formatoMs(vm.citamedica.fecha, vm.citamedica.fin);
            // vm.consultarMedicos();
        });



        vm.consultarMedicos = function () {
            vm.spinerLoadingHoras = true;
            vm.radioModel = {};
            var fecha = $filter('date')(vm.dt, 'dd/MM/yyyy');
            var param = {
                idsede: vm.citamedica.idsede,
                fecha: fecha,
                idperfil: 3
            };
            vm.checkCobertura = false;
            citamedicaService.GetmedicosDisponibles(param).then(function (array) {
                // Citas mayor a la hora actual
                array.data.forEach(function (row) {
                    row.horas.forEach(function (hora) {
                        hora.inicioms = formatoMs(fecha, hora.inicio);
                        hora.finms = formatoMs(fecha, hora.fin);
                    });

                    var horasValida = row.horas.filter(function (hora) {
                        return hora.inicioms > milisegundosactual
                    });

                    row.horas = horasValida;
                });

                var dataHoras = array.data.filter(function (row) {
                    return row.horas.length > 0
                });

                vm.medicos = dataHoras;
                vm.spinerLoadingHoras = false;
            });
        };

        vm.save = function () {

            if (!vm.radioModel.idmedico) {
                Notification.warning({ message: 'Seleccione hora para la reprogramaci&oacute;n.' });
                $scope.miForm.$submitted = false;
                return false;
            }

            var citamedica = {
                idcitamedica: vm.citamedica.idcitamedica,
                idsede: vm.citamedica.idsede,
                idmedico: vm.radioModel.idmedico,
                idpaciente: vm.citamedica.idpaciente,
                fecha: $filter('date')(vm.dt, 'dd/MM/yyyy'),
                inicio: vm.radioModel.inicio,
                fin: vm.radioModel.fin,
                idestado: vm.citamedica.idestado
            };

            var OBJentidad = {
                citamedica: citamedica
            };

            citamedicaService.Update(OBJentidad).then(function (array) {
                if (array.type === 'success') {
                    Notification.primary({ message: '¡Su <strong>Cita Médica</strong> ha sido <strong>reprogramada exitosamente</strong>!', templateUrl: 'angular-ui-notification-intranet-primary.html' });
                    $uibModalInstance.close(OBJentidad);
                } else {
                    Notification.error({ title: 'Oh..!', message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                    $scope.miForm.$submitted = false;
                }
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    modalReprogramarCitaTerapeutaCtrl.$inject = ['$scope', '$uibModal', '$uibModalInstance', '$log', '$filter', 'modalParam', 'citaterapeuticaService', '$timeout', 'Notification'];

    function modalReprogramarCitaTerapeutaCtrl($scope, $uibModal, $uibModalInstance, $log, $filter, modalParam, citaterapeuticaService, $timeout, Notification) {

        var vm = this;

        vm.medicos = [];
        vm.radioModel = {};
        vm.citaterapeutica = {};
        vm.dt = null; //new Date();
        vm.dateOptions = {
            minDate: new Date(),
            showWeeks: false
        };

        vm.spinerLoadingHoras = true;
        var milisegundosactual = new Date().getTime();

        citaterapeuticaService.GetShow(modalParam.data.idcitaterapeutica).then(function (array) {
            vm.citaterapeutica = array.data;
            vm.citaterapeutica.inicioms = formatoMs(vm.citaterapeutica.fecha, vm.citaterapeutica.inicio);
            vm.citaterapeutica.finms = formatoMs(vm.citaterapeutica.fecha, vm.citaterapeutica.fin);
            // vm.consultarMedicos();
        });

        vm.consultarMedicos = function () {
            vm.spinerLoadingHoras = true;
            vm.radioModel = {};
            var fecha = $filter('date')(vm.dt, 'dd/MM/yyyy');
            var param = {
                idsede: vm.citaterapeutica.idsede,
                fecha: fecha,
                idaseguradora: vm.citaterapeutica.idaseguradora,
                idpaciente: vm.citaterapeutica.idpaciente,
                turnos: vm.citaterapeutica.turnos
            };
            if (vm.citaterapeutica.idsede == undefined) {
                Notification.error({ message: "Volver a Seleccionar la fecha" });
                vm.spinerLoadingHoras = false;
                return false;
            }

            // citaterapeuticaService.GetterapistasDisponibles(param).then(function (array) {
            citaterapeuticaService.GetterapistasDisponiblesPostCovid(param).then(function (array) {
                if (array.type === 'success') {

                    // Citas mayor a la hora actual
                    array.data.forEach(function (row) {
                        row.horas.forEach(function (hora) {
                            hora.inicioms = formatoMs(fecha, hora.inicio);
                            hora.finms = formatoMs(fecha, hora.fin);
                        });

                        var horasValida = row.horas.filter(function (hora) {
                            return hora.inicioms > milisegundosactual
                        });

                        row.horas = horasValida;
                    });

                    var dataHoras = array.data.filter(function (row) {
                        return row.horas.length > 0
                    });

                    var msj = "";
                    if (dataHoras.length > 0) {
                        if (dataHoras[0].IntentosProg == 0) {
                            msj = "Queda solo 2 posibilidad de reprogramar";
                        } else if (dataHoras[0].IntentosProg == 2) {
                            msj = "Excedio con los intentos de reprogramar";
                        } else {
                            msj = "Queda solo " + dataHoras[0].IntentosProg + " posibilidad de reprogramar";
                        }
                    }

                    vm.medicos = dataHoras;
                    vm.intentosProgramada = msj;

                } else {
                    Notification.error({ message: array.data });
                }
                vm.spinerLoadingHoras = false;
            });
        };

        vm.save = function () {

            vm.mensajError = null;

            if (!vm.radioModel.idmedico) {
                Notification.warning({ message: 'Seleccione fecha y hora para la reprogramación.' });
                $scope.miForm.$submitted = false;
                return false;
            }

            var citaterapeutica = {
                idcitaterapeutica: vm.citaterapeutica.idcitaterapeutica,
                idaseguradora: vm.citaterapeutica.idaseguradora,
                idsede: vm.citaterapeutica.idsede,
                idterapista: vm.radioModel.idmedico,
                idpaciente: vm.citaterapeutica.idpaciente,
                fecha: $filter('date')(vm.dt, 'dd/MM/yyyy'),
                inicio: vm.radioModel.inicio,
                fin: vm.radioModel.fin,
                idestado: vm.citaterapeutica.idestado
            };

            var OBJentidad = {
                citaterapeutica: citaterapeutica
            };

            citaterapeuticaService.Update(OBJentidad).then(function (array) {
                if (array.type === 'success') {
                    Notification.primary({ message: '¡Su <strong>Cita de Terapia</strong> ha sido <strong>reprogramada exitosamente</strong>!', templateUrl: 'angular-ui-notification-intranet-primary.html' });
                    $uibModalInstance.close(OBJentidad);
                } else {
                    // Notification.error({ title: 'Oh..!', message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                    // Notification.error({ message: array.data });
                    $scope.miForm.$submitted = false;
                    vm.mensajError = array.data;
                }
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    miReservaMedicaCtrl.$inject = ['$http', '$rootScope', '$stateParams', '$scope', '$uibModal', '$uibModalStack', '$state', '$log', '$filter', '$timeout', 'citamedicaService', 'ositedsService', 'sedeService', 'Notification', '$cookies'];

    function miReservaMedicaCtrl($http, $rootScope, $stateParams, $scope, $uibModal, $uibModalStack, $state, $log, $filter, $timeout, citamedicaService, ositedsService, sedeService, Notification, $cookies) {
        var ab = $('#funciones_izi').length;
        if (ab > 0) {
            window.location.reload();
            $state.go("reservar-cita-medica");
        }
        $scope.seguros = [
            { "nombre": "Rimac", "planes": [{ "idplan": "1", "plan": "20001", "nombre": "EPS" }, { "idplan": "2", "plan": "40007", "nombre": "Seguros" }] },
            { "nombre": 'La Positiva', "planes": [{ "idplan": '27', "plan": '20029', "nombre": 'EPS' }, { "idplan": '6', "plan": '40005', "nombre": 'Seguros' }] },
            { "nombre": 'Pacifico', "planes": [{ "idplan": '9', "plan": '20002', "nombre": 'EPS' }, { "idplan": '10', "plan": '40004', "nombre": 'Seguros' }] },
            { "nombre": 'Mapfre', "planes": [{ "idplan": '14', "plan": '20004', "nombre": 'EPS' }, { "idplan": '15', "plan": '40006', "nombre": 'Seguros' }] },
            { "nombre": 'Sanitas Perú', "planes": [{ "idplan": '19', "plan": '20005', "nombre": 'EPS' }] },
        ];

        var vm = this;
        vm.medicos = [];
        vm.radioModel = {};
        vm.citamedica = {};
        var milisegundosactual = new Date().getTime();
        var sede_local = true;
        $('#detalle_cita').css('display', 'none')

        vm.spinerLoading = true;
        vm.spinerLoadingHoras = true;
        vm.spinerLoadingPagar = false;
        vm.dt = null;
        vm.form_login = null;
        vm.formtoken = null;

        $scope.IsDateAvailable = function (date) {
            for (var i = 0; i < $scope.availableDates.length; i++) {
                if (date.getDate() === $scope.availableDates[i].getDate() && date.getMonth() === $scope.availableDates[i].getMonth() && date.getFullYear() === $scope.availableDates[i].getFullYear())
                    return true;
            }

            return false;
        }
        vm.tienecobertura = null;
        // vm.numCodIafa = modalParam.numCodIafa;
        vm.iprees_sited;
        vm.sededeipress = null;
        vm.gridBusqueda = [];
        vm.gridBeneficios = [];
        vm.beneficio;
        vm.sedesdeipressTemp = [];
        var num_carrera_global = 1;
        vm.checkCobertura = false;
        vm.infocita = false;
        vm.detalleFinal = [];
        vm.param = [];
        vm.preciocm = null;
        vm.checkpaso2 = false;
        vm.checkpasofinal = false;
        vm.checkmedioPE = false;
        vm.izipayIniciado = false;

        vm.nombresede = '';
        vm.correo = '';

        sedeService.GetIndex({ preciocm: '1' }).then(function (sedes) {
            vm.sedes = sedes.data;
            vm.spinerLoading = false;
            /*vm.sedes.forEach(function (row,turn) {
              if(row.idsede==11 || row.idsede==10 || row.idsede==9){
                vm.sedes.splice(turn, 1);
              }
            });*/

            if ($stateParams.idsede)
                vm.sede_select();
        });

        var form_generate = false;

        vm.openModalcorreo = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalCorreo.html',
                // controller: 'modalHorarioFaltaInstanceCtrl as vm',
                windowClass: 'modal-primary',
                backdrop: 'static',
                scope: $scope,
                size: 'sm',
                resolve: {
                    modalParam: function () {
                        return {};
                    }
                }
            });
            modalInstance.result.then(function (reload) {

            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        vm.changeTieneCobertura = function () {

            if (vm.tienecobertura == 0) {
                vm.infocita = true;

                $('#button_pago').hide();
                vm.izipayIniciado = false;
                vm.citamedica.mediopago = null;
                vm.checkmedioPE = false;

                var correo = $('#correo').val()
                if (correo != undefined) {
                    vm.correo = correo;
                }
                if (vm.correo == '') {
                    Notification.warning({ message: 'Ingresar el correo electrónico' });
                    return false;
                };
                $('#aceptar_correo').prop("disabled", true);

                vm.preciocm = vm.sedes.filter(function (row) {
                    return row.idsede === parseInt(vm.citamedica.idsede, 10);
                })[0].preciocm;

                vm.preciocm = parseFloat(vm.preciocm) * 100;

                var usu_izipay = null;
                var passw_izipay = null;
                var llave_publica = null;
                var pe_idservice = null;
                var pe_accesskey = null;
                var pe_secretkey = null;
                vm.sedes.forEach(function (row) {
                    if (row.idsede === parseInt(vm.citamedica.idsede, 10)) {
                        usu_izipay = row.usu_izipay;
                        passw_izipay = row.passw_izipay;
                        llave_publica = row.clave_publica_izipay;
                        pe_idservice = row.pe_idservice;
                        pe_accesskey = row.pe_accesskey;
                        pe_secretkey = row.pe_secretkey;
                    }
                });
                if (usu_izipay == null || passw_izipay == null) {
                    Notification.warning({ message: 'Los Servicios no funcionaron correctamente"' });
                    vm.spinerLoadingfecha = false;
                    return false;
                }

                var today = new Date();
                var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
                var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                var dateTime = date + ' ' + time;
                var aleatorio = Math.floor(Math.random() * (999 - 100 + 1) + 100);

                vm.param = {
                    'usuario': usu_izipay,
                    'password': passw_izipay,
                    "llave_publica": llave_publica,
                    "pe_idservice": pe_idservice,
                    "pe_accesskey": pe_accesskey,
                    "pe_secretkey": pe_secretkey,
                    'precio': vm.preciocm,
                    'email': vm.correo,
                    'orderid': "pagoPortalCitamedica" + '_' + $rootScope.entidad.identidad + '_' + aleatorio
                }
                vm.precio = (parseFloat(vm.preciocm) / 100).toFixed(2);
                // vm.formulariocreate(vm.param);
            } else {
                vm.infocita = false;
                $('#button_pago').css('display', 'none')

            }
        }

        $scope.getPlanes = function (selectedSeguro) {
            var filteredSeguro = $filter('filter')($scope.seguros, selectedSeguro);
            return filteredSeguro[0].planes;
        };

        vm.buscarCobertura = function () {
            vm.spinerHorapaso3 = true;

            citamedicaService.IpreesSited().then(function (array) {
                if (array.success === false) {
                    array.message;
                } else {
                    vm.iprees_sited = array.data.ipress;
                    vm.beneficio = array.data.beneficio;

                    ositedsService.GetIafasOsiteds().then(function (resOsiteds) {
                        vm.aIafas = resOsiteds.map(function (row) {
                            return {
                                numcodiafa: row.CO_IAFASCODE,
                                nombre: row.NO_SHORTNAME,
                                logo: null,
                                descripcion: row.NO_IAFASNAME
                            }
                        });
                    });
                    vm.sedesdeipress = [];
                    vm.sedesdeipressTemp = [];
                    ositedsService.GetSedesDeIpress()
                        .then(function (resOsiteds) {
                            if (resOsiteds.success == false) {
                                Notification.warning({ message: 'No hay respuesta del SitedWeb se habilita los campos para llenar' });
                                $uibModalInstance.close(false);
                                return false;
                            }
                            vm.sedesdeipress = resOsiteds;
                            vm.sedesdeipressTemp = resOsiteds;
                            vm.validadEntidadVinculada();
                        });
                }
            });
        }

        vm.validadEntidadVinculada = function () {
            var mensaje = "";
            var num_carrera = 1;
            // vm.numCodIafaCG = vm.numCodIafa;
            var status = false;
            vm.filaSelectBusqueda = [];
            vm.gridBusqueda = [];
            vm.gridBeneficios = [];
            vm.sitedsDetalle = null;
            vm.restricciones = null;
            console.log("vm.iprees_sited", vm.iprees_sited)
            vm.sededeipress = vm.iprees_sited.filter(function (row) {
                return row.idsede == vm.citamedica.idsede && row.n_carrera == num_carrera;
            }); //primera carrerra
            if (this.sededeipress.length > 0) {
                vm.sededeipress = vm.sededeipress[0].codigo_sited
            }

            var iafas = vm.planes.split('-');
            ositedsService.GetEntidadVinculada({
                numCodIafa: iafas[1],
                numCodIpress: vm.sededeipress,
            }).then(function (resOsiteds) {
                if (resOsiteds.nomCodPoseeEntVinculada === 'Y' || resOsiteds.desMensajeEntidadVinculada == "Mensaje Entidad Vinculada") {
                    vm.entVinculada = true;
                    status = true;
                    // vm.spinerLoadingHorasSited = true;
                    // mensaje = resOsiteds.desMensajeEntidadVinculada ? resOsiteds.desMensajeEntidadVinculada : 'Si posee entidad vinculada';
                    // Notification.primary({
                    //     message: mensaje
                    // });
                    vm.loadBusquedaIafa();
                }
                if (resOsiteds.coError == 0 || resOsiteds.nomCodPoseeEntVinculada === 'N' || resOsiteds.nomCodPoseeEntVinculada == '0') {
                    num_carrera++; //segunda carrerra
                    vm.entVinculada = false;
                    mensaje = resOsiteds.desMensajeEntidadVinculada ? resOsiteds.desMensajeEntidadVinculada : 'No posee entidad vinculada';
                    vm.sededeipress = vm.iprees_sited.filter(function (row) {
                        return row.idsede == vm.citamedica.idsede && row.n_carrera == num_carrera;
                    })[0].codigo_sited;
                    ositedsService.GetEntidadVinculada({
                        numCodIafa: iafas[1],
                        numCodIpress: vm.sededeipress,
                    }).then(function (resOsiteds) {

                        if (resOsiteds.nomCodPoseeEntVinculada === 'Y' || resOsiteds.desMensajeEntidadVinculada == "Mensaje Entidad Vinculada") {
                            vm.entVinculada = true;
                            status = true;
                            // vm.spinerLoadingHorasSited = true;
                            // mensaje = resOsiteds.desMensajeEntidadVinculada ? resOsiteds.desMensajeEntidadVinculada : 'Si posee entidad vinculada';
                            // Notification.primary({
                            //     message: mensaje
                            // });
                            vm.loadBusquedaIafa();
                        }
                        if (resOsiteds.coError == 0 || resOsiteds.nomCodPoseeEntVinculada === 'N' || resOsiteds.nomCodPoseeEntVinculada == '0') {
                            num_carrera++; //tercera carrerra
                            vm.entVinculada = false;
                            mensaje = resOsiteds.desMensajeEntidadVinculada ? resOsiteds.desMensajeEntidadVinculada : 'No posee entidad vinculada';
                            vm.sededeipress = vm.iprees_sited.filter(function (row) {
                                return row.idsede == vm.citamedica.idsede && row.n_carrera == num_carrera;
                            })[0].codigo_sited;
                            ositedsService.GetEntidadVinculada({
                                numCodIafa: iafas[1],
                                numCodIpress: vm.sededeipress,
                            }).then(function (resOsiteds) {

                                if (resOsiteds.nomCodPoseeEntVinculada === 'Y' || resOsiteds.desMensajeEntidadVinculada == "Mensaje Entidad Vinculada") {
                                    vm.entVinculada = true;
                                    status = true;
                                    // vm.spinerLoadingHorasSited = true;
                                    // mensaje = resOsiteds.desMensajeEntidadVinculada ? resOsiteds.desMensajeEntidadVinculada : 'Si posee entidad vinculada';
                                    // Notification.primary({
                                    //     message: mensaje
                                    // });
                                    vm.loadBusquedaIafa();
                                }

                                if (resOsiteds.coError == 0 || resOsiteds.nomCodPoseeEntVinculada === 'N' || resOsiteds.nomCodPoseeEntVinculada == '0') {
                                    num_carrera++; //cuarta carrerra
                                    vm.entVinculada = false;
                                    mensaje = resOsiteds.desMensajeEntidadVinculada ? resOsiteds.desMensajeEntidadVinculada : 'No posee entidad vinculada';
                                    vm.sededeipress = vm.iprees_sited.filter(function (row) {
                                        return row.idsede == vm.citamedica.idsede && row.n_carrera == num_carrera;
                                    })[0].codigo_sited;
                                    ositedsService.GetEntidadVinculada({
                                        numCodIafa: iafas[1],
                                        numCodIpress: vm.sededeipress,
                                    }).then(function (resOsiteds) {
                                        if (resOsiteds.nomCodPoseeEntVinculada === 'Y' || resOsiteds.desMensajeEntidadVinculada == "Mensaje Entidad Vinculada") {
                                            vm.entVinculada = true;
                                            status = true;
                                            vm.spinerLoadingHorasSited = true;
                                            mensaje = resOsiteds.desMensajeEntidadVinculada ? resOsiteds.desMensajeEntidadVinculada : 'Si posee entidad vinculada';
                                            Notification.primary({
                                                message: mensaje
                                            });
                                            vm.loadBusquedaIafa();
                                        }
                                        if (resOsiteds.coError == 0 || resOsiteds.nomCodPoseeEntVinculada === 'N' || resOsiteds.nomCodPoseeEntVinculada == '0') {
                                            vm.spinerHorapaso3 = false;
                                            vm.entVinculada = false;
                                            // vm.spinerLoadingHorasSited = true;
                                            mensaje = resOsiteds.desMensajeEntidadVinculada ? resOsiteds.desMensajeEntidadVinculada : 'Si posee entidad vinculada';
                                            Notification.warning({ message: 'No se encontró cobertura, para poder ayudarlo comuniquese con nuestra central teléfonica. (01) 7390888 ' });
                                            // $uibModalInstance.close(false);
                                            return false;
                                            // Notification.primary({
                                            //   message: mensaje
                                            // });
                                        }
                                    });
                                }
                            });
                        }
                    });
                } else if (resOsiteds.coError) {
                    vm.spinerHorapaso3 = false;
                    Notification.warning({ message: 'No se encontró cobertura, para poder ayudarlo comuniquese con nuestra central teléfonica. (01) 7390888 ' });
                    $uibModalInstance.close(false);
                    return false;
                }
            })
        }

        vm.loadBusquedaIafa = function () {
            var iafas = vm.planes.split('-');
            if (!iafas[1]) {
                Notification.warning({ message: 'Seleccione IAFA' });
                return false;
            }
            if (!vm.sededeipress) {
                Notification.warning({ message: 'Seleccione Ipress' });
                return false;
            }

            vm.filaSelectBusqueda = [];
            vm.gridBusqueda.data = [];
            vm.gridBeneficios.data = [];
            vm.sitedsDetalle = null;
            vm.restricciones = null;
            vm.datosPacienteRegafi = null;
            console.log("$rootScope.entidad", $rootScope.entidad)
            ositedsService.GetCodigoAfiliadoSiteds({
                apePaternoOrNumDniAsegurado: $rootScope.entidad.numerodoc,
                numCodIafa: iafas[1],
                numCodIpress: vm.sededeipress,
            }).then(function (resOsiteds) {
                vm.spinerLoadingHorasSited = true;
                if (resOsiteds.coError) {
                    Notification.warning({ message: resOsiteds.desError });
                    $uibModalInstance.close(false);
                    return false;
                } else {
                    vm.gridBusqueda.data = resOsiteds;

                    if (vm.gridBusqueda.data.length == 1 && vm.gridBusqueda.data[0].nomCodEstado == "VIGENTE" && vm.gridBusqueda.data[0].nomProducto != "SCTR") { // cuando solo tiene un producto
                        var sede = vm.sedesdeipress.filter(function (row) {
                            return row.CO_RENIPRESS == vm.sededeipress;
                        })[0];
                        Notification.primary({ message: 'Se esta buscado beneficio para la sede.' });
                        console.log("cargaproducto")
                        vm.capturarProducto(vm.gridBusqueda.data[0]);
                    } else if (vm.gridBusqueda.data.length > 1) {
                        var checkBeneficiario = false;
                        vm.gridBusqueda.data.forEach(function (row) {
                            if (row.nomCodEstado == "VIGENTE" && row.numDocumentoAsegurado == $rootScope.entidad.numerodoc && row.nomProducto != "SCTR") {
                                checkBeneficiario = true;
                                console.log("row.checkBeneficiario", checkBeneficiario);
                                vm.capturarProducto(row);
                            }
                        });
                        if (!checkBeneficiario) {
                            vm.spinerHorapaso3 = false;
                            console.log("NO hay cobertura")
                            Notification.warning({ message: 'No se encontró cobertura, para poder ayudarlo comuniquese con nuestra central teléfonica. (01) 7390888 ' });
                            $uibModalInstance.close(false);
                            return false;

                        }
                    } else {
                        vm.spinerLoadingHorasSited = true;
                    }
                }
                if (resOsiteds.success == false) {
                    Notification.warning({ message: 'No hay respuesta del SitedWeb. Intente nuevamente' });
                    $uibModalInstance.close(false);
                    return false;
                }
            });

        }

        vm.capturarProducto = function (producto) {
            producto.numRuc = '20431738806';
            vm.spinerLoadingHorasSited = false;
            vm.productodetalle = producto;
            if (producto.nomColorEstado === 'ROJO') {
                Notification.warning({ message: 'El asegurado no se encuentra Vigente.' });
                vm.spinerLoadingHorasSited = true;
                return false;
            }
            vm.ProductoSeleccionado = producto
            vm.filaSelectBeneficio = [];
            vm.gridBeneficios.data = [];
            ositedsService.GetDetalleAseguradoSiteds(producto)
                .then(function (resDetAsegOsiteds) {
                    if (resDetAsegOsiteds.coError) {
                        Notification.error({ message: resDetAsegOsiteds.desError });
                        vm.active = 0;
                    } else {
                        if (resDetAsegOsiteds.indAfiliadoSinCobertActConIpress === false) {
                            vm.active = 0;


                            Notification.warning({ message: 'No se encontro beneficio para la sede.' });
                            // vm.sededeipress = vm.iprees_sited.filter(function(row) {
                            //     return row.idsede == vm.citamedica.idsede && row.n_carrera == num_carrera_global;
                            // })[0].codigo_sited;

                            Object.keys(vm.sedesdeipressTemp).forEach(function (key) {
                                if (vm.sedesdeipressTemp[key]['CO_RENIPRESS'] === vm.sededeipress) {
                                    vm.sedesdeipressTemp[key]['ESTADO'] = 0;
                                }
                            });
                            num_carrera_global++;
                            vm.sededeipress = vm.iprees_sited.filter(function (row) {
                                return row.idsede == vm.citamedica.idsede && row.n_carrera == num_carrera_global;
                            })[0].codigo_sited;

                            vm.loadBusquedaIafa();

                            // Notification.error({ message: 'El afiliado no tiene coberturas activas para ORG. DE SALUD INTERCONTINENTAL S.A.' });
                        } else {
                            vm.sitedsDetalle = resDetAsegOsiteds
                            vm.gridBeneficios.data = resDetAsegOsiteds.beneficios;
                            vm.numDocPacRegafiBusqueda = vm.sitedsDetalle.datosPaciente.numDocumento;
                            //logica de beneficio
                            vm.gridBeneficios.data.forEach(function (row, index) {
                                vm.beneficio.forEach(function (row2) {
                                    var array_plan = (row2.plan_seguros).split(';');

                                    array_plan.forEach(function (row3) {
                                        var iafas = vm.planes.split('-');
                                        if (row3 == iafas[0]) {
                                            if (row.numCodigoBeneficio == row2.codigo) {
                                                vm.active = 1;
                                                vm.status_recomen_beneficio = true;
                                                vm.cobertura = row;
                                                // vm.cobertura.codbeneficio=row.numCodigoBeneficio;
                                                // vm.cobertura.deducible=row.desCopagoVariable;
                                                // vm.cobertura.coa=parseInt(row.numCopagoVariable)+'%';
                                                vm.recomen_beneficio = row;
                                                vm.cobertura.seguro = vm;
                                                // vm.gridApiBeneficios.grid.modifyRows(vm.gridBeneficios.data);
                                                // vm.gridApiBeneficios.selection.selectRow(vm.gridBeneficios.data[index]);
                                                vm.spinerLoadingHorasSited = true;
                                                var sede = vm.sedesdeipress.filter(function (row) {
                                                    return row.CO_RENIPRESS == vm.sededeipress;
                                                })[0];
                                                Notification.primary({ message: 'Se encontro beneficio para la sede.' });
                                                vm.spinerHorapaso3 = false;

                                                vm.detalleFinal = {
                                                    status_recomen_beneficio: true,
                                                    cobertura: row,
                                                    codbeneficio: row.numCodigoBeneficio,
                                                    deducible: row.desCopagoVariable,
                                                    coa: parseInt(row.numCopagoVariable) + '%',
                                                    recomen_beneficio: row,
                                                    seguro: vm

                                                };
                                                vm.guardaCobertura(vm.detalleFinal);
                                                return;
                                            }
                                        }
                                    });
                                });
                            });
                            // logica para definir beneficio
                            if (vm.cobertura == undefined) {

                                var sede = vm.sedesdeipress.filter(function (row) {
                                    return row.CO_RENIPRESS == vm.sededeipress;
                                })[0];
                                Notification.warning({ message: 'No se encontro beneficio para la sede.' });

                                Object.keys(vm.sedesdeipressTemp).forEach(function (key) {
                                    if (vm.sedesdeipressTemp[key]['CO_RENIPRESS'] === vm.sededeipress) {
                                        vm.sedesdeipressTemp[key]['ESTADO'] = 0;
                                    }
                                });
                                num_carrera_global++;
                                vm.sededeipress = vm.iprees_sited.filter(function (row) {
                                    return row.idsede == vm.citamedica.idsede && row.n_carrera == num_carrera_global;
                                })[0].codigo_sited;
                                vm.loadBusquedaIafa();
                            }

                        }
                    }
                });

            vm.desCondicionesMedicos = null;

            ositedsService.GetCondicionesMedicas(producto)
                .then(function (resDetAsegOsiteds) {
                    vm.oCondicionesMedicas = resDetAsegOsiteds;
                    vm.indExisteCondicion = resDetAsegOsiteds.indExisteCondicion;

                });
        }

        vm.guardaCobertura = function (detalle) {
            $('#button_pago').hide();
            vm.izipayIniciado = false;
            vm.citamedica.mediopago = null;
            vm.checkmedioPE = false;

            var correo = $('#correo').val()
            if (correo != undefined) {
                vm.correo = correo;
            }
            if (vm.correo == '') {
                Notification.warning({ message: 'Ingresar el correo electrónico' });
                return false;
            };
            $('#aceptar_correo').prop("disabled", true);

            vm.preciocm = parseFloat(detalle.cobertura.impCopagoFijo) * 100;

            var usu_izipay = null;
            var passw_izipay = null;
            var llave_publica = null;
            var pe_idservice = null;
            var pe_accesskey = null;
            var pe_secretkey = null;
            vm.sedes.forEach(function (row) {
                if (row.idsede === parseInt(vm.citamedica.idsede, 10)) {
                    usu_izipay = row.usu_izipay;
                    passw_izipay = row.passw_izipay;
                    llave_publica = row.clave_publica_izipay;
                    pe_idservice = row.pe_idservice;
                    pe_accesskey = row.pe_accesskey;
                    pe_secretkey = row.pe_secretkey;
                }
            });
            if (usu_izipay == null || passw_izipay == null) {
                Notification.warning({ message: 'Los Servicios no funcionaron correctamente"' });
                vm.spinerLoadingfecha = false;
                return false;
            }

            var today = new Date();
            var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            var dateTime = date + ' ' + time;
            var aleatorio = Math.floor(Math.random() * (999 - 100 + 1) + 100);
            var orderid = "pagoPortalCitamedica" + '_' + $rootScope.entidad.identidad + '_' + aleatorio;

            vm.param = {
                'usuario': usu_izipay,
                'password': passw_izipay,
                'llave_publica': llave_publica,
                "pe_idservice": pe_idservice,
                "pe_accesskey": pe_accesskey,
                "pe_secretkey": pe_secretkey,
                'precio': vm.preciocm,
                'email': vm.correo,
                'orderid': orderid
            }
            vm.precio = (parseFloat(vm.preciocm) / 100).toFixed(2);
            console.log("vm.param", vm.param);
            vm.infocita = true;
            if (vm.preciocm == 0) {
                debugger
                vm.checkCobertura == false;
                vm.infocita = false;
                Notification.warning({ message: 'Usted tiene un deducible costo cero , en ese caso, para poder ayudarlo comuníquese con nuestra central telefónica. (01) 7390888' });
                return false;
            }
        }

        vm.mediopago_select = function (mediopago) {
            if (mediopago == 'izipay') {
                vm.checkmedioPE = false;

                // Si ya fue creado y el contenedor tiene los elementos de Krypton, sólo lo mostramos
                if (vm.izipayIniciado && $('#button_pago .kr-embedded').length > 0) {
                    $('#button_pago').stop(true, true).fadeIn(300);
                    vm.spinerLoadingPagar = false;
                } else {
                    vm.spinerLoadingPagar = true;
                    $('#button_pago').hide();
                    vm.formulariocreate(vm.param);
                }
            } else {
                // Pagoefectivo seleccionado
                vm.spinerLoadingPagar = false;
                // Ocultar botón de Izipay sin destruir su HTML ni la instancia de Krypton
                $('#button_pago').hide();
                if (window.KR && typeof window.KR.closePopin === 'function') {
                    try { window.KR.closePopin(); } catch (e) { }
                }
                vm.checkmedioPE = true;
                console.log("Pagoefectivo", vm.param);
            }
        };

        function loadScriptKR(src, llave, callback) {
            var script = document.createElement("script");
            script.setAttribute("src", src);
            script.setAttribute('kr-public-key', llave);
            script.setAttribute('id', 'payment_kr');
            script.addEventListener("load", callback);
            document.head.appendChild(script);
        }

        vm.formulariocreate = function (param) {
            vm.spinerLoadingPagar = true;
            $('#button_pago').hide();

            citamedicaService.CrearFormularioIziPay(param).then(function (array2) {

                if (array2.status == "SUCCESS") {
                    $('#button_pago').empty().hide();

                    $('#button_pago').append('<div class="kr-embedded" kr-popin kr-form-token="' + array2.answer.formToken + '" id="form_login" style="margin: 15px auto; text-align: center;">' +
                        '<div class="kr-pan"></div>' +
                        '<div class="kr-expiry"></div>' +
                        '<div class="kr-security-code"></div>' +
                        '<button class="kr-payment-button"></button>' +
                        ' <div class="customerror"></div>' +
                        '</div>');

                    vm.formtoken = true;
                    vm.spinerLoadingfecha = false;
                    vm.izipayIniciado = true;

                    $('#response_page').val('');

                    var setupKRListeners = function () {
                        try {
                            if (window.KR) {
                                KR.setShopName('Centro Medico OSI Servicio: Consulta Evaluacion Medicina Alternativa');
                                $('#kr-field-app-16').children().css('border', '1px solid #ced4da');

                                KR.onSubmit(function (event) {
                                    if (event.clientAnswer && event.clientAnswer.orderStatus == 'PAID') {
                                        $('#response_page').val(JSON.stringify(event));
                                        try {
                                            KR.closePopin();
                                        } catch (e) {
                                            console.warn("Error closePopin:", e);
                                        }
                                        $scope.$evalAsync(function () {
                                            vm.openPagar();
                                        });
                                        $('#button_page').click();
                                    }

                                    if (event.clientAnswer) {
                                        $('.kr-payment-button > span:first').html(event.clientAnswer.orderStatus);
                                    }
                                    $('.kr-spinner').hide();
                                    $('.kr-payment-button > span:first').show();

                                    return false;
                                });

                                KR.onError(function (event) {
                                    var message = (event && (event.errorMessage || event.detailedErrorMessage)) || 'Error en pasarela de pagos';
                                    var code = event ? (event.errorCode || event.detailedErrorCode) : null;

                                    // Ignorar si el usuario cierra el popin, cancela o cambia de medio de pago
                                    if (code === 'CLIENT_101' ||
                                        message === 'Abortado' ||
                                        (typeof message === 'string' && (
                                            message.toLowerCase().indexOf('abort') >= 0 ||
                                            message.toLowerCase().indexOf('cancel') >= 0
                                        ))
                                    ) {
                                        console.warn("Transacción cancelada o popin cerrado por el usuario:", event);
                                        return false;
                                    }

                                    if (message) {
                                        Notification.error({ message: message, templateUrl: 'angular-ui-notification-intranet-error.html' });
                                    }
                                    return false;
                                });
                            }
                        } catch (error) {
                            console.warn("Aviso al configurar KR:", error);
                        }
                    };

                    // Si KR ya está disponible en window (instancia existente), actualizamos el token
                    if (window.KR && typeof window.KR.setFormToken === 'function') {
                        window.KR.setFormToken(array2.answer.formToken).then(function () {
                            setupKRListeners();
                            setTimeout(function () {
                                if (vm.citamedica && vm.citamedica.mediopago === 'izipay') {
                                    $('#button_pago').fadeIn(300);
                                }
                                $scope.$evalAsync(function () {
                                    vm.spinerLoadingPagar = false;
                                });
                            }, 500);
                        }).catch(function (err) {
                            console.warn("setFormToken catch:", err);
                            setupKRListeners();
                            setTimeout(function () {
                                if (vm.citamedica && vm.citamedica.mediopago === 'izipay') {
                                    $('#button_pago').fadeIn(300);
                                }
                                $scope.$evalAsync(function () {
                                    vm.spinerLoadingPagar = false;
                                });
                            }, 500);
                        });
                    } else {
                        // Primera carga del script
                        $('#payment_kr').remove();
                        loadScriptKR('https://static.micuentaweb.pe/static/js/krypton-client/V4.0/stable/kr-payment-form.min.js', param.llave_publica, function () {
                            setTimeout(function () {
                                setupKRListeners();
                            }, 1000);

                            setTimeout(function () {
                                if (vm.citamedica && vm.citamedica.mediopago === 'izipay') {
                                    $('#button_pago').fadeIn(300);
                                }
                                $scope.$evalAsync(function () {
                                    vm.spinerLoadingPagar = false;
                                });
                            }, 1200);
                        });
                    }

                } else {
                    vm.spinerLoadingPagar = false;
                    Notification.warning({ message: 'Los Servicios de Izipay no funcionaron correctamente' });
                    $scope.miForm.$submitted = false;
                    return false;
                }
            }, function (error) {
                vm.spinerLoadingPagar = false;
                Notification.error({ message: 'Error al conectar con la pasarela de pagos.' });
                $scope.miForm.$submitted = false;
                return false;
            });
        };
        vm.sede_select = function () {
            debugger;

            if ($stateParams.idsede && sede_local) {
                vm.citamedica.idsede = $stateParams.idsede;
                // vm.sede_select();
            }

            // if (vm.sedes == undefined)
            //     return;

            if (!sede_local) {
                $('#referenciar').attr('href', '#/reservar-cita-medica/' + vm.citamedica.idsede)
                $('#referenciar').click();
                sede_local = true;
                $stateParams.idsede = vm.citamedica.idsede;
                window.location.reload();
            }
            sede_local = false;
            vm.spinerLoadingfecha = true;
            vm.correo = $rootScope.entidad.email;

            sedeService.GetHorariosDisponibles({ sedeid: vm.citamedica.idsede }).then(function (horarios) {
                vm.spinerLoadingfecha = false;
                vm.checkpaso2 = true;
                var fechasdisponibles = horarios.data;
                vm.availableDates = [];

                var arrayDate = []
                angular.forEach(fechasdisponibles, function (row) {
                    arrayDate.push(new Date(row));
                })

                $scope.availableDates = arrayDate;

                vm.dateOptions = {
                    minDate: new Date(),
                    showWeeks: false,
                    dateDisabled: function (data) {
                        var date = data.date,
                            mode = data.mode;
                        return mode === 'day' && !$scope.IsDateAvailable(date);
                    }
                };
            });

            // var fechasdisponibles = vm.sedes.filter(function (row) {
            //   return row.idsede == vm.citamedica.idsede;
            // })[0].disponibles;

            // var arrayDate = []
            // angular.forEach(fechasdisponibles, function(row) {
            //     arrayDate.push(new Date(row));
            // })
            // $scope.availableDates = arrayDate;
            // vm.dateOptions = {
            //     minDate: new Date(),
            //     showWeeks: false,
            //     dateDisabled: function(data) {
            //         var date = data.date,
            //             mode = data.mode;
            //         return mode === 'day' && !$scope.IsDateAvailable(date);
            //     }
            // };
        };





        vm.consultarMedicos = function () {
            vm.checkCobertura == false;
            vm.spinerLoadingHoras = true;
            $('#button_pago').empty().hide();
            $('#detalle_cita').css('display', 'none');
            vm.infocita = false;
            vm.checkCobertura = false;
            vm.izipayIniciado = false;
            vm.citamedica.mediopago = null;
            vm.radioModel = {};
            var fecha = $filter('date')(vm.dt, 'dd/MM/yyyy');
            var param = {
                idsede: vm.citamedica.idsede,
                fecha: fecha,
                idperfil: 3
            };

            citamedicaService.GetmedicosDisponibles(param).then(function (array) {
                // Citas mayor a la hora actual
                array.data.forEach(function (row) {
                    row.horas.forEach(function (hora) {
                        hora.inicioms = formatoMs(fecha, hora.inicio);
                        hora.finms = formatoMs(fecha, hora.fin);
                    });

                    var horasValida = row.horas.filter(function (hora) {
                        return hora.inicioms > milisegundosactual
                    });

                    row.horas = horasValida;
                });

                var dataHoras = array.data.filter(function (row) {
                    return row.horas.length > 0
                });

                vm.medicos = dataHoras;
                vm.spinerLoadingHoras = false;
            });
            vm.nombresede = selectObject(vm.sedes, parseInt(vm.citamedica.idsede, 10), 'idsede').nombre;

        };
        vm.labelHoraCitamedica = function () {
            vm.spinerHorapaso3 = true;
            var citamedica = {
                idsede: parseInt(vm.citamedica.idsede, 10),
                idpaciente: $rootScope.entidad.identidad,
                fecha: $filter('date')(vm.dt, 'dd/MM/yyyy'),
                inicio: vm.radioModel.inicio,
                fin: vm.radioModel.fin,
                email: vm.correo,
                horaactual: 1,
                idmedico: vm.radioModel.idmedico,
                orderid: "pagoPortalCitamedica" + '_' + $rootScope.entidad.identidad,
                bloqueo: 1 // bloquea el horario 15 min mientras el paciente paga 
            };


            citamedicaService.CreateTempCitaMedica({ citamedica: citamedica }).then(function (array) {
                vm.spinerHorapaso3 = false;
                if (array.type === 'success') {
                    // $('#button_pago').css('display', 'block');
                    // $('#detalle_cita').css('display', 'block')
                    vm.checkCobertura = true;
                } else {
                    Notification.error({ message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                }
            });

        }
        /*Modal Mapa Sede*/
        vm.openMapaSedeModal = function (id) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalMapaSedeContent.html',
                controller: 'modalMapaSedeCtrl as vm',
                windowClass: 'modal-primary',
                // size: 'lg',
                resolve: {
                    modalParam: function () {
                        return {
                            idsede: id
                        };
                    }
                }
            });
            modalInstance.result.then(function (reload) { }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        vm.openPagadoModal = function (fileNamePdf) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalPagadoContent.html',
                controller: 'modalPagadoCtrl as vm',
                windowClass: 'modal-primary',
                size: 'sm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    modalParam: function () {
                        return {
                            filenamepdf: fileNamePdf
                        };
                    }
                }
            });
            modalInstance.result.then(function (reload) {

            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        vm.generarCIP = function () {
            $("#btngeneracip").prop('disabled', true);
            vm.modalParam = {
                idsede: vm.citamedica.idsede,
                namesede: vm.nombresede,
                pe_idservice: vm.param.pe_idservice,
                pe_accesskey: vm.param.pe_accesskey,
                pe_secretkey: vm.param.pe_secretkey,
                nombre: $rootScope.entidad.nombres,
                apellidos: $rootScope.entidad.apellidos,
                dni: $rootScope.entidad.numerodoc,
                celular: $rootScope.entidad.celular,
                idmedico: vm.radioModel.idmedico,
                namemedico: vm.radioModel.nombre,
                idpaciente: $rootScope.entidad.identidad,
                fecha: vm.radioModel.fecha,
                inicio: vm.radioModel.inicio,
                fin: vm.radioModel.fin,
                idestado: 4, // pendiente
                idestadopago: 72, // pendiente
                idreferencia: 16, // Pagina web
                idatencion: 70, // Portal paciente
                email: $rootScope.entidad.email,
                seguro: vm.seguros,
                cobertura: vm.cobertura,
                precio: (vm.preciocm / 100),
                descripcion: "Intranet paciente",
                orderid: "pagoPortalCitamedica" + '_' + $rootScope.entidad.identidad + '_' + "reserva",
                bloqueo: 1 // bloquea el horario 15 min mientras el paciente paga

            }
            citamedicaService.CreatePagarPe({ citamedica: vm.modalParam }).then(function (array) {
                if (array.type === 'success') {
                    console.log("EXITO", array);
                    $state.go("miscitasmedicas.list");
                    var modalInstance = $uibModal.open({
                        templateUrl: 'myModalCodigoCIPContent.html',
                        controller: 'modalReservaCtrl as vm',
                        windowClass: 'modal-primary',
                        size: 'md',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            modalParam: function () {
                                return {
                                    namesede: vm.nombresede,
                                    nombre: $rootScope.entidad.nombres,
                                    apellidos: $rootScope.entidad.apellidos,
                                    celular: $rootScope.entidad.celular,
                                    namemedico: vm.radioModel.nombre,
                                    fecha: vm.radioModel.fecha,
                                    inicio: vm.radioModel.inicio,
                                    fin: vm.radioModel.fin,
                                    precio: (vm.preciocm / 100),
                                    codigocip: array.data.cip,
                                };
                            }
                        }
                    });
                    modalInstance.result.then(function (reload) {

                    }, function () {
                        $log.info('Modal dismissed at: ' + new Date());
                    });
                    // vm.checkCobertura = true;
                } else {
                    Notification.error({ message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                }
            });
        }

        vm.error_form = function () {
            var error_form = $('#error_form').val();
            if (error_form) {
                Notification.error({ message: error_form, templateUrl: 'angular-ui-notification-intranet-error.html' });
            }
        };

        vm.openPagar = function () {
            var val = $('#response_page').val();
            if (val != '') {
                vm.spinerLoadingPagar = true;
                vm.spinerLoadingPagar = false;
                vm.openPagadoModal('');
                $state.go("mireserva");
                // vm.save(response_page.clientAnswer.orderDetails.orderId, response_page.clientAnswer.transactions[0].transactionDetails.cardDetails.legacyTransId);
            }
        }
        vm.save = function (orderid, transaction) {
            $scope.miForm.$submitted = false;

            var citamedica = {
                idsede: parseInt(vm.citamedica.idsede, 10),
                idmedico: vm.radioModel.idmedico,
                idpaciente: $rootScope.entidad.identidad,
                fecha: $filter('date')(vm.dt, 'dd/MM/yyyy'),
                inicio: vm.radioModel.inicio,
                fin: vm.radioModel.fin,
                idestado: 4, //pendiente
                idreferencia: 16, //Pagina web
                idatencion: 70, //Portal paciente
                email: vm.correo,
                orderid: orderid,
                descripcion: "Intranet paciente",
                transaction: transaction
            };

            citamedicaService.CreatePagarIzipay({ citamedica: citamedica }).then(function (array) {
                if (array.type === 'success') {
                    // Notification.primary({ message: '¡Su <strong>Cita Médica</strong> ha sido <strong>reservada exitosamente</strong>!', templateUrl: 'angular-ui-notification-intranet-primary.html' });
                    vm.spinerLoadingPagar = false;
                    vm.openPagadoModal(array.data.filenamepdf);
                    $state.go("miscitasmedicas.list");
                } else {
                    Notification.error({ message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                    vm.spinerLoadingPagar = false;
                    $scope.miForm.$submitted = false;
                }
            });
        };
        vm.autoValidarCitamedica = function () {
            if ($state.current.name == 'mireservamedica' || $state.current.name == 'mireservamedicasede') {
                vm.spinerLoading = false;
                $timeout(function () {
                    if (vm.checkCobertura == true) {

                        var citamedica = {
                            idsede: parseInt(vm.citamedica.idsede, 10),
                            fecha: $filter('date')(vm.dt, 'dd/MM/yyyy'),
                            inicio: vm.radioModel.inicio
                        };
                        citamedicaService.GetValidarCitamedicaPortal({ citamedica: citamedica }).then(function (array) {
                            if (array.type === 'info') {
                                if (array.data == "Cita Disponible") {
                                    vm.autoValidarCitamedica();
                                } else {
                                    vm.spinerLoading = true;
                                    vm.checkCobertura == false;
                                    Notification.primary({ message: 'Ya <strong> Reservaron la cita en este rango de horario</strong><strong> volver a seleccionar</strong>!', templateUrl: 'angular-ui-notification-intranet-primary.html' });
                                    setTimeout("window.location.reload();$state.go('reservar-cita-medica');", 3000);
                                }
                            } else {
                                Notification.error({ message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                            }
                        });
                    }
                    vm.autoValidarCitamedica();

                }, 30000);
            }
        }
        // vm.autoValidarCitamedica();
    }

    miReservaTerapeutaCtrl.$inject = ['$rootScope', '$scope', '$uibModal', '$state', '$log', '$filter', '$http', 'citaterapeuticaService', 'sedeService', 'Notification', 'cicloatencionService'];

    function miReservaTerapeutaCtrl($rootScope, $scope, $uibModal, $state, $log, $filter, $http, citaterapeuticaService, sedeService, Notification, cicloatencionService) {

        var vm = this;
        vm.data = [];
        vm.diagnostico = [];
        vm.ciclosabiertos = [];
        vm.cicloscerrados = [];

        vm.medicos = [];
        vm.radioModel = {};
        vm.citaterapeutica = {};
        vm.spinerLoading = true;
        vm.spinerLoadingHoras = true;
        vm.dt = null;
        vm.dateOptions = {
            minDate: new Date(),
            showWeeks: false
        };
        vm.nombresede = '';
        var milisegundosactual = new Date().getTime();

        var p = {
            idpaciente: $rootScope.entidad.identidad,
            idestado: 20,
            paciente: 1
        }

        var idsedes = [];
        vm.sedes = [];
        cicloatencionService.GetIndex(p).then(function (array) {
            if (array.code) {
                $('#msj_cita').text(array.message);
            } else {
                if (array.data.length == 0)
                    $('#msj_cita').text('No tiene ciclos de atención abiertos.');
                array.data.forEach(function (row) {
                    if (idsedes.indexOf(row.idsede) === -1) {
                        idsedes.push(row.idsede);
                        vm.sedes.push({ idsede: row.idsede, nombre: row.sedenombre, direccion: row.direccionsede });
                    }
                });
                vm.data = array.others;

                if (vm.data.length > 0) {
                    vm.turnos = '0' + vm.data[0]['ciclo'].turnos + vm.data[0]['ciclo'].idsede;
                }
            }
            vm.spinerLoading = false;
        });


        var idaseguradora = null;
        vm.consultarAseguradoras = function () {
            var param = {
                idpaciente: $rootScope.entidad.identidad,
                idsede: vm.citaterapeutica.idsede
            };

            idaseguradora = null;
            citaterapeuticaService.GetAseguradorasPaciente(param).then(function (array) {

                if (array.data.length === 1) {
                    idaseguradora = array.data[0].idaseguradora;
                }

                var mayor = 0;
                if (array.data.length > 1) {
                    for (i = 0; i < array.data.length; i++) {
                        if (!array.data[i].nroagenda) { //Si esta vacio tomo este
                            idaseguradora = array.data[i].idaseguradora;
                            break;
                        }

                        if (array.data[i].nroagenda > mayor) {
                            mayor = array.data[i].nroagenda;
                            idaseguradora = array.data[i].idaseguradora;
                        }
                    }
                }
                vm.consultarMedicos();
            });
        }

        vm.consultarMedicos = function () {
            debugger;
            if (!vm.turnos) {
                Notification.warning({ message: 'Seleccione ciclo en "PASO 1"' });
                $scope.miForm.$submitted = false;
                return false;
            }

            var turnos = parseInt(vm.turnos.substr(0, 2));
            var sede = vm.turnos.substr(2, vm.turnos.length - 2);
            if (sede == "") {
                Notification.warning({ message: 'No cuenta con historia medica' });
                $scope.miForm.$submitted = false;
                return false;
            }

            vm.radioModel = {};
            var fecha = $filter('date')(vm.dt, 'dd/MM/yyyy');
            var param = {
                idsede: sede,
                fecha: fecha,
                idaseguradora: idaseguradora,
                idpaciente: $rootScope.entidad.identidad,
                turnos: turnos
            };
            vm.spinerLoadingHoras = true;

            // citaterapeuticaService.GetterapistasDisponibles(param).then(function (array) {
            citaterapeuticaService.GetterapistasDisponiblesPostCovid(param).then(function (array) {
                if (array.type === 'success') {

                    // Citas mayor a la hora actual
                    array.data.forEach(function (row) {
                        row.horas.forEach(function (hora) {
                            hora.inicioms = formatoMs(fecha, hora.inicio);
                            hora.finms = formatoMs(fecha, hora.fin);
                        });

                        var horasValida = row.horas.filter(function (hora) {
                            return hora.inicioms > milisegundosactual
                        });

                        row.horas = horasValida;
                    });

                    var dataHoras = array.data.filter(function (row) {
                        return row.horas.length > 0
                    });

                    vm.medicos = dataHoras;
                    vm.spinerLoadingHoras = false;
                } else {
                    Notification.error({ message: array.data });
                }
            });

            vm.nombresede = selectObject(vm.sedes, parseInt(vm.citaterapeutica.idsede, 10), 'idsede').nombre;
        };

        /*Modal Mapa Sede*/
        vm.openMapaSedeModal = function (id) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalMapaSedeContent.html',
                controller: 'modalMapaSedeCtrl as vm',
                windowClass: 'modal-primary',
                // size: 'lg',
                resolve: {
                    modalParam: function () {
                        return {
                            idsede: id
                        };
                    }
                }
            });
            modalInstance.result.then(function (reload) { }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        vm.save = function () {

            if (!vm.dt) {
                Notification.warning({ message: 'Seleccione fecha en "PASO 2"' });
                $scope.miForm.$submitted = false;
                return false;
            }

            if (!vm.radioModel.idmedico) {
                Notification.warning({ message: 'Seleccione hora en "PASO 3"' });
                $scope.miForm.$submitted = false;
                return false;
            }
            var turnos = vm.turnos;
            var turnos_ = turnos.substr(1, 1);
            var sede = turnos.substr(2, turnos.length - 2);


            var citaterapeutica = {
                idsede: sede,
                turnos: turnos_,
                idterapista: vm.radioModel.idmedico,
                idpaciente: $rootScope.entidad.identidad,
                fecha: $filter('date')(vm.dt, 'dd/MM/yyyy'),
                inicio: vm.radioModel.inicio,
                fin: vm.radioModel.fin,
                idestado: 32,
                idaseguradora: idaseguradora,
                portal: 'paciente'
            };

            citaterapeuticaService.Create({ citaterapeutica: citaterapeutica, horaactual: 1 }).then(function (array) {
                if (array.type === 'success') {
                    Notification.primary({ message: '¡Su <strong>Cita de terapia</strong> ha sido <strong>reservada exitosamente</strong>!', templateUrl: 'angular-ui-notification-intranet-primary.html' });
                    $state.go("miscitasterapeutas");
                } else {
                    Notification.error({ title: 'Oh..!', message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                    $scope.miForm.$submitted = false;
                }
            });
        };
    }

    misPagosCtrl.$inject = ['$rootScope', '$scope', '$state', '$uibModal', '$log', 'ventaService', 'settings'];

    function misPagosCtrl($rootScope, $scope, $state, $uibModal, $log, ventaService, settings) {

        try {
            // Verifica si $rootScope.tokenPayload está definido y tiene la propiedad 'my'
            if ($rootScope.tokenPayload && $rootScope.tokenPayload.my) {
                // Accede a la propiedad 'my' de tokenPayload
                console.log('Token payload:', $rootScope.tokenPayload.my);
                // Aquí puedes agregar más lógica si es necesario
            } else {
                window.location = settings.baseURL + '/#/login/';

            }
        } catch (error) {
            window.location = settings.baseURL + '/#/login/';
        }

        var vm = this;
        vm.spinerLoading = true;
        vm.data = [];
        vm.anos = [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017];
        vm.ano = new Date().getFullYear();

        vm.loadPagos = function () {
            vm.spinerLoading = true;
            var desde = '01/01/' + vm.ano;
            var hasta = '31/12/' + vm.ano;
            var param = { idcliente: $rootScope.tokenPayload.my, desde: desde, hasta: hasta };

            ventaService.GetIndex(param).then(function (array) {
                vm.data = array.data;
                vm.data.forEach(function (row) {

                    row.urlPdf = null;
                    if (mayorFechaLimite(row.fechaventa)) {
                        var codTipoDocumento;
                        if (row.iddocumentofiscal === 1) {
                            codTipoDocumento = '01';
                        }

                        if (row.iddocumentofiscal === 2) {
                            codTipoDocumento = '03';
                        }

                        if (row.iddocumentofiscal === 13) {
                            codTipoDocumento = '07';
                        }

                        if (codTipoDocumento) {
                            var nombre = row.numerodocafiliado + '-' + codTipoDocumento + '-' + row.serie + '-' + row.serienumero + '.pdf';
                            row.urlPdf = $rootScope.servidorUrl + '/content/uploads?us=' + $rootScope.token + '&tipFolder=comprobantes&archivo=' + nombre;
                        }
                    }
                });

                vm.spinerLoading = false;
            });
        }


        vm.loadPagos();
    }

    misCiclosDetalleCtrl.$inject = ['$scope', '$state', '$uibModal', 'cicloatencionService', '$stateParams', '$filter', '$log', 'Notification', 'citamedicaService'];

    function misCiclosDetalleCtrl($scope, $state, $uibModal, cicloatencionService, $stateParams, $filter, $log, Notification, citamedicaService) {
        var vm = this;



        vm.cicloatencion = {};
        vm.costototalterapias = 0;
        vm.costototalpagos = 0;
        vm.creditodisp = 0;
        vm.porpagar = 0;
        vm.presupuesto = { montopago: 0, montoefectuado: 0 };
        vm.spinerLoading = true;
        vm.activeCiclo = null;

        vm.spinerLoadingPagar = false;
        vm.detallecompra = [];

        var loadCiclo = function () {


            vm.spinerLoading = true;
            cicloatencionService.GetShow($stateParams.paramId).then(function (array) {
                vm.others = array.others;

                vm.cicloatencion = array.data;
                /* Presupuesto */
                vm.presupuesto = array.others.presupuesto;
                if (vm.presupuesto) {
                    vm.presupuestoseleccionado = vm.presupuesto.tipotarifa === 1 ? vm.presupuesto.regular : (vm.presupuesto.tipotarifa === 2 ? vm.presupuesto.tarjeta : vm.presupuesto.efectivo);
                    vm.creditodisp = vm.presupuesto.montocredito - vm.presupuesto.montoefectuado;
                    vm.porpagar = vm.presupuestoseleccionado - vm.presupuesto.montopago;
                    vm.porpagar = vm.porpagar > 0 ? vm.porpagar : 0;
                }

                array.others.presupuestodet.forEach(function (row) {
                    row.nombretipoprecio = row.tipoprecio === 1 ? 'Cubierto' : (row.tipoprecio === 2 ? 'No cubierto' : 'Particular');
                });

                vm.others.citasmedicas.forEach(function (row) {
                    row.tipoconsulta = row.tipocm === 1 ? 'Consulta' : (row.tipocm === 2 ? 'Interconsulta' : '');
                });

                vm.others.terapiasrealizadas.forEach(function (row) {
                    vm.costototalterapias += row.total;
                    if (row.inicio)
                        row.inicio = $filter('date')(formatoMs(row.fecha, row.inicio), 'hh:mm a');
                    if (row.fin)
                        row.fin = $filter('date')(formatoMs(row.fecha, row.fin), 'hh:mm a');
                });

                vm.others.pagosrealizadas.forEach(function (row) {
                    row.total = parseFloat(row.total);
                    if (row.nota === 'notadebito')
                        row.total = row.total * -1;
                    vm.costototalpagos += row.total;
                });

                vm.others.pagosconsultas.forEach(function (row) {
                    row.total = parseFloat(row.total);
                    if (row.nota === 'notadebito')
                        row.total = row.total * -1;
                });

                vm.spinerLoading = false;
            });
        }

        /*Modal Mapa Sede*/
        vm.openSeleccionarPagoModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalSeleccionarPagoContent.html',
                controller: 'modalSeleccionarPagoCtrl as vm',
                windowClass: 'modal-primary',
                // size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    modalParam: function () {
                        return {
                            presupuesto: vm.presupuesto,
                            presupuestodet: vm.others.presupuestodet,
                            idsede: vm.cicloatencion.idsede,
                            email: vm.cicloatencion.email
                        };
                    }
                }
            });

            modalInstance.result.then(function (reload) {
                if (!reload) {
                    return false;
                }
                vm.spinerLoadingPagar = true;

                var ab = $('#funciones_izi').length;
                if (ab > 0) {
                    window.location.reload();
                    $state.go("mis-ciclos");
                }


                var total = 0;
                reload.ventadet.forEach(function (row) {
                    total += row.total;
                    row.idcicloatencion = vm.cicloatencion.idcicloatencion
                });

                total = redondearValor(total, 2);
                var amout = total * 100;

                vm.detallecompra = reload;
                vm.detallecompra.amout = amout;
                vm.detallecompra.subtotal = redondearValor(total / 1.18, 2);
                vm.detallecompra.valorimpuesto = redondearValor(total - redondearValor(total / 1.18, 2), 2);
                vm.detallecompra.total = total;

                var today = new Date();
                var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
                var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                var dateTime = date + ' ' + time;


                var param = {
                    'usuario': vm.detallecompra.afiliado.usu_izipay,
                    'password': vm.detallecompra.afiliado.passw_izipay,
                    'precio': amout,
                    'email': vm.cicloatencion.email,
                    'orderid': 'PagoTratamiento' + '_' + vm.cicloatencion.identidad + '_' + 'Servicio: ' + reload.codigocompra
                }

                function loadScriptKR(src, callback) {
                    var script = document.createElement("script");
                    script.setAttribute("src", src);
                    script.setAttribute('kr-public-key', vm.detallecompra.afiliado.clave_publica_izipay);
                    script.setAttribute('id', 'payment_kr');
                    script.addEventListener("load", callback);
                    document.head.appendChild(script);
                    vm.spinerLoadingPagar = false;
                };

                var parametros_envio = {//registrar un temporal de tratamiento para validar
                    venta: {
                        idsede: vm.cicloatencion.idsede,
                        idpaciente: vm.cicloatencion.identidad,
                        subtotal: vm.detallecompra.subtotal,
                        valorimpuesto: vm.detallecompra.valorimpuesto,
                        total: vm.detallecompra.total,
                        idcicloatencion: vm.cicloatencion.idcicloatencion,
                        email: vm.cicloatencion.email,
                        amount: vm.detallecompra.amout,
                        description: vm.detallecompra.codigocompra,
                        orderid: param.orderid
                    },
                    ventadet: vm.detallecompra.ventadet,
                    afiliado: {
                        idafiliado: vm.detallecompra.afiliado.idafiliado,
                        serie: vm.detallecompra.afiliado.serie
                    }
                };
                var data_enviar = {
                    'params': parametros_envio,
                    'orderid': param.orderid,
                    'idpaciente': vm.cicloatencion.identidad
                }

                citamedicaService.CreateTempTratamiento(data_enviar).then(function (array) {
                    vm.spinerHorapaso3 = false;
                    if (array.type === 'success') {
                        citamedicaService.CrearFormularioIziPay(param).then(function (array2) {
                            if (array2.status == "SUCCESS") {
                                $('#button_pago').empty();
                                $('#payment_kr').remove();
                                $('#css_izi').remove();
                                $('#funciones_izi').remove();
                                $('#krtoolbar').remove();

                                $('#button_pago').append('<div class="kr-embedded" kr-popin kr-form-token="' + array2.answer.formToken + '" id="form_login">' +
                                    '<div class="kr-pan"></div>' +
                                    '<div class="kr-expiry"></div>' +
                                    '<div class="kr-security-code"></div>' +
                                    '<button class="kr-payment-button"  ></button>' +
                                    ' <div class="customerror"></div>' +
                                    '</div>');

                                vm.formtoken = true;

                                $('#response_page').val('');
                                var setupKRListenersTratamiento = function () {
                                    try {
                                        if (window.KR) {
                                            KR.setShopName('Centro Medico OSI Servicio: Pago Tratamiento');
                                            $('#kr-field-app-16').children().css('border', '1px solid #ced4da');

                                            KR.onSubmit(function (event) {
                                                if (event.clientAnswer && event.clientAnswer.orderStatus == 'PAID') {
                                                    $('#response_page').val(JSON.stringify(event));
                                                    try {
                                                        KR.closePopin();
                                                    } catch (e) {
                                                        console.warn("Error closePopin:", e);
                                                    }
                                                    $scope.$evalAsync(function () {
                                                        vm.openPagar();
                                                    });
                                                    $('#button_page').click();
                                                }

                                                if (event.clientAnswer) {
                                                    $('.kr-payment-button > span:first').html(event.clientAnswer.orderStatus);
                                                }
                                                $('.kr-spinner').hide();
                                                $('.kr-payment-button > span:first').show();

                                                return false;
                                            });

                                            KR.onError(function (event) {
                                                var message = (event && (event.errorMessage || event.detailedErrorMessage)) || 'Error en pasarela de pagos';
                                                var code = event ? (event.errorCode || event.detailedErrorCode) : null;
                                                if (code === 'CLIENT_101' || message === 'Abortado') {
                                                    return false;
                                                }
                                                $('#error_form').val(message);
                                                vm.error_form();
                                                return false;
                                            });
                                        }
                                    } catch (error) {
                                        console.warn("Aviso KR tratamiento:", error);
                                    }
                                };

                                loadScriptKR('https://static.micuentaweb.pe/static/js/krypton-client/V4.0/stable/kr-payment-form.min.js', function () {
                                    setTimeout(function () {
                                        setupKRListenersTratamiento();
                                    }, 1000);
                                    setTimeout(function () {
                                        $('#button_pago').css('display', 'block');
                                    }, 1000);
                                });

                            } else {
                                Notification.warning({ message: 'Los Servicios de Izipay no funcionaron correctamente"' });
                                $scope.miForm.$submitted = false;
                                return false;
                            }
                        });

                        vm.openPagar(reload.codigocompra, amout, reload.sede);
                        vm.checkCobertura = true;
                    } else {
                        Notification.error({ message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                    }
                });


            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        vm.error_form = function () {
            debugger;
            var error_form = $('#error_form').val();
            Notification.error({ message: error_form, templateUrl: 'angular-ui-notification-intranet-error.html' });
            if (error_form == 'Error HTTP') {
                window.location.reload();
            }
        };

        vm.openPagar = function () {
            var val = $('#response_page').val();
            if (val != '') {
                vm.spinerLoadingPagar = true;
                var response_page = JSON.parse(val);
                vm.save(response_page.clientAnswer.orderDetails.orderId, response_page.clientAnswer.transactions[0].transactionDetails.cardDetails.legacyTransId);
            }
        }
        vm.save = function (orderid, transaction) {

            var param = {
                venta: {
                    idsede: vm.cicloatencion.idsede,
                    idpaciente: vm.cicloatencion.identidad,
                    subtotal: vm.detallecompra.subtotal,
                    valorimpuesto: vm.detallecompra.valorimpuesto,
                    total: vm.detallecompra.total,
                    idcicloatencion: vm.cicloatencion.idcicloatencion,
                    email: vm.cicloatencion.email,
                    amount: vm.detallecompra.amout,
                    description: vm.detallecompra.codigocompra,
                    orderid: orderid,
                    transaction: transaction
                },
                ventadet: vm.detallecompra.ventadet,
                afiliado: {
                    idafiliado: vm.detallecompra.afiliado.idafiliado,
                    serie: vm.detallecompra.afiliado.serie
                }
            };
            citamedicaService.CreatePagarTratIzipay(param).then(function (array) {
                if (array.type === 'success') {
                    loadCiclo();
                    vm.spinerLoadingPagar = false;
                    vm.openPagadoModal(array.data.filenamepdf);
                } else {
                    Notification.error({ message: array.data, templateUrl: 'angular-ui-notification-intranet-error.html' });
                    vm.spinerLoadingPagar = false;
                }
            });
        };

        vm.openPagadoModal = function (fileNamePdf) {
            var modalInstance = $uibModal.open({
                templateUrl: 'myModalTratPagadoContent.html',
                controller: 'modalPagadoCtrl as vm',
                windowClass: 'modal-primary',
                size: 'sm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    modalParam: function () {
                        return {
                            filenamepdf: fileNamePdf
                        };
                    }
                }
            });
            modalInstance.result.then(function (reload) {

            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };

        loadCiclo();

    }

    modalArchivosAdjuntosInstanceCtrl.$inject = ['$scope', '$rootScope', '$uibModalInstance', 'modalParam', 'citamedicaarchivoService', 'enterpriseService', 'Notification'];

    function modalArchivosAdjuntosInstanceCtrl($scope, $rootScope, $uibModalInstance, modalParam, citamedicaarchivoService, enterpriseService, Notification) {

        var vm = this;

        vm.galeria = {};
        vm.data = [];
        vm.src = $rootScope.servidorUrl + '/content/uploads?us=' + $rootScope.token + '&tipFolder=adjuntos_citasmedicas&archivo=';
        vm.spinerLoading = true;
        vm.submit = false;
        vm.citamedica = modalParam.data;

        vm.enviarImagen = function () {
            var file = vm.imagen1;

            if (typeof file === 'undefined' || typeof file.name === 'undefined') {
                Notification.warning({ message: 'Seleccionar archivo' });
                return false;
            } else {
                vm.imagen1 = {};
                // console.log(file.type);
                if (['application/x-msdownload'].indexOf(file.type) !== -1) {
                    Notification.error({ message: 'Archivo no permitido' });
                    return false;
                }

                enterpriseService.UploadtmpFile(file, 'adjuntos_citasmedicas').then(function (array) {
                    if (array.type === 'success') {
                        vm.galeria.idcitamedica = modalParam.data.idcitamedica
                        vm.galeria.nombre = array.data.name;
                        vm.galeria.archivo = array.data.file;
                        vm.save();
                    } else {
                        Notification.error({ message: array.data });
                    }
                });
            }
        };

        vm.loadGaleria = function () {
            var param = {
                idcitamedica: modalParam.data.idcitamedica
            };
            vm.spinerLoading = true;
            citamedicaarchivoService.GetIndex(param).then(function (data) {
                vm.spinerLoading = false;
                vm.data = data.data.map(function (row) {
                    row.tipo = row.nombre.split(".").reverse()[0];
                    return row;
                });
            });
        }

        vm.deleteImg = function (idcitamedicaarchivo) {
            citamedicaarchivoService.Delete(idcitamedicaarchivo).then(function (array) {
                if (array.type === 'success') {
                    Notification.primary({ message: 'Archivo ' });
                    vm.loadGaleria();
                } else {
                    Notification.error({ message: array.data });
                }
            });
        }

        vm.loadGaleria();

        vm.save = function () {
            var OBJgaleria = {
                citamedicaarchivo: angular.copy(vm.galeria)
            };

            vm.submit = true;
            citamedicaarchivoService.Create(OBJgaleria).then(function (data) {
                if (data.type === 'success') {
                    Notification.primary({ message: data.data });
                    vm.submit = false;
                    vm.loadGaleria();
                } else {
                    Notification.error({ message: data.data });
                    vm.submit = false;
                }
            });
        };

        $scope.close = function () {
            $uibModalInstance.close(true);
        };
    }


    fileModel.$inject = ['$parse']

    function fileModel($parse) {
        //Detecta el cambio en el input y lo asigna al model...
        //Tal como lo explica aca: http://uncorkedstudios.com/blog/multipartformdata-file-upload-with-angularjs
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;

                element.bind('change', function () {
                    scope.$apply(function () {
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    }


    modalIframeReservasPorAsistirInstanceCtrl.$inject = ['$rootScope', '$scope', '$uibModalInstance', '$state', 'modalParam', '$filter'];

    function modalIframeReservasPorAsistirInstanceCtrl($rootScope, $scope, $uibModalInstance, $state, modalParam, $filter) {

        var vm = this;
        var fecha = $filter('date')(new Date().getTime(), 'dd/MM/yyyy');
        var hora = $filter('date')(new Date().getTime(), 'HH:mm:ss');

        console.log('idpaciente: ' + modalParam.data.idpaciente);

        vm.url = $rootScope.servidor + '/pdf/citaterapeuticaporasistir/' + modalParam.data.idpaciente + '?idsede=' + modalParam.data.idsede + '&inEstado=32,33&fecha=' + fecha + '&hora=' + hora + '&us=' + $rootScope.token;
        console.log(vm.url);
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('minotaur')
        // Setup global settings
        .factory('settings', ['$rootScope', '$location', function($rootScope, $location) {

            var baseURL = null;
            if ($location.host() === 'localhost') {
                baseURL = 'http://localhost:4002';
            } else if ($location.host() === '18.216.230.188') {
                baseURL = 'http://18.216.230.188/clinicanet';
            } else {
                baseURL = 'https://pacientes.centromedicoosi.com';
            }

            var settings = {
                baseURL: baseURL,
                globalImagePath: baseURL + '/assets/images',
                adminImagePath: baseURL + '/assets/admin/img'
            };
            $rootScope.settings = settings;
            return settings;
        }])
        .run(runBlock);

    /** @ngInject */
    function runBlock($log, $rootScope, settings, $state, $stateParams, $location, $cookies, $http, jwtHelper, AuthenticationService, entidadService) {

        $rootScope.$state = $state; // state to be accessed from view
        $rootScope.$location = $location; // location to be accessed from view
        $rootScope.settings = settings; // global settings to be accessed from view
        $rootScope.$stateParams = $stateParams;

        var servidorOsiteds = null;
        var urlente = null;
        var servidor = null;

        if ($location.host() === 'localhost') {
            urlente = 'osi';
            // servidor = 'http://lumenionic.pe';
            servidor = 'http://localhost/api-osi-erp/public/';
            servidorOsiteds = "https://ositeds.centromedicoosi.com"; // Api Sited
            $rootScope.subdominioreal = $location.host();
        } else if ($location.host() === '18.216.230.188') {
            urlente = 'osi'
            servidor = 'http://18.216.230.188/Backend/public'
            servidorOsiteds = "https://ositeds.centromedicoosi.com"; // Api Sited
        } else {
            $rootScope.subdominioreal = $location.host().split(".")[0];
            urlente = 'osi';
            servidor = 'https://api.centromedicoosi.com';
            servidorOsiteds = "https://ositeds.centromedicoosi.com"; // Api Sited
        }

        $rootScope.urlente = urlente; //Subdominio
        $rootScope.servidor = servidor + '/' + urlente; //Server Rest
        $rootScope.api = servidor;
        $rootScope.servidorUrl = servidor;
        //TokBox
        $rootScope.tokboxApiKey = 46839504;
        //Contenedor OSITED
        $rootScope.servidorOsiteds = servidorOsiteds;
        $rootScope.GLOBALidsede = parseInt($cookies.get("GLOBALidsede") || null);

      //   if(!AuthenticationService.authenticate() ){
      //     debugger
      //   //$location.path('/sign-in');
      //   window.location = settings.baseURL + '/#/login/';
      // }

        if (!AuthenticationService.authenticate()) {
          var redirection = true;
         var url = $location.url();
         var rutas = url.split('/');

         switch (rutas[1]) {
             case 'registro':
                 redirection = false;
                 break;
             case 'confirmacion':
                 redirection = false;
                 break;
             case 'recuperar-contrasena':
                 redirection = false;
                 break;
             case 'actualizacion-de-datos':
                 redirection = false;
                 break;
             case 'encuesta-de-citamedica':
                 redirection = false;
                 break;
             case 'encuesta-de-terapia':
                 redirection = false;
                 break;
             case 'libro-reclamaciones':
                 redirection = false;
                 break;
             default:
               window.location = settings.baseURL + '/#/login/';
         }
     }
        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
            // Si ya se ha autenticado ...
            var isAuthenticated = AuthenticationService.authenticate();
            console.log("toState", toState)
                // Cualquier accion publica es permitido
            var isPublicAction = angular.isObject(toState.data) &&
                toState.data.isPublic === true;

            if (isAuthenticated) {
              window.location = settings.baseURL + '/#/reservar-cita';

            } else {
                console.log('isPublicAction', isPublicAction);
                if (isPublicAction) {

                } else {
                    window.location = settings.baseURL + '/#/login';
                }
            }

        });

        var unregister = $rootScope.$on('$stateChangeSuccess', function(event, toState) {

            event.targetScope.$watch('$viewContentLoaded', function() {
                angular.element('html, body, #content').animate({ scrollTop: 0 }, 200);
            });
            $rootScope.$state.current = toState;
            $rootScope.specialClass = toState.specialClass;
        });

        $rootScope.$on('$destroy', unregister);

        $log.debug('runBlock end ClinicaNet');
    }

})();

(function () {
  'use strict';

  angular
    .module('minotaur')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      //app core pages (errors, login,signup)
      .state('pages', {
        url: '',
        template: '<div ui-view></div>'
      })

       //Surveys
       .state('pages.survey', { 
        url: '/encuesta-de-citamedica/:param',
        templateUrl: 'app/pages/pages-survey/pages-survey.html',
        controller: 'SurveyController',
        controllerAs: 'vm',
        parent: 'pages',
        specialClass: 'core',
        data: { isPublic: true }
      })

      .state('pages.terapiaencuesta', { 
        url: '/encuesta-de-terapia/:param',
        templateUrl: 'app/pages/pages-terapiaencuesta/pages-terapiaencuesta.html',
        controller: 'terapiaencuestaController',
        controllerAs: 'vm',
        parent: 'pages',
        specialClass: 'core',
        data: { isPublic: true }
      })

       //Surveys
       .state('pages.reclamaciones', { 
        url: '/libro-reclamaciones',
        templateUrl: 'app/pages/pages-recovery/libro-reclamaciones.html', 
        controller: 'LibroReclamacionesController',
        controllerAs: 'vm',
        parent: 'pages',
        specialClass: 'core',
        data: { isPublic: true }
      })
      //login
      .state('pages.login', {
        url: '/login',
        templateUrl: 'app/pages/pages-login/sign-in.html',
        controller: 'SigninCtrl',
        controllerAs: 'vm',
        parent: 'pages',
        specialClass: 'core'
      })

      //register
      .state('pages.signup', {
        url: '/registro',
        templateUrl: 'app/pages/pages-signup/pages-signup.html',
        controller: 'RegisterController',
        controllerAs: 'vm',
        parent: 'pages',
        specialClass: 'core',
        data: { isPublic: true }
      })

      //register
      .state('pages.actualizacion', { 
        url: '/actualizacion-de-datos/:param',
        templateUrl: 'app/pages/pages-signup/pages-update.html',
        controller: 'UpdateController',
        controllerAs: 'vm',
        parent: 'pages',
        specialClass: 'core',
        data: { isPublic: true }
      })

      //confirn
      .state('pages.confirm', {
        url: '/confirmacion/:paramtoken',
        templateUrl: 'app/pages/pages-confirm/pages-confirm.html',
        controller: 'ConfirmController',
        controllerAs: 'vm',
        parent: 'pages',
        specialClass: 'core',
        data: { isPublic: true }
      })

      //recovery
      .state('pages.recovery', {
        url: '/recuperar-contrasena',
        templateUrl: 'app/pages/pages-recovery/pages-recovery.html',
        controller: 'RecoveryController',
        controllerAs: 'vm',
        parent: 'pages',
        specialClass: 'core',
        data: { isPublic: true }
      })

      //New password
      .state('pages.newpassword', {
        url: '/nueva-contrasena',
        templateUrl: 'app/pages/pages-newpassword/pages-newpassword.html',
        controller: 'NewpasswordController',
        controllerAs: 'vm',
        parent: 'pages',
        specialClass: 'core',
        data: { isPublic: true }
      })

      //miscitasmedicas
      .state('miscitasmedicas', {
        abstract: true,
        url: '/mis-citasmedicas',
        templateUrl: 'app/views/administracion/miscitasmedicas.html',
        controller: 'misCitasMedicasCtrl as vm'
      })
      .state('miscitasmedicas.list', { url: '' })
      .state('miscitasmedicas.show', {
        url: '/resultado/:paramId',
        templateUrl: 'app/views/administracion/miscitasmedicas-show.html',
        controller: 'misCitasMedicasShowCtrl as vm'
      })
      .state('miscitasterapeutas', {
        url: '/mis-citasterapeutas',
        templateUrl: 'app/views/administracion/miscitasterapeutas.html',
        controller: 'misCitasTerapeutasCtrl as vm'
      })
      .state('misdatos', {
        url: '/mis-datos',
        templateUrl: 'app/views/administracion/misdatos.html',
        controller: 'misDatosCtrl as vm'
      })
      .state('mireserva', {
        url: '/reservar-cita',
        templateUrl: 'app/views/administracion/mireserva.html',
        controller: 'miReservarCtrl as vm'
      })
      .state('faq', {
        url: '/faq',
        templateUrl: 'app/views/administracion/faq.html',
        controller: 'faqCtrl as vm'
      })
      .state('mireservamedica', {
        url: '/reservar-cita-medica',
        templateUrl: 'app/views/administracion/mireservamedica.html',
        controller: 'miReservaMedicaCtrl as vm'
      })
      .state('mireservamedicasede', {
        url: '/reservar-cita-medica/:idsede',
        templateUrl: 'app/views/administracion/mireservamedica.html',
        controller: 'miReservaMedicaCtrl as vm'
      })

      .state('mireservaterapeuta', {
        url: '/reservar-cita-terapeuta',
        templateUrl: 'app/views/administracion/mireservaterapeuta.html',
        controller: 'miReservaTerapeutaCtrl as vm'
      })
      .state('mispagos', {
        url: '/mis-pagos',
        templateUrl: 'app/views/administracion/mispagos.html',
        controller: 'misPagosCtrl as vm'
      })
      .state('misordenes', {
        url: '/mis-ordenes',
        templateUrl: 'app/views/administracion/misordenes.html',
        controller: 'misOrdenesCtrl as vm'
      })
      .state('misciclos', {
        abstract: true,
        url: '/mis-ciclos',
        templateUrl: 'app/views/administracion/misciclos.html',
        controller: 'misCiclosCtrl as vm'
      })
      .state('misciclos.list', { url: '' })
      .state('misciclos.edit', {
        url: '/editar/:paramId',
        templateUrl: 'app/views/administracion/misciclos-detalle.html',
        controller: 'misCiclosDetalleCtrl as vm'
      })

    $urlRouterProvider.otherwise('/reservar-cita');
  }

})();

(function () {
    'use strict';

    angular
        .module('minotaur')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($state,$http, $rootScope, jwtHelper, $cookies, AuthenticationService, entidadService, settings, Notification) {

        function loadModulosAuth() {

            if (AuthenticationService.authenticate()) {


                $http.defaults.headers.common['AuthorizationToken'] = $cookies.get('token');
                $rootScope.tokenPayload = jwtHelper.decodeToken($cookies.get("token"));
                $rootScope.token = $cookies.get("token");
                $rootScope.entidad = $cookies.getObject("entidad");
                if ($rootScope.entidad && typeof $rootScope.entidad === 'object' && Object.keys($rootScope.entidad).length > 0) {
                  $state.go("mireserva");
                }else{
                  $state.go("pages.login");
                }
                entidadService.GetModulos().then(function (response) {
                    // if (
                    //     response.tokenstatus.mensaje === "Token invalid" ||
                    //     response.tokenstatus.mensaje === "Token error" ||
                    //     response.tokenstatus.mensaje === "Token expired"
                    // ) {
                    //     $cookies.remove('token');
                    //     $cookies.remove('GLOBALidsede');
                    //     Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                    //     window.location = settings.baseURL + '/#/login/';
                    // }
                })
                .catch(function (error) {
                    $cookies.remove('token');
                    $cookies.remove('GLOBALidsede');
                    Notification.error({ message: 'Al parecer hubo un error con su sessión, por favor acceda nuevamente' });
                    window.location = settings.baseURL + '/#/login/';
                });
            }
        }

        loadModulosAuth();
    }

})();

/* global moment:false */
(function() {
  'use strict';

  /* eslint-disable */
  angular
    .module('minotaur')
    .constant('moment', moment)
    .constant('_', window._);
  /*esling-enable*/

})();

(function() {
  'use strict';

  angular
    .module('minotaur')
    .config(config);

  /** @ngInject */
  function config($logProvider, $locationProvider, NotificationProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // remove ! hash prefix
    $locationProvider.hashPrefix('');

    NotificationProvider.setOptions({
            delay: 10000,
            startTop: 20,
            startRight: 10,
            verticalSpacing: 20,
            horizontalSpacing: 20,
            positionX: 'center',
            positionY: 'top',
            replaceMessage: true
        });

        

  }

})();

function selectObject(data, valor, cell) {
    var value = '';
    for (var i = 0, len = data.length; i < len; i++) {
        if (data[i][cell] === valor) {
            value = data[i];
            break;
        }
    }
    return value;
}

function mayorFechaLimite(fecha) {
    //fecha: 24/02/2016
    var d = parseInt(fecha.substr(0, 2), 10);
    var m = parseInt(fecha.substr(3, 2), 10) - 1;
    var y = parseInt(fecha.substr(6, 4), 10);

    var limite = '05/12/2019'
    var dlimite = parseInt(limite.substr(0, 2), 10);
    var mlimite = parseInt(limite.substr(3, 2), 10) - 1;
    var ylimite = parseInt(limite.substr(6, 4), 10);

    var fechaemision = new Date(y, m, d).getTime();
    var fechalimite = new Date(ylimite, mlimite, dlimite).getTime();

    return (fechaemision > fechalimite) ? true : false;
}

function formatoMs(fecha, hora) {
    //fecha: 24/02/2016
    //formato: "dd/MM/yyyy H:mm:ss"
    if (fecha === '') {

    } else {
        var d = fecha.substr(0, 2);
        var m = fecha.substr(3, 2) - 1;
        var y = fecha.substr(6, 4);
    }

    if (hora === '') {
        var milisegundos = new Date(y, m, d).getTime();
    } else {
        var h = hora.substr(0, 2);
        var min = hora.substr(3, 2);
        var seg = hora.substr(6, 2);
        var milisegundos = new Date(y, m, d, h, min, seg).getTime();
    }

    return milisegundos;
    //return $filter('date')(milisegundos, formato);
}


function redondearValor(valor, precision) {
    if (precision > 0) {
        var rounded = Math.round(parseFloat((valor * Math.pow(10, precision)).toFixed(precision))) / Math.pow(10, precision);
        var numero = rounded.toFixed(precision);
        return parseFloat(numero);
    } else {
        return Math.round(valor);
    }
}

function primerdia() {
    var hoy = new Date();

    var mm = hoy.getMonth() + 1; //hoy es 0!
    var yyyy = hoy.getFullYear();

    if (mm < 10) {
        mm = '0' + mm
    }

    return hoy = '01/' + mm + '/' + yyyy;
    //new Date().toJSON().slice(0,10)
}

function horaactual() {

    var f = new Date();

    var fecha = {
        y: f.getFullYear(),
        m: f.getMonth(),
        d: f.getDate(),
        hh: f.getHours(),
        mm: f.getMinutes()
    }

    return new Date(fecha.y, fecha.m, fecha.d, fecha.hh, fecha.mm);
}

function horaactualcero() {

    var f = new Date();

    var fecha = {
        y: f.getFullYear(),
        m: f.getMonth(),
        d: f.getDate(),
        hh: f.getHours(),
        mm: f.getMinutes()
    }

    return new Date(fecha.y, fecha.m, fecha.d, 0, 0, 0);
}

function convertDate(fecha, hora) {
    //fecha: 24/02/2016
    //fecha: 15:02:54
    var d = fecha.substr(0, 2);
    var m = fecha.substr(3, 2) - 1;
    var y = fecha.substr(6, 4);

    if (fecha && hora)
        return new Date(y, m, d, hora.substr(0, 2), hora.substr(3, 2), hora.substr(6, 2));

    if (fecha)
        return new Date(y, m, d);
}

function extractdate(fecha) {
    //2017-08-28 11:19:15
    if (fecha) {
        var d = fecha.substr(8, 2);
        var m = fecha.substr(5, 2);
        var y = fecha.substr(0, 4);
        return d + '/' + m + '/' + y;
    } else {
        return '';
    }
}

function restardias(dias) {
    var f = new Date();
    var dayOfMonth = f.getDate();

    f.setDate(dayOfMonth - dias);
    if (f.getDay() === 0)
        f.setDate(dayOfMonth - (dias + 1));

    return new Date(f.getFullYear(), f.getMonth(), f.getDate());
}

function hoy() {
    var hoy = new Date();
    var dd = hoy.getDate();
    var mm = hoy.getMonth() + 1; //hoy es 0!
    var yyyy = hoy.getFullYear();

    if (dd < 10) {
        dd = '0' + dd
    }

    if (mm < 10) {
        mm = '0' + mm
    }

    return hoy = dd + '/' + mm + '/' + yyyy;
    //new Date().toJSON().slice(0,10)
}

function recortarApellidos(data) {
    /*Formatear apellido y nombre*/
    var cadena = data.split(",");
    var apellidos = cadena[0].split(" ");
    var nombres = cadena[1].replace(" ", "").split(" ");
    apellidos[0] = apellidos[0].replace(',', ''); //retirar coma de apellidopat
    var personal = apellidos[0] + ', ' + nombres[0];

    return personal;
}


function utf8_to_b64(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
}

function b64_to_utf8(str) {
    return decodeURIComponent(escape(window.atob(str)));
}



// https://deployando.net/2012/08/16/js-ordenar-arreglos-objetos/
/*! Ordenar elementos del arreglo por una propiedad numérica. */
Array.prototype.orderByNumber = function (property, sortOrder) {
    // Primero se verifica que la propiedad sortOrder tenga un dato válido.
    if (sortOrder != -1 && sortOrder != 1) sortOrder = 1;
    this.sort(function (a, b) {
        // La función de ordenamiento devuelve la comparación entre property de a y b.
        // El resultado será afectado por sortOrder.
        return (a[property] - b[property]) * sortOrder;
    })
}
/*! Ordenar elementos del arreglo por una propiedad de tipo String */
Array.prototype.orderByString = function (property, sortOrder, ignoreCase) {
    if (sortOrder != -1 && sortOrder != 1) sortOrder = 1;
    this.sort(function (a, b) {
        var stringA = a[property], stringB = b[property];
        // Si un valor es null o undefined, se convierte a cadena vacía.
        if (stringA == null) stringA = '';
        if (stringB == null) stringB = '';
        // Si ignoreCase es true, se convierten ambas variables a minúsculas.
        if (ignoreCase == true) { stringA = stringA.toLowerCase(); stringB = stringB.toLowerCase() }
        var res = 0;
        if (stringA < stringB) res = -1;
        else if (stringA > stringB) res = 1;
        return res * sortOrder;
    })
}
/*! Ordenar elementos de arreglo  */
Array.prototype.orderByDate = function (property, sortOrder) {
    if (sortOrder != -1 && sortOrder != 1) sortOrder = 1;
    this.sort(function (a, b) {
        var dateA = new Date(a[property]), dateB = new Date(b[property]);
        return (dateA - dateB) * sortOrder;
    })
}
angular.module("minotaur").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/templates/messages_tmpl.html","<p ng-message=required style=\"margin: 0\">This field is required</p><p ng-message=minlength style=\"margin: 0\">This field is too short</p><p ng-message=maxlength style=\"margin: 0\">This field is too long</p><p ng-message=email style=\"margin: 0\">This needs to be a valid email</p><p ng-message=number style=\"margin: 0\">This needs to be a valid number</p><p ng-message=match style=\"margin: 0\">Values do not match!</p><p ng-message=pattern style=\"margin: 0\">Input in bad format!</p><p ng-message=min style=\"margin: 0\">This value is too low</p><p ng-message=max style=\"margin: 0\">This value is too high</p>");
$templateCache.put("app/pages/pages-confirm/pages-confirm.html","<div class=padreback if-loading ng-if=vm.spinerLoading><div class=\"hijoback text-center text-primary\" style=\"padding: 40px; width: 320px; height: 180px; background-color: #FFFFFF\"><span class=\"fa fa-spinner fa-spin fa-4x\"></span><p class=m-10>Procesando solicitud..</p></div></div><div class=\"page page-core page-signup\"><div class=login-modal><div class=branding><a href=https://pacientes.centromedicoosi.com><img ng-src={{servidorUrl}}/img/osi/logologin.png width=270></a></div><h4 class=\"text-center mb-20 text-primary\">CONFIRMACIÓN</h4><div ng-if=vm.data.entidad><div class=\"text-center form-registro-respuesta\"><div class=\"alert alert-primary alert-dismissable\">{{vm.data.entidad.nombres}}, registro confirmado exitosamente!</div>Iniciando sesión...</div></div><div ng-if=\"vm.data.code === \'1\' || vm.data.code === \'2\'\"><div class=\"text-center form-registro-respuesta\"><span class=\"fa fa-like fa-2x text-primary\"></span><div class=\"alert alert-danger alert-dismissable\">{{vm.data.message}}</div></div><div class=\"mt-15 text-center\">Ya tiene una cuenta? <a ui-sref=pages.login>INICIA SESIÓN</a></div></div></div></div>");
$templateCache.put("app/views/administracion/faq.html","<div class=\"page page-ui pull-to-header\"><div class=row><div class=col-md-12><ol class=breadcrumb><li><a ui-sref=mireserva>Inicio</a></li><li class=active>Preguntas frecuentes</li></ol><h4 class=\"text-center text-primary\">Preguntas</h4><uib-accordion close-others=false><div ng-repeat=\"item in vm.preguntasfrec\" uib-accordion-group class=panel-default is-open=true><uib-accordion-heading>{{item.pregunta}} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': true, \'glyphicon-chevron-right\': !true}\"></i></uib-accordion-heading>{{item.respuesta}}</div></uib-accordion></div></div></div>");
$templateCache.put("app/views/administracion/mireserva.html","<div class=\"page page-ui pull-to-header\"><div class=row><div class=col-md-12><ol class=breadcrumb><li class=active>Inicio</li></ol><div class=tile><section class=tile-body><h3 class=text-center><span ng-if=\"entidad.sexo === \'F\'\">Bienvenida</span> <span ng-if=\"entidad.sexo === \'M\'\">Bienvenido</span> <span class=text-primary>{{entidad.nombres}}</span></h3><h5 class=\"mt-20 text-center\">¿Deseas reservar cita Médica o de Terapia?</h5><div class=row><div class=col-md-6><a ui-sref=mireservamedica><img ng-src={{settings.globalImagePath}}/medico.webp width=100%></a><p><a ui-sref=mireservamedica class=\"btn btn-primary btn-ef btn-ef-3 btn-ef-3c mb-10 btn-block\">Reserva cita médica <i class=\"fa fa-arrow-right\"></i></a></p></div><div class=col-md-6><a ui-sref=mireservaterapeuta><img ng-src={{settings.globalImagePath}}/terapeuta.webp width=100%></a><p><a ui-sref=mireservaterapeuta class=\"btn btn-greensea btn-ef btn-ef-3 btn-ef-3c mb-10 btn-block\">Reserva cita de terapia <i class=\"fa fa-arrow-right\"></i></a></p></div></div></section></div></div></div></div>");
$templateCache.put("app/views/administracion/mireservamedica.html","<!-- <div class=\"padreback\" if-loading>\r\n    <div class=\"hijoback text-center\">\r\n        <span class=\"fa fa-spinner fa-spin fa-4x\"></span>\r\n        <br /><br />\r\n        Procesando..\r\n    </div>\r\n</div> --><link rel=stylesheet href=https://static.micuentaweb.pe/static/js/krypton-client/V4.0/ext/classic-reset.css><script src=https://static.micuentaweb.pe/static/js/krypton-client/V4.0/ext/classic.js></script><link rel=stylesheet href=https://use.fontawesome.com/releases/v5.1.0/css/all.css integrity=sha384-lKuwvrZot6UHsBSfcMvOkWwlCMgc0TaWr+30HWe3a4ltaBwTZhyTEggF5tJv8tbt crossorigin=anonymous><style>.viewport-sm .mt-xs {\r\n        margin: 30px 0px 15px 0px;\r\n    }\r\n\r\n    .viewport-sm .p-xs {\r\n        padding: 0px 10px;\r\n    }\r\n\r\n    .spinerLoading {\r\n        text-align: center;\r\n        padding: 40px;\r\n    }\r\n\r\n    .customturno {\r\n        padding: 5px;\r\n        width: 80px;\r\n        margin: 0px 5px 5px 0px;\r\n    }\r\n\r\n    .osi-radio {\r\n        padding: 1rem;\r\n        border-radius: 8px;\r\n        border: 1px solid #d3d3d3;\r\n        background-color: #fdfdfd;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .osi-radio input {\r\n        display: none;\r\n    }\r\n\r\n    .osi-radio--label {\r\n        font-size: 1rem;\r\n        cursor: pointer;\r\n        position: relative;\r\n        display: flex;\r\n        align-items: center;\r\n        margin: 0;\r\n    }\r\n\r\n    .osi-radio--label p {\r\n        margin: 0;\r\n        margin-left: 1rem;\r\n        color: #1c2a69;\r\n        font-size: 0.9rem;\r\n    }\r\n\r\n    .osi-radio--button {\r\n        height: 20px;\r\n        width: 20px;\r\n        border: 4px solid #005cb9;\r\n        border-radius: 50%;\r\n        position: relative;\r\n        flex-shrink: 0;\r\n    }\r\n\r\n    .osi-radio--button::after {\r\n        content: \"\";\r\n        display: block;\r\n        background-color: #0a9d4b;\r\n        height: 8px;\r\n        width: 8px;\r\n        border-radius: 50%;\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        transform: translate(-50%, -50%);\r\n        opacity: 0;\r\n        transition: opacity 0.1s ease;\r\n    }\r\n\r\n    .osi-radio input:checked+.osi-radio--label .osi-radio--button::after {\r\n        opacity: 1;\r\n    }\r\n\r\n\r\n    .merchant.header.image.src {}\r\n\r\n    .uib-day .btn[disabled] {\r\n        opacity: 0.90;\r\n        filter: alpha(opacity=90);\r\n        background-color: white;\r\n        color: #777;\r\n    }\r\n\r\n    .uib-day button {\r\n        opacity: 0.90;\r\n        filter: alpha(opacity=90);\r\n        background-color: rgb(225, 245, 225);\r\n        border-radius: 32px;\r\n    }\r\n\r\n    /* Contenedor del Botón de Pago Izipay */\r\n    #button_pago {\r\n        display: none;\r\n        text-align: center;\r\n        margin: 25px auto 15px auto;\r\n        width: 100%;\r\n    }\r\n\r\n    #button_pago .kr-embedded {\r\n        margin: 0 auto !important;\r\n        text-align: center !important;\r\n        display: block !important;\r\n    }\r\n\r\n    #button_pago .kr-popin-wrapper {\r\n        display: flex !important;\r\n        justify-content: center !important;\r\n        align-items: center !important;\r\n        margin: 0 auto !important;\r\n        text-align: center !important;\r\n    }\r\n\r\n    /* Diseño moderno y centrado del Botón Pagar Izipay y PagoEfectivo */\r\n    #button_pago button.kr-popin-button,\r\n    #button_pago .kr-popin-button,\r\n    button.kr-popin-button,\r\n    .btn-pago-efectivo {\r\n        display: inline-flex !important;\r\n        align-items: center !important;\r\n        justify-content: center !important;\r\n        margin: 12px auto !important;\r\n        min-width: 260px !important;\r\n        height: 48px !important;\r\n        padding: 0 35px !important;\r\n        background: linear-gradient(135deg, #00AF41 0%, #008f35 100%) !important;\r\n        color: #ffffff !important;\r\n        font-family: inherit !important;\r\n        font-size: 15px !important;\r\n        font-weight: 700 !important;\r\n        text-transform: uppercase !important;\r\n        letter-spacing: 0.8px !important;\r\n        border: none !important;\r\n        border-radius: 25px !important;\r\n        box-shadow: 0 5px 16px rgba(0, 175, 65, 0.35) !important;\r\n        cursor: pointer !important;\r\n        transition: all 0.25s ease-in-out !important;\r\n        outline: none !important;\r\n        box-sizing: border-box !important;\r\n    }\r\n\r\n    #button_pago button.kr-popin-button:hover,\r\n    #button_pago .kr-popin-button:hover,\r\n    button.kr-popin-button:hover,\r\n    .btn-pago-efectivo:hover {\r\n        background: linear-gradient(135deg, #009636 0%, #007a2d 100%) !important;\r\n        box-shadow: 0 7px 22px rgba(0, 175, 65, 0.45) !important;\r\n        transform: translateY(-2px) !important;\r\n    }\r\n\r\n    #button_pago button.kr-popin-button:active,\r\n    #button_pago .kr-popin-button:active,\r\n    button.kr-popin-button:active,\r\n    .btn-pago-efectivo:active {\r\n        transform: translateY(1px) !important;\r\n        box-shadow: 0 2px 8px rgba(0, 175, 65, 0.3) !important;\r\n    }\r\n\r\n    /* Caja de Loading para la Pasarela de Pago */\r\n    .izipay-loading-wrapper {\r\n        text-align: center;\r\n        margin: 25px auto;\r\n        padding: 20px 25px;\r\n        background: #f0fdf4;\r\n        border: 1.5px dashed #00AF41;\r\n        border-radius: 14px;\r\n        max-width: 440px;\r\n        box-shadow: 0 4px 15px rgba(0, 175, 65, 0.08);\r\n    }\r\n\r\n    .izipay-loading-wrapper .izipay-spinner-icon {\r\n        color: #00AF41;\r\n        font-size: 32px;\r\n        margin-bottom: 6px;\r\n    }\r\n\r\n    .izipay-loading-wrapper .izipay-loading-title {\r\n        color: #166534;\r\n        font-size: 15px;\r\n        font-weight: 700;\r\n        margin: 8px 0 4px 0;\r\n    }\r\n\r\n    .izipay-loading-wrapper .izipay-loading-desc {\r\n        color: #4b5563;\r\n        font-size: 12.5px;\r\n        margin: 0;\r\n    }</style><script>function culqi() {\r\n\r\n    };</script><script type=text/ng-template id=myModalCorreo.html><form name=\"miForm\"  ng-submit=\"vm.formulariocreate()\" novalidate id=\"form_pop\">\r\n        <div class=\"modal-header bg-primary\">\r\n            <h4 class=\"modal-title\">Correo electrónico</h4>\r\n        </div> \r\n        <div class=\"modal-body\">  \r\n\r\n            <div class=\"row\">\r\n                <div class=\"form-group col-sm-12\">\r\n                  <label for=\"address2\">Correo electrónico</label>\r\n                  <input type=\"email\" name=\"correo\" id=\"correo\" class=\"form-control input-sm mb-5\"\r\n                    maxlength=\"50\" />\r\n                  <div ng-messages=\"miForm.correo.$error\" class=\"required\" role=\"alert\">\r\n                    <div ng-message=\"email\">Correo formato inv&aacute;lido</div>\r\n                  </div>\r\n                </div>\r\n              </div>        \r\n            <!-- <pre>{{vm.asistencia | json}}</pre> --> \r\n        </div> \r\n        <div class=\"modal-footer\">\r\n            <button class=\"btn btn-primary btn-sm\" id=\"aceptar_correo\"    >\r\n            <span>Aceptar</span>  \r\n            </button>\r\n         </div>\r\n    </form></script><!-- if-loading --><div class=padreback if-loading ng-if=vm.spinerLoadingPagar><div class=\"hijoback text-center text-primary\" style=\"padding: 40px; width: 320px; height: 220px; background-color: #FFFFFF\"><span class=\"fa fa-spinner fa-spin fa-4x\"></span><p class=m-10>Estamos procesando su compra, por favor espere..</p><i class=\"fa fa-shopping-cart fa-2x text-greensea\"></i></div></div><script type=text/ng-template id=myModalPagadoContent.html><div class=\"modal-body\">  \r\n        <p class=\"text-center mt-20 text-primary\">¡Su <strong>Cita Médica</strong> ha sido <strong>reservada exitosamente.</strong>!</p>\r\n        <div class=\"text-center mt-20\" ng-if=\"vm.urlPdf\"><small><em>Boleta de Venta enviado a su correo.</em></small></div> \r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <a href=\"{{vm.urlPdf}}\" target=\"_blank\" class=\"btn btn-greensea btn-rounded-20 btn-sm\" ng-if=\"vm.urlPdf\"><i class=\"fa fa-cloud-download\"></i> COMPROBANTE</a>\r\n        <button class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n    </div></script><script type=text/ng-template id=myModalCodigoCIPContent.html><div class=\"modal-body\">  \r\n        <p class=\"text-center mt-20 text-primary\">¡Su <strong>reserva</strong> se ha <strong>realizado exitosamente.</strong>!</p>\r\n        <div class=\"text-center mt-20\" ng-if=\"vm.codigocip\"><small><em>Se ha enviado los detalles de la reserva y del pago a tu número celular.</em></small>\r\n            <div class=\"p-xs text-center\">\r\n               \r\n                <p class=\"mt-10\"><span class=\"ng-binding\"><b>\r\n                        Monto a pagar: </b></span><span class=\"ng-binding\">\r\n                            S/. {{vm.precio}} </span></p>\r\n                <p class=\"mt-10\"><span class=\"ng-binding\"><b>\r\n                    Codigo de pago CIP: </b></span><span class=\"ng-binding\">\r\n                        {{vm.codigocip}} </span></p>\r\n                <p class=\"mt-10\"><span class=\"ng-binding\"><b>\r\n                    Como pagar: </b></span><span class=\"ng-binding\">\r\n                            <a href=\"https://pagoefectivo.pe/como-pagar.html\" target=\"_blank\">https://pagoefectivo.pe/como-pagar.html</a></span></p>\r\n            </div>\r\n        </div>\r\n        \r\n    </div>\r\n    <div class=\"modal-footer\" style=\"margin:20px; text-align:left\" >\r\n        <p>Tenga en cuenta lo siguiente: </p>\r\n        <p>\r\n            <li>Toda cita medica se confirma previo pago.</li>\r\n            <li>La pre-reserva tiene vigencia de 4 horas. Sino realiza el pago, luego de ese tiempo, su reserva se eliminará.</li>\r\n            <li>Realizar el pago confirma la lectura y aceptación de los términos y condiciones de atención. </li>\r\n            <li>Puede leer los términos y condiciones de atención haciendo <a href=\"https://centromedicoosi.com/condiciones-de-atencion1.pdf\" target=\"_blank\"> click aquí</a></li>\r\n        </p>\r\n        <!-- <a href=\"{{vm.urlPdf}}\" target=\"_blank\" class=\"btn btn-greensea btn-rounded-20 btn-sm\" ng-if=\"vm.urlPdf\"><i class=\"fa fa-cloud-download\"></i> COMPROBANTE</a> -->\r\n        <button style=\"float:right\" class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n    </div></script><script type=text/ng-template id=myModalMapaSedeContent.html><div class=\"modal-header bg-primary\">\r\n        <h4 class=\"modal-title\">{{vm.sede.nombre}}</h4>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <p><i class=\"fa fa-map-marker\"></i> Dirección</p>  \r\n        <p>{{vm.sede.direccion}}</p> \r\n        <div class=\"mt-20\"><em>Más información llamando al <a href=\"tel:017390888\" class=\"llamarfono\">01 739 0888</a></em></div> \r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <button class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n    </div></script><div class=\"page page-ui pull-to-header\"><div class=row><div class=col-md-12><ol class=breadcrumb><li><a ui-sref=mireserva>Inicio</a></li><li><a ui-sref=miscitasmedicas.list>Citas médicas</a></li><li class=active>Reservar cita</li></ol><h4 class=\"text-center text-greensea mb-20 mt-30\">Reserva de cita médica</h4><div class=tile><section class=tile-body><form name=miForm ng-submit=vm.openPagar(); novalidate id=form_pagar><h6 class=text-primary><strong>PASO 1</strong></h6><h5 class=\"text-greensea pt-0\">Seleccionar sede</h5><div class=row><div class=\"col-sm-12 col-xs-12\"><div class=spinerLoading ng-if=vm.spinerLoading><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><label class=\"checkbox minotaur-radio\" ng-repeat=\"row in vm.sedes\" ng-if=\"row.comercial === \'1\'\"><strong>{{row.nombre}}</strong> <small>{{row.direccion}}</small> <input type=radio name=sede ng-model=vm.citamedica.idsede value={{row.idsede}} required ng-change=\"vm.dt = null;\" ng-click=vm.sede_select()><div class=input-indicator></div></label><div ng-messages=miForm.sede.$error class=required role=alert ng-show=miForm.sede.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><hr class=row ng-if=vm.citamedica.idsede><div class=spinerLoading ng-if=vm.spinerLoadingfecha><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><div class=row><div class=\"col-sm-4 col-xs-12\" ng-if=vm.checkpaso2><h6 class=text-primary><strong>PASO 2</strong><h5 class=text-greensea>Seleccionar fecha</h5><div uib-datepicker ng-model=vm.dt datepicker-options=vm.dateOptions ng-change=vm.consultarMedicos() show-weeks=false></div></h6></div><div class=\"col-sm-4 col-xs-12\" ng-if=vm.dt><h6 class=\"text-primary mt-xs\"><strong>PASO 3</strong></h6><h5 class=text-greensea>Seleccionar hora</h5><div class=spinerLoading ng-if=vm.spinerLoadingHoras><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><div ng-repeat=\"row in vm.medicos\" class=\"mt-20 mb-20\" ng-if=!vm.spinerLoadingHoras><!-- <p class=\"m-0\"><i class=\"fa fa-user-md\"></i> {{row.nombre}}</p> --><h5><i class=\"fa fa-user-circle-md\"></i> {{row.nombre}}</h5><label ng-click=vm.labelHoraCitamedica() class=\"btn btn-xs btn-primary customturno\" ng-model=vm.radioModel uib-btn-radio=hora ng-repeat=\"hora in row.horas\">{{hora.inicioms | date:\'hh:mm a\'}}</label></div><p ng-if=\"!vm.spinerLoadingHoras && vm.medicos.length === 0\">No hay horarios disponibles.</p></div><div class=spinerLoading ng-if=vm.spinerHorapaso3><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><div class=\"col-sm-4 col-xs-12\" ng-if=vm.checkCobertura><h6 class=text-primary><strong>PASO 4</strong><h5 class=text-greensea>Consultar Cobertura</h5><div class=spinerLoading ng-if=vm.spinerLoading><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><div class=\"col-sm-12 col-xs-6\"><label class=\"col-sm-12 col-xs-6 control-label text-theme\">¿Cuenta con seguro?</label><select name=tienecobertura ng-model=vm.tienecobertura ng-change=vm.changeTieneCobertura(); class=\"form-control input-sm mb-5\"><option value=\"\">-- Seleccione --</option><option value=1>Si</option><option value=0>No</option></select><label class=\"col-sm-12 col-xs-6 control-label text-theme\" ng-if=\"vm.tienecobertura == 1\">Seleccione seguro:</label><select name=seguros ng-model=vm.seguros ng-change=vm.changeSeguros(); ng-if=\"vm.tienecobertura == 1\" class=\"form-control input-sm mb-5\"><option value=\"\">-- Seleccione --</option><option ng-repeat=\"seguro in seguros\" value={{seguro.nombre}}>{{seguro.nombre}}</option></select><div class=\"alert alert-warning mt-5\" ng-if=\"vm.tienecobertura == 1 && vm.seguros && vm.seguros.toLowerCase().indexOf(\'pacifico\') >= 0\"><i class=\"fa fa-phone\"></i> <strong>Seguro Pacífico:</strong> Para más información sobre su reserva, comunicarse a nuestra <strong>Central</strong> al <strong>017390888</strong> o al<strong> Call Center</strong> al <strong>943719118</strong></div><label class=\"col-sm-12 col-xs-6 control-label text-theme\" ng-if=\"vm.seguros && vm.tienecobertura == 1 && vm.seguros.toLowerCase().indexOf(\'pacifico\') < 0\">Seleccione plan:</label><select name=planes ng-model=vm.planes ng-change=vm.changePlanes(); ng-if=\"vm.seguros && vm.tienecobertura == 1 && vm.seguros.toLowerCase().indexOf(\'pacifico\') < 0\" class=\"form-control input-sm mb-5\"><option value=\"\">-- Seleccione --</option><option ng-repeat=\"plan in getPlanes(vm.seguros)\" value=\"{{plan.idplan+\'-\'+plan.plan}}\">{{plan.nombre}}</option></select><br><button class=\"btn btn-sm btn-primary\" ng-if=\"vm.planes && vm.seguros.toLowerCase().indexOf(\'pacifico\') < 0\" ng-click=vm.buscarCobertura()><i class=\"fa fa-user-plus\"></i> Consultar cobertura</button></div></h6></div></div><div class=row id=consultar_cobertura ng-if=vm.checkCobertura><hr><div class=\"col-sm-8 col-xs-12\" id=detalle_cita ng-if=vm.infocita><div class=\"col-lg-4 col-md-3 col-sm-3 col-xs-12\"><div class=\"text-center bg-greensea p-40\"><span>{{vm.radioModel.inicioms | date: \'EEEE\'}}</span><h1 class=m-0>{{vm.radioModel.inicioms | date: \'d\'}}</h1><small class=mt-10>{{vm.radioModel.inicioms | date: \"MMMM\"}}</small></div></div><div class=\"col-lg-8 col-md-9 col-sm-9 col-xs-12\"><div class=p-xs><p class=mt-10><i class=\"fa fa-user-md\"></i> {{vm.radioModel.nombre}}</p><p class=mt-10><i class=\"fa fa-calendar\"></i> {{vm.radioModel.inicioms | date: \'d LLLL yyyy\'}}</p><p class=mt-10><i class=\"fa fa-clock-o\"></i> {{vm.radioModel.inicioms | date: \'h:mm a\'}}</p><p class=mt-10><span><i class=\"fa fa-user\"></i> {{entidad.entidad}} </span></p><p class=mt-10><i class=\"fa fa-map-marker\"></i> {{vm.nombresede | uppercase}} <a href=javascript:; ng-click=vm.openMapaSedeModal(vm.citamedica.idsede) class=\"text-primary ml-5\">Ver dirección</a></p><p class=mt-10><span><i class=\"fa fa-money\"></i> S/. {{vm.precio}} </span></p></div></div></div></div><br><br><div class=\"row text-center\" ng-if=vm.infocita><h6 class=text-primary><strong>Medios de pago</strong></h6><div class=col-sm-6><div class=osi-radio style=\"width: 45%; float:right\"><input id=osi-radio-izipay type=radio ng-model=vm.citamedica.mediopago name=mediopago value=izipay ng-click=\"vm.mediopago_select(\'izipay\')\" ng-disabled=vm.spinerLoadingPagar><label for=osi-radio-izipay class=osi-radio--label style=\"min-height: 30px\"><span class=osi-radio--button></span><div class=\"alineado ancho50\" style=\"margin-left: 10px\"><img src=assets/images/vinetaTarjeta.png class=\"margenIzquierdo10 margenSuperior10\"></div><p>Tarjeta de crédito o débito</p></label></div></div><div class=col-sm-6><div class=osi-radio style=\"width: 45%\"><input id=osi-radio-pagoefectivo type=radio ng-model=vm.citamedica.mediopago name=mediopago value=pagoefectivo ng-click=\"vm.mediopago_select(\'pagoefectivo\')\" ng-disabled=vm.spinerLoadingPagar><label for=osi-radio-pagoefectivo class=osi-radio--label style=\"min-height: 30px\"><span class=osi-radio--button></span><div class=\"alineado ancho50\" style=\"margin-left: 10px\"><img src=assets/images/vinetaPagoEfectivo.png class=\"margenIzquierdo10 margenSuperior10\"></div><p>Pagoefectivo</p></label></div></div></div><!-- Indicador de carga automático para Izipay --><div class=\"text-center mt-20 mb-20\" ng-if=vm.spinerLoadingPagar><p class=text-greensea><i class=\"fa fa-spinner fa-spin fa-2x\"></i></p><p class=text-greensea><strong>Generando enlace de pago seguro con Izipay...</strong></p></div><br><hr><!-- Indicador de carga para Izipay --><div class=izipay-loading-wrapper ng-if=vm.spinerLoadingPagar><i class=\"fa fa-spinner fa-spin izipay-spinner-icon\"></i><p class=izipay-loading-title>Cargando pasarela de pago seguro...</p><p class=izipay-loading-desc>Por favor espere un momento mientras se genera el botón de pago.</p></div><div id=button_pago style=\"display: none; text-align: center\"></div><button style=\"display: none\" id=button_page type=submit></button><div id=button_pagoefectivo class=text-center ng-if=vm.checkmedioPE style=\"text-align: center; margin: 20px auto\"><button type=button class=btn-pago-efectivo id=btngeneracip ng-click=vm.generarCIP()>Generar Código CIP</button></div></form></section><input type=hidden id=response_page name=response_page> <input type=hidden id=error_form name=error_form> <button style=\"display: none\" ng-click=vm.error_form() id=button_errorForm></button></div></div></div></div><a id=referenciar></a>");
$templateCache.put("app/views/administracion/mireservaterapeuta.html","<style>.viewport-sm .mt-xs {\r\n        margin: 30px 0px 15px 0px;\r\n    }\r\n\r\n    .spinerLoading {\r\n        text-align: center;\r\n        padding: 40px;\r\n    }</style><script type=text/ng-template id=myModalMapaSedeContent.html><form name=\"miForm\" ng-submit=\"vm.save();\" novalidate>\r\n        <div class=\"modal-header bg-primary\">\r\n            <h4 class=\"modal-title\">{{vm.sede.nombre}}</h4>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n            <p><i class=\"fa fa-map-marker\"></i> Dirección</p>  \r\n            <p>{{vm.sede.direccion}}</p> \r\n            <div class=\"mt-20\"><em>Más información llamando al <a href=\"tel:017390888\" class=\"llamarfono\">01 739 0888</a></em></div> \r\n        </div>\r\n        <div class=\"modal-footer\">\r\n                <button class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n        </div>\r\n    </form></script><div class=\"page page-ui pull-to-header\"><div class=row><div class=col-md-12><ol class=breadcrumb><li><a ui-sref=mireserva>Inicio</a></li><li><a ui-sref=miscitasterapeutas>Citas de terapia</a></li><li class=active>Reservar cita</li></ol><h4 class=\"text-center text-greensea mb-20 mt-30\">Reservar cita de terapia</h4><div class=tile><!-- <section class=\"tile-header bg-greensea\">\r\n                    <h1 class=\"heading text-center\">Reservar cita de terapia</h1>\r\n                </section> --><section class=tile-body><form name=miForm ng-submit=vm.save(); novalidate><!-- <h5 class=\"text-greensea\"><strong>PASO 1</strong> Seleccionar sede</h5> --><!-- <h6 class=\"text-primary\"><strong>PASO 1</strong></h5>\r\n                            <h5 class=\"text-greensea pt-0\"> Seleccionar sede</h5>\r\n\r\n                            <div class=\"row\">\r\n                                <div class=\"col-sm-12 col-xs-12\">\r\n\r\n                                    <div class=\"spinerLoading\" ng-if=\"vm.spinerLoading\">\r\n                                        <i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i>\r\n                                    </div>\r\n\r\n                                    <label class=\"checkbox minotaur-radio\" ng-repeat=\"row in vm.sedes\">\r\n                                        <strong> {{row.nombre}}</strong>\r\n                                        <small>{{row.direccion}}</small>\r\n                                        <input type=\"radio\" name=\"sede\" ng-model=\"vm.citaterapeutica.idsede\"\r\n                                            value=\"{{row.idsede}}\" required ng-change=\"vm.dt = null;\">\r\n                                        <div class=\"input-indicator\"></div>\r\n                                    </label>\r\n\r\n                                    <div ng-messages=\"miForm.sede.$error\" class=\"required\" role=\"alert\"\r\n                                        ng-show=\"miForm.sede.$dirty\">\r\n                                        <div ng-message=\"required\">El campo es requerido</div>\r\n                                    </div>\r\n\r\n                                    <div ng-if=\"!vm.spinerLoading && vm.sedes.length === 0\">\r\n                                        No tiene ciclos de atención abiertos.\r\n                                    </div>\r\n                                </div>\r\n                            </div> --><div ng-model=vm.msj_cita><h5 id=msj_cita></h5></div><div ng-if=\"vm.data.length > 0\"><div class=\"col-sm-8 col-xs-12\"><h6 class=text-primary><strong>PASO 1</strong></h6><h5 class=\"text-greensea pt-0\">Seleccionar ciclo</h5><div class=list-group data-ng-repeat=\"(key, row) in vm.data\"><div class=\"row tile\"><div class=\"col-sm-1 col-xs-2\"><label class=\"checkbox minotaur-radio\"><input ng-model=vm.turnos name=customRadio type=radio value=\"{{key}}{{row[\'ciclo\'].turnos }}{{row[\'ciclo\'].idsede }}\"><div class=input-indicator></div></label></div><div class=\"col-sm-3 col-xs-6\"><a class=list-group-item style=\"margin-top: 12px\"><span class=\"badge bg-greensea\">abierto</span> <i class=\"fa fa-folder-open text-slategray\"></i> {{row[\'ciclo\'].idcicloatencion}}</a></div><div class=\"col-sm-8 col-xs-12\" style=\"margin-top: 13px\"><div class=table-responsive><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th width=8%><strong>Cita</strong></th><th width=20%><strong>Nombre de diagnóstico</strong></th><th width=3%><strong>Zona</strong></th></tr></thead><tbody><tr data-ng-repeat=\"val in row\" ng-if=val.zona_cuerpo><td class=text-center>{{val.fecha}}</td><td class=text-center>{{val.nombre}}</td><td class=text-center>{{val.zona_cuerpo}}</td></tr></tbody></table></div></div></div></div></div><div class=\"col-sm-9 col-xs-12\"><div ui-view></div></div></div><div class=row ng-if=\"vm.data.length !== 0 && vm.turnos\"><div class=\"col-sm-4 col-xs-12\"><h6 class=text-primary><strong>PASO 2</strong><h5 class=text-greensea>Seleccionar fecha</h5><div uib-datepicker ng-model=vm.dt datepicker-options=vm.dateOptions ng-change=vm.consultarMedicos() show-weeks=false></div></h6></div><div class=\"col-sm-8 col-xs-12\" ng-if=vm.dt><!-- <h5 class=\"text-greensea mt-xs\"><strong>PASO 3</strong> Seleccionar hora</h5> --><h6 class=\"text-primary mt-xs\"><strong>PASO 3</strong></h6><h5 class=text-greensea>Seleccionar hora</h5><div class=spinerLoading ng-if=vm.spinerLoadingHoras><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><div ng-repeat=\"row in vm.medicos\" class=\"mt-20 mb-20\" ng-if=!vm.spinerLoadingHoras><h5><i class=\"fa fa-user-circle-o\"></i> {{row.nombre}}</h5><label class=\"btn btn-xs btn-primary\" ng-model=vm.radioModel uib-btn-radio=hora ng-repeat=\"hora in row.horas\">{{hora.inicioms | date:\'hh:mm a\'}}</label></div><p ng-if=\"!vm.spinerLoadingHoras && vm.medicos.length === 0\">No hay horarios disponibles.</p></div></div><div ng-if=\"vm.dt && vm.radioModel.inicioms\"><hr><!-- <h5 class=\"text-greensea\"><strong>RESERVAR CITA DE TERAPIA</strong></h5> --><div class=row><div class=\"col-lg-4 col-md-3 col-sm-3 col-xs-12\"><div class=\"text-center bg-greensea p-40\"><span>{{vm.radioModel.inicioms | date: \'EEEE\'}}</span><h1 class=m-0>{{vm.radioModel.inicioms | date: \'d\'}}</h1><small class=mt-10>{{vm.radioModel.inicioms | date: \"MMMM\"}}</small></div></div><div class=\"col-lg-8 col-md-9 col-sm-9 col-xs-12\"><p class=mt-10><i class=\"fa fa-user-circle-o\"></i> {{vm.radioModel.nombre}}</p><p class=mt-10><i class=\"fa fa-calendar\"></i> {{vm.radioModel.inicioms | date: \'d LLLL yyyy\'}}</p><p class=mt-10><i class=\"fa fa-clock-o\"></i> {{vm.radioModel.inicioms | date: \'h:mm a\'}}</p><p class=mt-10><span><i class=\"fa fa-user\"></i> {{entidad.entidad}} </span></p><p class=mt-10><i class=\"fa fa-map-marker\"></i> {{vm.nombresede | uppercase}} <a href=javascript:; ng-click=vm.openMapaSedeModal(vm.citaterapeutica.idsede) class=\"text-primary ml-5\">Ver dirección</a></p></div></div></div><div class=row ng-if=\"vm.sedes.length > 0\"><div class=\"col-sm-12 col-xs-12\"><button type=submit ng-disabled=\"miForm.$invalid || miForm.$submitted\" class=\"btn btn-greensea btn-rounded-40 full-width mt-20 btn-lg\">REGISTRAR RESERVA</button></div></div></form></section></div></div></div></div>");
$templateCache.put("app/views/administracion/misciclos-detalle.html","<link rel=stylesheet href=https://static.micuentaweb.pe/static/js/krypton-client/V4.0/ext/classic-reset.css><script src=https://static.micuentaweb.pe/static/js/krypton-client/V4.0/ext/classic.js></script><link rel=stylesheet href=https://use.fontawesome.com/releases/v5.1.0/css/all.css integrity=sha384-lKuwvrZot6UHsBSfcMvOkWwlCMgc0TaWr+30HWe3a4ltaBwTZhyTEggF5tJv8tbt crossorigin=anonymous><style>.viewport-sm .ml-xs {\r\n    margin-left: 15px;\r\n  }\r\n\r\n  .tabla-pagos td {\r\n    line-height: 24px;\r\n    width: 100%\r\n  }\r\n\r\n\r\n  .osi-radio {\r\n  padding: 1rem;\r\n  border-radius: 8px;\r\n  border: 1px solid #d3d3d3;\r\n  background-color: #fdfdfd;\r\n  display: flex;\r\n  align-items: center; }\r\n  .osi-radio input {\r\n    display: none; }\r\n  .osi-radio--label {\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 0; }\r\n    .osi-radio--label p {\r\n      margin: 0;\r\n      margin-left: 1rem;\r\n      color: #1c2a69;\r\n      font-size: 0.9rem; }\r\n  .osi-radio--button {\r\n    height: 20px;\r\n    width: 20px;\r\n    border: 4px solid #005cb9;\r\n    border-radius: 50%;\r\n    position: relative;\r\n    flex-shrink: 0; }\r\n    .osi-radio--button::after {\r\n      content: \"\";\r\n      display: block;\r\n      background-color: #0a9d4b;\r\n      height: 8px;\r\n      width: 8px;\r\n      border-radius: 50%;\r\n      position: absolute;\r\n      top: 50%;\r\n      left: 50%;\r\n      transform: translate(-50%, -50%);\r\n      opacity: 0;\r\n      transition: opacity 0.1s ease; }\r\n  .osi-radio input:checked + .osi-radio--label .osi-radio--button::after {\r\n    opacity: 1; }</style><script>function culqi() {\r\n\r\n  };</script><!-- if-loading --><div class=padreback if-loading ng-if=vm.spinerLoadingPagar><div class=\"hijoback text-center text-primary\" style=\"padding: 40px; width: 320px; height: 220px; background-color: #FFFFFF\"><span class=\"fa fa-spinner fa-spin fa-4x\"></span><p class=m-10>Estamos procesando su compra, por favor espere..</p><i class=\"fa fa-shopping-cart fa-2x text-greensea\"></i></div></div><script type=text/ng-template id=myModalTratPagadoContent.html><div class=\"modal-body\">\r\n      <p class=\"text-center mt-20 text-primary\">¡Su <strong>compra</strong> ha sido <strong>realizado exitosamente.</strong>!</p>\r\n      <div class=\"text-center mt-20\" ng-if=\"vm.urlPdf\"><small><em>Boleta de Venta enviado a su correo.</em></small></div>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n      <a href=\"{{vm.urlPdf}}\" target=\"_blank\" class=\"btn btn-greensea btn-rounded-20 btn-sm\" ng-if=\"vm.urlPdf\"><i class=\"fa fa-cloud-download\"></i> COMPROBANTE</a>\r\n      <button class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n  </div></script><script type=text/ng-template id=myModalCodigoCIPContent.html><div class=\"modal-body\">\r\n      <p class=\"text-center mt-20 text-primary\">¡Su <strong>reserva</strong> se ha <strong>realizado exitosamente.</strong>!</p>\r\n      <div class=\"text-center mt-20\" ng-if=\"vm.urlPdf\"><small><em>Se ha enviado el codigo CIP a su numero de celular.</em></small></div>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n      <!-- <a href=\"{{vm.urlPdf}}\" target=\"_blank\" class=\"btn btn-greensea btn-rounded-20 btn-sm\" ng-if=\"vm.urlPdf\"><i class=\"fa fa-cloud-download\"></i> COMPROBANTE</a> -->\r\n      <button class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n  </div></script><script type=text/ng-template id=myModalSeleccionarPagoContent.html><!-- <form name=\"miForm\" ng-submit=\"vm.save();\" novalidate> -->\r\n<div class=\"modal-header bg-primary\">\r\n  <h4 class=\"modal-title\" ng-if=\"!vm.generoCIP\">\r\n    <i class=\"fa fa-shopping-cart\"></i> <span class=\"ml-5\">Carrito de compras</span>\r\n  </h4>\r\n  <h4 class=\"modal-title\" ng-if=\"vm.generoCIP\">\r\n    <i class=\"fa fa-money\"></i> <span class=\"ml-5\">DETALLES DE PAGO</span>\r\n  </h4>\r\n</div>\r\n<div class=\"modal-body\" ng-if=\"!vm.generoCIP\">\r\n  <div class=\"row\" ng-if=\"vm.total <= vm.porpagar\">\r\n    <div class=\"col-sm-12 col-xs-12\">\r\n      <h5 class=\"text-primary\">Ingrese cantidad</h5>\r\n\r\n      <table class=\"table table-striped table-bordered\">\r\n        <thead>\r\n          <tr>\r\n            <th width=\"49%\">Tratamiento</th>\r\n            <th width=\"17%\" class=\"text-center text-primary\">Cantidad</th>\r\n            <th width=\"17%\" class=\"text-center\">P.Unit.</th>\r\n            <th width=\"17%\" class=\"text-right\">Total</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr data-ng-repeat=\"item in vm.presupuestodetTemp\">\r\n            <td>\r\n              {{item.nombreproducto}}\r\n            </td>\r\n            <td class=\"text-center\">\r\n              <input type=\"number\" ng-change=\"vm.actualizarCantidad(vm.presupuestodetTemp, $index, item.idproducto)\"\r\n                class=\"form-control input-sm\" ng-model=\"vm.presupuestodetTemp[$index][\'cantidad\']\"\r\n                ng-if=\"item.idproducto !== 23\">\r\n              <span ng-if=\"item.idproducto === 23\">\r\n                {{item.cantidad}}\r\n              </span>\r\n            </td>\r\n            <td class=\"text-center\">{{item.preciounit}}</td>\r\n            <td class=\"text-right\">{{item.total | number:2}}</td>\r\n          </tr>\r\n          <tr data-ng-show=\"vm.presupuestodetTemp.length === 0\">\r\n            <td colspan=\"4\" class=\"text-center\">No hay registros.</td>\r\n          </tr>\r\n        </tbody>\r\n        <tfoot>\r\n          <tr>\r\n            <td colspan=\"3\" class=\"text-right p-20\">Total S/</td>\r\n            <td class=\"text-right p-20\"><strong>{{vm.totalTemp | number:2}}</strong></td>\r\n          </tr>\r\n        </tfoot>\r\n      </table>\r\n\r\n      <div class=\"spinerLoading\" ng-if=\"!vm.mediopago_status\">\r\n        <i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i>\r\n    </div>\r\n\r\n      <div class=\"row text-center\"ng-if=\"vm.mediopago_status\" >\r\n        <h6 class=\"text-primary\"><strong>Medios de pago</strong></h6>\r\n           \r\n        <div class=\"col-sm-6 \">\r\n            <div class=\"osi-radio\" style=\"width: 80%; float:right \"  >\r\n                <input id=\"osi-radio-izipay\" type=\"radio\" ng-model=\"vm.mediopago\"  name=\"mediopago\"\r\n                    value=\"izipay\" ng-click=\"vm.mediopago_select(\'izipay\')\"/>\r\n                <label for=\"osi-radio-izipay\" class=\"osi-radio--label\" style=\"min-height: 30px;\">\r\n                    <span class=\"osi-radio--button\"></span>\r\n                    <div class=\"alineado ancho50\" style=\"margin-left: 10px;\" >\r\n                        <img src=\"assets/images/vinetaTarjeta.png\" class=\"margenIzquierdo10 margenSuperior10\" />\r\n                        </div>\r\n                    <p>Tarjeta de crédito o débito</p>\r\n                </label>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"col-sm-6 \">\r\n            <div class=\"osi-radio\" style=\"width: 80%; \"  >\r\n                <input id=\"osi-radio-pagoefectivo\" type=\"radio\" ng-model=\"vm.mediopago\"  name=\"mediopago\"\r\n                    value=\"pagoefectivo\" ng-click=\"vm.mediopago_select(\'pagoefectivo\')\"/>\r\n                <label for=\"osi-radio-pagoefectivo\" class=\"osi-radio--label\" style=\"min-height: 30px;\">\r\n                    <span class=\"osi-radio--button\"></span>\r\n                    <div class=\"alineado ancho50\" style=\"margin-left: 10px;\" >\r\n                        <img src=\"assets/images/vinetaPagoEfectivo.png\" class=\"margenIzquierdo10 margenSuperior10\" />\r\n                        </div>\r\n                    <p>Pagoefectivo</p>\r\n                </label>\r\n            </div>\r\n        </div>\r\n      </div>\r\n    <hr>\r\n      <button type=\"button\" ng-if=\"vm.mediopagoIzi\" class=\"btn btn-greensea btn-rounded-40 full-width\" ng-click=\"vm.save(\'carrito\')\"\r\n        ng-disabled=\"vm.btnpagar\">\r\n        <i class=\"fa fa-shopping-cart\"></i> Pagar\r\n      </button>\r\n    \r\n      <button id=\"btnGenerarCIP\" class=\"btn btn-greensea btn-rounded-40 full-width\" ng-if=\"vm.mediopagoPE\" ng-click=\"vm.generarCIP()\" > Generar Codigo CIP</button>\r\n\r\n    </div>\r\n  </div>\r\n  <!-- <pre>\r\n        {{vm.presupuestodetTemp|json}}\r\n      </pre> -->\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-6 col-xs-12\" ng-if=\"vm.total > vm.porpagar && vm.porpagar > 0\">\r\n      <div class=\"tile\" style=\"border: 1px solid #005CB8;\">\r\n        <div class=\"tile-body\">\r\n          <h5 class=\"text-primary text-center\"><strong>Todos los tratamientos</strong></h5>\r\n          <div style=\"min-height: 80px;\">\r\n            <table class=\"full-width\">\r\n              <tr data-ng-repeat=\"item in vm.presupuestodet\">\r\n                <td width=\"100%\">{{item.nombreproducto}}</td>\r\n              </tr>\r\n            </table>\r\n          </div>\r\n          <button type=\"button\" class=\"btn btn-greensea btn-rounded-40 full-width mt-10\"\r\n            ng-click=\"vm.save(\'acuentatodo\', \'Todos los tratamientos\')\" ng-disabled=\"vm.btnpagar\">\r\n            S/ {{vm.porpagar}} <i class=\"fa fa-shopping-cart\"></i>\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer\" ng-if=\"!vm.generoCIP\">\r\n  <button class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR\r\n    VENTANA</button>\r\n</div>\r\n\r\n\r\n<div class=\"modal-body\" ng-if=\"vm.generoCIP\">  \r\n  <p class=\"text-center mt-20 text-primary\">Se ha enviado los detalles del pago de su terapia a su número celular.</strong>!</p>\r\n  <div class=\"text-center mt-20\" >\r\n      <div class=\"p-xs text-center\">\r\n         \r\n          <p class=\"mt-10\"><span class=\"ng-binding\"><b>\r\n                  Monto a pagar: </b></span><span class=\"ng-binding\">\r\n                      S/. {{vm.precio}} </span></p>\r\n          <p class=\"mt-10\"><span class=\"ng-binding\"><b>\r\n              Codigo de pago CIP: </b></span><span class=\"ng-binding\">\r\n                  {{vm.codigocip}} </span></p>\r\n          <p class=\"mt-10\"><span class=\"ng-binding\"><b>\r\n              Como pagar: </b></span><span class=\"ng-binding\">\r\n                      <a href=\"https://pagoefectivo.pe/como-pagar.html\" target=\"_blank\">https://pagoefectivo.pe/como-pagar.html</a></span></p>\r\n      </div>\r\n  </div>\r\n  \r\n</div>\r\n<div class=\"modal-footer\" style=\"margin:20px; text-align:left\" ng-if=\"vm.generoCIP\">\r\n  <p>Tenga en cuenta lo siguiente: </p>\r\n  <p>\r\n      <li>Toda terapia se confirma previo pago.</li>\r\n      <li>Realizar el pago confirma la lectura y aceptación de los términos y condiciones de atención. </li>\r\n      <li>Puede leer los términos y condiciones de atención haciendo <a href=\"https://centromedicoosi.com/condiciones-de-atencion1.pdf\" target=\"_blank\"> click aquí</a></li>\r\n  </p>\r\n  <!-- <a href=\"{{vm.urlPdf}}\" target=\"_blank\" class=\"btn btn-greensea btn-rounded-20 btn-sm\" ng-if=\"vm.urlPdf\"><i class=\"fa fa-cloud-download\"></i> COMPROBANTE</a> -->\r\n  <button style=\"float:right\" class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n</div> \r\n\r\n\r\n<!-- </form> --></script><script type=text/ng-template id=myModalCodigoCIPContent.html><div class=\"modal-body\">  \r\n      <p class=\"text-center mt-20 text-primary\">Se ha enviado los detalles del pago de su terapia a su número celular.</strong>!</p>\r\n      <div class=\"text-center mt-20\" >\r\n          <div class=\"p-xs text-center\">\r\n             \r\n              <p class=\"mt-10\"><span class=\"ng-binding\"><b>\r\n                      Monto a pagar: </b></span><span class=\"ng-binding\">\r\n                          S/. {{vm.precio}} </span></p>\r\n              <p class=\"mt-10\"><span class=\"ng-binding\"><b>\r\n                  Codigo de pago CIP: </b></span><span class=\"ng-binding\">\r\n                      {{vm.codigocip}} </span></p>\r\n              <p class=\"mt-10\"><span class=\"ng-binding\"><b>\r\n                  Como pagar: </b></span><span class=\"ng-binding\">\r\n                          <a href=\"https://pagoefectivo.pe/como-pagar.html\" target=\"_blank\">https://pagoefectivo.pe/como-pagar.html</a></span></p>\r\n          </div>\r\n      </div>\r\n      \r\n  </div>\r\n  <div class=\"modal-footer\" style=\"margin:20px; text-align:left\" >\r\n      <p>Tenga en cuenta lo siguiente: </p>\r\n      <p>\r\n          <li>Toda terapia se confirma previo pago.</li>\r\n          <li>Realizar el pago confirma la lectura y aceptación de los términos y condiciones de atención. </li>\r\n          <li>Puede leer los términos y condiciones de atención haciendo <a href=\"https://centromedicoosi.com/condiciones-de-atencion1.pdf\" target=\"_blank\"> click aquí</a></li>\r\n      </p>\r\n      <!-- <a href=\"{{vm.urlPdf}}\" target=\"_blank\" class=\"btn btn-greensea btn-rounded-20 btn-sm\" ng-if=\"vm.urlPdf\"><i class=\"fa fa-cloud-download\"></i> COMPROBANTE</a> -->\r\n      <button style=\"float:right\" class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n  </div></script><div class=tile><div class=spinerLoading ng-if=vm.spinerLoading><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><uib-tabset class=\"minotaur-tab minotaur-tab-light padded\" ng-if=!vm.spinerLoading><uib-tab><uib-tab-heading>TERAPIAS</uib-tab-heading><div class=row><label class=\"col-sm-1 col-xs-7 text-primary\">Ciclo</label><div class=\"col-sm-3 col-xs-5\">{{vm.cicloatencion.idcicloatencion}}</div><label class=\"col-sm-1 col-xs-7 text-primary\">Fecha</label><div class=\"col-sm-3 col-xs-5\">{{vm.cicloatencion.fecha}}</div><label class=\"col-sm-1 col-xs-7 text-primary\">Sede</label><div class=\"col-sm-3 col-xs-5\">{{vm.cicloatencion.nombresede}}</div></div><h5 class=mt-10>Terapias efectuadas</h5><div class=row><div class=\"col-md-12 col-xs-12\"><div class=table-responsive><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th width=2%><strong>#</strong></th><th width=8%><strong>Fecha</strong></th><th width=20%><strong>Terapeuta</strong></th><th width=6% class=text-center><strong>TF</strong></th><th width=6% class=text-center><strong>AC</strong></th><th width=6% class=text-center><strong>QT</strong></th><th width=6% class=text-center><strong>OCH</strong></th><th width=6% class=text-center><strong>ESP</strong></th><th width=6% class=text-center><strong>BL</strong></th><th width=6% class=text-center><strong>BMG</strong></th><th width=6% class=text-center><strong>AGUJA</strong></th><th width=6% class=text-center><strong>OTROS</strong></th><th width=6% class=text-center><strong>TOTAL</strong></th></tr></thead><tbody><tr data-ng-repeat=\"item in vm.others.terapiasrealizadas\"><td>{{$index + 1}}</td><!-- {{item.inicio}} --><td>{{item.fecha}}</td><td>{{item.nombreterapista}}</td><td class=text-center>{{item.TF}}</td><td class=text-center>{{item.AC}}</td><td class=text-center>{{item.QT}}</td><td class=text-center>{{item.OCH}}</td><td class=text-center>{{item.ESP}}</td><td class=text-center>{{item.BL}}</td><td class=text-center>{{item.BMG}}</td><td class=text-center>{{item.AGUJA}}</td><td class=text-center>{{item.OTROS}}</td><td class=text-center>{{item.total}}</td></tr><tr data-ng-show=\"vm.others.terapiasrealizadas.length === 0\"><td colspan=23 class=text-center>No hay registros.</td></tr></tbody><tfoot><tr><td colspan=12 class=text-right>Total efectuado S/.</td><td class=text-center>{{vm.costototalterapias}}</td></tr></tfoot></table></div></div></div></uib-tab><uib-tab><uib-tab-heading>PRESUPUESTO</uib-tab-heading><div class=row><label class=\"col-sm-1 col-xs-7 text-primary\">Ciclo</label><div class=\"col-sm-3 col-xs-5\">{{vm.cicloatencion.idcicloatencion}}</div><label class=\"col-sm-1 col-xs-7 text-primary\">Fecha</label><div class=\"col-sm-3 col-xs-5\">{{vm.cicloatencion.fecha}}</div><label class=\"col-sm-1 col-xs-7 text-primary\">Sede</label><div class=\"col-sm-3 col-xs-5\">{{vm.cicloatencion.nombresede}}</div></div><h5 class=mt-10>Presupuesto</h5><div class=row><div class=col-md-12><div class=table-responsive><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th width=60%><strong>Tratamientos indicados por el médico</strong></th><th width=10% class=text-center><strong>Cantidad <i class=\"fa fa-question-circle\" uib-tooltip=\"Indicadas por el médico\"></i></strong></th><th width=10% class=text-center><strong>Efectuadas <i class=\"fa fa-question-circle\" uib-tooltip=\"Terapias efectuadas\"></i></strong></th><th width=10% class=text-center ng-if=\"vm.presupuesto.tipotarifa === 1\"><strong>Precio Unit.</strong></th><th width=10% class=text-right ng-if=\"vm.presupuesto.tipotarifa === 1\"><strong>Total</strong></th><th width=10% class=text-center ng-if=\"vm.presupuesto.tipotarifa === 2\"><strong>Precio Unit.</strong></th><th width=10% class=text-right ng-if=\"vm.presupuesto.tipotarifa === 2\"><strong>Total</strong></th><th width=10% class=text-center ng-if=\"vm.presupuesto.tipotarifa === 3\"><strong>Precio Unit.</strong></th><th width=10% class=text-right ng-if=\"vm.presupuesto.tipotarifa === 3\"><strong>Total</strong></th></tr></thead><tbody><tr data-ng-repeat=\"item in vm.others.presupuestodet\"><td>{{item.nombreproducto}}</td><td class=text-center>{{item.cantcliente}}</td><td class=text-center>{{item.cantefectivo}}</td><td class=text-center ng-if=\"vm.presupuesto.tipotarifa === 1\">{{item.preciounitregular}}</td><td class=text-right ng-if=\"vm.presupuesto.tipotarifa === 1\">{{item.totalregular}}</td><td class=text-center ng-if=\"vm.presupuesto.tipotarifa === 2\">{{item.preciounittarjeta}}</td><td class=text-right ng-if=\"vm.presupuesto.tipotarifa === 2\">{{item.totaltarjeta}}</td><td class=text-center ng-if=\"vm.presupuesto.tipotarifa === 3\">{{item.preciounitefectivo}}</td><td class=text-right ng-if=\"vm.presupuesto.tipotarifa === 3\">{{item.totalefectivo}}</td></tr><tr data-ng-show=\"vm.others.presupuestodet.length === 0\"><td colspan=5 class=text-center>No hay registros.</td></tr></tbody><tfoot><tr><!-- <span class=\"label bg-greensea\"> --><td colspan=4 class=text-right ng-if=\"vm.presupuesto.tipotarifa === 1\">Total presupuesto S/.</td><td colspan=4 class=text-right ng-if=\"vm.presupuesto.tipotarifa === 1\"><span>{{vm.presupuesto.regular| number:2}}</span></td><td colspan=4 class=text-right ng-if=\"vm.presupuesto.tipotarifa === 2\">Total presupuesto S/.</td><td colspan=4 class=text-right ng-if=\"vm.presupuesto.tipotarifa === 2\"><span>{{vm.presupuesto.tarjeta| number:2}}</span></td><td colspan=4 class=text-right ng-if=\"vm.presupuesto.tipotarifa === 3\">Total presupuesto S/.</td><td colspan=4 class=text-right ng-if=\"vm.presupuesto.tipotarifa === 3\"><span>{{vm.presupuesto.efectivo| number:2}}</span></td></tr></tfoot></table></div></div></div></uib-tab><uib-tab><uib-tab-heading>PAGOS</uib-tab-heading><div class=row><label class=\"col-sm-1 col-xs-7 text-primary\">Ciclo</label><div class=\"col-sm-3 col-xs-5\">{{vm.cicloatencion.idcicloatencion}}</div><label class=\"col-sm-1 col-xs-7 text-primary\">Fecha</label><div class=\"col-sm-3 col-xs-5\">{{vm.cicloatencion.fecha}}</div><label class=\"col-sm-1 col-xs-7 text-primary\">Sede</label><div class=\"col-sm-3 col-xs-5\">{{vm.cicloatencion.nombresede}}</div></div><div class=row><div class=\"col-md-6 col-xs-12\"><h5 class=mt-10>Pagos de tratamientos</h5><div class=\"table-responsive mb-20\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th width=48%><strong>Documento</strong></th><th width=13%><strong>F.Emisión</strong></th><th width=13% class=text-center><strong>Total</strong></th></tr></thead><tbody><tr data-ng-repeat=\"item in vm.others.pagosrealizadas\"><td>{{item.documento}}</td><td>{{item.fechaventa}}</td><td class=text-center>{{item.total}}</td></tr><tr data-ng-show=\"vm.others.pagosrealizadas.length === 0\"><td colspan=3 class=text-center>No hay registros.</td></tr></tbody><tfoot><tr><td colspan=2 class=text-right>Total S/.</td><td class=text-center>{{vm.costototalpagos}}</td></tr></tfoot></table></div></div><div class=\"col-md-6 col-xs-12\"><h5>Pagos de consultas</h5><div class=\"table-responsive mb-20\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th width=48%><strong>Documento</strong></th><th width=13%><strong>F.Emisión</strong></th><th width=13% class=text-center><strong>Total</strong></th></tr></thead><tbody><tr data-ng-repeat=\"item in vm.others.pagosconsultas\"><td>{{item.documento}}</td><td>{{item.fechaventa}}</td><td class=text-center>{{item.total}}</td></tr><tr data-ng-show=\"vm.others.pagosconsultas.length === 0\"><td colspan=3 class=text-center>No hay registros.</td></tr></tbody></table></div></div></div></uib-tab></uib-tabset></div><div class=tile ng-if=!vm.spinerLoading><section class=tile-body><h5>Resumen de presupuesto</h5><div class=row><div class=\"col-sm-6 col-xs-12\"><!-- <div class=\"row\">\r\n          <label class=\"col-sm-6 col-xs-7 text-primary\">Pagó tratamientos:</label>\r\n          <div class=\"col-sm-6 col-xs-5 text-right\">\r\n            S/ {{vm.presupuesto.montopago| number:2}}\r\n          </div>\r\n        </div> --><div class=row><label class=\"col-sm-4 col-xs-7 text-primary\">Por pagar:</label><div class=\"col-sm-8 col-xs-5 text-left\">S/ {{vm.porpagar| number:2}}</div></div></div><div class=\"col-sm-6 col-xs-12\"><!-- <div class=\"row\">\r\n          <label class=\"col-sm-6 col-xs-7 text-primary\">Saldo efectuado: <i class=\"fa fa-question-circle\"\r\n              uib-tooltip=\"Costo de terapias realizadas\"></i></label>\r\n          <div class=\"col-sm-6 col-xs-5 text-right\">\r\n            S/ {{vm.presupuesto.montoefectuado| number:2}}\r\n          </div>\r\n        </div> --><div class=row><label class=\"col-sm-6 col-xs-7 text-primary\">Saldo disponible: <i class=\"fa fa-question-circle\" uib-tooltip=\"Realizar terapias\"></i></label><div class=\"col-sm-6 col-xs-5 text-left\">S/ {{vm.creditodisp| number:2}}</div></div></div></div></section></div><div class=row ng-if=\"vm.cicloatencion.idestado === 20 && vm.porpagar > 0\"><div class=\"col-sm-6 col-xs-12\"><button type=button class=\"btn btn-greensea btn-rounded-40 full-width btn-lg\" ng-click=vm.openSeleccionarPagoModal()><i class=\"fa fa-shopping-cart\"></i> Pagar tratamientos</button></div></div><hr><div id=button_pago style=\"display: none;text-align: center\"></div><form name=miForm ng-submit=vm.openPagar(); novalidate><button style=\"display: none\" id=button_page type=submit></button></form><input type=hidden id=response_page name=response_page> <input type=hidden id=error_form name=error_form> <button style=\"display: none\" ng-click=vm.error_form() id=button_errorForm></button>");
$templateCache.put("app/views/administracion/misciclos.html","<style>.spinerLoading {\r\n        text-align: center;\r\n        padding: 40px;\r\n    }</style><div class=\"page page-ui pull-to-header\"><div class=row><div class=col-md-12><ol class=breadcrumb><li><a ui-sref=mireserva>Inicio</a></li><li class=active>Mis ciclos</li></ol><div class=pull-left><h4 class=\"pl-15 text-primary\">Mis ciclos</h4></div><div class=clearfix></div><div class=spinerLoading ng-if=vm.spinerLoading><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><div class=row ng-if=\"vm.data.length === 0 && !vm.spinerLoading\"><div class=col-sm-12>No tiene ciclos de atención.</div></div><div class=row ng-if=\"vm.data.length > 0\"><div class=\"col-sm-3 col-xs-12\"><div class=list-group><a ui-sref=\"misciclos.edit({paramId: row.idcicloatencion})\" class=list-group-item data-ng-repeat=\"row in vm.data\" ng-click=\"vm.activeCiclo = row.idcicloatencion;\" ng-class=\"{\'active\': vm.activeCiclo === row.idcicloatencion}\"><span class=\"badge bg-greensea\" ng-if=\"row.idestado === 20\">abierto</span> <span class=\"badge bg-primary\" ng-if=\"row.idestado === 21\">cerrado</span> <i class=\"fa fa-folder text-slategray\" ng-if=\"row.idestado === 21\"></i> <i class=\"fa fa-folder-open text-slategray\" ng-if=\"row.idestado === 20\"></i> {{row.idcicloatencion}}</a></div></div><div class=\"col-sm-9 col-xs-12\"><div ui-view></div></div></div></div></div></div>");
$templateCache.put("app/views/administracion/miscitasmedicas-show.html","<style>.viewport-sm .mt-20 {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  fieldset {\r\n    color: #454545;\r\n    /* border: 1px solid #367fa9; */\r\n    border: 1px solid rgba(0, 0, 0, 0.2) !important;\r\n    border-radius: 5px;\r\n    padding: 5px 10px;\r\n    line-height: 16px;\r\n    background: #FFF;\r\n  }\r\n\r\n  fieldset legend {\r\n    color: #367fa9;\r\n    padding: 5px;\r\n    margin: 0px;\r\n    font-size: 12px;\r\n    border: none !important;\r\n    width: auto !important;\r\n  }\r\n\r\n  table {\r\n    border: 1px solid rgba(0, 0, 0, 0.1) !important;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  table thead tr th {\r\n    color: #367fa9;\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n  }\r\n\r\n  .spinerLoading {\r\n    text-align: center;\r\n    padding: 40px;\r\n  }</style><div class=\"page page-ui pull-to-header\"><div class=row><div class=col-md-12><ol class=breadcrumb ng-if=!vm.spinerLoading><li><a ui-sref=mireserva>Inicio</a></li><li><a ui-sref=miscitasmedicas.list>Citas médicas</a></li><li class=active>Resultado</li></ol><h4 class=text-center ng-if=!vm.spinerLoading>Historia clínica</h4><div class=tile><div class=spinerLoading ng-if=vm.spinerLoading><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><section class=tile-body ng-if=vm.citamedica.idcicloatencion><div class=row><div class=\"col-sm-6 col-xs-12\"><fieldset><legend><strong>CITA</strong></legend><div class=row><label class=\"col-sm-2 col-xs-3 control-label text-theme\">Fecha</label><div class=\"col-sm-10 col-xs-9\">{{vm.citamedica.fecha}}</div></div><div class=row><label class=\"col-sm-2 col-xs-3 control-label text-theme\">Sede</label><div class=\"col-sm-10 col-xs-9\">{{vm.citamedica.nombresede}}</div></div><div class=row><label class=\"col-sm-2 col-xs-3 control-label text-theme\">Médico</label><div class=\"col-sm-10 col-xs-9\">{{vm.citamedica.nombremedico}}</div></div><div class=row><label class=\"col-sm-2 col-xs-3 control-label text-theme\">Paciente</label><div class=\"col-sm-10 col-xs-9\">{{vm.citamedica.nombrepaciente}}</div></div><div class=row><label class=\"col-sm-2 col-xs-3 control-label text-theme\">Ciclo</label><div class=\"col-sm-10 col-xs-9\"><i class=\"fa fa-folder-open text-slategray\"></i> {{vm.citamedica.idcicloatencion}}</div></div><div class=row><div class=\"col-sm-12 col-xs-12 text-center\"><a href={{vm.citamedica.urlPdf}} target=_blank class=\"btn btn-danger btn-ef btn-ef-7 btn-ef-7h mt-10 mb-10 btn-rounded-20\" style=\"width: 220px\" ng-if=vm.citamedica.urlPdf><i class=\"fa fa-cloud-download\"></i> Descargar Historia</a></div></div></fieldset></div><div class=\"col-sm-6 col-xs-12\"><fieldset class=mt-xs><legend><strong>ENFERMEDAD ACTUAL</strong></legend><div class=\"row mt-5\"><div class=\"col-sm-2 text-theme\">Síntomas y disfunción:</div><div class=col-sm-10>{{vm.citamedica.nota}}</div></div><div class=\"row mt-5\"><div class=\"col-sm-2 text-theme\">Tiempo:</div><div class=col-sm-10>{{vm.citamedica.enfermedad}} <span ng-if=vm.citamedica.enfermedad>- </span>{{vm.citamedica.enfermedadtiempo}}</div></div></fieldset></div></div><div class=row><div class=\"col-sm-6 col-xs-12\"><fieldset class=mt-20><legend><strong>DIAGNÓSTICO MÉDICO CIE 10</strong></legend><fieldset data-ng-repeat=\"grupo in vm.gruposdx\"><legend><strong>{{grupo.nombre}}</strong></legend><table class=\"table mb-0 b-0\"><thead><tr><th style=\"width: 50%\"><small>Diagnóstico</small></th><th style=\"width: 25%\"><small>Zona</small></th><th style=\"width: 25%\"><small>Segmento</small></th></tr></thead><tbody><tr data-ng-repeat=\"item in grupo.diagnosticos\" ng-class=\"{\'text-muted\': vm.idcitamedica !== item.idcitamedica}\"><td>{{item.codigo}} - {{item.nombre}}<p class=\"text-italic text-darkgray\" ng-if=\"vm.idcitamedica !== item.idcitamedica\">(Dx de ciclo)</p></td><td><span ng-if=\"item.idzona === \'B\'\">Bilateral</span> <span ng-if=\"item.idzona === \'I\'\">Izquierda</span> <span ng-if=\"item.idzona === \'D\'\">Derecha</span> <span ng-if=\"item.idzona === \'N\'\">-</span></td><td>{{item.segmentos.toString()}}</td></tr><tr ng-if=!grupo.diagnosticos.length><td colspan=2 class=text-center><small>No hay registros.</small></td></tr></tbody></table></fieldset></fieldset></div><div class=\"col-sm-6 col-xs-12\"><fieldset class=mt-20><legend><strong>INDICACIÓN MÉDICA</strong></legend><fieldset data-ng-repeat=\"grupo in vm.gruposdx\"><legend><strong>{{grupo.nombre}}</strong></legend><div><table class=\"table mb-0 b-0 mt-0\"><thead><tr><th style=\"width: 20%\"><small>Cantidad</small></th><th style=\"width: 80%\"><small>Nombre</small></th></tr></thead><tbody><tr data-ng-repeat=\"item in grupo.tratamientos\"><td>{{item.cantidad}}</td><td>{{item.nombreproducto}}</td></tr><tr ng-if=!grupo.tratamientos.length><td colspan=2 class=text-center><small>No hay registros.</small></td></tr></tbody></table></div></fieldset><div class=\"row mt-5\"><div class=\"col-sm-12 text-theme text-center\">Asistencia:</div><div class=\"col-sm-12 text-center\"><p ng-if=\"vm.citamedica.frecuencia === \'D\'\">Diaria</p><p ng-if=\"vm.citamedica.frecuencia === \'I\'\">Interdiaria</p></div></div></fieldset></div></div><div class=row><div class=\"col-sm-6 col-xs-12\"><fieldset class=mt-20><legend><strong>INDICACIÓN EXAMEN AUXILIAR</strong></legend><table class=\"table table-hover mb-0 b-0\"><thead><tr><th style=\"width: 20%\"><small>Nombre</small></th><th style=\"width: 80%\"><small>Descripción</small></th></tr></thead><tbody><tr data-ng-repeat=\"item in vm.others.examenescita\"><td>{{item.nombre}}</td><td>{{item.descripcion}}</td></tr><tr ng-if=!vm.others.examenescita.length><td class=text-center colspan=2><small>No hay registros.</small></td></tr></tbody></table></fieldset></div><div class=\"col-sm-6 col-xs-12\"><fieldset class=mt-20><legend><strong>OBSERVACIÓN EXAMEN AUXILIAR</strong></legend><table class=\"table table-hover mb-0 b-0\"><thead><tr><th style=\"width: 20%\"><small>Nombre</small></th><th style=\"width: 80%\"><small>Descripción</small></th></tr></thead><tbody><tr data-ng-repeat=\"item in vm.others.examenescitaobs\"><td>{{item.nombre}}</td><td>{{item.descripcion}}</td></tr><tr ng-if=!vm.others.examenescitaobs.length><td class=text-center colspan=2><small>No hay registros.</small></td></tr></tbody></table></fieldset></div></div><div class=row><div class=\"col-sm-6 col-xs-12\"><fieldset class=mt-20><legend><strong>INDICACIÓN FARMACOLÓGICA</strong></legend><div class=row><div class=col-sm-12>{{vm.citamedica.notamedicamento}}</div></div></fieldset></div><div class=\"col-sm-6 col-xs-12\"><fieldset class=mt-20><legend><strong>OBSERVACIÓN / EVALUACIÓN</strong></legend><div class=row><div class=col-sm-12>{{vm.citamedica.observacion}}</div></div></fieldset></div></div><div class=row><div class=\"col-sm-6 col-xs-12\"><fieldset class=mt-20><legend><strong>ALTA MÉDICA</strong></legend><div class=row><div class=\"col-sm-3 text-center\"><p ng-if=\"vm.citamedica.altamedica === \'1\'\" style=\"font-weight: bold\">Si</p><p ng-if=\"vm.citamedica.altamedica === \'0\' || !vm.citamedica.altamedica\" style=\"font-weight: bold\">No</p></div><div class=col-sm-9>{{vm.citamedica.altamedicacomentario}}</div></div></fieldset></div><div class=\"col-sm-6 col-xs-12\"><fieldset class=mt-20><legend><strong>DESCANSO MÉDICO</strong></legend><div class=row><label class=\"col-sm-1 col-xs-6 control-label text-theme\">Del</label><div class=\"col-sm-3 col-xs-6\">{{vm.citamedica.descansodesde}}</div><label class=\"col-sm-1 col-xs-6 control-label text-theme\">Al</label><div class=\"col-sm-3 col-xs-6\">{{vm.citamedica.descansohasta}}</div><div class=\"col-sm-4 col-xs-6\">{{vm.citamedica.descansodias}}</div></div></fieldset></div></div></section></div></div></div></div>");
$templateCache.put("app/views/administracion/miscitasmedicas.html","<style>.uib-day .btn[disabled] {\r\n    opacity: 0.90;\r\n    filter: alpha(opacity=90);\r\n    background-color: white;\r\n    color: #777;\r\n  }\r\n\r\n  .uib-day button {\r\n    opacity: 0.90;\r\n    filter: alpha(opacity=90);\r\n    background-color: rgb(225, 245, 225);\r\n    border-radius: 32px;\r\n  }</style><script>var $content, $modal, $apnData, $modalCon;\r\n\r\n  $content = $(\".min\");\r\n\r\n  function minimizarLlamada() {\r\n\r\n    $apnData = $(\".mymodal\");\r\n\r\n    $modal = \"#myModalTokBoxPopUp\";\r\n\r\n    $(\".modal-backdrop\").addClass(\"display-none\");\r\n\r\n    $($modal).toggleClass(\"min\");\r\n\r\n    btnMaximize = $(\'#btnMaximize\');\r\n    btnMinimize = $(\'#btnMinimize\');\r\n    videos = $(\'#videos\');\r\n\r\n    if ($($modal).hasClass(\"min\")) {\r\n      btnMaximize.show();\r\n      btnMinimize.hide();\r\n      videos.removeClass(\'app-full\');\r\n      videos.addClass(\'app-min\');\r\n      $(\'#minotaur\').removeClass(\'modal-open\');\r\n      $(\".minmaxCon\").append($apnData);\r\n      $(this).find(\"i\").toggleClass(\'fa-minus\').toggleClass(\'fa-clone\');\r\n\r\n    } else {\r\n      btnMinimize.show();\r\n      btnMaximize.hide();\r\n      videos.removeClass(\'app-min\');\r\n      videos.addClass(\'app-full\');\r\n      $(\'#minotaur\').addClass(\'modal-open\');\r\n      $(\".container\").append($apnData);\r\n      $(this).find(\"i\").toggleClass(\'fa-clone\').toggleClass(\'fa-minus\');\r\n    };\r\n  }\r\n\r\n  function closeLlamada() {\r\n    $(\'#myModalTokBoxPopUp\').modal(\'toggle\');\r\n    disconnect();\r\n  }\r\n\r\n  var session;\r\n\r\n  function disconnect() {\r\n    if (session != null) {\r\n      console.log(\'disconnecting session\');\r\n      session.disconnect();\r\n    }\r\n    $(\'#subscriber\').html();\r\n    $(\'#publisher\').html();\r\n  }\r\n\r\n  function putOnHold() {\r\n    $(\'#subscriber\').html();\r\n    $(\'#publisher\').html();\r\n  }\r\n\r\n  function initializeSession(apiKey, sessionId, token) {\r\n\r\n    session = OT.initSession(apiKey, sessionId);\r\n\r\n    // Contar las conexiones\r\n    var connectionCount = 0;\r\n    $(\'#connectionCountTokBox\').hide();\r\n\r\n    session.on(\"connectionCreated\", function (event) {\r\n      connectionCount++;\r\n      displayConnectionCount();\r\n    });\r\n\r\n    session.on(\"connectionDestroyed\", function (event) {\r\n      connectionCount--;\r\n      displayConnectionCount();\r\n    });\r\n\r\n    function displayConnectionCount() {\r\n      console.log(\'connectionCount: \', connectionCount)\r\n      if (connectionCount === 1) {\r\n        $(\'#connectionCountTokBox\').show().html(\'<i class=\"fa fa-user-md\"></i> Espere la conexión del doctor...\');\r\n      } else {\r\n        $(\'#connectionCountTokBox\').hide();\r\n      }\r\n    }\r\n\r\n    // Subscribe to a newly created stream\r\n    session.on(\'streamCreated\', function (event) {\r\n\r\n      //only add stream to appropriate div if this user not already subscribed to\r\n      alreadySubscribed = false;\r\n\r\n      //before reconnecting check whether there\'s already a subscriber with same connection Id\r\n      var subscribers = session.getSubscribersForStream(event.stream);\r\n      for (let subscriber of subscribers) {\r\n        if (subscriber.stream.connection.connectionId === event.stream.connection.connectionId) {\r\n          alreadySubscribed = true;\r\n          break;\r\n        }\r\n      }\r\n\r\n      if (!alreadySubscribed) {\r\n        session.subscribe(event.stream, \'subscriber\', {\r\n          insertMode: \'append\',\r\n          width: \'100%\',\r\n          height: \'100%\',\r\n          name: \'Doctor\',\r\n          showControls: true\r\n        }, handleError);\r\n      }\r\n    });\r\n\r\n    // Create a publisher\r\n    var publisher = OT.initPublisher(\'publisher\', {\r\n      insertMode: \'append\',\r\n      width: \'100%\',\r\n      height: \'100%\',\r\n      name: \'Paciente\',\r\n      showControls: true\r\n    }, handleError);\r\n\r\n    // Connect to the session\r\n    session.connect(token, function (error) {\r\n      // If the connection is successful, initialize a publisher and publish to the session\r\n      if (error) {\r\n        handleError(error);\r\n      } else {\r\n        session.publish(publisher, handleError);\r\n      }\r\n    });\r\n\r\n    function handleError(error) {\r\n      if (error) {\r\n        console.log(error.name, error.message);\r\n\r\n        switch (error.name) {\r\n\r\n          case \'OT_NO_DEVICES_FOUND\':\r\n            $(\'#errorTokBox\').show().html(\'No hay dispositivos de entrada de voz <i class=\"fa fa-microphone\"></i> o video <i class=\"fa fa-video-camera\"></i> en este equipo.\');\r\n            break;\r\n\r\n          case \'OT_HARDWARE_UNAVAILABLE\':\r\n            $(\'#errorTokBox\').show().html(\'El hardware para cumplir con la solicitud de medios del usuario parece existir pero no se pudo adquirir. Podría estar en uso por otra aplicación.\');\r\n            break;\r\n\r\n          case \'OT_NO_VALID_CONSTRAINTS\':\r\n            $(\'#errorTokBox\').show().html(\'El video y el audio fueron deshabilitados. Necesita habilitar al menos uno.\');\r\n            break;\r\n\r\n          case \'OT_MEDIA_ERR_NETWORK\':\r\n            $(\'#errorTokBox\').show().html(\'Un error de red provocó que la transmisión dejara de recuperarse.\');\r\n            break;\r\n\r\n          case \'OT_NOT_CONNECTED\':\r\n            $(\'#errorTokBox\').show().html(\'No se pudo realizar la acción porque no está conectado a la red.\');\r\n            break;\r\n\r\n          default:\r\n            $(\'#errorTokBox\').hide();\r\n            break;\r\n        }\r\n      }\r\n    }\r\n  }</script><style>p {\r\n    padding: 3px 0px;\r\n  }\r\n\r\n  .viewport-sm .mt-xs {\r\n    margin: 25px 0px 15px 0px;\r\n  }\r\n\r\n  .viewport-sm .mt-xs-5 {\r\n    margin-top: 5px;\r\n  }\r\n\r\n  .viewport-sm .mt-xs-10 {\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .viewport-sm .ocultar {\r\n    display: none;\r\n  }\r\n\r\n  .spinerLoading {\r\n    text-align: center;\r\n    padding: 40px;\r\n  }\r\n\r\n  /*CSS TokBox*/\r\n  #myModalTokBoxPopUp {\r\n    background: rgba(0, 0, 0, 0.8);\r\n  }\r\n\r\n  .minmaxCon #myModalTokBoxPopUp {\r\n    background: none !important;\r\n  }\r\n\r\n  .app-full {\r\n    background-color: #4a4a4a;\r\n    height: 100% !important;\r\n    width: 100%;\r\n  }\r\n\r\n  .app-min {\r\n    background-color: #4a4a4a;\r\n    height: 390px !important;\r\n    width: 100%;\r\n  }\r\n\r\n  .call {\r\n    height: 100%;\r\n  }\r\n\r\n  .small-tiles {\r\n    position: absolute;\r\n    z-index: 999999;\r\n    bottom: 5px;\r\n    left: 20px;\r\n    width: 35% !important;\r\n    height: 35% !important;\r\n    background-color: white;\r\n  }\r\n\r\n  #publisher {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n  }\r\n\r\n  #subscriber {\r\n    height: 100% !important;\r\n    background: #000 !important;\r\n    width: 100% !important;\r\n    background-color: #1908ff;\r\n  }\r\n\r\n  .modal-header .btnGrp {\r\n    position: absolute;\r\n    top: 8px;\r\n    right: 10px;\r\n  }\r\n\r\n  .min {\r\n    width: 100%;\r\n    /* height: 35px; */\r\n    overflow: hidden !important;\r\n    padding: 0px !important;\r\n    margin: 0px;\r\n    float: left;\r\n    position: static !important;\r\n  }\r\n\r\n  .min .modal-dialog,\r\n  .min .modal-content {\r\n    height: 100%;\r\n    width: 100%;\r\n    margin: 0px !important;\r\n    padding: 0px !important;\r\n  }\r\n\r\n  .min .modal-header {\r\n    height: 100%;\r\n    width: 100%;\r\n    margin: 0px !important;\r\n  }\r\n\r\n  .display-none {\r\n    display: none;\r\n  }\r\n\r\n  .min iframe {\r\n    height: 250px !important;\r\n  }\r\n\r\n  .min .menuTab {\r\n    display: none;\r\n  }\r\n\r\n  .minmaxCon {\r\n    /* height: 35px; */\r\n    width: 33%;\r\n    bottom: 0px;\r\n    left: 0px;\r\n    position: fixed;\r\n    right: 1px;\r\n    z-index: 9999;\r\n  }\r\n\r\n  #myModalTokBoxPopUp .modal-dialog {\r\n    width: 98%;\r\n    height: 99%;\r\n    padding: 0;\r\n    margin: 5px auto;\r\n  }\r\n\r\n  #myModalTokBoxPopUp .modal-content {\r\n    height: 99%;\r\n    margin-top: 3px !important;\r\n  }\r\n\r\n  #myModalTokBoxPopUp .modal-header {\r\n    padding: 5px;\r\n  }\r\n\r\n  #myModalTokBoxPopUp .modal-body {\r\n    height: 95% !important;\r\n  }\r\n\r\n  #myModalTokBoxPopUp h4.modal-title {\r\n    padding: 5px 5px;\r\n  }\r\n\r\n  /*End CSS TokBox*/</style><script type=text/ng-template id=myModalReprogramarCitaContent.html><form name=\"miForm\" ng-submit=\"vm.save();\" novalidate>\r\n    <div class=\"modal-header bg-primary\">\r\n      <h4 class=\"modal-title\">Reprogramar cita médica</h4>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n      <div class=\"row\">\r\n        <div class=\"spinerLoading\" ng-if=\"vm.spinerLoadingv2\">\r\n          <i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i>\r\n      </div>\r\n        <div class=\"col-sm-5 col-xs-12\" ng-if=\"vm.checkpaso2\">\r\n            <h6 class=\"text-primary\"><strong>PASO 1</strong></h5>\r\n            <h5 class=\"text-greensea pt-0\"> Seleccionar fecha</h5>\r\n            <div uib-datepicker ng-model=\"vm.dt\" datepicker-options=\"vm.dateOptions\" ng-change=\"vm.consultarMedicos()\" show-weeks=\"false\"></div>\r\n\r\n        </div>\r\n        <div class=\"col-sm-7 col-xs-12\" ng-if=\"vm.dt\">\r\n              <h6 class=\"text-primary mt-xs\"><strong>PASO 2</strong></h5>\r\n              <h5 class=\"text-greensea pt-0\"> Seleccionar hora</h5>\r\n\r\n              <div class=\"spinerLoading\" ng-if=\"vm.spinerLoadingHoras\">\r\n                  <i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i>\r\n              </div>\r\n\r\n              <div ng-repeat=\"row in vm.medicos\" class=\"mt-20 mb-20\" ng-if=\"!vm.spinerLoadingHoras\">\r\n                <p class=\"m-0\"><i class=\"fa fa-user-md\"></i> {{row.nombre}}</p>\r\n                <label class=\"btn btn-xs btn-primary\" ng-model=\"vm.radioModel\" uib-btn-radio=\"hora\" ng-repeat=\"hora in row.horas\">{{hora.inicioms | date:\'hh:mm a\'}}</label>\r\n              </div>\r\n\r\n              <p ng-if=\"!vm.spinerLoadingHoras && vm.medicos.length === 0\">No hay horarios\r\n                  disponibles.\r\n              </p>\r\n        </div>\r\n      </div>\r\n\r\n      <hr ng-if=\"vm.radioModel.nombre\">\r\n\r\n      <h5 class=\"text-greensea\" ng-if=\"vm.radioModel.nombre\">Nueva reprogramación</h5>\r\n\r\n      <div class=\"row\" ng-if=\"vm.radioModel.nombre\">\r\n          <label class=\"col-sm-1 col-xs-3\"><strong>Fecha:</strong></label>\r\n          <div class=\"col-sm-4 col-xs-9\">\r\n              {{vm.dt | date:\'dd/MM/yyyy\' }} <i class=\"fa fa-clock-o ml-20\" ng-show=\"vm.radioModel.inicioms\"></i> <label ng-show=\"vm.radioModel.inicioms\">{{vm.radioModel.inicioms | date:\'hh:mm a\'}}</label>\r\n          </div>\r\n          <label class=\"col-sm-1 col-xs-3\" ><strong>Médico:</strong></label>\r\n          <div class=\"col-sm-6 col-xs-9\">\r\n              {{vm.radioModel.nombre}}\r\n          </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n      <button class=\"btn btn-primary btn-rounded-20 btn-sm\" ng-disabled=\"miForm.$submitted\">SI, ACEPTAR</button>\r\n      <button class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n    </div>\r\n  </form></script><script type=text/ng-template id=myModalMapaSedeContent.html><form name=\"miForm\" ng-submit=\"vm.save();\" novalidate>\r\n    <div class=\"modal-header bg-primary\">\r\n        <h4 class=\"modal-title\">{{vm.sede.nombre}}</h4>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n        <p><i class=\"fa fa-map-marker\"></i> Dirección</p>\r\n        <p>{{vm.sede.direccion}}</p>\r\n        <div class=\"mt-20\"><em>Más información llamando al <a href=\"tel:017390888\" class=\"llamarfono\">01 739 0888</a></em></div>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <button class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n    </div>\r\n  </form></script><script type=text/ng-template id=myModalAnularCitaContent.html><form name=\"miForm\" ng-submit=\"vm.save();\" novalidate>\r\n    <div class=\"modal-header bg-primary\">\r\n      <h4 class=\"modal-title\">Anular</h4>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-12 col-md-12 text-center\">\r\n          ¿Seguro que desea anular su cita médica para el {{vm.citamedica.fechams | date: \'d\' }} de {{vm.citamedica.fechams | date: \'LLLL yyyy\' }}?\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n      <button class=\"btn btn-danger btn-rounded-20 btn-sm\" ng-disabled=\"miForm.$submitted\"><span>SI, ANULAR</span></button>\r\n      <button class=\"btn btn-danger btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n    </div>\r\n  </form></script><script type=text/ng-template id=myModalArchivosAdjuntosContent.html><div class=\"modal-header bg-primary\">\r\n      <h4 class=\"modal-title\">Adjuntar archivos para el doctor</h4>\r\n  </div>\r\n  <div class=\"modal-body p-20\">\r\n      <div class=\"row\">\r\n          <div class=\"col-md-7 col-xs-12\">\r\n            <h5 class=\"text-primary\"><strong>Paso 1</strong> <span class=\"text-greensea ml-5\">Seleccionar archivo</span></h5>\r\n            <input type=\"file\" data-file-model=\"vm.imagen1\">\r\n          </div>\r\n          <div class=\"col-md-5 col-xs-12 mt-xs-10\">\r\n            <h5 class=\"text-primary\"><strong>Paso 2</strong> <span class=\"text-greensea ml-5\">Subir archivo</span></h5>\r\n            <button type=\"button\" ng-disabled=\"vm.submit\" class=\"btn btn-default full-width\" ng-click=\"vm.enviarImagen()\">\r\n              <i class=\"fa fa-upload\" aria-hidden=\"true\" ng-if=\"!vm.submit\"></i> <span ng-if=\"!vm.submit\">Subir</span>\r\n              <i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\" ng-if=\"vm.submit\"></i> <span ng-if=\"vm.submit\">Subiendo</span>\r\n            </button>\r\n          </div>\r\n      </div>\r\n      <hr>\r\n      <div class=\"row\" class=\"smoothy\" style=\"max-height: 600px; overflow: hidden; width: auto; height: 100%;\" slimscroll=\"{\r\n          height: \'100%\',\r\n          size: \'6px\',\r\n          borderRadius: \'0px\',\r\n          opacity: .2\r\n          }\">\r\n          <scrollable>\r\n              <div class=\"col-sm-12 col-md-6 col-lg-6\" ng-repeat=\"row in vm.data\" ng-if=\"!vm.spinerLoading\">\r\n                  <div class=\"tile tile-simple\">\r\n                      <!-- <div class=\"tile-header p-0 text-center\"  style=\"height: 100px;\">\r\n                      </div> -->\r\n                      <div class=\"tile-body text-center\" style=\"height: 100px;\">\r\n                          <a href=\"{{vm.src}}{{row.nombre}}\" target=\"_blank\">\r\n                            <img class=\"img-responsive\" ng-src=\"{{vm.src}}{{row.nombre}}\" style=\"max-height: 100px; margin-left: auto; margin-right: auto;\"\r\n                              ng-if=\"[\'jpg\',\'jpeg\',\'png\',\'gif\',\'bmp\'].indexOf(row.tipo) !== -1\">\r\n                            <i class=\"fa fa-file-text-o fa-5x\" ng-if=\"[\'jpg\',\'jpeg\',\'png\',\'gif\',\'bmp\'].indexOf(row.tipo) === -1\"></i>\r\n                          </a>\r\n                      </div>\r\n                      <div class=\"tile-footer p-10 bg-primary\">\r\n                          <div class=\"pull-left\">\r\n                              {{row.archivo}}\r\n                          </div>\r\n                          <div class=\"pull-right\">\r\n                              <button class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"vm.deleteImg(row.idcitamedicaarchivo)\" uib-tooltip=\"Eliminar\"><i class=\"fa fa-trash-o\"></i></a></button>\r\n                              <a href=\"{{vm.src}}{{row.nombre}}\" target=\"_blank\" class=\"btn btn-info btn-sm\" ng-if=\"row.nombre\"><i class=\"fa fa-eye\"></i> Ver</a>\r\n                          </div>\r\n                          <div class=\"clearfix\"> </div>\r\n\r\n                      </div>\r\n                  </div>\r\n              </div>\r\n\r\n              <div ng-if=\"vm.data.length === 0 && !vm.spinerLoading\" class=\"text-center p-20\">\r\n                  No hay archivos.\r\n              </div>\r\n\r\n              <div class=\"spinerLoading\" ng-if=\"vm.spinerLoading\">\r\n                  <i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i>\r\n              </div>\r\n          </scrollable>\r\n      </div>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <!-- <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"close()\">Cerrar ventana</button> -->\r\n    <!-- <button class=\"btn btn-danger btn-rounded-20 btn-sm\" ng-disabled=\"miForm.$submitted\"><span>SI, ANULAR</span></button> -->\r\n    <button class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"close()\">CERRAR VENTANA</button>\r\n  </div></script><div class=\"page page-ui pull-to-header\" ng-show=\"$state.includes(\'{{vm.stateparent}}.list\')\"><div class=row><div class=col-md-12><ol class=breadcrumb><li><a ui-sref=mireserva>Inicio</a></li><li class=active>Citas médicas</li></ol><div class=pull-left><h4 class=\"pl-15 text-primary\">Citas médicas</h4></div><div class=pull-right><a ui-sref=mireservamedica class=\"btn btn-rounded-20 btn-greensea mb-10\">RESERVAR CITA</a></div><div class=clearfix></div><div class=tile><div class=row><div class=\"col-sm-6 col-xs-2 text-right p-10\"><label class=\"control-label minotaur-label pt-10\">año</label></div><div class=\"col-sm-6 col-xs-10 p-10\"><select ng-model=vm.ano ng-options=\"item as item for item in vm.anos\" class=\"form-control w-100\" ng-change=vm.loadCitamedicas()></select></div></div><div class=spinerLoading ng-if=vm.spinerLoading><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><div class=spinerLoading ng-if=\"vm.citas.length === 0 && !vm.spinerLoading\"><span>No hay registros</span></div><div class=list-group><div class=list-group-item ng-repeat=\"row in vm.citas\" ng-if=!vm.spinerLoading style=\"border: 0px; border-radius: 0!important; border-top: 1px solid #ddd\"><div class=row><div class=\"col-sm-4 col-xs-4\"><div class=\"text-center bg-primary p-10\"><span>{{row.inicioms | date: \'EEEE\'}}</span><h1 class=m-0>{{row.inicioms | date: \'d\'}}</h1><small class=mt-10>{{row.inicioms | date: \"MMMM\"}}</small></div></div><div class=\"col-sm-4 col-xs-8\" style=\"padding-left: 0px\"><div class=pull-left><span class=text-left><i class=\"fa fa-calendar\"></i> {{row.fecha}}</span></div><div class=pull-right><span style=\"text-align: right\"><i class=\"fa fa-clock-o\"></i> {{row.fechams | date: \'h:mm a\'}}</span></div><div class=clearfix></div><span><i class=\"fa fa-user-md\"></i> {{row.medico}}</span><br><span><i class=\"fa fa-map-marker\"></i> {{row.sedenombre}} <a href=javascript:; ng-click=vm.openMapaSedeModal(row.idsede) class=\"text-primary ml-5\"><small>Dirección</small></a></span><div class=row><div class=\"col-sm-6 col-xs-12\"><span><i class=\"fa fa-circle\"></i> <span ng-class=\"{\'text-greensea\': row.idestado === 6}\">{{row.estadocita}}</span> <i class=\"fa fa fa-check text-greensea\" ng-if=\"row.idestado === 6\"></i></span></div><div class=\"col-sm-6 col-xs-12\" ng-if=\"row.idestado === 6\"><button type=button class=\"btn btn-primary btn-border btn-xs full-width mt-xs-5\" ng-click=vm.openArchivosAdjuntos(row) ng-click=vm.openAnularCitaModal(row)><i class=\"fa fa-files-o\" aria-hidden=true></i> Adjuntar</button></div></div><div class=row ng-if=\"row.idestado !== 6\"><div class=\"col-sm-4 col-xs-6\" ng-if=!row.fechavencida><button type=button class=\"btn btn-primary btn-border btn-xs full-width\" ng-click=vm.openReprogramarCitaModal(row)>Reprogramar</button></div><div class=\"col-sm-4 col-xs-6\" ng-if=\"row.idestadopago === 72 && !row.fechavencida\"><button type=button class=\"btn btn-danger btn-border btn-xs full-width\" ng-click=vm.openAnularCitaModal(row)>Anular</button></div><div class=\"col-sm-4 col-xs-12\" ng-if=!row.fechavencida><button type=button class=\"btn btn-primary btn-border btn-xs full-width mt-xs-5\" ng-click=vm.openArchivosAdjuntos(row) ng-click=vm.openAnularCitaModal(row)><i class=\"fa fa-files-o\" aria-hidden=true></i> Adjuntar</button></div><div class=\"col-sm-12 col-xs-12\" ng-if=\"row.idsede === 15 && row.fecha === vm.zoomhoy && row.tokboxSession && row.idpaciente === 52617\"><button type=button class=\"btn btn-sm btn-green full-width mt-5\" ng-click=\"vm.abrirVideoLlamada(row.tokboxSession, row.tokboxToken, row.medico)\"><i class=\"fa fa-video-camera\"></i> Iniciar cita</button></div></div></div></div><!-- <div class=\"row\"\r\n              ng-if=\"row.idestado !== 6 && row.idsede === 15 && row.fecha === vm.zoomhoy && row.tokboxSession && row.idpaciente === 52617\">\r\n              <div class=\"col-sm-8 col-xs-12\">\r\n                <button type=\"button\" class=\"btn btn-sm btn-green full-width mt-5\"\r\n                  ng-click=\"vm.abrirVideoLlamada(row.tokboxSession, row.tokboxToken, row.medico)\"><i\r\n                    class=\"fa fa-video-camera\"></i>\r\n                  Iniciar cita</button>\r\n              </div>\r\n            </div> --><div class=row ng-if=\"row.idestado !== 6 && row.idsede === 15 && row.fecha === vm.zoomhoy && row.idpaciente !== 52617\"><div class=\"col-sm-8 col-xs-12\"><fieldset style=\"border: #1908ff 1px solid !important; padding: 8px; border-radius: 10px\" class=mt-5><div class=row><label class=\"col-sm-12 col-xs-12\">Telemedicina. <strong>Hoy {{row.fechams | date: \'h:mm a\'}}</strong></label></div><div class=row><div class=\"col-sm-12 col-xs-12\"><a style=\"color: #1908ff\" href={{row.urlzoom}} target=_blank>{{row.urlzoom}}</a></div></div><div class=\"row mt-5\"><div class=\"col-sm-4 col-xs-12\"><div class=row><label class=\"col-sm-3 col-xs-3\">ID</label><div class=\"col-sm-9 col-xs-9\"><span style=\"color: #1908ff\">{{row.idzoom}}</span> <button type=button class=\"btn btn-default btn-xs\" ngclipboard data-clipboard-text={{row.idzoom}} uib-tooltip=Copiar><i class=\"fa fa-files-o\" aria-hidden=true></i></button></div></div></div><div class=\"col-sm-4 col-xs-12\"><div class=row><label class=\"col-sm-3 col-xs-3\">CLAVE</label><div class=\"col-sm-9 col-xs-9\"><span style=\"color: #1908ff\">{{row.clavezoom}}</span> <button type=button class=\"btn btn-default btn-xs\" ngclipboard data-clipboard-text={{row.clavezoom}} uib-tooltip=Copiar><i class=\"fa fa-files-o\" aria-hidden=true></i></button></div></div></div></div></fieldset></div></div></div></div></div></div></div></div><div ui-view></div><!-- modal pop up minmaxcon --><div class=minmaxCon></div><!-- modal pop up tokbox --><div class=\"modal fade mymodal\" id=myModalTokBoxPopUp role=dialog><div class=modal-dialog><div class=modal-content><div class=\"modal-header bg-green b-0\"><div class=pull-left><h5 class=\"modal-title pt-10 pl-5\" style=\"font-weight: normal !important\">{{vm.doctor}}</h5></div><div class=pull-right><a href=javascript:; class=icon onclick=minimizarLlamada() style=\"display: none\" id=btnMaximize tooltip-placement=left uib-tooltip=Maximizar><i class=\"fa fa-window-maximize\"></i> </a><a href=javascript:; class=\"icon ocultar\" onclick=minimizarLlamada() id=btnMinimize tooltip-placement=left uib-tooltip=Minimizar><i class=\"fa fa-minus\"></i> </a><a href=javascript:; class=icon onclick=closeLlamada() tooltip-placement=left uib-tooltip=Cerrar>Cerrar <i class=\"fa fa-times\"></i></a></div><div class=clearfix></div></div><div class=\"modal-body p-0\"><div class=row style=\"height: 100%\"><div class=col-lg-12 class=publisher style=\"height: 100%\"><div id=connectionCountTokBox class=\"bg-primary lt text-center p-10\"></div><div id=errorTokBox class=\"bg-danger lt text-center p-10\"></div><div class=app-full id=videos><div class=call><div id=subscriber></div><div class=small-tiles><div id=publisher></div></div></div></div></div></div></div></div><!-- modal-content --></div><!-- modal-dialog --></div>");
$templateCache.put("app/views/administracion/miscitasterapeutas.html","<style>.table > thead > tr > th, .table > thead > tr > td, .table > tbody > tr > th, .table > tbody > tr > td, .table > tfoot > tr > th, .table > tfoot > tr > td {\r\n    padding: 18px;\r\n    line-height: 0.42858;\r\n    }\r\n    p {\r\n        padding: 2px 0px;\r\n    }\r\n\r\n    .viewport-sm .mt-xs {\r\n        margin: 25px 0px 15px 0px;\r\n    }\r\n\r\n    .spinerLoading {\r\n        text-align: center;\r\n        padding: 40px;\r\n    }\r\n\r\n    .b-1 {\r\n        /* border: 1px solid red; */\r\n    }\r\n\r\n    .table-calificacion td {\r\n        padding: 0px 8px;\r\n        text-align: center;\r\n        /* border: 1px solid red; */\r\n    }\r\n\r\n    .table-calificacioncuadrado td, th{\r\n        border: 1px solid black;  \r\n    }\r\n\r\n    .table-calificacioncuadrado {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    }\r\n\r\n    .smile {\r\n        width: 32px;\r\n        height: 32px;\r\n    }\r\n\r\n    .smile-gris {\r\n        width: 32px;\r\n        height: 32px;\r\n    }\r\n\r\n    .smile-peor {\r\n        background: url(../assets/images/smile-peor.png) no-repeat;\r\n        background-size: 32px 32px;\r\n        /* padding: 4px; */\r\n    }\r\n\r\n    .smile-peor-gris {\r\n        background: url(../assets/images/smile-peor-gris.png) no-repeat;\r\n        background-size: 32px 32px;\r\n    }\r\n    .cuadrado-ocupado{\r\n        background-color: #337ab7;\r\n        color: white; \r\n    }\r\n    .cuadrado-libre{\r\n        background-color: #ffffff;\r\n    color: #6f7c83;\r\n    }\r\n\r\n    .smile-igual {\r\n        background: url(../assets/images/smile-igual.png) no-repeat;\r\n        background-size: 32px 32px;\r\n    }\r\n\r\n    .smile-igual-gris {\r\n        background: url(../assets/images/smile-igual-gris.png) no-repeat;\r\n        background-size: 32px 32px;\r\n    }\r\n\r\n    .smile-mejor {\r\n        background: url(../assets/images/smile-mejor.png) no-repeat;\r\n        background-size: 32px 32px;\r\n\r\n    }\r\n\r\n    .smile-mejor-gris {\r\n        background: url(../assets/images/smile-mejor-gris.png) no-repeat;\r\n        background-size: 32px 32px;\r\n    }</style><script type=text/ng-template id=myModalIframeReservacionesPorAsistirImprimirContent.html><div class=\"modal-body p-0\">\r\n        <object name=\"DocumentoReserva\" type=\"application/pdf\" data=\"{{vm.url}}\" width=\"100%\" height=\"500\"> \r\n            <div class=\"text-center p-10\">\r\n                 <a href=\"{{vm.url}}\" class=\"btn btn-greensea btn-rounded-20 btn-lg\" target=\"_blank\"> \r\n                    <i class=\"fa fa-download\"></i> Descargar</a>  \r\n            </div> \r\n        </object>\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n        <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"cancel()\">Cerrar</button>\r\n    </div></script><script type=text/ng-template id=myModalReprogramarCitaTerapeutaContent.html><form name=\"miForm\" ng-submit=\"vm.save();\" novalidate>\r\n        <div class=\"modal-header bg-primary\">\r\n            <h4 class=\"modal-title\">Reprogramar cita de terapia</h4>\r\n        </div>\r\n        <div class=\"modal-body\">  \r\n            <div class=\"alert alert-big alert-red alert-dismissable fade in\" ng-if=\"vm.mensajError\">\r\n                <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-hidden=\"true\">×</button> \r\n                    {{vm.mensajError}}\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-5 col-xs-12\">\r\n                    <h6 class=\"text-primary\"><strong>PASO 1</strong></h5>\r\n                    <h5 class=\"text-greensea pt-0\"> Seleccionar fecha</h5>\r\n                    <div uib-datepicker ng-model=\"vm.dt\" datepicker-options=\"vm.dateOptions\" ng-change=\"vm.consultarMedicos()\" show-weeks=\"false\"></div>\r\n                </div>\r\n                <div class=\"col-sm-7 col-xs-12\" ng-if=\"vm.dt\">                    \r\n                    <h6 class=\"text-primary mt-xs\"><strong>PASO 2</strong></h5>\r\n                    <h5 ng-model=\"vm.intentosProgramada\" style=\"font-size: 15px;\">{{ vm.intentosProgramada}}</h5>\r\n                    <h5 class=\"text-greensea pt-0\"> Seleccionar hora</h5>\r\n                    \r\n                    <div class=\"spinerLoading\" ng-if=\"vm.spinerLoadingHoras\">\r\n                        <i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i>\r\n                    </div>\r\n                        \r\n                    <div ng-repeat=\"row in vm.medicos\" class=\"mt-20 mb-20\" ng-if=\"!vm.spinerLoadingHoras\">\r\n                        <h5><i class=\"fa fa-user-circle-o\"></i> <strong>{{row.nombre}}</strong></h5>\r\n                        <label class=\"btn btn-xs btn-primary\" ng-model=\"vm.radioModel\" uib-btn-radio=\"hora\" ng-repeat=\"hora in row.horas\">{{hora.inicioms | date:\'hh:mm a\'}}</label>\r\n                    </div>\r\n\r\n                    <p ng-if=\"!vm.spinerLoadingHoras && vm.medicos.length === 0\">No hay horarios\r\n                        disponibles.\r\n                    </p>\r\n\r\n                </div>\r\n            </div>\r\n            <hr style=\"margin: 20px 0px\"> \r\n\r\n            <h5 class=\"text-greensea\" ng-if=\"vm.radioModel.nombre\">Nueva reprogramación</h5>\r\n\r\n            <div class=\"row\" ng-if=\"vm.radioModel.nombre\">\r\n                <label class=\"col-sm-1 col-xs-3\"><strong>Fecha:</strong></label>\r\n                <div class=\"col-sm-4 col-xs-9\">\r\n                    {{vm.dt | date:\'dd/MM/yyyy\' }} <i class=\"fa fa-clock-o ml-20\" ng-show=\"vm.radioModel.inicioms\"></i> <label ng-show=\"vm.radioModel.inicioms\">{{vm.radioModel.inicioms | date:\'hh:mm a\'}}</label>\r\n                </div>\r\n                <label class=\"col-sm-1 col-xs-3\" ><strong>Terapeuta:</strong></label>\r\n                <div class=\"col-sm-6 col-xs-9\">\r\n                    &nbsp;&nbsp;{{vm.radioModel.nombre}}\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n            <button class=\"btn btn-primary btn-rounded-20 btn-sm\" ng-disabled=\"miForm.$submitted\">SI, ACEPTAR</button>\r\n            <button class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n        </div>\r\n    </form></script><script type=text/ng-template id=myModalMapaSedeContent.html><form name=\"miForm\" ng-submit=\"vm.save();\" novalidate>\r\n        <div class=\"modal-header bg-primary\">\r\n            <h4 class=\"modal-title\">{{vm.sede.nombre}}</h4>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n            <p><i class=\"fa fa-map-marker\"></i> Dirección</p>  \r\n            <p>{{vm.sede.direccion}}</p> \r\n            <div class=\"mt-20\"><em>Más información llamando al <a href=\"tel:017390888\" class=\"llamarfono\">01 739 0888</a></em></div> \r\n        </div>\r\n        <div class=\"modal-footer\">\r\n            <button class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n        </div>\r\n    </form></script><script type=text/ng-template id=myModalAnularCitaContent.html><form name=\"miForm\" ng-submit=\"vm.save();\" novalidate>\r\n        <div class=\"modal-header bg-primary\">\r\n            <h4 class=\"modal-title\">Anular</h4>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n            <div class=\"row\">\r\n                <div class=\"col-xs-12 col-md-12 text-center\">\r\n                    ¿Seguro que desea anular su cita de terapia para el {{vm.citaterapeutica.fechams | date: \'d\' }} de {{vm.citaterapeutica.fechams | date: \'LLLL yyyy\' }}?\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n            <button class=\"btn btn-danger btn-rounded-20 btn-sm\" ng-disabled=\"miForm.$submitted\"><span>SI, ANULAR</span></button>\r\n      <button class=\"btn btn-danger btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n        </div>\r\n    </form></script><script type=text/ng-template id=myModalCalificacionContent.html><form name=\"miForm\" ng-submit=\"vm.save();\" novalidate>\r\n        <div class=\"modal-header bg-primary\">\r\n            <h4 class=\"modal-title\">Calificación</h4>\r\n        </div>\r\n        <div class=\"modal-body\" style=\"margin-left: 18px;\">\r\n            <p>Con tu opinión, mejoramos tu tratamiento</p>  \r\n            <p>1. ¿La terapeuta le atendió amablemente?</p>  \r\n            <div class=\"pull-left b-1\">\r\n                <table class=\"table table-bordered\" >\r\n                    <tr>\r\n                        <td ng-click=\"vm.p1_califica = 1;\" class=\"cuadrado-libre\"  ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 1, \'cuadrado-libre\': vm.p1_califica !== 1}\" >1</td>\r\n                        <td ng-click=\"vm.p1_califica = 2;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 2, \'cuadrado-libre\': vm.p1_califica !== 2}\" >2</td>\r\n                        <td ng-click=\"vm.p1_califica = 3;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 3, \'cuadrado-libre\': vm.p1_califica !== 3}\" >3</td>\r\n                        <td ng-click=\"vm.p1_califica = 4;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 4, \'cuadrado-libre\': vm.p1_califica !== 4}\" >4</td>\r\n                        <td ng-click=\"vm.p1_califica = 5;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 5, \'cuadrado-libre\': vm.p1_califica !== 5}\" >5</td>\r\n                        <td ng-click=\"vm.p1_califica = 6;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 6, \'cuadrado-libre\': vm.p1_califica !== 6}\" >6</td>\r\n                        <td ng-click=\"vm.p1_califica = 7;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 7, \'cuadrado-libre\': vm.p1_califica !== 7}\" >7</td>\r\n                        <td ng-click=\"vm.p1_califica = 8;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 8, \'cuadrado-libre\': vm.p1_califica !== 8}\" >8</td>\r\n                        <td ng-click=\"vm.p1_califica = 9;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 9, \'cuadrado-libre\': vm.p1_califica !== 9}\" >9</td>\r\n                        <td ng-click=\"vm.p1_califica = 10;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 10, \'cuadrado-libre\': vm.p1_califica !== 10}\" >10</td>\r\n                    </tr> \r\n                </table> \r\n                <div class=\"row\">\r\n                    <div class=\"col-md-2\" style=\"margin-top: -10px;\">\r\n                        <span>Nada amable</span>\r\n                    </div>\r\n                    <div class=\"col-md-8\"></div>\r\n                    <div class=\"col-md-2\" style=\"margin-top: -10px;\">\r\n                        <span>Super amable</span>\r\n                    </div>\r\n                </div> \r\n            </div>\r\n            <!-- <div class=\"pull-right b-1\">\r\n                <span style=\"color: #000;\" ng-if=\"vm.p1_califica\">{{vm.p1_califica}}</span>\r\n            </div> -->\r\n            <div class=\"clearfix\"></div> \r\n            \r\n            <p class=\"mt-20\">2. Antes de su sesión, ¿Cuanto dolor sentía?</p>  \r\n            <div class=\"pull-left b-1\">\r\n                <table class=\"table table-bordered\" >\r\n                    <tr>\r\n                        <td ng-click=\"vm.p2_antes = 1;\" class=\"cuadrado-libre\"  ng-class=\"{\'cuadrado-ocupado\': vm.p2_antes === 1, \'cuadrado-libre\': vm.p2_antes !== 1}\" >1</td>\r\n                        <td ng-click=\"vm.p2_antes = 2;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p2_antes === 2, \'cuadrado-libre\': vm.p2_antes !== 2}\" >2</td>\r\n                        <td ng-click=\"vm.p2_antes = 3;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p2_antes === 3, \'cuadrado-libre\': vm.p2_antes !== 3}\" >3</td>\r\n                        <td ng-click=\"vm.p2_antes = 4;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p2_antes === 4, \'cuadrado-libre\': vm.p2_antes !== 4}\" >4</td>\r\n                        <td ng-click=\"vm.p2_antes = 5;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p2_antes === 5, \'cuadrado-libre\': vm.p2_antes !== 5}\" >5</td>\r\n                        <td ng-click=\"vm.p2_antes = 6;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p2_antes === 6, \'cuadrado-libre\': vm.p2_antes !== 6}\" >6</td>\r\n                        <td ng-click=\"vm.p2_antes = 7;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p2_antes === 7, \'cuadrado-libre\': vm.p2_antes !== 7}\" >7</td>\r\n                        <td ng-click=\"vm.p2_antes = 8;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p2_antes === 8, \'cuadrado-libre\': vm.p2_antes !== 8}\" >8</td>\r\n                        <td ng-click=\"vm.p2_antes = 9;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p2_antes === 9, \'cuadrado-libre\': vm.p2_antes !== 9}\" >9</td>\r\n                        <td ng-click=\"vm.p2_antes = 10;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p2_antes === 10, \'cuadrado-libre\': vm.p2_antes !== 10}\" >10</td>      \r\n                    </tr> \r\n                </table> \r\n                <div class=\"row\">\r\n                    <div class=\"col-md-2\" style=\"margin-top: -10px;\">\r\n                        <span>Muy leve</span>\r\n                    </div>\r\n                    <div class=\"col-md-8\"></div>\r\n                    <div class=\"col-md-2\" style=\"margin-top: -10px;\">\r\n                        <span>Insoportable</span>\r\n                    </div>\r\n                </div> \r\n            </div> \r\n            <div class=\"clearfix\"></div> \r\n\r\n            <p class=\"mt-20\">3. Al finalizar su sesión, ¿Cuánto dolor sentía?</p>  \r\n            <div class=\"pull-left b-1\">\r\n                <table class=\"table table-bordered\" >\r\n                    <tr>\r\n                        <td ng-click=\"vm.p3_desp = 1;\" class=\"cuadrado-libre\"  ng-class=\"{\'cuadrado-ocupado\': vm.p3_desp === 1, \'cuadrado-libre\': vm.p3_desp !== 1}\" >1</td>\r\n                        <td ng-click=\"vm.p3_desp = 2;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p3_desp === 2, \'cuadrado-libre\': vm.p3_desp !== 2}\" >2</td>\r\n                        <td ng-click=\"vm.p3_desp = 3;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p3_desp === 3, \'cuadrado-libre\': vm.p3_desp !== 3}\" >3</td>\r\n                        <td ng-click=\"vm.p3_desp = 4;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p3_desp === 4, \'cuadrado-libre\': vm.p3_desp !== 4}\" >4</td>\r\n                        <td ng-click=\"vm.p3_desp = 5;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p3_desp === 5, \'cuadrado-libre\': vm.p3_desp !== 5}\" >5</td>\r\n                        <td ng-click=\"vm.p3_desp = 6;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p3_desp === 6, \'cuadrado-libre\': vm.p3_desp !== 6}\" >6</td>\r\n                        <td ng-click=\"vm.p3_desp = 7;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p3_desp === 7, \'cuadrado-libre\': vm.p3_desp !== 7}\" >7</td>\r\n                        <td ng-click=\"vm.p3_desp = 8;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p3_desp === 8, \'cuadrado-libre\': vm.p3_desp !== 8}\" >8</td>\r\n                        <td ng-click=\"vm.p3_desp = 9;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p3_desp === 9, \'cuadrado-libre\': vm.p3_desp !== 9}\" >9</td>\r\n                        <td ng-click=\"vm.p3_desp = 10;\" class=\"cuadrado-libre\" ng-class=\"{\'cuadrado-ocupado\': vm.p3_desp === 10, \'cuadrado-libre\': vm.p3_desp !== 10}\" >10</td>      \r\n                    </tr>  \r\n                </table> \r\n                <div class=\"row\">\r\n                    <div class=\"col-md-3\" style=\"margin-top: -10px;\">\r\n                        <span>Muy leve</span>\r\n                    </div>\r\n                    <div class=\"col-md-7\"></div>\r\n                    <div class=\"col-md-2\" style=\"margin-top: -10px;\">\r\n                        <span>Insoportable</span>\r\n                    </div>\r\n                </div> \r\n            </div> \r\n            <div class=\"clearfix\"></div>  \r\n\r\n            <p class=\"mt-20\">4. Apreciamos nos escriba si tiene comentarios</p>  \r\n            <textarea class=\"form-control\" ng-model=\"vm.p4_comen\"></textarea\r\n\r\n            <div class=\"clearfix\"></div>  \r\n\r\n\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n                <button class=\"btn btn-primary btn-rounded-20 btn-sm\" ng-disabled=\"miForm.$submitted\">ENVIAR CALIFICACION</button>\r\n            <button class=\"btn btn-primary btn-border btn-rounded-20 btn-sm\" type=\"button\" ng-click=\"cancel()\">CERRAR VENTANA</button>\r\n        </div>\r\n    </form></script><div class=\"page page-ui pull-to-header\"><div class=row><div class=col-md-12><ul class=breadcrumb><li><a ui-sref=mireserva>Inicio</a></li><li class=active>Citas de terapia</li></ul><div class=pull-left><h4 class=\"pl-15 text-primary\">Citas de terapia</h4></div><div class=pull-left style=\"margin-left: 50px;font-weight: bold\"><span class=ng-binding>Nota :Usted puede Reprogramar sus terapias solos 2 veces</span></div><div class=pull-right><a ui-sref=mireservaterapeuta class=\"btn btn-rounded-20 btn-greensea mb-10\"><!-- <i class=\"fa fa fa-plus\"></i>  --> RESERVAR CITA</a></div><div class=pull-right><a href=javascript:; class=\"btn btn-rounded-20 btn-default mb-10 mr-5\" ng-click=vm.openModalIframeImprimir()><i class=\"fa fa-print\"></i> Terapias</a></div><div class=clearfix></div><div class=tile><div class=row><div class=\"col-sm-6 col-xs-2 text-right p-10\"><label class=\"control-label minotaur-label pt-10\">año</label></div><div class=\"col-sm-6 col-xs-10 p-10\"><select ng-model=vm.ano ng-options=\"item as item for item in vm.anos\" class=\"form-control w-100\" ng-change=vm.loadCitamedicas()></select></div></div><div class=spinerLoading ng-if=vm.spinerLoading><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><div class=spinerLoading ng-if=\"vm.citas.length === 0 && !vm.spinerLoading\"><span>No hay registros</span></div><div class=list-group><div class=list-group-item ng-repeat=\"row in vm.citas\" ng-if=!vm.spinerLoading style=\"border: 0px; border-radius: 0!important; border-top: 1px solid #ddd\"><div class=row><div class=\"col-sm-4 col-xs-4\"><div class=\"text-center bg-primary p-10\"><span>{{row.inicioms | date: \'EEEE\'}}</span><h1 class=m-0>{{row.inicioms | date: \'d\'}}</h1><small class=mt-10>{{row.inicioms | date: \"MMMM\"}}</small></div></div><div class=\"col-sm-4 col-xs-8\" style=\"padding-left: 0px\"><div class=pull-left><span class=text-left><i class=\"fa fa-calendar\"></i> {{row.fecha}}</span></div><div class=pull-right><span style=\"text-align: right\"><i class=\"fa fa-clock-o\"></i> {{row.fechams | date: \'h:mm a\'}}</span></div><div class=clearfix></div><span><i class=\"fa fa-user-circle-o\"></i> {{row.terapista}}</span><br><span><i class=\"fa fa-map-marker\"></i> {{row.sedenombre}} <a href=javascript:; ng-click=vm.openMapaSedeModal(row.idsede) class=\"text-primary ml-5\"><small>Dirección</small></a></span><div class=row><div class=\"col-sm-12 col-xs-12\"><p><i class=\"fa fa-circle\"></i> <span ng-class=\"{\'text-greensea\': row.idestado === 34}\">{{row.estadocita}} <i class=\"fa fa fa-check text-greensea\" ng-if=\"row.idestado === 34\"></i></span></p></div></div><div class=row ng-if=\"row.idestado !== 34\"><div class=\"col-sm-6 col-xs-6\"><button type=button class=\"btn btn-primary btn-border btn-xs full-width\" ng-click=vm.openReprogramarCitaModal(row) ng-if=!row.fechavencida>Reprogramar</button></div><div class=\"col-sm-6 col-xs-6\"><button type=button class=\"btn btn-danger btn-border btn-xs full-width\" ng-click=vm.openAnularCitaModal(row) ng-if=!row.fechavencida>Anular</button></div></div><div class=row ng-if=\"row.idestado === 34 && !row.p1_califica\"><div class=\"col-sm-12 col-xs-12\"><button class=\"btn btn-primary btn-border btn-xs full-width\" ng-click=vm.openCalificacionModal(row.idcitaterapeutica)><i class=\"fa fa-star-o\"></i> Calificar atención</button></div></div><div class=row ng-if=\"row.idestado === 34 && row.p1_califica\"><div class=\"col-sm-12 col-xs-12\"><div><small>Calificación</small> <i class=\"fa fa-check-circle\"></i></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/views/administracion/misdatos.html","<style>.spinerLoading {\r\n    text-align: center;\r\n    padding: 40px;\r\n  }</style><script type=text/ng-template id=myModalChangePasswordContent.html><form name=\"miForm\" ng-submit=\"vm.save();\" novalidate>\r\n    <div class=\"modal-header bg-primary\">\r\n      <h3 class=\"modal-title\">Cambiar contraseña</h3>\r\n    </div>\r\n    <div class=\"modal-body\"> \r\n      <div class=\"row\">\r\n        <div class=\"form-group col-xs-12 col-md-12\">\r\n          <label>Contraseña actual: <span class=\"asterisk\">*</span></label>\r\n          <input type=\"password\" name=\"contrasenaactual\" class=\"form-control input-sm\" maxlength=\"20\" ng-model=\"vm.entidad.contrasenaactual\"\r\n            required>\r\n          <div ng-messages=\"miForm.contrasenaactual.$error\" class=\"required\" role=\"alert\" ng-show=\"miForm.contrasenaactual.$dirty\">\r\n            <div ng-message=\"required\">El campo es requerido</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"form-group col-xs-12 col-md-12\">\r\n          <label>Contraseña nueva: <span class=\"asterisk\">*</span></label>\r\n          <input type=\"password\" name=\"contrasenanueva\" class=\"form-control input-sm\" ng-minlength=\"6\" maxlength=\"20\" ng-model=\"vm.entidad.contrasenanueva\"\r\n            ng-change=\"confirm=false\" required>\r\n          <div ng-messages=\"miForm.contrasenanueva.$error\" class=\"required\" role=\"alert\" ng-show=\"miForm.contrasenanueva.$dirty\">\r\n            <div ng-message=\"required\">El campo es requerido</div>\r\n            <div ng-message=\"minlength\">M&iacute;nimo 6 caracteres</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"form-group col-xs-12 col-md-12\">\r\n          <label>Confirmar contraseña: <span class=\"asterisk\">*</span></label>\r\n          <input type=\"password\" name=\"contrasenaconfirm\" class=\"form-control input-sm\" ng-minlength=\"6\" maxlength=\"20\" ng-model=\"vm.entidad.contrasenaconfirm\"\r\n            ng-change=\"confirm=false\" required>\r\n          <div ng-messages=\"miForm.contrasenaconfirm.$error\" class=\"required\" role=\"alert\" ng-show=\"miForm.contrasenaconfirm.$dirty\">\r\n            <div ng-message=\"required\">El campo es requerido</div>\r\n            <div ng-message=\"minlength\">M&iacute;nimo 6 caracteres</div>\r\n          </div>\r\n          <div class=\"required\" ng-show=\"confirm\">\r\n            <span>Contraseña nueva y confirmaci&oacute;n, no coinciden.</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"modal-footer\"> \r\n       <button type=\"submit\" class=\"btn btn-primary btn-sm\" ng-disabled=\"miForm.$invalid || miForm.$submitted\">Guardar</button>       \r\n      <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"cancel()\">Cerrar</button>\r\n    </div>\r\n  </form></script><div class=\"page page-ui pull-to-header\"><div class=row><div class=col-md-12><ol class=breadcrumb><li><a ui-sref=mireserva>Inicio</a></li><li class=active>Mis datos</li></ol><h4 class=\"text-center text-primary\">Mis datos personales</h4><div class=tile><div class=spinerLoading ng-if=vm.spinerLoading><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><section class=tile-body><form name=miForm ng-submit=vm.save(); novalidate><div ng-if=!vm.spinerLoading><div class=row><div class=\"form-group col-sm-6\"><label><strong>{{vm.entidad.documentoabrev}}</strong></label><div>{{vm.entidad.numerodoc}}</div></div><div class=\"form-group col-sm-6\"><label><strong>Nombres</strong></label><div>{{vm.entidad.nombre}}</div></div></div><div class=row><div class=\"form-group col-sm-6\"><label><strong>Apelido paterno</strong></label><div>{{vm.entidad.apellidopat}}</div></div><div class=\"form-group col-sm-6\"><label><strong>Apellido materno</strong></label><div>{{vm.entidad.apellidomat}}</div></div></div><div class=row><div class=\"form-group col-sm-6\"><label>Fecha nacimiento</label><input data-input-mask type=text name=fechanacimiento ng-model=vm.entidad.fechanacimiento maxlength=10 class=\"form-control input-sm mb-5\" data-inputmask=\"\'alias\': \'dd/mm/yyyy\'\" ng-pattern=/^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$/ ></div><div class=\"form-group col-sm-6\"><label>Sexo</label><div><label class=\"checkbox-inline minotaur-radio\">Masculino <input type=radio name=sexo id=radio-type-masculino ng-model=vm.entidad.sexo value=M required><div class=input-indicator></div></label><label class=\"checkbox-inline minotaur-radio\">Femenino <input type=radio name=sexo id=radio-type-femenino ng-model=vm.entidad.sexo value=F required><div class=input-indicator></div></label></div></div></div><div class=row><div class=\"form-group col-sm-6\"><label for=address2>Teléfono</label><input type=text name=telefono ng-model=vm.entidad.telefono class=\"form-control input-sm mb-5\" ng-minlength=7 maxlength=9><div ng-messages=miForm.telefono.$error role=alert ng-show=miForm.telefono.$dirty><div ng-message=minlength>Debe ser 7 d&iacute;gitos</div><div ng-message=maxlength>Debe ser 9 d&iacute;gitos</div></div></div><div class=\"form-group col-sm-6\"><label for=address1>Celular <small class=text-primary>(Obligatorio)</small></label><input type=text name=celular ng-model=vm.entidad.celular class=\"form-control input-sm mb-5\" ng-minlength=9 maxlength=9 required><div ng-messages=miForm.celular.$error class=required role=alert ng-show=miForm.celular.$dirty><div ng-message=minlength>Debe ser 9 d&iacute;gitos</div><div ng-message=required>El campo es requerido</div></div></div></div><div class=row><div class=\"form-group col-sm-6\"><label for=address2>Correo electrónico</label><input type=email name=correo ng-model=vm.entidad.email class=\"form-control input-sm mb-5\" maxlength=50><div ng-messages=miForm.correo.$error class=required role=alert><div ng-message=email>Correo formato inv&aacute;lido</div></div></div></div><div class=row><div class=\"form-group col-md-12 legend\"><h4 class=mt-20>Dirección</h4><p>Ingresa direccion donde reside actualmente</p></div></div><div class=row><div class=\"form-group col-sm-4\"><label for=city>Departamento</label><select name=departamento ng-model=vm.entidad.dpto ng-options=\"item.dpto as item.nombre for item in vm.others.departamentos\" class=\"form-control input-sm mb-5\" ng-change=\"vm.changeUbigeo({pais: vm.entidad.pais, dpto: vm.entidad.dpto || \'\'}, \'provincias\')\"><option value=\"\">-- Provincia --</option></select></div><div class=\"form-group col-sm-4\"><label for=state>Provincia</label><select name=provincia ng-model=vm.entidad.prov ng-options=\"item.prov as item.nombre for item in vm.others.provincias\" class=\"form-control input-sm mb-5\" ng-change=\"vm.changeUbigeo({pais: vm.entidad.pais, dpto: vm.entidad.dpto || \'\', prov: vm.entidad.prov || \'\'}, \'distritos\')\"><option value=\"\">-- Provincia --</option></select></div><div class=\"form-group col-sm-4\"><label for=zip>Distrito</label><select name=distrito ng-model=vm.entidad.dist ng-options=\"item.dist as item.nombre for item in vm.others.distritos\" class=\"form-control input-sm mb-5\"><option value=\"\">-- Distrito --</option></select></div></div><div class=row><div class=\"form-group col-sm-12\"><label for=city>Dirección</label><input type=text name=direccion ng-model=vm.entidad.direccion maxlength=100 class=\"form-control input-sm mb-5\"></div></div><div class=row><div class=\"form-group col-md-12 legend\"><h4 class=mt-20>Datos clínicos</h4><p>Ingrese datos de su condición física.</p></div></div><div class=row><div class=\"form-group col-sm-4\"><label for=city>Peso (Kg).</label><input type=number name=peso ng-model=vm.entidad.peso min=0 maxlength=5 class=\"form-control input-sm mb-5\"></div><div class=\"form-group col-sm-4\"><label for=state>Altura (Metro).</label><input type=number name=altura ng-model=vm.entidad.altura min=0 maxlength=5 class=\"form-control input-sm mb-5\"></div><div class=\"form-group col-sm-4\"><label for=zip>Tipo de sangre</label><select name=sangre ng-model=vm.entidad.sangre class=\"form-control input-sm mb-5\"><option value=\"\">-- Seleccione --</option><option value=A+>A+</option><option value=A->A-</option><option value=B+>B+</option><option value=B->B-</option><option value=AB+>AB+</option><option value=AB->AB-</option><option value=O+>O+</option><option value=O->O-</option></select></div></div><button type=submit ng-disabled=\"miForm.$invalid || miForm.$submitted\" class=\"btn btn-primary btn-rounded-40 full-width mt-20 btn-lg\">ACTUALIZAR DATOS</button></div></form></section></div><!-- <div class=\"tile\" ng-if=\"!vm.spinerLoading\">\r\n        <section class=\"tile-body\">  --> <button type=button class=\"btn btn-greensea btn-rounded-40 full-width mt-20 btn-lg\" ng-click=vm.openResetPasswordModal(entidad.identidad) ng-if=!vm.spinerLoading>CAMBIAR CONTRASEÑA</button><!-- </section>\r\n      </div> --></div></div></div>");
$templateCache.put("app/views/administracion/misordenes.html","<div class=\"page page-ui pull-to-header\"><div class=row><div class=col-md-12><ol class=breadcrumb><li><a ui-sref=mireserva>Inicio</a></li><li class=active>Mis Ordenes</li></ol><h4 class=\"text-center text-primary\">Mis Ordenes</h4><ol class=breadcrumb><section class=tile-body><table class=table><thead><tr><th>#</th><th>Pedido Referencia</th><th>Fecha Hora</th><th>Medio Pago</th><th>Total Pagado</th><th>Estado</th><th>Nro Transacción</th><th>Número Comprobante pago</th></tr></thead><tbody><tr ng-if=\"vm.misordenes.length == 0\"><td rowspan=8>No cuenta con ordenes en el sistema.</td></tr><tr data-ng-repeat=\"item in vm.misordenes\"><td>{{item.count}}</td><td>{{item.pedidoref}}</td><td>{{item.fecha}}</td><td>{{item.mediopagos}}</td><td>{{item.total_pagado}}</td><td>{{item.estado}}</td><td>{{item.nro_transaccion}}</td><td><a href={{item.urlPdf}} target=_blank class=\"btn btn-primary btn-border btn-xs full-width\" ng-if=item.urlPdf><i class=\"fa fa-cloud-download\"></i> {{item.serie}}-{{item.serienumero}}</a></td></tr></tbody></table></section></ol></div></div></div>");
$templateCache.put("app/views/administracion/mispagos.html","<style>p {\r\n        padding: 2px 0px;\r\n    }\r\n\r\n    .viewport-sm .mt-xs {\r\n        margin: 25px 0px 15px 0px;\r\n    }\r\n\r\n    .spinerLoading {\r\n        text-align: center;\r\n        padding: 40px;\r\n    }</style><div class=\"page page-ui pull-to-header\"><div class=row><div class=col-md-12><ol class=breadcrumb><li><a ui-sref=mireserva>Inicio</a></li><li class=active>Mis pagos</li></ol><h4 class=\"text-center text-primary\">Mis pagos</h4><div class=tile><div class=row><div class=\"col-sm-6 col-xs-2 text-right p-10\"><label class=\"control-label minotaur-label pt-10\">año</label></div><div class=\"col-sm-6 col-xs-10 p-10\"><select ng-model=vm.ano ng-options=\"item as item for item in vm.anos\" class=\"form-control w-100\" ng-change=vm.loadPagos()></select></div></div><div class=spinerLoading ng-if=vm.spinerLoading><i class=\"fa fa-spinner fa-spin fa-3x fa-fw\"></i></div><div class=spinerLoading ng-if=\"vm.data.length === 0 && !vm.spinerLoading\"><span>No hay registros</span></div><div class=list-group><div class=list-group-item ng-repeat=\"row in vm.data\" ng-if=!vm.spinerLoading><div class=row><div class=\"col-sm-10 col-xs-12\"><div class=row><div class=\"col-sm-6 col-xs-12\"><p><strong>{{row.nombredocventa}}</strong> <span>{{row.serie}}-{{row.serienumero}}</span></p></div><div class=\"col-sm-6 col-xs-12\"><p><strong>Fecha emisión</strong> <span>{{row.fechaventa}}</span></p></div><div class=\"col-sm-6 col-xs-12\"><p><strong>Cliente</strong> <span>{{row.nombrecliente}}</span></p></div><div class=\"col-sm-6 col-xs-12\"><p><strong>Total</strong> <span>S/ {{row.total | number:2}}</span></p></div><div class=\"col-sm-6 col-xs-12\"><p><strong>Estado</strong> <span ng-class=\"{\'text-greensea\': row.idestadodocumento === 27}\">{{row.estadodocumento}} <i class=\"fa fa fa-check text-greensea\" ng-if=\"row.idestadodocumento === 27\"></i></span></p></div></div><div ng-if=row.urlPdf><a href={{row.urlPdf}} target=_blank class=\"btn btn-primary btn-border btn-xs full-width\" ng-if=row.urlPdf><i class=\"fa fa-cloud-download\"></i> Descargar comprobante</a></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/views/partials/footer.html","2023 - <span data-copyright-year></span> &copy; Blankon Admin. Created by Julio Chauca, Lima <span class=pull-right>0.01 GB(0%) of 15 GB used</span>");
$templateCache.put("app/views/partials/header-content.html","<h2><i class={{$state.current.data.pageHeader.icon}}></i> {{$state.current.data.pageHeader.title}}<!--<span> {{$state.current.data.pageHeader.subtitle}}</span>--></h2>");
$templateCache.put("app/views/partials/modal-password.html","<script type=text/ng-template id=myModalPasswordContent.html><form name=\"miForm\" ng-submit=\"save();\" novalidate>\r\n            <div class=\"modal-header bg-primary\">\r\n                <h3 class=\"modal-title\">Cambiar contraseña</h3>\r\n            </div> \r\n            <div class=\"modal-body\"> \r\n                <div class=\"row\" >\r\n                    <div class=\"form-group col-xs-12 col-md-12\">\r\n                        <label>Contraseña actual: <span class=\"asterisk\">*</span></label>                        \r\n                        <input type=\"password\" name=\"contrasenaactual\"  class=\"form-control input-sm\" maxlength=\"20\" ng-model=\"entidad.contrasenaactual\" required> \r\n                        <div ng-messages=\"miForm.contrasenaactual.$error\" class=\"required\" role=\"alert\" ng-show=\"miForm.contrasenaactual.$dirty\">\r\n                            <div ng-message=\"required\">El campo es requerido</div>                            \r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\" >\r\n                    <div class=\"form-group col-xs-12 col-md-12\">\r\n                        <label>Contraseña nueva: <span class=\"asterisk\">*</span></label>                        \r\n                        <input type=\"password\" name=\"contrasenanueva\"  class=\"form-control input-sm\" ng-minlength=\"6\" maxlength=\"20\" ng-model=\"entidad.contrasenanueva\" ng-change=\"confirm=false\" required> \r\n                        <div ng-messages=\"miForm.contrasenanueva.$error\" class=\"required\" role=\"alert\" ng-show=\"miForm.contrasenanueva.$dirty\">\r\n                            <div ng-message=\"required\">El campo es requerido</div>\r\n                            <div ng-message=\"minlength\">M&iacute;nimo 6 caracteres</div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\" >\r\n                    <div class=\"form-group col-xs-12 col-md-12\">\r\n                        <label>Confirmar contraseña: <span class=\"asterisk\">*</span></label>                        \r\n                        <input type=\"password\" name=\"contrasenaconfirm\"  class=\"form-control input-sm\" ng-minlength=\"6\" maxlength=\"20\" ng-model=\"entidad.contrasenaconfirm\" ng-change=\"confirm=false\" required> \r\n                        <div ng-messages=\"miForm.contrasenaconfirm.$error\" class=\"required\" role=\"alert\" ng-show=\"miForm.contrasenaconfirm.$dirty\">\r\n                            <div ng-message=\"required\">El campo es requerido</div>\r\n                            <div ng-message=\"minlength\">M&iacute;nimo 6 caracteres</div>\r\n                        </div>\r\n                        <div class=\"required\" ng-show=\"confirm\">\r\n                            <span>Contraseña nueva y confirmaci&oacute;n, no coinciden.</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"modal-footer\">            \r\n                <button class=\"btn btn-primary btn-sm\" ng-disabled=\"miForm.$invalid || miForm.$submitted\">Guardar</button>\r\n                <button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"cancel()\">Cerrar</button>\r\n            </div>\r\n        </form></script>");
$templateCache.put("app/pages/pages-login/sign-in.html","<div class=\"page page-core page-login\"><div class=login-modal><div class=branding><img ng-src={{servidorUrl}}/img/osi/logologin.png width=270></div><h4 class=\"text-center mb-20 text-primary\">BIENVENIDO</h4><div class=\"mt-20 mb-10 text-center\">Reserva tus citas en línea</div><form name=miForm ng-submit=vm.login()><div class=\"form-group with-addon\"><select ng-model=vm.iddocumento ng-options=\"item.iddocumento as item.abreviatura for item in vm.documentos\" name=iddocumento class=form-control required></select></div><div class=\"form-group with-addon\"><span class=input-addon><i class=\"fa fa-id-card-o\"></i></span> <input type=text placeholder=\"N° Documento\" class=form-control id=username name=username ng-model=vm.username required></div><div class=\"form-group with-addon\"><span class=input-addon><i class=\"fa fa-key\"></i></span> <input type=password placeholder=Contraseña class=form-control name=password ng-model=vm.password required></div><button type=submit class=\"btn btn-green btn-block btn-lg btn-rounded-40\" ng-disabled=miForm.$submitted style=\"box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.10)\">{{vm.submitlogin}}</button></form><div ng-show=vm.warning class=\"alert alert-info mt-20\">{{ vm.warning}}</div><div class=\"alert alert-danger alert-dismissable mt-20\" ng-show=vm.error><button type=button class=close ng-click=\"vm.error = null\" aria-hidden=true>×</button> {{ vm.error}}</div><div class=\"text-center p-20\"><a ui-sref=pages.recovery>¿Olvidaste tu contraseña?</a></div><div class=text-center><a class=\"btn btn-block btn-lg btn-rounded-40 btn-primary\" ui-sref=pages.signup style=\"box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.10); font-size: 14px\">¿No tienes cuenta? Regístrate</a></div></div></div>");
$templateCache.put("app/pages/pages-signup/pages-signup.html","<style>.m-custom {\r\n    margin: -5px 0 0 -5px;\r\n  }</style><div class=padreback if-loading ng-if=vm.spinerLoading><div class=\"hijoback text-center text-primary\" style=\"padding: 40px; width: 320px; height: 180px; background-color: #FFFFFF\"><span class=\"fa fa-spinner fa-spin fa-4x\"></span><p class=m-10>Procesando solicitud..</p></div></div><div class=\"page page-core page-signup\"><div class=login-modal><div class=branding><img ng-src={{servidorUrl}}/img/osi/logologin.png width=270></div><h4 class=\"text-center mb-20 text-primary\">REGISTRO DE PACIENTE</h4><div ng-if=vm.registrado><div class=\"text-center form-registro-respuesta\"><span class=\"fa fa-envelope fa-2x text-primary\"></span><p class=m-10>Enviamos un correo a <span class=text-primary><strong>{{vm.data}}</strong></span> por favor <strong>confirme su registro</strong> para continuar.</p></div><small>Importante: Revise su BANDEJA de correo y SPAM</small></div><form name=miForm ng-submit=vm.save() class=form-registro><div ng-if=!vm.registrado><div class=row><div class=\"form-group col-sm-6\"><label for=iddocumento>Tipo documento</label><select ng-model=vm.iddocumento ng-options=\"item.iddocumento as item.abreviatura for item in vm.documentos\" name=iddocumento class=\"form-control input-sm\" required></select></div><div class=\"form-group col-sm-6\"><label for=iddocumento>Fecha nacimiento <span class=red>(*)</span></label><input type=date name=fechanacimiento ng-model=vm.fechanacimiento class=\"form-control input-sm mb-5\" required><div ng-messages=miForm.fechanacimiento.$error class=required role=alert ng-show=miForm.fechanacimiento.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><div class=row><div class=\"form-group col-sm-6\"><label for=numerodoc>N° Documento <small class=text-primary>*</small></label><input type=text name=numerodoc ng-model=vm.numerodoc class=\"form-control input-sm\" maxlength=12 required><div ng-messages=miForm.numerodoc.$error class=required role=alert ng-show=miForm.numerodoc.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-6\"><label for=nombre>Nombres <small class=text-primary>*</small></label><input type=text name=nombre ng-model=vm.nombre class=\"form-control input-sm\" maxlength=30 required><div ng-messages=miForm.nombre.$error class=required role=alert ng-show=miForm.nombre.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><div class=row><div class=\"form-group col-sm-6\"><label for=apellidopat>Apellido paterno <span class=text-primary>*</span></label><input type=text name=apellidopat ng-model=vm.apellidopat class=\"form-control input-sm\" maxlength=30 required><div ng-messages=miForm.apellidopat.$error class=required role=alert ng-show=miForm.apellidopat.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-6\"><label for=apellidomat>Apellido materno<span class=text-primary>*</span></label><input type=text name=apellidomat ng-model=vm.apellidomat class=\"form-control input-sm\" required maxlength=30></div></div><div class=row><div class=\"form-group col-sm-6\"><label for=celular>Celular <span class=text-primary>*</span></label><input type=text name=celular ng-model=vm.celular class=\"form-control input-sm\" maxlength=20 required><div ng-messages=miForm.celular.$error class=required role=alert ng-show=miForm.celular.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-6\"><label for=sexo>Sexo <span class=text-primary>*</span></label><select ng-model=vm.sexo name=sexo class=form-control required><option value=\"\"></option><option value=M>Masculino</option><option value=F>Femenino</option></select><div ng-messages=miForm.sexo.$error class=required role=alert ng-show=miForm.sexo.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><div class=row><div class=\"form-group col-sm-6\"><label for=correo>Correo <span class=text-primary>*</span></label><input type=email name=correo ng-model=vm.correo class=\"form-control input-sm\" maxlength=50 autocomplete=off required><div ng-messages=miForm.correo.$error class=required role=alert ng-show=miForm.correo.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=col-sm-6><label for=password>Contraseña <span class=text-primary>*</span></label><div class=\"form-group with-addon\"><span class=\"input-addon text-primary cursor m-custom\" ng-click=\"vm.pass = vm.pass === \'password\'? \'text\' : \'password\'\"><i class=\"fa fa-eye\"></i></span> <input type={{vm.pass}} name=password ng-model=vm.password class=\"form-control input-sm\" maxlength=20 autocomplete=new-password required><div ng-messages=miForm.password.$error class=required role=alert ng-show=miForm.password.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><!-- \r\n          <div class=\"form-group col-sm-6\" ng-if=\"vm._isNotMobile\">\r\n            <label for=\"fechanacimiento\">Fecha de nacimiento <span class=\"text-primary\">*</span></label>\r\n            <input data-input-mask type=\"text\" name=\"fechanacimiento\" ng-model=\"vm.fechanacimiento\" maxlength=\"10\"\r\n              class=\"form-control input-sm\" data-inputmask=\"\'alias\': \'dd/mm/yyyy\'\"\r\n              ng-pattern=\"/^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$/\"\r\n              required />\r\n            <div ng-messages=\"miForm.fechanacimiento.$error\" class=\"required\" role=\"alert\"\r\n              ng-show=\"miForm.fechanacimiento.$dirty\">\r\n              <div ng-message=\"required\">El campo es requerido</div>\r\n            </div>\r\n          </div>\r\n\r\n         <div class=\"form-group col-sm-6\" ng-if=\"!vm._isNotMobile\">\r\n            <label for=\"fechanacimiento\">Fecha de nacimiento <span class=\"text-primary\">*</span></label>\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-4 col-xs-4\">\r\n                <select ng-model=\"vm.iddocumento\"\r\n                  ng-options=\"item.iddocumento as item.abreviatura for item in vm.documentos\" name=\"iddocumento\"\r\n                  class=\"form-control input-sm\" required>\r\n                </select>\r\n              </div>\r\n              <div class=\"col-sm-4 col-xs-4\">\r\n                <select ng-model=\"vm.iddocumento\"\r\n                  ng-options=\"item.iddocumento as item.abreviatura for item in vm.documentos\" name=\"iddocumento\"\r\n                  class=\"form-control input-sm\" required>\r\n                </select>\r\n              </div>\r\n              <div class=\"col-sm-4 col-xs-4\">\r\n                <select ng-model=\"vm.iddocumento\"\r\n                  ng-options=\"item.iddocumento as item.abreviatura for item in vm.documentos\" name=\"iddocumento\"\r\n                  class=\"form-control input-sm\" required>\r\n                </select>\r\n              </div>\r\n            </div>\r\n            <div ng-messages=\"miForm.fechanacimiento.$error\" class=\"required\" role=\"alert\"\r\n              ng-show=\"miForm.fechanacimiento.$dirty\">\r\n              <div ng-message=\"required\">El campo es requerido</div>\r\n            </div>\r\n          </div> --></div><div class=row><div class=\"form-group col-sm-4\"><label for=numerodoc>Departamento<span class=red>(*)</span></label><select name=departamento ng-model=vm.dpto ng-options=\"item.dpto as item.nombre for item in vm.others.departamentos\" class=\"form-control input-sm mb-5\" ng-change=\"vm.changeUbigeo({pais: vm.pais, dpto: vm.dpto || \'\'}, \'provincias\',\'normal\')\"><option value=\"\">-- Departamento --</option></select><div ng-messages=miForm.dpto.$error class=required role=alert ng-show=miForm.dpto.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=nombre>Provincia <span class=red>(*)</span></label><select name=provincia ng-model=vm.prov ng-options=\"item.prov as item.nombre for item in vm.others.provincias\" class=\"form-control input-sm mb-5\" ng-change=\"vm.changeUbigeo({pais: vm.pais, dpto: vm.dpto || \'\', prov: vm.prov || \'\'}, \'distritos\',\'normal\')\"><option value=\"\">-- Provincia --</option></select><div ng-messages=miForm.prov.$error class=required role=alert ng-show=miForm.prov.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=numerodoc>Distrito <span class=red>(*)</span></label><select name=distrito ng-model=vm.dist ng-options=\"item.dist as item.nombre for item in vm.others.distritos\" class=\"form-control input-sm mb-5\" required><option value=\"\">-- Distrito --</option></select><div ng-messages=miForm.dist.$error class=required role=alert ng-show=miForm.dist.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><!-- <div class=\"row\">\r\n\r\n          <div class=\"col-sm-6\">\r\n            <label for=\"passwordrepeat\">Repita contraseña<span class=\"text-primary\">*</span></label>\r\n            <div class=\"form-group with-addon\">\r\n              <span class=\"input-addon text-primary cursor m-custom\"\r\n                ng-click=\"vm.passrepeat = vm.passrepeat === \'password\'? \'text\' : \'password\'\">\r\n                <i class=\"icon-eye\"></i></span>\r\n              <input type=\"{{vm.passrepeat}}\" name=\"passwordrepeat\" ng-model=\"vm.passwordrepeat\"\r\n                class=\"form-control input-sm\" maxlength=\"20\" required />\r\n              <div ng-messages=\"miForm.passwordrepeat.$error\" class=\"required\" role=\"alert\"\r\n                ng-show=\"miForm.passwordrepeat.$dirty\">\r\n                <div ng-message=\"required\">El campo es requerido</div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div> --><div class=\"form-group col-sm-12\"><label class=\"minotaur-checkbox inline-block\">Acepto los <a href=https://www.centromedicoosi.com/deberes-y-derechos class=text-primary target=_blank style=\"text-decoration: underline\">términos y condiciones</a> del servicio. <input type=checkbox ng-model=vm.aceptado ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\"><div class=input-indicator></div></label><div ng-if=\"vm.aceptado === \'0\'\" class=\"required ml-30\" role=alert><div>Es requisito aceptar los términos y condiciones del servicio.</div></div></div><button type=submit class=\"btn btn-green btn-lg btn-block btn-rounded-40\" ng-disabled=\"miForm.$invalid || miForm.$submitted\">Enviar</button></div></form><div class=\"mt-30 text-center\" ng-if=!vm.registrado>Ya tiene una cuenta? <a ui-sref=pages.login>INICIA SESIÓN</a></div></div></div>");
$templateCache.put("app/pages/pages-signup/pages-update.html","<style>.m-custom {\r\n    margin: -5px 0 0 -5px;\r\n  }\r\n    hr{\r\n      margin-top: 0px;\r\n    \r\n  }</style><div class=padreback if-loading ng-if=vm.spinerLoading><div class=\"hijoback text-center text-primary\" style=\"padding: 40px; width: 320px; height: 180px; background-color: #FFFFFF\"><span class=\"fa fa-spinner fa-spin fa-4x\"></span><p class=m-10>Procesando solicitud..</p></div></div><div class=\"page page-core page-signup\"><div class=login-modal><div class=branding><img ng-src={{servidorUrl}}/img/osi/logologin.png width=270></div><h4 class=\"text-center mb-20 text-primary\" ng-if=!vm.noExiste>Hola, {{vm.entidad.nombre}}</h4><div class=text-center ng-if=!vm.noExiste><p class=\"m-10 mb-20\">Por favor complete sus datos personales y familiares para su consulta médica</p></div><div class=text-center ng-if=vm.noExiste style=\"padding: 120px 20px\"><p>Paciente no existe, comunicarse con central.</p><a href=\"tel:01 739 0888\"><strong>01 739 0888</strong></a></div><form name=miForm ng-submit=vm.save() class=form-registro><div ng-if=!vm.noExiste><div class=row><div class=\"form-group col-sm-12\"><label for=numerodoc>Paciente</label><div class=text-primary><strong>{{vm.entidad.entidad}}</strong></div></div></div><div class=row><div class=\"form-group col-sm-6\"><label for=numerodoc>Tipo documento</label><select ng-model=vm.entidad.iddocumento ng-options=\"item.iddocumento as item.abreviatura for item in vm.documentos\" name=iddocumento class=\"form-control input-sm\" required ng-disabled=vm.ingresarDoc></select><div ng-messages=miForm.iddocumento.$error class=required role=alert ng-show=miForm.iddocumento.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-6\"><label for=nombre>Número documento</label><input type=text name=numerodoc ng-model=vm.entidad.numerodoc class=\"form-control input-sm\" maxlength=12 required ng-disabled=vm.ingresarDoc><div ng-messages=miForm.numerodoc.$error class=required role=alert ng-show=miForm.numerodoc.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><div class=row><div class=\"form-group col-sm-6\"><label for=iddocumento>Fecha nacimiento</label><input type=date name=fechanacimiento ng-model=vm.entidad.fechanacimiento class=\"form-control input-sm mb-5\" required><div ng-messages=miForm.fechanacimiento.$error class=required role=alert ng-show=miForm.fechanacimiento.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-6\"><label for=iddocumento>Ocupación</label><input type=text name=ocupacion ng-model=vm.entidad.ocupacion class=\"form-control input-sm mb-5\" maxlength=40 required><div ng-messages=miForm.ocupacion.$error class=required role=alert ng-show=miForm.ocupacion.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><div class=row><div class=\"form-group col-sm-6\"><label for=numerodoc>Estado civil</label><select ng-model=vm.entidad.estadocivil name=estadocivil class=\"form-control input-sm mb-5\" required><!-- <option value=\"\">-- Seleccione --</option> --><option value=Soltero>Soltero</option><option value=Casado>Casado</option><option value=Conviviente>Conviviente</option><option value=\"Divorciado separado\">Divorciado separado</option><option value=Viudo>Viudo</option></select><div ng-messages=miForm.estadocivil.$error class=required role=alert ng-show=miForm.estadocivil.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-6\"><label for=nombre>Nro. hijos</label><input type=number name=hijos ng-model=vm.entidad.hijos class=\"form-control input-sm mb-5\" required><div ng-messages=miForm.hijos.$error class=required role=alert ng-show=miForm.hijos.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-6\"><label for=nombre>Celular</label><input type=text name=celular ng-model=vm.entidad.celular class=\"form-control input-sm mb-5\" required><div ng-messages=miForm.celular.$error class=required role=alert ng-show=miForm.celular.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><strong class=\"text-center mb-20 text-primary ng-binding ng-scope\">Dirección</strong><br><label for=city style=font-size:11px>Ingresa dirección donde reside actualmente.</label><hr><div class=row><div class=\"form-group col-sm-6\"><label for=numerodoc>Departamento</label><select name=departamento ng-model=vm.entidad.dpto ng-options=\"item.dpto as item.nombre for item in vm.others.departamentos\" class=\"form-control input-sm mb-5\" ng-change=\"vm.changeUbigeo({pais: vm.entidad.pais, dpto: vm.entidad.dpto || \'\'}, \'provincias\')\"><option value=\"\">-- Departamento --</option></select><div ng-messages=miForm.dpto.$error class=required role=alert ng-show=miForm.dpto.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-6\"><label for=nombre>Provincia</label><select name=provincia ng-model=vm.entidad.prov ng-options=\"item.prov as item.nombre for item in vm.others.provincias\" class=\"form-control input-sm mb-5\" ng-change=\"vm.changeUbigeo({pais: vm.entidad.pais, dpto: vm.entidad.dpto || \'\', prov: vm.entidad.prov || \'\'}, \'distritos\')\"><option value=\"\">-- Provincia --</option></select><div ng-messages=miForm.prov.$error class=required role=alert ng-show=miForm.prov.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><div class=row><div class=\"form-group col-sm-6\"><label for=numerodoc>Distrito</label><select name=distrito ng-model=vm.entidad.dist ng-options=\"item.dist as item.nombre for item in vm.others.distritos\" class=\"form-control input-sm mb-5\" required><option value=\"\">-- Distrito --</option></select><div ng-messages=miForm.idubigeo.$error class=required role=alert ng-show=miForm.idubigeo.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><div class=row><div class=\"col-sm-12 col-xs-12\"><label for=nombre>Dirección</label><input type=text name=direccion ng-model=vm.entidad.direccion maxlength=150 class=\"form-control input-sm mb-5\"><br></div><br></div><strong class=\"text-center mb-20 text-primary ng-binding ng-scope\">Datos Clínicos</strong><br><label for=city style=font-size:11px>Ingrese datos de su condición fisica.</label><hr><div class=row><div class=\"form-group col-sm-4\"><label for=city>Peso (Kg).</label><input type=number name=peso ng-model=vm.entidad.peso min=0 maxlength=5 class=\"form-control input-sm mb-5\"></div><div class=\"form-group col-sm-4\"><label for=state>Altura (Metro).</label><input type=number step=0.01 name=altura ng-model=vm.entidad.altura min=0 maxlength=5 class=\"form-control input-sm mb-5\"></div><div class=\"form-group col-sm-4\"><label for=zip>Tipo de sangre</label><select name=sangre ng-model=vm.entidad.sangre class=\"form-control input-sm mb-5\"><option value=\"\">-- Seleccione --</option><option value=A+>A+</option><option value=A->A-</option><option value=B+>B+</option><option value=B->B-</option><option value=AB+>AB+</option><option value=AB->AB-</option><option value=O+>O+</option><option value=O->O-</option></select></div></div><button type=submit class=\"btn btn-green btn-lg btn-block btn-rounded-40\" ng-disabled=\"miForm.$invalid || miForm.$submitted\">Enviar</button></div></form><div class=\"mt-30 text-center\">Ya tiene una cuenta? <a ui-sref=pages.login>INICIA SESIÓN</a></div></div></div>");
$templateCache.put("app/pages/pages-recovery/libro-reclamaciones.html","<style>.m-custom {\r\n      margin: -5px 0 0 -5px;\r\n    }\r\n      hr{\r\n        margin-top: 0px;\r\n      \r\n    }\r\n    .red{ \r\n      color:red;\r\n    }</style><div ng-if=vm.spinerLoading><div class=padreback><div class=\"hijoback text-center\"><span class=\"fa fa-spinner fa-spin fa-4x\"></span><br><br>Procesando..</div></div></div><div class=login-modal style=\"width: 945px!important\"><div class=branding><img ng-src={{servidorUrl}}/img/osi/logologin.png width=270></div><form name=miForm ng-submit=vm.saveLibroReclamo() class=form-registro><div class=row><div class=\"form-group col-sm-12\"><h4>Libro de Reclamaciones</h4><br><strong class=\"text-center mb-20 text-primary ng-binding ng-scope\">1. IDENTIFICACIÓN DEL USUARIO (PACIENTE) O TERCERO LEGITIMADO</strong></div></div><div class=row><div class=\"form-group col-sm-4\"><label for=numerodoc>Tipo documento <span class=red>(*)</span></label><select ng-model=vm.entidad.iddocumento ng-options=\"item.iddocumento as item.abreviatura for item in vm.documentos\" name=iddocumento class=\"form-control input-sm\" required ng-disabled=vm.ingresarDoc></select><div ng-messages=miForm.iddocumento.$error class=required role=alert ng-show=miForm.iddocumento.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=nombre>Número documento <span class=red>(*)</span></label><input type=text name=numerodoc ng-model=vm.entidad.numerodoc class=\"form-control input-sm\" ng-change=vm.getDocumento(); maxlength=12 required ng-disabled=vm.ingresarDoc><div ng-messages=miForm.numerodoc.$error class=required role=alert ng-show=miForm.numerodoc.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=iddocumento>Fecha nacimiento <span class=red>(*)</span></label><input type=date name=fechanacimiento ng-model=vm.entidad.fechanacimiento class=\"form-control input-sm mb-5\" required><div ng-messages=miForm.fechanacimiento.$error class=required role=alert ng-show=miForm.fechanacimiento.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><div class=row><div class=\"form-group col-sm-4\"><label for=iddocumento>Apellido paterno <span class=red>(*)</span></label><input type=text name=apellidopat ng-model=vm.entidad.apellidopat maxlength=50 class=\"form-control input-sm mb-5\" required ng-disabled=!vm.requiredNombre capitalize-first></div><div class=\"form-group col-sm-4\"><label for=iddocumento>Apellido materno <span class=red>(*)</span></label><input type=text name=apellidomat ng-model=vm.entidad.apellidomat class=\"form-control input-sm mb-5\" maxlength=50 required capitalize-first ng-disabled=!vm.requiredNombre><div ng-messages=miForm.apellidomat.$error class=required role=alert ng-show=miForm.apellidomat.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=iddocumento>Nombre(s) <span class=red>(*)</span></label><input type=text name=nombre ng-model=vm.entidad.nombre required class=\"form-control input-sm mb-5\" maxlength=50 required capitalize-first ng-disabled=!vm.requiredNombre><div ng-messages=miForm.nombre.$error class=required role=alert ng-show=miForm.nombre.$dirty><div ng-message=required>El campo es requerido</div></div></div></div><div class=row><div class=\"form-group col-sm-4\"><label for=iddocumento>Correo Electrónico <span class=red>(*)</span></label><input type=email name=email ng-model=vm.entidad.email class=\"form-control input-sm mb-5\" maxlength=40 required><div ng-messages=miForm.email.$error class=required role=alert ng-show=miForm.email.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=iddocumento>Sexo <span class=red>(*)</span></label><select ng-model=vm.entidad.sexo name=sexo class=\"form-control input-sm\" required><option value=\"\">-- Seleccione --</option><option value=M>Masculino</option><option value=F>Femenino</option></select><div ng-messages=miForm.sexo.$error class=required role=alert ng-show=miForm.sexo.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=iddocumento>Teléfono</label><input type=number name=celular ng-model=vm.entidad.celular class=\"form-control input-sm mb-5\" ng-minlength=7 maxlength=9></div></div><div class=row style=\"margin-left: 5px\"><strong class=\"text-center mb-20 text-primary ng-binding ng-scope\">DOMICILIO</strong><hr><div class=row><div class=\"form-group col-sm-4\"><label for=numerodoc>Departamento <span class=red>(*)</span></label><select name=departamento ng-model=vm.entidad.dpto ng-options=\"item.dpto as item.nombre for item in vm.others.departamentos\" class=\"form-control input-sm mb-5\" ng-change=\"vm.changeUbigeo({pais: vm.entidad.pais, dpto: vm.entidad.dpto || \'\'}, \'provincias\',\'normal\')\"><option value=\"\">-- Departamento --</option></select><div ng-messages=miForm.dpto.$error class=required role=alert ng-show=miForm.dpto.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=nombre>Provincia <span class=red>(*)</span></label><select name=provincia ng-model=vm.entidad.prov ng-options=\"item.prov as item.nombre for item in vm.others.provincias\" class=\"form-control input-sm mb-5\" ng-change=\"vm.changeUbigeo({pais: vm.entidad.pais, dpto: vm.entidad.dpto || \'\', prov: vm.entidad.prov || \'\'}, \'distritos\',\'normal\')\"><option value=\"\">-- Provincia --</option></select><div ng-messages=miForm.prov.$error class=required role=alert ng-show=miForm.prov.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=numerodoc>Distrito <span class=red>(*)</span></label><select name=distrito ng-model=vm.entidad.dist ng-options=\"item.dist as item.nombre for item in vm.others.distritos\" class=\"form-control input-sm mb-5\" required><option value=\"\">-- Distrito --</option></select><div ng-messages=miForm.dist.$error class=required role=alert ng-show=miForm.dist.$dirty><div ng-message=required>El campo es requerido</div></div></div></div></div><div class=row><div class=col-sm-6><label for=nombre>Dirección <span class=red>(*)</span></label><input type=text name=direccion ng-model=vm.entidad.direccion required maxlength=150 class=\"form-control input-sm mb-5\"><br></div><div class=col-sm-6><label for=nombre>Referencia de Domicilio</label><input type=text name=direccion ng-model=vm.entidad.direccion_ref maxlength=150 class=\"form-control input-sm mb-5\"><br></div><div class=\"form-group col-sm-12\"><strong class=\"text-center mb-20 text-primary ng-binding ng-scope\">2. IDENTIFICACIÓN DE QUIÉN PRESENTA EL RECLAMO</strong><label><span class=wpcf7-list-item-label style=\"margin-left: 40px\">En caso de ser el usuario afectado marque aquí</span></label><input ng-model=vm.entidad.idusuarioafectado type=checkbox name=es-usuario-afectado ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" aria-invalid=false style=\"width: 31px;height: 18px\"></div></div><div class=row ng-show=\"!vm.entidad.idusuarioafectado || vm.entidad.idusuarioafectado == 0 \"><div class=\"form-group col-sm-4\"><label for=iddocumento>Nombre o Razón Social <span class=red>(*)</span></label><input type=text name=nombre_afect ng-model=vm.entidad.nombre_afect class=\"form-control input-sm mb-5\" maxlength=50 ng-required=\"vm.entidad.idusuarioafectado != 1\" capitalize-first><div ng-messages=miForm.nombre_afect.$error class=required role=alert ng-show=miForm.nombre_afect.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=iddocumento>Apellido Paterno <span class=red>(*)</span></label><input type=text name=apellidopat_afect ng-model=vm.entidad.apellidopat_afect class=\"form-control input-sm mb-5\" maxlength=50 ng-required=\"vm.entidad.idusuarioafectado != 1\" capitalize-first><div ng-messages=miForm.apellidopat_afect.$error class=required role=alert ng-show=miForm.apellidopat_afect.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=iddocumento>Apellido Materno <span class=red>(*)</span></label><input type=text name=apellidoma_afect ng-model=vm.entidad.apellidoma_afect class=\"form-control input-sm mb-5\" maxlength=50 ng-required=\"vm.entidad.idusuarioafectado != 1\" capitalize-first><div ng-messages=miForm.apellidoma_afect.$error class=required role=alert ng-show=miForm.apellidoma_afect.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-3\"><label for=iddocumento>Correo Electrónico <span class=red>(*)</span></label><input ng-required=\"vm.entidad.idusuarioafectado != 1\" type=email name=email_afect ng-model=vm.entidad.email_afect class=\"form-control input-sm mb-5\" maxlength=40><div ng-messages=miForm.email_afect.$error class=required role=alert ng-show=miForm.email_afect.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-3\"><label for=iddocumento>Teléfono</label><input type=number name=telefono_afect ng-model=vm.entidad.celular_afect class=\"form-control input-sm mb-5\" ng-minlength=7 maxlength=9></div><div class=\"form-group col-sm-3\"><label for=iddocumento>Fecha nacimiento <span class=red>(*)</span></label><input type=date name=fechanacimiento_afect ng-model=vm.entidad.fechanacimiento_afect class=\"form-control input-sm mb-5\" ng-required=\"vm.entidad.idusuarioafectado != 1\"><div ng-messages=miForm.fechanacimiento_afect.$error class=required role=alert ng-show=miForm.fechanacimiento_afect.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-3\"><label for=iddocumento>Sexo <span class=red>(*)</span></label><select ng-model=vm.entidad.sexo_afect name=sexo_afect class=\"form-control input-sm\" ng-required=\"vm.entidad.idusuarioafectado != 1\"><option value=\"\">-- Seleccione --</option><option value=M>Masculino</option><option value=F>Femenino</option></select><div ng-messages=miForm.sexo_afect.$error class=required role=alert ng-show=miForm.sexo_afect.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-12\"><strong class=\"text-center mb-20 text-primary ng-binding ng-scope\">DOMICILIO</strong><hr></div><div class=\"form-group col-sm-4\"><label for=numerodoc>Departamento <span class=red>(*)</span></label><select ng-required=\"vm.entidad.idusuarioafectado != 1\" ng-model=vm.entidad.dpto_afect name=dpto_afect ng-model=vm.entidad.dpto_afect ng-options=\"item.dpto as item.nombre for item in vm.others.departamentos\" class=\"form-control input-sm mb-5\" ng-change=\"vm.changeUbigeo({pais: vm.entidad.pais, dpto_afect: vm.entidad.dpto_afect || \'\'}, \'prov_afect\',\'afectado\')\"><option value=\"\">-- Departamento --</option></select><div ng-messages=miForm.dpto_afect.$error class=required role=alert ng-show=miForm.dpto_afect.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=nombre>Provincia <span class=red>(*)</span></label><select ng-required=\"vm.entidad.idusuarioafectado != 1\" name=provincia_afect ng-model=vm.entidad.prov_afect ng-options=\"item.prov as item.nombre for item in vm.others.prov_afect\" class=\"form-control input-sm mb-5\" ng-change=\"vm.changeUbigeo({pais: vm.entidad.pais, dpto_afect: vm.entidad.dpto_afect || \'\', prov_afect: vm.entidad.prov_afect || \'\'}, \'dist_afect\',\'afectado\')\"><option value=\"\">-- Provincia --</option></select><div ng-messages=miForm.prov_afect.$error class=required role=alert ng-show=miForm.prov_afect.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=numerodoc>Distrito <span class=red>(*)</span></label><select name=distrito_afect ng-model=vm.entidad.dist_afect ng-options=\"item.dist as item.nombre for item in vm.others.dist_afect\" class=\"form-control input-sm mb-5\" ng-required=\"vm.entidad.idusuarioafectado != 1\"><option value=\"\">-- Distrito --</option></select><div ng-messages=miForm.dist_afect.$error class=required role=alert ng-show=miForm.dist_afect.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=col-sm-6><label for=nombre>Dirección <span class=red>(*)</span></label><input type=text name=direccion_afect ng-model=vm.entidad.direccion_afect ng-required=\"vm.entidad.idusuarioafectado != 1\" maxlength=150 class=\"form-control input-sm mb-5\"><br></div><div class=col-sm-6><label for=nombre>Referencia de Domicilio</label><input type=text name=direccion ng-model=vm.entidad.direccion_ref_afect maxlength=150 class=\"form-control input-sm mb-5\"><br></div></div><div class=row ng-show=\"!vm.entidad.idusuarioafectado || vm.entidad.idusuarioafectado == 0 \"><div class=\"form-group col-sm-12\"><strong class=\"text-center mb-20 text-primary ng-binding ng-scope\">TIPO DE RECLAMANTE</strong><hr><div class=col-sm-6 style=\"margin-left: -13px\"><label for=nombre>Tipo de reclamante <span class=red>(*)</span></label><select ng-required=\"vm.entidad.idusuarioafectado != 1\" ng-model=vm.entidad.tipo_reclamo name=tipo-reclamante class=\"form-control input-sm mb-5\" aria-required=true aria-invalid=false><option value=\"\">-- Seleccione --</option><option value=Agraviado>Agraviado</option><option value=Representante>Representante</option><option value=Abogado>Abogado</option><option value=\"Asoc. de consumidores\">Asoc. de consumidores</option><option value=\"No hay relación\">No hay relación</option><option value=ONG>ONG</option><option value=\"Asistente social\">Asistente social</option></select></div><div class=col-sm-6><label for=nombre>Tipo de relacion <span class=red>(*)</span></label><select ng-required=\"vm.entidad.idusuarioafectado != 1\" ng-model=vm.entidad.tipo_relacion name=tipo-relacion class=\"form-control input-sm mb-5\" aria-required=true aria-invalid=false><option value=\"\">-- Seleccione --</option><option value=Hermano(a)>Hermano(a)</option><option value=Cónyuge>Cónyuge</option><option value=Apoderado>Apoderado</option><option value=\"Esposo (a)\">Esposo (a)</option><option value=Hija(o)>Hija(o)</option></select></div></div></div><div class=row><div class=\"form-group col-sm-12\"><strong class=\"text-center mb-20 text-primary ng-binding ng-scope\">3. DETALLE DEL RECLAMO</strong></div><div class=\"form-group col-sm-4\"><label for=iddocumento>fecha de suceso <span class=red>(*)</span></label><input type=date name=fecha_reclamo ng-model=vm.entidad.fecha_reclamo class=\"form-control input-sm mb-5\" required><div ng-messages=miForm.fecha_reclamo.$error class=required role=alert ng-show=miForm.fecha_reclamo.$dirty><div ng-message=required>El campo es requerido</div></div></div><div class=\"form-group col-sm-4\"><label for=iddocumento>Sede de ocurrencia <span class=red>(*)</span></label><select ng-model=vm.entidad.idsede_afect ng-options=\"item.idsede as item.nombre for item in vm.others.sedes\" class=\"form-control input-sm mb-5 ng-pristine ng-valid ng-empty ng-touched\" aria-invalid=false><option value=\"\">-- Seleccione --</option></select></div><div class=\"form-group col-sm-4\"><label for=iddocumento>Tipo Producto/Servicio <span class=red>(*)</span></label><select ng-model=vm.entidad.tiposervicio class=\"form-control input-sm mb-5 ng-pristine ng-valid ng-empty ng-touched\" aria-invalid=false><option value=\"\">-- Seleccione --</option><option value=producto>Producto</option><option value=servicio>Servicio</option></select></div><div class=\"form-group col-sm-12\"><label for=iddocumento>Descripción del Reclamo <span class=red>(*)</span></label><textarea class=form-control ng-model=vm.entidad.desc_reclamo required style=\"height: 180px\"></textarea></div><div class=\"form-group col-sm-12\"><label for=iddocumento>Pedido<span class=red>(*)</span></label><textarea class=form-control ng-model=vm.entidad.pedido required style=\"height: 180px\"></textarea></div></div><div class=row><div class=\"form-group col-sm-12\"><strong class=\"col-sm-5 mb-20 text-primary ng-binding ng-scope\">4. AUTORIZO NOTIFICACIÓN DE RESULTADO DE RECLAMO A E-MAIL CONSIGNADO (MARCAR)</strong><div class=col-sm-7><label><span class=\"wpcf7-list-item-label text-right\">En caso de ser el usuario afectado marque aquí</span></label><input ng-model=vm.entidad.autorizacion type=checkbox name=es-usuario-afectado ng-true-value=\"\'1\'\" aria-invalid=false style=\"width: 31px;height: 18px\"> SI <input ng-model=vm.entidad.autorizacion type=checkbox name=es-usuario-afectado ng-true-value=\"\'0\'\" aria-invalid=false style=\"width: 31px;height: 18px\"> NO</div></div></div><p style=\"text-align: center\">Las IAFAS, IPRESS O UGIPRESS deben atender el reclamo en un plazo de 30 días hábiles.</p><p style=\"text-align: center\">\"Estimado usuario: Usted puede presentar su denuncia ante Susalud ante hechos o actos que vulneren o pudieran vulnerar el derecho a la salud, o cuando no le hayan brindado un servicio, prestación o coberturas solicitada o recibidas de las IAFAS o IPRESS, o que dependan de la UGIPRESS pública, privada o mixtas. También ante la negativa de atención de su reclamo, irregularidad en su tratamiento o disconformidad con el resultado del mismo o hacer uso de los mecanismos alternativos de solución de controversias ante el Centro de Conciliación y Arbitraje - CECONAR de SUSALUD\"</p><span style=\"color: red\">*Este campo es necesario para poder enviar el formulario</span><br><label><input ng-model=vm.entidad.declaro ng-true-value=\"\'1\'\" required type=checkbox name=acceptance-final value=1 aria-invalid=false style=\"width: 31px;height: 18px\" required> <span class=wpcf7-list-item-label>Declaro que los datos consignados son reales</span></label><br><button type=submit class=\"btn btn-green btn-lg btn-block btn-rounded-40\">Enviar Mensaje</button></form></div>");
$templateCache.put("app/pages/pages-recovery/pages-recovery.html","<div class=padreback if-loading ng-if=vm.spinerLoading><div class=\"hijoback text-center text-primary\" style=\"padding: 40px; width: 320px; height: 180px; background-color: #FFFFFF\"><span class=\"fa fa-spinner fa-spin fa-4x\"></span><p class=m-10>Procesando solicitud..</p></div></div><div class=\"page page-core page-forgotpass\"><div class=login-modal><div class=branding><img ng-src={{servidorUrl}}/img/osi/logologin.png width=270></div><h4 class=\"text-center mb-20 text-primary\">RECUPERAR CONTRASEÑA</h4><div ng-if=vm.enviado><div class=\"text-center form-registro-respuesta\"><span class=\"fa fa-envelope fa-2x text-primary\"></span><p class=m-10>{{vm.data.nombre}}, enviamos tu contraseña a <span class=text-primary><strong>{{vm.data.email}}</strong></span></p></div><small>Importante: Revise su BANDEJA de correo y SPAM</small></div><div class=\"mt-20 mb-10 text-center\" ng-if=!vm.enviado>Enviaremos tu contraseña a tu correo.</div><form name=miForm ng-submit=vm.save()><div ng-if=!vm.enviado><div class=\"form-group with-addon\"><select ng-model=vm.iddocumento ng-options=\"item.iddocumento as item.abreviatura for item in vm.documentos\" name=iddocumento class=form-control required></select></div><div class=\"form-group with-addon\"><span class=input-addon><i class=\"fa fa-id-card-o\"></i></span> <input type=text placeholder=\"N° Documento\" class=form-control id=numerodoc name=numerodoc ng-model=vm.numerodoc required><label class=error ng-show=\"form.numerodoc.$dirty && form.numerodoc.$error.required\" style=\"display: inline-block\">Ingrese N° documento</label></div><button type=submit class=\"btn btn-green btn-lg btn-block btn-rounded-40\" ng-disabled=miForm.$submitted>Recuperar</button><div class=\"alert alert-danger alert-dismissable mt-20\" ng-show=vm.error><button type=button class=close ng-click=\"vm.error = null\" aria-hidden=true>×</button> {{ vm.error}}</div></div></form><div class=\"mt-30 text-center\" ng-if=!vm.enviado>Ya tiene una cuenta? <a ui-sref=pages.login>INICIA SESIÓN</a></div></div></div>");
$templateCache.put("app/pages/pages-terapiaencuesta/pages-terapiaencuesta.html","<style>.m-custom {\r\n    margin: -5px 0 0 -5px;\r\n  }\r\n    hr{\r\n      margin-top: 0px;\r\n\r\n  }\r\n   .cuadrado-ocupado{\r\n        background-color: #337ab7;\r\n        color: white;\r\n    }\r\n    .cuadrado-libre{\r\n        background-color: #ffffff;\r\n    color: #6f7c83;\r\n    }\r\n    .gridblanco {\r\n        height: 220px;\r\n        background: #FFF;\r\n    }\r\n\r\n    .gridblanco-xs {\r\n        height: 150px;\r\n        background: #FFF;\r\n    }\r\n\r\n    fieldset {\r\n        color: #454545;\r\n        border: 1px solid rgba(0, 0, 0, 0.2) !important;\r\n        border-radius: 5px;\r\n        padding: 5px 10px;\r\n        line-height: 16px;\r\n    }\r\n\r\n    fieldset legend {\r\n        color: #367fa9;\r\n        padding: 5px;\r\n        margin: 0px;\r\n        font-size: 12px;\r\n        border: none !important;\r\n        width: auto !important;\r\n    }\r\n\r\n    table {\r\n        border: 1px solid rgba(0, 0, 0, 0.1) !important;\r\n        border-radius: 5px;\r\n    }\r\n\r\n    table thead tr th {\r\n        color: #367fa9;\r\n        font-size: 12px;\r\n        font-weight: normal;\r\n    }\r\n\r\n    table td{\r\n        text-align: center;\r\n        width:9.09%;\r\n    }\r\n\r\n    .azul-claro {\r\n        background-color: #F0F0F0;\r\n        color: #367fa9;\r\n    }\r\n\r\n    .input-sm {\r\n        height: 24px;\r\n        line-height: 13px;\r\n    }\r\n    .smile-mejor-gris {\r\n        background: url(../assets/images/smile-mejor-gris.png) no-repeat;\r\n        background-size: 32px 32px;\r\n    }\r\n    #content .page{\r\n      padding: 20px;\r\n    }\r\n    .span_detail{\r\n      color: #616f77b3;\r\n      font-size: 13px;\r\n    }\r\n\r\n    @media (max-width: 680px) {\r\n    .appWrap.core #content .page {\r\n        padding-top: 10px; } }\r\n\r\n    @media (max-width: 380px) {\r\n      #content .page {\r\n      padding: 5px; } }</style><div class=padreback if-loading ng-if=vm.spinerLoading><div class=\"hijoback text-center text-primary\" style=\"padding: 40px; width: 320px; height: 180px; background-color: #FFFFFF\"><span class=\"fa fa-spinner fa-spin fa-4x\"></span><p class=m-10>Procesando...</p></div></div><div class=\"page page-core page-signup\"><div class=login-modal style=\"padding:30px 8px\"><div class=branding><img ng-src={{servidorUrl}}/img/osi/logologin.png width=270></div><h4 class=\"text-center mb-20 text-primary\" ng-if=\"!vm.noExiste  && !vm.encuestacompleta\">Hola, {{vm.entidad.primernombre}}</h4><div class=text-center ng-if=\"!vm.noExiste && !vm.encuestacompleta\"><p class=\"m-10 mb-20\">Su opinión es muy importante para nosotros.<br>Agradecemos pueda calificar su atención en OSI.</p></div><div class=text-center ng-if=\"vm.noExiste && !vm.encuestacompleta\" style=\"padding: 120px 20px\"><p>Paciente no existe, comunicarse con central.</p><a href=\"tel:01 739 0888\"><strong>01 739 0888</strong></a></div><div class=text-center ng-if=\"vm.encuestacompleta && !vm.noExiste\" style=\"padding: 120px 20px\"><a href=#><strong>¡Gracias por responder la encuesta!</strong></a><p>Tus respuestas nos ayudan a mejorar para día a día ofrecerte la mejor atención.</p></div><hr><form name=miForm ng-submit=vm.save() class=form-survey><div ng-if=\"!vm.noExiste && !vm.encuestacompleta\"><div class=row><div class=\"form-group col-sm-12\"><label for=sede>Sede:</label>&nbsp; <strong>{{vm.others.nombresede}}</strong></div><div class=\"form-group col-sm-6\"><label for=fecha>Fecha cita:</label>&nbsp; <strong>{{vm.others.fecha}}</strong></div><div class=\"form-group col-sm-6\"><label for=fecha>Hora cita:</label>&nbsp; <strong>{{vm.others.inicio}}</strong></div><div class=\"form-group col-sm-12\"><label for=medico>Terapeuta:</label>&nbsp; <strong>{{vm.others.nombreterapista}}</strong></div></div><hr><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor1><div class=\"form-group col-sm-12\"><label for=pregunta_1 style=\"margin-bottom: 5px\">1. ¿El trato de la terapeuta fue con amabilidad y paciencia?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p1_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 0, \'cuadrado-libre\': vm.p1_califica !== 0}\">0</td><td ng-click=\"vm.p1_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 1, \'cuadrado-libre\': vm.p1_califica !== 1}\">1</td><td ng-click=\"vm.p1_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 2, \'cuadrado-libre\': vm.p1_califica !== 2}\">2</td><td ng-click=\"vm.p1_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 3, \'cuadrado-libre\': vm.p1_califica !== 3}\">3</td><td ng-click=\"vm.p1_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 4, \'cuadrado-libre\': vm.p1_califica !== 4}\">4</td><td ng-click=\"vm.p1_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 5, \'cuadrado-libre\': vm.p1_califica !== 5}\">5</td><td ng-click=\"vm.p1_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 6, \'cuadrado-libre\': vm.p1_califica !== 6}\">6</td><td ng-click=\"vm.p1_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 7, \'cuadrado-libre\': vm.p1_califica !== 7}\">7</td><td ng-click=\"vm.p1_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 8, \'cuadrado-libre\': vm.p1_califica !== 8}\">8</td><td ng-click=\"vm.p1_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 9, \'cuadrado-libre\': vm.p1_califica !== 9}\">9</td><td ng-click=\"vm.p1_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 10, \'cuadrado-libre\': vm.p1_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada Satisfactorio</span> <span class=span_detail style=\"float: right\">Muy Satisfactorio</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor2><div class=\"form-group col-sm-12\"><label for=pregunta_2 style=\"margin-bottom: 5px\">2. ¿La terapeuta se tomó el tiempo para explicarle el <strong>tratamiento?</strong></label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p2_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 0, \'cuadrado-libre\': vm.p2_califica !== 0}\">0</td><td ng-click=\"vm.p2_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 1, \'cuadrado-libre\': vm.p2_califica !== 1}\">1</td><td ng-click=\"vm.p2_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 2, \'cuadrado-libre\': vm.p2_califica !== 2}\">2</td><td ng-click=\"vm.p2_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 3, \'cuadrado-libre\': vm.p2_califica !== 3}\">3</td><td ng-click=\"vm.p2_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 4, \'cuadrado-libre\': vm.p2_califica !== 4}\">4</td><td ng-click=\"vm.p2_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 5, \'cuadrado-libre\': vm.p2_califica !== 5}\">5</td><td ng-click=\"vm.p2_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 6, \'cuadrado-libre\': vm.p2_califica !== 6}\">6</td><td ng-click=\"vm.p2_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 7, \'cuadrado-libre\': vm.p2_califica !== 7}\">7</td><td ng-click=\"vm.p2_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 8, \'cuadrado-libre\': vm.p2_califica !== 8}\">8</td><td ng-click=\"vm.p2_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 9, \'cuadrado-libre\': vm.p2_califica !== 9}\">9</td><td ng-click=\"vm.p2_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 10, \'cuadrado-libre\': vm.p2_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada Satisfactorio</span> <span class=span_detail style=\"float: right\">Muy Satisfactorio</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor3><div class=\"form-group col-sm-12\"><label for=pregunta_3 style=\"margin-bottom: 5px\">3. ¿La presentación y vestimenta de la terapeuta fue la adecuada durante su atención?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p3_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 0, \'cuadrado-libre\': vm.p3_califica !== 0}\">0</td><td ng-click=\"vm.p3_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 1, \'cuadrado-libre\': vm.p3_califica !== 1}\">1</td><td ng-click=\"vm.p3_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 2, \'cuadrado-libre\': vm.p3_califica !== 2}\">2</td><td ng-click=\"vm.p3_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 3, \'cuadrado-libre\': vm.p3_califica !== 3}\">3</td><td ng-click=\"vm.p3_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 4, \'cuadrado-libre\': vm.p3_califica !== 4}\">4</td><td ng-click=\"vm.p3_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 5, \'cuadrado-libre\': vm.p3_califica !== 5}\">5</td><td ng-click=\"vm.p3_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 6, \'cuadrado-libre\': vm.p3_califica !== 6}\">6</td><td ng-click=\"vm.p3_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 7, \'cuadrado-libre\': vm.p3_califica !== 7}\">7</td><td ng-click=\"vm.p3_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 8, \'cuadrado-libre\': vm.p3_califica !== 8}\">8</td><td ng-click=\"vm.p3_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 9, \'cuadrado-libre\': vm.p3_califica !== 9}\">9</td><td ng-click=\"vm.p3_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 10, \'cuadrado-libre\': vm.p3_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada Satisfactorio</span> <span class=span_detail style=\"float: right\">Muy Satisfactorio</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor4><div class=\"form-group col-sm-12\"><label for=pregunta_4 style=\"margin-bottom: 5px\">4. ¿El tiempo de espera para su tratamiento fue la adecuada?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p4_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 0, \'cuadrado-libre\': vm.p4_califica !== 0}\">0</td><td ng-click=\"vm.p4_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 1, \'cuadrado-libre\': vm.p4_califica !== 1}\">1</td><td ng-click=\"vm.p4_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 2, \'cuadrado-libre\': vm.p4_califica !== 2}\">2</td><td ng-click=\"vm.p4_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 3, \'cuadrado-libre\': vm.p4_califica !== 3}\">3</td><td ng-click=\"vm.p4_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 4, \'cuadrado-libre\': vm.p4_califica !== 4}\">4</td><td ng-click=\"vm.p4_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 5, \'cuadrado-libre\': vm.p4_califica !== 5}\">5</td><td ng-click=\"vm.p4_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 6, \'cuadrado-libre\': vm.p4_califica !== 6}\">6</td><td ng-click=\"vm.p4_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 7, \'cuadrado-libre\': vm.p4_califica !== 7}\">7</td><td ng-click=\"vm.p4_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 8, \'cuadrado-libre\': vm.p4_califica !== 8}\">8</td><td ng-click=\"vm.p4_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 9, \'cuadrado-libre\': vm.p4_califica !== 9}\">9</td><td ng-click=\"vm.p4_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 10, \'cuadrado-libre\': vm.p4_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada Satisfactorio</span> <span class=span_detail style=\"float: right\">Muy Satisfactorio</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor5><div class=\"form-group col-sm-12\"><label for=pregunta_5 style=\"margin-bottom: 5px\">5. ¿El espacio de terapia estuvo ordenado, limpio, cómodo y acogedor?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p5_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p5_califica === 0, \'cuadrado-libre\': vm.p5_califica !== 0}\">0</td><td ng-click=\"vm.p5_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p5_califica === 1, \'cuadrado-libre\': vm.p5_califica !== 1}\">1</td><td ng-click=\"vm.p5_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p5_califica === 2, \'cuadrado-libre\': vm.p5_califica !== 2}\">2</td><td ng-click=\"vm.p5_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p5_califica === 3, \'cuadrado-libre\': vm.p5_califica !== 3}\">3</td><td ng-click=\"vm.p5_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p5_califica === 4, \'cuadrado-libre\': vm.p5_califica !== 4}\">4</td><td ng-click=\"vm.p5_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p5_califica === 5, \'cuadrado-libre\': vm.p5_califica !== 5}\">5</td><td ng-click=\"vm.p5_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p5_califica === 6, \'cuadrado-libre\': vm.p5_califica !== 6}\">6</td><td ng-click=\"vm.p5_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p5_califica === 7, \'cuadrado-libre\': vm.p5_califica !== 7}\">7</td><td ng-click=\"vm.p5_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p5_califica === 8, \'cuadrado-libre\': vm.p5_califica !== 8}\">8</td><td ng-click=\"vm.p5_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p5_califica === 9, \'cuadrado-libre\': vm.p5_califica !== 9}\">9</td><td ng-click=\"vm.p5_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p5_califica === 10, \'cuadrado-libre\': vm.p5_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada Satisfactorio</span> <span class=span_detail style=\"float: right\">Muy Satisfactorio</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor6><div class=\"form-group col-sm-12\"><label for=pregunta_6 style=\"margin-bottom: 5px\">6. ¿Recomendaría a la terapeuta que le atendió?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p6_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 0, \'cuadrado-libre\': vm.p6_califica !== 0}\">0</td><td ng-click=\"vm.p6_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 1, \'cuadrado-libre\': vm.p6_califica !== 1}\">1</td><td ng-click=\"vm.p6_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 2, \'cuadrado-libre\': vm.p6_califica !== 2}\">2</td><td ng-click=\"vm.p6_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 3, \'cuadrado-libre\': vm.p6_califica !== 3}\">3</td><td ng-click=\"vm.p6_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 4, \'cuadrado-libre\': vm.p6_califica !== 4}\">4</td><td ng-click=\"vm.p6_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 5, \'cuadrado-libre\': vm.p6_califica !== 5}\">5</td><td ng-click=\"vm.p6_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 6, \'cuadrado-libre\': vm.p6_califica !== 6}\">6</td><td ng-click=\"vm.p6_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 7, \'cuadrado-libre\': vm.p6_califica !== 7}\">7</td><td ng-click=\"vm.p6_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 8, \'cuadrado-libre\': vm.p6_califica !== 8}\">8</td><td ng-click=\"vm.p6_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 9, \'cuadrado-libre\': vm.p6_califica !== 9}\">9</td><td ng-click=\"vm.p6_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 10, \'cuadrado-libre\': vm.p6_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada Satisfactorio</span> <span class=span_detail style=\"float: right\">Muy Satisfactorio</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor10><div class=\"col-sm-12 col-xs-12\"><label for=pregunta_10 style=\"margin-bottom: 5px\">7. Apreciamos nos escriba si tiene comentarios adicionales?</label><textarea type=text name=p7_califica ng-model=vm.p7_califica maxlength=250 class=\"form-control input-sm mb-5\"></textarea><br></div><br></div><button type=submit class=\"btn btn-green btn-lg btn-block btn-rounded-40\" ng-disabled=miForm.$submitted>Enviar</button></div></form></div></div>");
$templateCache.put("app/pages/pages-survey/pages-survey.html","<style>.m-custom {\r\n    margin: -5px 0 0 -5px;\r\n  }\r\n    hr{\r\n      margin-top: 0px;\r\n    \r\n  }\r\n   .cuadrado-ocupado{\r\n        background-color: #337ab7;\r\n        color: white; \r\n    }\r\n    .cuadrado-libre{\r\n        background-color: #ffffff;\r\n    color: #6f7c83;\r\n    }\r\n    .gridblanco {\r\n        height: 220px;\r\n        background: #FFF;\r\n    }\r\n\r\n    .gridblanco-xs {\r\n        height: 150px;\r\n        background: #FFF;\r\n    }\r\n\r\n    fieldset {\r\n        color: #454545;\r\n        border: 1px solid rgba(0, 0, 0, 0.2) !important;\r\n        border-radius: 5px;\r\n        padding: 5px 10px;\r\n        line-height: 16px;\r\n    }\r\n\r\n    fieldset legend {\r\n        color: #367fa9;\r\n        padding: 5px;\r\n        margin: 0px;\r\n        font-size: 12px;\r\n        border: none !important;\r\n        width: auto !important;\r\n    }\r\n\r\n    table {\r\n        border: 1px solid rgba(0, 0, 0, 0.1) !important;\r\n        border-radius: 5px;\r\n    }\r\n\r\n    table thead tr th {\r\n        color: #367fa9;\r\n        font-size: 12px;\r\n        font-weight: normal;\r\n    }\r\n\r\n    table td{\r\n        text-align: center;\r\n        width:9.09%;\r\n    }\r\n\r\n    .azul-claro {\r\n        background-color: #F0F0F0;\r\n        color: #367fa9;\r\n    }\r\n\r\n    .input-sm {\r\n        height: 24px;\r\n        line-height: 13px;\r\n    }\r\n    .smile-mejor-gris {\r\n        background: url(../assets/images/smile-mejor-gris.png) no-repeat;\r\n        background-size: 32px 32px;\r\n    }\r\n    #content .page{\r\n      padding: 20px;\r\n    }\r\n    .span_detail{\r\n      color: #616f77b3;\r\n      font-size: 13px;\r\n    }\r\n\r\n    @media (max-width: 680px) {\r\n    .appWrap.core #content .page {\r\n        padding-top: 10px; } }\r\n\r\n    @media (max-width: 380px) {\r\n      #content .page {\r\n      padding: 5px; } }</style><div class=padreback if-loading ng-if=vm.spinerLoading><div class=\"hijoback text-center text-primary\" style=\"padding: 40px; width: 320px; height: 180px; background-color: #FFFFFF\"><span class=\"fa fa-spinner fa-spin fa-4x\"></span><p class=m-10>Procesando...</p></div></div><div class=\"page page-core page-signup\"><div class=login-modal style=\"padding:30px 8px\"><div class=branding><img ng-src={{servidorUrl}}/img/osi/logologin.png width=270></div><h4 class=\"text-center mb-20 text-primary\" ng-if=\"!vm.noExiste  && !vm.encuestacompleta\">Hola, {{vm.entidad.primernombre}}</h4><div class=text-center ng-if=\"!vm.noExiste && !vm.encuestacompleta\"><p class=\"m-10 mb-20\">Su opinión es muy importante para nosotros.<br>Agradecemos pueda calificar su atención en OSI.</p></div><div class=text-center ng-if=\"vm.noExiste && !vm.encuestacompleta\" style=\"padding: 120px 20px\"><p>Paciente no existe, comunicarse con central.</p><a href=\"tel:01 739 0888\"><strong>01 739 0888</strong></a></div><div class=text-center ng-if=\"vm.encuestacompleta && !vm.noExiste\" style=\"padding: 120px 20px\"><a href=#><strong>¡Gracias por responder la encuesta!</strong></a><p>Tus respuestas nos ayudan a mejorar para día a día ofrecerte la mejor atención.</p></div><hr><form name=miForm ng-submit=vm.save() class=form-survey><div ng-if=\"!vm.noExiste && !vm.encuestacompleta\"><div class=row><div class=\"form-group col-sm-12\"><label for=sede>Sede:</label>&nbsp; <strong>{{vm.others.nombresede.replace(\'OSI - \', \'\').replace(\'OSI -\', \'\').replace(\'OSI \', \'\').replace(\'OSI\', \'\').trim()}}</strong></div><div class=\"form-group col-sm-6\"><label for=fecha>Fecha cita:</label>&nbsp; <strong>{{vm.others.fecha}}</strong></div><div class=\"form-group col-sm-6\"><label for=fecha>Hora cita:</label>&nbsp; <strong>{{vm.others.inicio}}</strong></div><div class=\"form-group col-sm-12\"><p><strong>Admisión</strong></p></div></div><hr><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor1><div class=\"form-group col-sm-12\"><label for=pregunta_1 style=\"margin-bottom: 5px\">1. ¿El personal de admisión le trató con amabilidad y paciencia?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p1_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 0, \'cuadrado-libre\': vm.p1_califica !== 0}\">0</td><td ng-click=\"vm.p1_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 1, \'cuadrado-libre\': vm.p1_califica !== 1}\">1</td><td ng-click=\"vm.p1_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 2, \'cuadrado-libre\': vm.p1_califica !== 2}\">2</td><td ng-click=\"vm.p1_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 3, \'cuadrado-libre\': vm.p1_califica !== 3}\">3</td><td ng-click=\"vm.p1_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 4, \'cuadrado-libre\': vm.p1_califica !== 4}\">4</td><td ng-click=\"vm.p1_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 5, \'cuadrado-libre\': vm.p1_califica !== 5}\">5</td><td ng-click=\"vm.p1_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 6, \'cuadrado-libre\': vm.p1_califica !== 6}\">6</td><td ng-click=\"vm.p1_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 7, \'cuadrado-libre\': vm.p1_califica !== 7}\">7</td><td ng-click=\"vm.p1_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 8, \'cuadrado-libre\': vm.p1_califica !== 8}\">8</td><td ng-click=\"vm.p1_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 9, \'cuadrado-libre\': vm.p1_califica !== 9}\">9</td><td ng-click=\"vm.p1_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p1_califica === 10, \'cuadrado-libre\': vm.p1_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada Satisfactorio</span> <span class=span_detail style=\"float: right\">Muy Satisfactorio</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor2><div class=\"form-group col-sm-12\"><label for=pregunta_2 style=\"margin-bottom: 5px\">2. ¿Qué tan ágil fue el proceso de admisión?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p2_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 0, \'cuadrado-libre\': vm.p2_califica !== 0}\">0</td><td ng-click=\"vm.p2_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 1, \'cuadrado-libre\': vm.p2_califica !== 1}\">1</td><td ng-click=\"vm.p2_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 2, \'cuadrado-libre\': vm.p2_califica !== 2}\">2</td><td ng-click=\"vm.p2_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 3, \'cuadrado-libre\': vm.p2_califica !== 3}\">3</td><td ng-click=\"vm.p2_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 4, \'cuadrado-libre\': vm.p2_califica !== 4}\">4</td><td ng-click=\"vm.p2_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 5, \'cuadrado-libre\': vm.p2_califica !== 5}\">5</td><td ng-click=\"vm.p2_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 6, \'cuadrado-libre\': vm.p2_califica !== 6}\">6</td><td ng-click=\"vm.p2_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 7, \'cuadrado-libre\': vm.p2_califica !== 7}\">7</td><td ng-click=\"vm.p2_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 8, \'cuadrado-libre\': vm.p2_califica !== 8}\">8</td><td ng-click=\"vm.p2_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 9, \'cuadrado-libre\': vm.p2_califica !== 9}\">9</td><td ng-click=\"vm.p2_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p2_califica === 10, \'cuadrado-libre\': vm.p2_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada ágil</span> <span class=span_detail style=\"float: right\">Muy ágil</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor3><div class=\"form-group col-sm-12\"><label for=pregunta_3 style=\"margin-bottom: 5px\">3. ¿Qué tan clara y completa fue la información brindada por el personal de admisión?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p3_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 0, \'cuadrado-libre\': vm.p3_califica !== 0}\">0</td><td ng-click=\"vm.p3_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 1, \'cuadrado-libre\': vm.p3_califica !== 1}\">1</td><td ng-click=\"vm.p3_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 2, \'cuadrado-libre\': vm.p3_califica !== 2}\">2</td><td ng-click=\"vm.p3_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 3, \'cuadrado-libre\': vm.p3_califica !== 3}\">3</td><td ng-click=\"vm.p3_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 4, \'cuadrado-libre\': vm.p3_califica !== 4}\">4</td><td ng-click=\"vm.p3_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 5, \'cuadrado-libre\': vm.p3_califica !== 5}\">5</td><td ng-click=\"vm.p3_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 6, \'cuadrado-libre\': vm.p3_califica !== 6}\">6</td><td ng-click=\"vm.p3_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 7, \'cuadrado-libre\': vm.p3_califica !== 7}\">7</td><td ng-click=\"vm.p3_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 8, \'cuadrado-libre\': vm.p3_califica !== 8}\">8</td><td ng-click=\"vm.p3_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 9, \'cuadrado-libre\': vm.p3_califica !== 9}\">9</td><td ng-click=\"vm.p3_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p3_califica === 10, \'cuadrado-libre\': vm.p3_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada claro</span> <span class=span_detail style=\"float: right\">Muy clara y completa</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor4><div class=\"form-group col-sm-12\"><label for=pregunta_4 style=\"margin-bottom: 5px\">4. ¿Qué tan probable es que recomiende al personal de admisión que le atendió?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p4_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 0, \'cuadrado-libre\': vm.p4_califica !== 0}\">0</td><td ng-click=\"vm.p4_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 1, \'cuadrado-libre\': vm.p4_califica !== 1}\">1</td><td ng-click=\"vm.p4_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 2, \'cuadrado-libre\': vm.p4_califica !== 2}\">2</td><td ng-click=\"vm.p4_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 3, \'cuadrado-libre\': vm.p4_califica !== 3}\">3</td><td ng-click=\"vm.p4_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 4, \'cuadrado-libre\': vm.p4_califica !== 4}\">4</td><td ng-click=\"vm.p4_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 5, \'cuadrado-libre\': vm.p4_califica !== 5}\">5</td><td ng-click=\"vm.p4_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 6, \'cuadrado-libre\': vm.p4_califica !== 6}\">6</td><td ng-click=\"vm.p4_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 7, \'cuadrado-libre\': vm.p4_califica !== 7}\">7</td><td ng-click=\"vm.p4_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 8, \'cuadrado-libre\': vm.p4_califica !== 8}\">8</td><td ng-click=\"vm.p4_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 9, \'cuadrado-libre\': vm.p4_califica !== 9}\">9</td><td ng-click=\"vm.p4_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p4_califica === 10, \'cuadrado-libre\': vm.p4_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada probable</span> <span class=span_detail style=\"float: right\">Muy probable</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor10><div class=\"col-sm-12 col-xs-12\"><label for=pregunta_5 style=\"margin-bottom: 5px\">5. Apreciamos nos indique el motivo de su calificación</label><textarea type=text name=p5_califica ng-model=vm.p5_califica maxlength=250 class=\"form-control input-sm mb-5\"></textarea><br></div><br></div><p><strong>Consulta médica</strong></p><div class=row><div class=\"form-group col-sm-12\"><label for=medico>Médico:</label>&nbsp; <strong>{{vm.others.nombremedico}}</strong></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor6><div class=\"form-group col-sm-12\"><label for=pregunta_6 style=\"margin-bottom: 5px\">1. ¿El médico le trató con amabilidad y paciencia?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p6_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 0, \'cuadrado-libre\': vm.p6_califica !== 0}\">0</td><td ng-click=\"vm.p6_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 1, \'cuadrado-libre\': vm.p6_califica !== 1}\">1</td><td ng-click=\"vm.p6_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 2, \'cuadrado-libre\': vm.p6_califica !== 2}\">2</td><td ng-click=\"vm.p6_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 3, \'cuadrado-libre\': vm.p6_califica !== 3}\">3</td><td ng-click=\"vm.p6_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 4, \'cuadrado-libre\': vm.p6_califica !== 4}\">4</td><td ng-click=\"vm.p6_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 5, \'cuadrado-libre\': vm.p6_califica !== 5}\">5</td><td ng-click=\"vm.p6_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 6, \'cuadrado-libre\': vm.p6_califica !== 6}\">6</td><td ng-click=\"vm.p6_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 7, \'cuadrado-libre\': vm.p6_califica !== 7}\">7</td><td ng-click=\"vm.p6_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 8, \'cuadrado-libre\': vm.p6_califica !== 8}\">8</td><td ng-click=\"vm.p6_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 9, \'cuadrado-libre\': vm.p6_califica !== 9}\">9</td><td ng-click=\"vm.p6_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p6_califica === 10, \'cuadrado-libre\': vm.p6_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada satisfactorio</span> <span class=span_detail style=\"float: right\">Muy satisfactorio</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor7><div class=\"form-group col-sm-12\"><label for=pregunta_7 style=\"margin-bottom: 5px\">2. ¿El tiempo de espera para su Consulta médica fue la adecuada?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p7_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p7_califica === 0, \'cuadrado-libre\': vm.p7_califica !== 0}\">0</td><td ng-click=\"vm.p7_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p7_califica === 1, \'cuadrado-libre\': vm.p7_califica !== 1}\">1</td><td ng-click=\"vm.p7_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p7_califica === 2, \'cuadrado-libre\': vm.p7_califica !== 2}\">2</td><td ng-click=\"vm.p7_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p7_califica === 3, \'cuadrado-libre\': vm.p7_califica !== 3}\">3</td><td ng-click=\"vm.p7_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p7_califica === 4, \'cuadrado-libre\': vm.p7_califica !== 4}\">4</td><td ng-click=\"vm.p7_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p7_califica === 5, \'cuadrado-libre\': vm.p7_califica !== 5}\">5</td><td ng-click=\"vm.p7_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p7_califica === 6, \'cuadrado-libre\': vm.p7_califica !== 6}\">6</td><td ng-click=\"vm.p7_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p7_califica === 7, \'cuadrado-libre\': vm.p7_califica !== 7}\">7</td><td ng-click=\"vm.p7_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p7_califica === 8, \'cuadrado-libre\': vm.p7_califica !== 8}\">8</td><td ng-click=\"vm.p7_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p7_califica === 9, \'cuadrado-libre\': vm.p7_califica !== 9}\">9</td><td ng-click=\"vm.p7_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p7_califica === 10, \'cuadrado-libre\': vm.p7_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada satisfactorio</span> <span class=span_detail style=\"float: right\">Muy satisfactorio</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor8><div class=\"form-group col-sm-12\"><label for=pregunta_8 style=\"margin-bottom: 5px\">3. ¿Qué tan clara y completa fue la información brindada por el médico que lo atendió?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p8_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p8_califica === 0, \'cuadrado-libre\': vm.p8_califica !== 0}\">0</td><td ng-click=\"vm.p8_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p8_califica === 1, \'cuadrado-libre\': vm.p8_califica !== 1}\">1</td><td ng-click=\"vm.p8_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p8_califica === 2, \'cuadrado-libre\': vm.p8_califica !== 2}\">2</td><td ng-click=\"vm.p8_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p8_califica === 3, \'cuadrado-libre\': vm.p8_califica !== 3}\">3</td><td ng-click=\"vm.p8_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p8_califica === 4, \'cuadrado-libre\': vm.p8_califica !== 4}\">4</td><td ng-click=\"vm.p8_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p8_califica === 5, \'cuadrado-libre\': vm.p8_califica !== 5}\">5</td><td ng-click=\"vm.p8_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p8_califica === 6, \'cuadrado-libre\': vm.p8_califica !== 6}\">6</td><td ng-click=\"vm.p8_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p8_califica === 7, \'cuadrado-libre\': vm.p8_califica !== 7}\">7</td><td ng-click=\"vm.p8_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p8_califica === 8, \'cuadrado-libre\': vm.p8_califica !== 8}\">8</td><td ng-click=\"vm.p8_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p8_califica === 9, \'cuadrado-libre\': vm.p8_califica !== 9}\">9</td><td ng-click=\"vm.p8_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p8_califica === 10, \'cuadrado-libre\': vm.p8_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada claro</span> <span class=span_detail style=\"float: right\">Muy clara y completa</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor9><div class=\"form-group col-sm-12\"><label for=pregunta_9 style=\"margin-bottom: 5px\">4. ¿Qué tan probable es que usted recomiende al médico que le atendió?</label><table class=\"table table-bordered\" style=\"margin-bottom: 10px\"><tr><td ng-click=\"vm.p9_califica = 0;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p9_califica === 0, \'cuadrado-libre\': vm.p9_califica !== 0}\">0</td><td ng-click=\"vm.p9_califica = 1;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p9_califica === 1, \'cuadrado-libre\': vm.p9_califica !== 1}\">1</td><td ng-click=\"vm.p9_califica = 2;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p9_califica === 2, \'cuadrado-libre\': vm.p9_califica !== 2}\">2</td><td ng-click=\"vm.p9_califica = 3;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p9_califica === 3, \'cuadrado-libre\': vm.p9_califica !== 3}\">3</td><td ng-click=\"vm.p9_califica = 4;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p9_califica === 4, \'cuadrado-libre\': vm.p9_califica !== 4}\">4</td><td ng-click=\"vm.p9_califica = 5;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p9_califica === 5, \'cuadrado-libre\': vm.p9_califica !== 5}\">5</td><td ng-click=\"vm.p9_califica = 6;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p9_califica === 6, \'cuadrado-libre\': vm.p9_califica !== 6}\">6</td><td ng-click=\"vm.p9_califica = 7;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p9_califica === 7, \'cuadrado-libre\': vm.p9_califica !== 7}\">7</td><td ng-click=\"vm.p9_califica = 8;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p9_califica === 8, \'cuadrado-libre\': vm.p9_califica !== 8}\">8</td><td ng-click=\"vm.p9_califica = 9;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p9_califica === 9, \'cuadrado-libre\': vm.p9_califica !== 9}\">9</td><td ng-click=\"vm.p9_califica = 10;\" class=cuadrado-libre ng-class=\"{\'cuadrado-ocupado\': vm.p9_califica === 10, \'cuadrado-libre\': vm.p9_califica !== 10}\">10</td></tr></table><div class=row><div class=col-md-12 style=\"margin-top: -10px\"><span class=span_detail style=\"float: left\">Nada probable</span> <span class=span_detail style=\"float: right\">Muy probable</span></div></div></div></div><div class=\"row anchor\" style=\"margin-bottom: 15px\" id=anchor10><div class=\"col-sm-12 col-xs-12\"><label for=pregunta_10 style=\"margin-bottom: 5px\">5. Apreciamos nos indique el motivo de su calificación</label><textarea type=text name=p10_califica ng-model=vm.p10_califica maxlength=250 class=\"form-control input-sm mb-5\"></textarea><br></div><br></div><button type=submit class=\"btn btn-green btn-lg btn-block btn-rounded-40\" ng-disabled=miForm.$submitted>Enviar</button></div></form></div></div>");
$templateCache.put("app/components/partials/header/header.html","<div class=navbar-header><button type=button class=\"header-nav-toggle collapsed\" data-toggle=collapse data-target=#header-navbar aria-expanded=false aria-controls=header-navbar><span class=sr-only>Toggle header</span> <i class=\"fa fa-cog\"></i></button> <a class=navbar-brand href=javascript:;><img ng-src={{servidorUrl}}/img/osi/logosistema.png width=180> </a><button type=button class=navigation-toggle id=navigation-toggle><span class=sr-only>Toggle navigation</span> <i class=\"fa fa-bars\"></i></button></div><div id=header-navbar class=\"navbar-collapse collapse\"><ul class=\"nav navbar-nav navbar-right\"><li><div uib-dropdown><span class=\"filled text-white hidden-xs\">{{entidad.nombres}}</span> <button id=profile type=button class=\"btn no-bg\" uib-dropdown-toggle><img ng-if=entidad.imgperfil ng-src={{servidorUrl}}/img/osi/{{entidad.numerodoc}}/{{entidad.imgperfil}} class=\"img-responsive img-circle hidden-xs\"> <img ng-if=\"!entidad.imgperfil && entidad.sexo == \'M\'\" ng-src={{servidorUrl}}/img/osi/masculino.png class=\"img-responsive img-circle hidden-xs\"> <img ng-if=\"!entidad.imgperfil && entidad.sexo == \'F\'\" ng-src={{servidorUrl}}/img/osi/femenino.png class=\"img-responsive img-circle hidden-xs\"> <span class=nav-text><i class=\"fa fa-user\"></i> {{entidad.nombres}}</span></button><div class=\"dropdown-menu with-arrow animated littleFadeInRight profile\" uib-dropdown-menu role=menu aria-labelledby=profile><div class=media><div class=media-left><img ng-if=entidad.imgperfil ng-src={{servidorUrl}}/img/osi/{{entidad.numerodoc}}/{{entidad.imgperfil}} class=\"media-object img-circle\"> <img ng-if=\"!entidad.imgperfil && entidad.sexo == \'M\'\" ng-src={{servidorUrl}}/img/osi/masculino.png class=\"media-object img-circle\"> <img ng-if=\"!entidad.imgperfil && entidad.sexo == \'F\'\" ng-src={{servidorUrl}}/img/osi/femenino.png class=\"media-object img-circle\"></div><div class=media-body><h4 class=\"text-sm uppercase-bold\">{{entidad.nombres}}</h4><ul class=list-unstyled><li><a ui-sref=misdatos><i class=\"fa fa-user\"></i> Mis datos</a></li><li><a href=javascript:; ng-click=header.abrirModal(entidad.identidad);><i class=\"fa fa-key\"></i> Cambiar contraseña</a></li></ul></div></div><div class=footer><button class=\"btn btn-default minotaur-btn pull-right\" ng-click=header.logout();><i class=\"fa fa-power-off\"></i> Salir</button><div class=clearfix></div></div></div></div></li><li><div><button type=button tooltip-placement=bottom uib-tooltip=Salir class=btn ng-click=header.logout();><i class=\"fa fa-power-off\"></i> <span class=nav-text>Salir</span></button></div></li></ul></div>");
$templateCache.put("app/components/partials/navigation/navigation.html","<section class=\"tile-widget pt-30 pb-20 text-center\"><div class=\"thumb thumb-xl\"><img ng-if=entidad.imgperfil ng-src={{servidorUrl}}/img/osi/{{entidad.numerodoc}}/{{entidad.imgperfil}} class=img-circle width=100> <img ng-if=\"!entidad.imgperfil && entidad.sexo == \'M\'\" ng-src={{servidorUrl}}/img/osi/masculino.png class=img-circle width=100> <img ng-if=\"!entidad.imgperfil && entidad.sexo == \'F\'\" ng-src={{servidorUrl}}/img/osi/femenino.png class=img-circle width=100></div><h4 class=mb-0>{{entidad.nombres}}</h4><div class=mt-10><a ui-sref=misdatos class=\"btn btn-rounded-20 btn-sm btn-greensea\">MIS DATOS</a></div></section><div slimscroll=\"{\r\n      height: \'100%\',\r\n      size: \'4px\',\r\n      borderRadius: \'0px\',\r\n      opacity: .2\r\n     }\"><ul class=\"nav nav-sidebar\"><li><a ui-sref=mireserva><span class=nav-text>Reservar cita</span> <i class=\"fa fa fa-plus\"></i></a></li><li><a ui-sref=miscitasmedicas.list><span class=nav-text>Citas médicas</span> <i class=\"fa fa-calendar-plus-o\"></i></a></li><li><a ui-sref=miscitasterapeutas><span class=nav-text>Citas de terapia</span> <i class=\"fa fa-calendar-plus-o\"></i></a></li><li><a ui-sref=misciclos.list><span class=nav-text>Mis ciclos</span> <i class=\"fa fa-folder-open\"></i></a></li><li><a ui-sref=mispagos><span class=nav-text>Mis pagos</span> <i class=\"fa fa-money\"></i></a></li><li><a ui-sref=misordenes><span class=nav-text>Mis Ordenes</span> <i class=\"fa fa-money\"></i></a></li><li><a ui-sref=faq><span class=nav-text>Preguntas</span> <i class=\"fa fa-question-circle\"></i></a></li></ul></div>");}]);